(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as uS, getPartnerDevApiHeaders as mS, WidgetContextProvider as pS, makeExecuteQuery as fS, makeUseLazyQuery as hS, makeUseQuery as yS, makeUseMutation as gS, validateApiHostName as tb, useTracking as kn, useWidgetContext as mn, hasDownstreamApiForbiddenError as gm, hasDownstreamApiAuthorizationError as km, DisplayErrors as wn, useCopyWithDelay as Xt, defaultDateFormat as lt, displayAttributeValue as rb, OAuthSettings as Ga, useData as vm, isDownstreamApiNotFoundError as kS, isDownstreamApiAuthorizationError as ib, KlaviyoSubscribeSetting as vS, isDownstreamApiPermissionError as bS, capitalizeFirstCharacter as ws, hasDownstreamApiTooManyRequestsError as _S, hasDownstreamApiPermissionError as ab, hasDownstreamApiNotFoundError as Ya, getCountryNameFromCountryCode as xS } from "@dixa/partner-widget-integration-support";
export * from "@dixa/partner-widget-integration-support";
import Se, { useMemo as et, useState as se, useEffect as qe, useRef as Fi, useCallback as pt, useReducer as SS, useLayoutEffect as NS, isValidElement as jS, createElement as wS, Fragment as CS } from "react";
import { Modal as gt, ModalHead as kt, ModalBody as vt, ModalFoot as wt, Text as A, FlexBox as b, Spinner as un, Icon as ue, Tooltip as Ke, List as He, Badge as Un, Button as Wn, IconButton as Kt, Tag as On, NavigationButton as jt, Select as br, CollapseCard as rr, Box as Jn, FormGrid as zt, FormField as nn, FieldWrapper as An, InputText as kr, Textarea as Au, TagsInput as Cs, Image as Li, Banner as Ja, Divider as bm, InputSelectionList as Kr, SelectionList as mt, FieldText as ir, FieldTextarea as FS, CopyToClipboardButton as IS, Avatar as _m, Timestamp as ES, Attachment as TS, Switch as Lu, FieldLabel as $S, EmptyState as xm, Table as Qn, Checkbox as Ap, TextWithHighlight as DS, ErrorBoundaryContext as ob, FieldSwitch as sb } from "@dixa/lib-shared-habla";
import { ApolloLink as Sm, Observable as lb, ApolloClient as RS, InMemoryCache as OS, createHttpLink as PS, ApolloProvider as AS, useApolloClient as LS, ApolloConsumer as VS, gql as Qr, NetworkStatus as ar, isApolloError as cb, ApolloError as zS, useQuery as US, useMutation as Lp } from "@apollo/client";
import MS from "cross-fetch";
import { config as qa } from "lib-shared-backend-config";
import ct from "classnames";
import Pn from "moment";
import { __rest as BS, __assign as Gs } from "tslib";
import { useNavigate as qS, useLocation as HS } from "react-router-dom";
import "moment-timezone";
function Nm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var co = { exports: {} }, Gi = {};
var Vp;
function WS() {
  if (Vp) return Gi;
  Vp = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Gi.Fragment = r, Gi.jsx = s, Gi.jsxs = s, Gi;
}
var Yi = {};
var zp;
function KS() {
  return zp || (zp = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c, R));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Yi.Fragment = i, Yi.jsx = Bn, Yi.jsxs = qn;
  })()), Yi;
}
var Up;
function GS() {
  return Up || (Up = 1, process.env.NODE_ENV === "production" ? co.exports = WS() : co.exports = KS()), co.exports;
}
var Ue = GS();
function db(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: YS } = Object.prototype, { getPrototypeOf: jm } = Object, { iterator: Fs, toStringTag: ub } = Symbol, Is = /* @__PURE__ */ ((e) => (n) => {
  const r = YS.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), _r = (e) => (e = e.toLowerCase(), (n) => Is(n) === e), Es = (e) => (n) => typeof n === e, { isArray: Vi } = Array, Ri = Es("undefined");
function Qa(e) {
  return e !== null && !Ri(e) && e.constructor !== null && !Ri(e.constructor) && qt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const mb = _r("ArrayBuffer");
function JS(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && mb(e.buffer), n;
}
const QS = Es("string"), qt = Es("function"), pb = Es("number"), Xa = (e) => e !== null && typeof e == "object", XS = (e) => e === !0 || e === !1, Mo = (e) => {
  if (Is(e) !== "object")
    return !1;
  const n = jm(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(ub in e) && !(Fs in e);
}, ZS = (e) => {
  if (!Xa(e) || Qa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, e0 = _r("Date"), n0 = _r("File"), t0 = _r("Blob"), r0 = _r("FileList"), i0 = (e) => Xa(e) && qt(e.pipe), a0 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || qt(e.append) && ((n = Is(e)) === "formdata" || // detect form-data instance
  n === "object" && qt(e.toString) && e.toString() === "[object FormData]"));
}, o0 = _r("URLSearchParams"), [s0, l0, c0, d0] = ["ReadableStream", "Request", "Response", "Headers"].map(_r), u0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Za(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Vi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Qa(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function fb(e, n) {
  if (Qa(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const oi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, hb = (e) => !Ri(e) && e !== oi;
function Vu() {
  const { caseless: e, skipUndefined: n } = hb(this) && this || {}, r = {}, i = (a, o) => {
    const s = e && fb(r, o) || o;
    Mo(r[s]) && Mo(a) ? r[s] = Vu(r[s], a) : Mo(a) ? r[s] = Vu({}, a) : Vi(a) ? r[s] = a.slice() : (!n || !Ri(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && Za(arguments[a], i);
  return r;
}
const m0 = (e, n, r, { allOwnKeys: i } = {}) => (Za(n, (a, o) => {
  r && qt(a) ? e[o] = db(a, r) : e[o] = a;
}, { allOwnKeys: i }), e), p0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), f0 = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, h0 = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && jm(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, y0 = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, g0 = (e) => {
  if (!e) return null;
  if (Vi(e)) return e;
  let n = e.length;
  if (!pb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, k0 = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && jm(Uint8Array)), v0 = (e, n) => {
  const i = (e && e[Fs]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, b0 = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, _0 = _r("HTMLFormElement"), x0 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, i, a) {
    return i.toUpperCase() + a;
  }
), Mp = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), S0 = _r("RegExp"), yb = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Za(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, N0 = (e) => {
  yb(e, (n, r) => {
    if (qt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (qt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, j0 = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Vi(e) ? i(e) : i(String(e).split(n)), r;
}, w0 = () => {
}, C0 = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function F0(e) {
  return !!(e && qt(e.append) && e[ub] === "FormData" && e[Fs]);
}
const I0 = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (Xa(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (Qa(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Vi(i) ? [] : {};
        return Za(i, (s, l) => {
          const d = r(s, a + 1);
          !Ri(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, E0 = _r("AsyncFunction"), T0 = (e) => e && (Xa(e) || qt(e)) && qt(e.then) && qt(e.catch), gb = ((e, n) => e ? setImmediate : n ? ((r, i) => (oi.addEventListener("message", ({ source: a, data: o }) => {
  a === oi && o === r && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), oi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  qt(oi.postMessage)
), $0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(oi) : typeof process < "u" && process.nextTick || gb, D0 = (e) => e != null && qt(e[Fs]), ge = {
  isArray: Vi,
  isArrayBuffer: mb,
  isBuffer: Qa,
  isFormData: a0,
  isArrayBufferView: JS,
  isString: QS,
  isNumber: pb,
  isBoolean: XS,
  isObject: Xa,
  isPlainObject: Mo,
  isEmptyObject: ZS,
  isReadableStream: s0,
  isRequest: l0,
  isResponse: c0,
  isHeaders: d0,
  isUndefined: Ri,
  isDate: e0,
  isFile: n0,
  isBlob: t0,
  isRegExp: S0,
  isFunction: qt,
  isStream: i0,
  isURLSearchParams: o0,
  isTypedArray: k0,
  isFileList: r0,
  forEach: Za,
  merge: Vu,
  extend: m0,
  trim: u0,
  stripBOM: p0,
  inherits: f0,
  toFlatObject: h0,
  kindOf: Is,
  kindOfTest: _r,
  endsWith: y0,
  toArray: g0,
  forEachEntry: v0,
  matchAll: b0,
  isHTMLForm: _0,
  hasOwnProperty: Mp,
  hasOwnProp: Mp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: yb,
  freezeMethods: N0,
  toObjectSet: j0,
  toCamelCase: x0,
  noop: w0,
  toFiniteNumber: C0,
  findKey: fb,
  global: oi,
  isContextDefined: hb,
  isSpecCompliantForm: F0,
  toJSONObject: I0,
  isAsyncFn: E0,
  isThenable: T0,
  setImmediate: gb,
  asap: $0,
  isIterable: D0
};
function Fn(e, n, r, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), r && (this.config = r), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ge.inherits(Fn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ge.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const kb = Fn.prototype, vb = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  vb[e] = { value: e };
});
Object.defineProperties(Fn, vb);
Object.defineProperty(kb, "isAxiosError", { value: !0 });
Fn.from = (e, n, r, i, a, o) => {
  const s = Object.create(kb);
  ge.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (m) => m !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", d = n == null && e ? e.code : n;
  return Fn.call(s, l, d, r, i, a), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const R0 = null;
function zu(e) {
  return ge.isPlainObject(e) || ge.isArray(e);
}
function bb(e) {
  return ge.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Bp(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = bb(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function O0(e) {
  return ge.isArray(e) && !e.some(zu);
}
const P0 = ge.toFlatObject(ge, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Ts(e, n, r) {
  if (!ge.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ge.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(N, F) {
    return !ge.isUndefined(F[N]);
  });
  const i = r.metaTokens, a = r.visitor || u, o = r.dots, s = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && ge.isSpecCompliantForm(n);
  if (!ge.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(S) {
    if (S === null) return "";
    if (ge.isDate(S))
      return S.toISOString();
    if (ge.isBoolean(S))
      return S.toString();
    if (!d && ge.isBlob(S))
      throw new Fn("Blob is not supported. Use a Buffer instead.");
    return ge.isArrayBuffer(S) || ge.isTypedArray(S) ? d && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function u(S, N, F) {
    let I = S;
    if (S && !F && typeof S == "object") {
      if (ge.endsWith(N, "{}"))
        N = i ? N : N.slice(0, -2), S = JSON.stringify(S);
      else if (ge.isArray(S) && O0(S) || (ge.isFileList(S) || ge.endsWith(N, "[]")) && (I = ge.toArray(S)))
        return N = bb(N), I.forEach(function(q, $) {
          !(ge.isUndefined(q) || q === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Bp([N], $, o) : s === null ? N : N + "[]",
            m(q)
          );
        }), !1;
    }
    return zu(S) ? !0 : (n.append(Bp(F, N, o), m(S)), !1);
  }
  const f = [], h = Object.assign(P0, {
    defaultVisitor: u,
    convertValue: m,
    isVisitable: zu
  });
  function v(S, N) {
    if (!ge.isUndefined(S)) {
      if (f.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      f.push(S), ge.forEach(S, function(I, g) {
        (!(ge.isUndefined(I) || I === null) && a.call(
          n,
          I,
          ge.isString(g) ? g.trim() : g,
          N,
          h
        )) === !0 && v(I, N ? N.concat(g) : [g]);
      }), f.pop();
    }
  }
  if (!ge.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), n;
}
function qp(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function wm(e, n) {
  this._pairs = [], e && Ts(e, this, n);
}
const _b = wm.prototype;
_b.append = function(n, r) {
  this._pairs.push([n, r]);
};
_b.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, qp);
  } : qp;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function A0(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function xb(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || A0;
  ge.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let o;
  if (a ? o = a(n, r) : o = ge.isURLSearchParams(n) ? n.toString() : new wm(n, r).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Hp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ge.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Sb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, L0 = typeof URLSearchParams < "u" ? URLSearchParams : wm, V0 = typeof FormData < "u" ? FormData : null, z0 = typeof Blob < "u" ? Blob : null, U0 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: L0,
    FormData: V0,
    Blob: z0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Cm = typeof window < "u" && typeof document < "u", Uu = typeof navigator == "object" && navigator || void 0, M0 = Cm && (!Uu || ["ReactNative", "NativeScript", "NS"].indexOf(Uu.product) < 0), B0 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", q0 = Cm && window.location.href || "http://localhost", H0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Cm,
  hasStandardBrowserEnv: M0,
  hasStandardBrowserWebWorkerEnv: B0,
  navigator: Uu,
  origin: q0
}, Symbol.toStringTag, { value: "Module" })), Ct = {
  ...H0,
  ...U0
};
function W0(e, n) {
  return Ts(e, new Ct.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ct.isNode && ge.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function K0(e) {
  return ge.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function G0(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Nb(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ge.isArray(a) ? a.length : s, d ? (ge.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ge.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ge.isArray(a[s]) && (a[s] = G0(a[s])), !l);
  }
  if (ge.isFormData(e) && ge.isFunction(e.entries)) {
    const r = {};
    return ge.forEachEntry(e, (i, a) => {
      n(K0(i), a, r, 0);
    }), r;
  }
  return null;
}
function Y0(e, n, r) {
  if (ge.isString(e))
    try {
      return (n || JSON.parse)(e), ge.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const eo = {
  transitional: Sb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, r) {
    const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ge.isObject(n);
    if (o && ge.isHTMLForm(n) && (n = new FormData(n)), ge.isFormData(n))
      return a ? JSON.stringify(Nb(n)) : n;
    if (ge.isArrayBuffer(n) || ge.isBuffer(n) || ge.isStream(n) || ge.isFile(n) || ge.isBlob(n) || ge.isReadableStream(n))
      return n;
    if (ge.isArrayBufferView(n))
      return n.buffer;
    if (ge.isURLSearchParams(n))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return W0(n, this.formSerializer).toString();
      if ((l = ge.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Ts(
          l ? { "files[]": n } : n,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), Y0(n)) : n;
  }],
  transformResponse: [function(n) {
    const r = this.transitional || eo.transitional, i = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (ge.isResponse(n) || ge.isReadableStream(n))
      return n;
    if (n && ge.isString(n) && (i && !this.responseType || a)) {
      const s = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? Fn.from(l, Fn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ct.classes.FormData,
    Blob: Ct.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ge.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  eo.headers[e] = {};
});
const J0 = ge.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Q0 = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && J0[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, Wp = Symbol("internals");
function Ji(e) {
  return e && String(e).trim().toLowerCase();
}
function Bo(e) {
  return e === !1 || e == null ? e : ge.isArray(e) ? e.map(Bo) : String(e);
}
function X0(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const Z0 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ys(e, n, r, i, a) {
  if (ge.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ge.isString(n)) {
    if (ge.isString(i))
      return n.indexOf(i) !== -1;
    if (ge.isRegExp(i))
      return i.test(n);
  }
}
function eN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function nN(e, n) {
  const r = ge.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ht = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = Ji(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ge.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Bo(l));
    }
    const s = (l, d) => ge.forEach(l, (m, u) => o(m, u, d));
    if (ge.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ge.isString(n) && (n = n.trim()) && !Z0(n))
      s(Q0(n), r);
    else if (ge.isObject(n) && ge.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ge.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ge.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Ji(n), n) {
      const i = ge.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return X0(a);
        if (ge.isFunction(r))
          return r.call(this, a, i);
        if (ge.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Ji(n), n) {
      const i = ge.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Ys(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ji(s), s) {
        const l = ge.findKey(i, s);
        l && (!r || Ys(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || Ys(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ge.forEach(this, (a, o) => {
      const s = ge.findKey(i, o);
      if (s) {
        r[s] = Bo(a), delete r[o];
        return;
      }
      const l = n ? eN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Bo(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ge.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ge.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Wp] = this[Wp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ji(s);
      i[l] || (nN(a, s), i[l] = !0);
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ht.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ge.reduceDescriptors(Ht.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ge.freezeMethods(Ht);
function Js(e, n) {
  const r = this || eo, i = n || r, a = Ht.from(i.headers);
  let o = i.data;
  return ge.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function jb(e) {
  return !!(e && e.__CANCEL__);
}
function zi(e, n, r) {
  Fn.call(this, e ?? "canceled", Fn.ERR_CANCELED, n, r), this.name = "CanceledError";
}
ge.inherits(zi, Fn, {
  __CANCEL__: !0
});
function wb(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new Fn(
    "Request failed with status code " + r.status,
    [Fn.ERR_BAD_REQUEST, Fn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function tN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function rN(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function iN(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const is = (e, n, r = 3) => {
  let i = 0;
  const a = rN(50, 250);
  return iN((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = s - i, m = a(d), u = s <= l;
    i = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: d,
      rate: m || void 0,
      estimated: m && l && u ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, Kp = (e, n) => {
  const r = e != null;
  return [(i) => n[0]({
    lengthComputable: r,
    total: e,
    loaded: i
  }), n[1]];
}, Gp = (e) => (...n) => ge.asap(() => e(...n)), aN = Ct.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ct.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ct.origin),
  Ct.navigator && /(msie|trident)/i.test(Ct.navigator.userAgent)
) : () => !0, oN = Ct.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ge.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), ge.isString(i) && s.push("path=" + i), ge.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function sN(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function lN(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function Cb(e, n, r) {
  let i = !sN(n);
  return e && (i || r == !1) ? lN(e, n) : n;
}
const Yp = (e) => e instanceof Ht ? { ...e } : e;
function fi(e, n) {
  n = n || {};
  const r = {};
  function i(m, u, f, h) {
    return ge.isPlainObject(m) && ge.isPlainObject(u) ? ge.merge.call({ caseless: h }, m, u) : ge.isPlainObject(u) ? ge.merge({}, u) : ge.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ge.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ge.isUndefined(u)) {
      if (!ge.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (f in n)
      return i(m, u);
    if (f in e)
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(Yp(m), Yp(u), f, !0)
  };
  return ge.forEach(Object.keys({ ...e, ...n }), function(u) {
    const f = d[u] || a, h = f(e[u], n[u], u);
    ge.isUndefined(h) && f !== l || (r[u] = h);
  }), r;
}
const Fb = (e) => {
  const n = fi({}, e);
  let { data: r, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  if (n.headers = s = Ht.from(s), n.url = xb(Cb(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), ge.isFormData(r)) {
    if (Ct.hasStandardBrowserEnv || Ct.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (ge.isFunction(r.getHeaders)) {
      const d = r.getHeaders(), m = ["content-type", "content-length"];
      Object.entries(d).forEach(([u, f]) => {
        m.includes(u.toLowerCase()) && s.set(u, f);
      });
    }
  }
  if (Ct.hasStandardBrowserEnv && (i && ge.isFunction(i) && (i = i(n)), i || i !== !1 && aN(n.url))) {
    const d = a && o && oN.read(o);
    d && s.set(a, d);
  }
  return n;
}, cN = typeof XMLHttpRequest < "u", dN = cN && function(e) {
  return new Promise(function(r, i) {
    const a = Fb(e);
    let o = a.data;
    const s = Ht.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, S;
    function N() {
      v && v(), S && S(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let F = new XMLHttpRequest();
    F.open(a.method.toUpperCase(), a.url, !0), F.timeout = a.timeout;
    function I() {
      if (!F)
        return;
      const q = Ht.from(
        "getAllResponseHeaders" in F && F.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? F.responseText : F.response,
        status: F.status,
        statusText: F.statusText,
        headers: q,
        config: e,
        request: F
      };
      wb(function(U) {
        r(U), N();
      }, function(U) {
        i(U), N();
      }, C), F = null;
    }
    "onloadend" in F ? F.onloadend = I : F.onreadystatechange = function() {
      !F || F.readyState !== 4 || F.status === 0 && !(F.responseURL && F.responseURL.indexOf("file:") === 0) || setTimeout(I);
    }, F.onabort = function() {
      F && (i(new Fn("Request aborted", Fn.ECONNABORTED, e, F)), F = null);
    }, F.onerror = function($) {
      const C = $ && $.message ? $.message : "Network Error", D = new Fn(C, Fn.ERR_NETWORK, e, F);
      D.event = $ || null, i(D), F = null;
    }, F.ontimeout = function() {
      let $ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const C = a.transitional || Sb;
      a.timeoutErrorMessage && ($ = a.timeoutErrorMessage), i(new Fn(
        $,
        C.clarifyTimeoutError ? Fn.ETIMEDOUT : Fn.ECONNABORTED,
        e,
        F
      )), F = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in F && ge.forEach(s.toJSON(), function($, C) {
      F.setRequestHeader(C, $);
    }), ge.isUndefined(a.withCredentials) || (F.withCredentials = !!a.withCredentials), l && l !== "json" && (F.responseType = a.responseType), m && ([h, S] = is(m, !0), F.addEventListener("progress", h)), d && F.upload && ([f, v] = is(d), F.upload.addEventListener("progress", f), F.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (q) => {
      F && (i(!q || q.type ? new zi(null, e, F) : q), F.abort(), F = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = tN(a.url);
    if (g && Ct.protocols.indexOf(g) === -1) {
      i(new Fn("Unsupported protocol " + g + ":", Fn.ERR_BAD_REQUEST, e));
      return;
    }
    F.send(o || null);
  });
}, uN = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(u instanceof Fn ? u : new zi(u instanceof Error ? u.message : u));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new Fn(`timeout ${n} of ms exceeded`, Fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ge.asap(l), d;
  }
}, mN = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, pN = async function* (e, n) {
  for await (const r of fN(e))
    yield* mN(r, n);
}, fN = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Jp = (e, n, r, i) => {
  const a = pN(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: m, value: u } = await a.next();
        if (m) {
          l(), d.close();
          return;
        }
        let f = u.byteLength;
        if (r) {
          let h = o += f;
          r(h);
        }
        d.enqueue(new Uint8Array(u));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(d) {
      return l(d), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Qp = 64 * 1024, { isFunction: uo } = ge, hN = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ge.global), {
  ReadableStream: Xp,
  TextEncoder: Zp
} = ge.global, ef = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, yN = (e) => {
  e = ge.merge.call({
    skipUndefined: !0
  }, hN, e);
  const { fetch: n, Request: r, Response: i } = e, a = n ? uo(n) : typeof fetch == "function", o = uo(r), s = uo(i);
  if (!a)
    return !1;
  const l = a && uo(Xp), d = a && (typeof Zp == "function" ? /* @__PURE__ */ ((S) => (N) => S.encode(N))(new Zp()) : async (S) => new Uint8Array(await new r(S).arrayBuffer())), m = o && l && ef(() => {
    let S = !1;
    const N = new r(Ct.origin, {
      body: new Xp(),
      method: "POST",
      get duplex() {
        return S = !0, "half";
      }
    }).headers.has("Content-Type");
    return S && !N;
  }), u = s && l && ef(() => ge.isReadableStream(new i("").body)), f = {
    stream: u && ((S) => S.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((S) => {
    !f[S] && (f[S] = (N, F) => {
      let I = N && N[S];
      if (I)
        return I.call(N);
      throw new Fn(`Response type '${S}' is not supported`, Fn.ERR_NOT_SUPPORT, F);
    });
  });
  const h = async (S) => {
    if (S == null)
      return 0;
    if (ge.isBlob(S))
      return S.size;
    if (ge.isSpecCompliantForm(S))
      return (await new r(Ct.origin, {
        method: "POST",
        body: S
      }).arrayBuffer()).byteLength;
    if (ge.isArrayBufferView(S) || ge.isArrayBuffer(S))
      return S.byteLength;
    if (ge.isURLSearchParams(S) && (S = S + ""), ge.isString(S))
      return (await d(S)).byteLength;
  }, v = async (S, N) => {
    const F = ge.toFiniteNumber(S.getContentLength());
    return F ?? h(N);
  };
  return async (S) => {
    let {
      url: N,
      method: F,
      data: I,
      signal: g,
      cancelToken: q,
      timeout: $,
      onDownloadProgress: C,
      onUploadProgress: D,
      responseType: U,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: ee
    } = Fb(S), J = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let G = uN([g, q && q.toAbortSignal()], $), P = null;
    const W = G && G.unsubscribe && (() => {
      G.unsubscribe();
    });
    let ne;
    try {
      if (D && m && F !== "get" && F !== "head" && (ne = await v(Z, I)) !== 0) {
        let be = new r(N, {
          method: "POST",
          body: I,
          duplex: "half"
        }), Ce;
        if (ge.isFormData(I) && (Ce = be.headers.get("content-type")) && Z.setContentType(Ce), be.body) {
          const [K, ze] = Kp(
            ne,
            is(Gp(D))
          );
          I = Jp(be.body, Qp, K, ze);
        }
      }
      ge.isString(Q) || (Q = Q ? "include" : "omit");
      const ke = o && "credentials" in r.prototype, me = {
        ...ee,
        signal: G,
        method: F.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: I,
        duplex: "half",
        credentials: ke ? Q : void 0
      };
      P = o && new r(N, me);
      let de = await (o ? J(P, ee) : J(N, me));
      const he = u && (U === "stream" || U === "response");
      if (u && (C || he && W)) {
        const be = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          be[Be] = de[Be];
        });
        const Ce = ge.toFiniteNumber(de.headers.get("content-length")), [K, ze] = C && Kp(
          Ce,
          is(Gp(C), !0)
        ) || [];
        de = new i(
          Jp(de.body, Qp, K, () => {
            ze && ze(), W && W();
          }),
          be
        );
      }
      U = U || "text";
      let H = await f[ge.findKey(f, U) || "text"](de, S);
      return !he && W && W(), await new Promise((be, Ce) => {
        wb(be, Ce, {
          data: H,
          headers: Ht.from(de.headers),
          status: de.status,
          statusText: de.statusText,
          config: S,
          request: P
        });
      });
    } catch (ke) {
      throw W && W(), ke && ke.name === "TypeError" && /Load failed|fetch/i.test(ke.message) ? Object.assign(
        new Fn("Network Error", Fn.ERR_NETWORK, S, P),
        {
          cause: ke.cause || ke
        }
      ) : Fn.from(ke, ke && ke.code, S, P);
    }
  };
}, gN = /* @__PURE__ */ new Map(), Ib = (e) => {
  let n = e ? e.env : {};
  const { fetch: r, Request: i, Response: a } = n, o = [
    i,
    a,
    r
  ];
  let s = o.length, l = s, d, m, u = gN;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : yN(n)), u = m;
  return m;
};
Ib();
const Mu = {
  http: R0,
  xhr: dN,
  fetch: {
    get: Ib
  }
};
ge.forEach(Mu, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const nf = (e) => `- ${e}`, kN = (e) => ge.isFunction(e) || e === null || e === !1, Eb = {
  getAdapter: (e, n) => {
    e = ge.isArray(e) ? e : [e];
    const { length: r } = e;
    let i, a;
    const o = {};
    for (let s = 0; s < r; s++) {
      i = e[s];
      let l;
      if (a = i, !kN(i) && (a = Mu[(l = String(i)).toLowerCase()], a === void 0))
        throw new Fn(`Unknown adapter '${l}'`);
      if (a && (ge.isFunction(a) || (a = a.get(n))))
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? s.length > 1 ? `since :
` + s.map(nf).join(`
`) : " " + nf(s[0]) : "as no adapter specified";
      throw new Fn(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Mu
};
function Qs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new zi(null, e);
}
function tf(e) {
  return Qs(e), e.headers = Ht.from(e.headers), e.data = Js.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Eb.getAdapter(e.adapter || eo.adapter, e)(e).then(function(i) {
    return Qs(e), i.data = Js.call(
      e,
      e.transformResponse,
      i
    ), i.headers = Ht.from(i.headers), i;
  }, function(i) {
    return jb(i) || (Qs(e), i && i.response && (i.response.data = Js.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = Ht.from(i.response.headers))), Promise.reject(i);
  });
}
const Tb = "1.12.2", $s = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  $s[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const rf = {};
$s.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Tb + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new Fn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        Fn.ERR_DEPRECATED
      );
    return r && !rf[s] && (rf[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
$s.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function vN(e, n, r) {
  if (typeof e != "object")
    throw new Fn("options must be an object", Fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new Fn("option " + o + " must be " + d, Fn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Fn("Unknown option " + o, Fn.ERR_BAD_OPTION);
  }
}
const qo = {
  assertOptions: vN,
  validators: $s
}, xr = qo.validators;
let di = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Hp(),
      response: new Hp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = fi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && qo.assertOptions(i, {
      silentJSONParsing: xr.transitional(xr.boolean),
      forcedJSONParsing: xr.transitional(xr.boolean),
      clarifyTimeoutError: xr.transitional(xr.boolean)
    }, !1), a != null && (ge.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : qo.assertOptions(a, {
      encode: xr.function,
      serialize: xr.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), qo.assertOptions(r, {
      baseUrl: xr.spelling("baseURL"),
      withXsrfToken: xr.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ge.merge(
      o.common,
      o[r.method]
    );
    o && ge.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (S) => {
        delete o[S];
      }
    ), r.headers = Ht.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(N) {
      typeof N.runWhen == "function" && N.runWhen(r) === !1 || (d = d && N.synchronous, l.unshift(N.fulfilled, N.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(N) {
      m.push(N.fulfilled, N.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const S = [tf.bind(this), void 0];
      for (S.unshift(...l), S.push(...m), h = S.length, u = Promise.resolve(r); f < h; )
        u = u.then(S[f++], S[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const S = l[f++], N = l[f++];
      try {
        v = S(v);
      } catch (F) {
        N.call(this, F);
        break;
      }
    }
    try {
      u = tf.call(this, v);
    } catch (S) {
      return Promise.reject(S);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = fi(this.defaults, n);
    const r = Cb(n.baseURL, n.url, n.allowAbsoluteUrls);
    return xb(r, n.params, n.paramsSerializer);
  }
};
ge.forEach(["delete", "get", "head", "options"], function(n) {
  di.prototype[n] = function(r, i) {
    return this.request(fi(i || {}, {
      method: n,
      url: r,
      data: (i || {}).data
    }));
  };
});
ge.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(fi(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  di.prototype[n] = r(), di.prototype[n + "Form"] = r(!0);
});
let bN = class $b {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new zi(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new $b(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function _N(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function xN(e) {
  return ge.isObject(e) && e.isAxiosError === !0;
}
const Bu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Bu).forEach(([e, n]) => {
  Bu[n] = e;
});
function Db(e) {
  const n = new di(e), r = db(di.prototype.request, n);
  return ge.extend(r, di.prototype, n, { allOwnKeys: !0 }), ge.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Db(fi(e, a));
  }, r;
}
const dt = Db(eo);
dt.Axios = di;
dt.CanceledError = zi;
dt.CancelToken = bN;
dt.isCancel = jb;
dt.VERSION = Tb;
dt.toFormData = Ts;
dt.AxiosError = Fn;
dt.Cancel = dt.CanceledError;
dt.all = function(n) {
  return Promise.all(n);
};
dt.spread = _N;
dt.isAxiosError = xN;
dt.mergeConfig = fi;
dt.AxiosHeaders = Ht;
dt.formToJSON = (e) => Nb(ge.isHTMLForm(e) ? new FormData(e) : e);
dt.getAdapter = Eb.getAdapter;
dt.HttpStatusCode = Bu;
dt.default = dt;
const {
  Axios: J4,
  AxiosError: Q4,
  CanceledError: X4,
  isCancel: Z4,
  CancelToken: eM,
  VERSION: nM,
  all: tM,
  Cancel: rM,
  isAxiosError: SN,
  spread: iM,
  toFormData: aM,
  AxiosHeaders: oM,
  HttpStatusCode: sM,
  formToJSON: lM,
  getAdapter: cM,
  mergeConfig: dM
} = dt;
class NN {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const af = new NN();
function jN(e, n) {
  return of(e), of(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function of(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const wN = Object.prototype.toString;
function CN(e, n) {
  return wN.call(e) === `[object ${n}]`;
}
function FN(e) {
  return CN(e, "Object");
}
function IN(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Da = "8.36.0", Mr = globalThis;
function Fm(e, n, r) {
  const i = r || Mr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Da] = a[Da] || {};
  return o[e] || (o[e] = n());
}
const Rb = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, EN = "Sentry Logger ", sf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], lf = {};
function Ob(e) {
  if (!("console" in Mr))
    return e();
  const n = Mr.console, r = {}, i = Object.keys(lf);
  i.forEach((a) => {
    const o = lf[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function TN() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Rb ? sf.forEach((r) => {
    n[r] = (...i) => {
      e && Ob(() => {
        Mr.console[r](`${EN}[${r}]:`, ...i);
      });
    };
  }) : sf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Ho = Fm("logger", TN);
function $N(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Rb && Ho.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Pb = 1e3;
function Im() {
  return Date.now() / Pb;
}
function DN() {
  const { performance: e } = Mr;
  if (!e || !e.now)
    return Im;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Pb;
}
const RN = DN();
(() => {
  const { performance: e } = Mr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Ii() {
  const e = Mr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function cf() {
  return {
    traceId: Ii(),
    spanId: Ii().substring(16)
  };
}
function Em() {
  return Tm(Mr), Mr;
}
function Tm(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Da, n[Da] = n[Da] || {};
}
function ON(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || RN(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Ii()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const qu = "_sentrySpan";
function df(e, n) {
  n ? $N(e, qu, n) : delete e[qu];
}
function uf(e) {
  return e[qu];
}
const PN = 100;
class $m {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = cf();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new $m();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, df(n, uf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && ON(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Oi ? [r.getScopeData(), r.getRequestSession()] : FN(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, df(this, void 0), this._attachments = [], this._propagationContext = cf(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : PN;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Im(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: uf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Ii();
    if (!this._client)
      return Ho.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Ii();
    if (!this._client)
      return Ho.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Ii();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Ho.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Oi = $m;
function AN() {
  return Fm("defaultCurrentScope", () => new Oi());
}
function LN() {
  return Fm("defaultIsolationScope", () => new Oi());
}
class VN {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Oi();
    let a;
    r ? a = r : a = new Oi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return IN(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Pi() {
  const e = Em(), n = Tm(e);
  return n.stack = n.stack || new VN(AN(), LN());
}
function zN(e) {
  return Pi().withScope(e);
}
function UN(e, n) {
  const r = Pi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function mf(e) {
  return Pi().withScope(() => e(Pi().getIsolationScope()));
}
function MN() {
  return {
    withIsolationScope: mf,
    withScope: zN,
    withSetScope: UN,
    withSetIsolationScope: (e, n) => mf(n),
    getCurrentScope: () => Pi().getScope(),
    getIsolationScope: () => Pi().getIsolationScope()
  };
}
function Ab(e) {
  const n = Tm(e);
  return n.acs ? n.acs : MN();
}
function Dm() {
  const e = Em();
  return Ab(e).getCurrentScope();
}
function Lb() {
  const e = Em();
  return Ab(e).getIsolationScope();
}
function BN() {
  return Dm().getClient();
}
function qN(e) {
  if (e)
    return HN(e) ? { captureContext: e } : KN(e) ? {
      captureContext: e
    } : e;
}
function HN(e) {
  return e instanceof Oi || typeof e == "function";
}
const WN = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function KN(e) {
  return Object.keys(e).some((n) => WN.includes(n));
}
function pf(e, n) {
  return Dm().captureException(e, qN(n));
}
function GN(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Dm().captureMessage(e, r, i);
}
function YN(e, n) {
  Lb().setContext(e, n);
}
const JN = 100;
function ti(e, n) {
  const r = BN(), i = Lb();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = JN } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Im(), ...e }, d = a ? Ob(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Ha;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Ha || (Ha = {}));
function Ei(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const QN = qa.backendDomain ? {
  "backend-domain": qa.backendDomain
} : void 0;
function Wo() {
  const e = new URLSearchParams({
    noToken: "true",
    ...QN
  }).toString();
  document.location.href = `${qa.url.logIn}?${e}`;
}
const Xs = "authData", Zs = 30, XN = 600, el = 5;
class ZN {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= el || this.clientServerTimeDiff <= -el ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + XN, a = Ei(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > el) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Xs, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Xs), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Xs);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Zs;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Ei(n), i = r.exp - Zs;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Zs - this.estimatedServerTime()) * 1e3;
  }
}
const bt = new ZN();
async function ej(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Ei(o).exp : "None", l = await Ds.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Ei(m).exp : "None", h = u ? Ei(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", S = typeof f == "number" ? d - f : "Unknown", N = typeof h == "number" ? d - h : "Unknown", F = e.response.headers["x-dixa-rid"];
      YN("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: S,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: N,
        xDixaRid: F,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    GN("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Ha.Platform,
        domain: n
      }
    });
  }
}
const nl = /* @__PURE__ */ new Map(), nj = 3;
function tj(e) {
  e.interceptors.response.use((n) => (nl.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Hu.Unauthorized:
          if (!Ds.isRefreshTokenExpired() && n.config) {
            ti({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = nl.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= nj)
              return nl.set(n.config.url, i + 1), e(n.config);
          }
          ej(n), console.error("401 unauthorized interceptor"), Wo();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Vb = dt.create();
tj(Vb);
const Pr = console.log;
async function ff(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class rj extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function ij(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const aj = 5;
class oj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      bt.setAuthData(r);
    else {
      const i = bt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new rj("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = bt.getAccessToken();
    if (!n)
      return {};
    const r = Ei(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return bt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = bt.getAuthData();
    return r ? bt.isAccessTokenExpired() ? (ti({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && bt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return bt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return bt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return bt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = bt.getAuthData();
    return n ? bt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!af.isElectron())
      return !0;
    const n = await af.getVersion();
    return jN(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = aj) {
    try {
      return await Vb.post(`${qa.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Pr("AUTH", "Network connection offline - waiting..."), ti({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await ff(5);
    n && (Pr("AUTH", "Network connection restored"), ti({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = ij(this.retryCount);
    return Pr("AUTH", `Retrying in ${i} seconds`), await ff(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (bt.isRefreshTokenExpired(r))
      return Pr("AUTH", "Refresh token expired"), ti({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), bt.removeAuthData(), Wo(), null;
    if (SN(n)) {
      if (n.message === "timeout exceeded")
        return Pr("AUTH", "Timeout exceeded"), ti({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Pr("AUTH", "Network error"), ti({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Pr("AUTH", "Refresh token invalid (401)"), bt.removeAuthData(), Wo(), null;
      pf(n, {
        level: "error",
        tags: {
          team: Ha.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Pr("AUTH", "Retries exhausted, logging out"), pf(n, {
      level: "error",
      tags: {
        team: Ha.Platform,
        errorSource: "authManager.refresh"
      }
    }), bt.removeAuthData(), Wo(), null) : (Pr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return bt.accessTokenExpiresInMs();
  }
}
const Ds = new oj();
var Hu;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Hu || (Hu = {}));
const sj = new Sm((e, n) => new lb((r) => {
  Ds.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), lj = new Sm(
  (e, n) => new lb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Ds.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...uS(qa.url.partnerIntegrations) && d?.access_token && mS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), cj = new AbortController(), zb = (e) => new RS({
  queryDeduplication: !1,
  cache: new OS(),
  link: Sm.from([
    sj,
    lj,
    PS({
      uri: `${e}/graphql`,
      fetch: MS,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: cj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), dj = ({
  configuration: e,
  children: n
}) => {
  const r = et(
    () => zb(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ue.jsx(AS, { client: r, children: n });
};
function uj() {
  try {
    return LS(), !0;
  } catch {
    return !1;
  }
}
const mj = ({
  configuration: e,
  children: n
}) => uj() ? n : /* @__PURE__ */ Ue.jsx(dj, { configuration: e, children: n }), pj = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ue.jsx(VS, { children: (o) => /* @__PURE__ */ Ue.jsx(
  pS,
  {
    value: {
      useMutation: gS(e, n),
      useQuery: yS(e, n),
      useLazyQuery: hS(e, n),
      executeQuery: fS(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Ub = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ue.jsx(mj, { configuration: r, children: s ? /* @__PURE__ */ Ue.jsx(
    pj,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, fj = Qr`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function hj(e) {
  const [n, r] = se([]), [i, a] = se(!1);
  return qe(() => {
    a(!0), zb(e).query({
      query: fj
    }).then(({ data: o }) => {
      r(o?.Management?.widgetConfigurations), a(!1);
    }).catch(() => a(!1));
  }, [e]), {
    isLoading: i,
    widgets: n
  };
}
const Mb = ({
  headline: e,
  text: n,
  children: r,
  onConfirm: i,
  onCancel: a,
  confirmLabel: o,
  cancelLabel: s = "Cancel",
  confirmVariant: l = "primary",
  cancelVariant: d = "secondary",
  isOpen: m,
  setIsOpen: u,
  showOnClose: f = !1
}) => /* @__PURE__ */ Ue.jsxs(
  gt,
  {
    isOpen: m,
    onClose: () => {
      a && a(), u(!1);
    },
    children: [
      /* @__PURE__ */ Ue.jsx(
        kt,
        {
          title: e,
          onClose: f ? a : void 0
        }
      ),
      /* @__PURE__ */ Ue.jsxs(vt, { children: [
        n && /* @__PURE__ */ Ue.jsx("div", { style: { width: "600px" }, children: n }),
        r
      ] }),
      /* @__PURE__ */ Ue.jsx(
        wt,
        {
          confirmOnClick: i ? () => {
            i(), u(!1);
          } : void 0,
          cancelOnClick: () => {
            a && a(), u(!1);
          },
          confirmName: o,
          cancelName: s,
          confirmProps: { variant: l },
          cancelProps: { variant: d }
        }
      )
    ]
  }
);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var tl = { exports: {} }, Qi = {}, hf;
function yj() {
  if (hf) return Qi;
  hf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Qi.Fragment = r, Qi.jsx = s, Qi.jsxs = s, Qi;
}
var mo = {}, yf;
function gj() {
  return yf || (yf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    mo.Fragment = i, mo.jsx = Bn, mo.jsxs = qn;
  })()), mo;
}
var gf;
function kj() {
  return gf || (gf = 1, process.env.NODE_ENV === "production" ? tl.exports = yj() : tl.exports = gj()), tl.exports;
}
var ae = kj();
const vj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, bj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, _j = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": vj,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": bj
};
function Bb(e) {
  return _j[e] ?? {};
}
const xj = Bb(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), Sj = Bb(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), Nj = "_copyIcon_1wjfs_48", jj = "_list_1wjfs_53", wj = "_listItem_1wjfs_63", Cj = "_collapsible_1wjfs_72", Fj = "_collapsibleIsOpen_1wjfs_80", Ij = "_collapsibleHeader_1wjfs_83", Ej = "_collapsibleIconTrue_1wjfs_86", Tj = "_collapsibleIconFalse_1wjfs_89", Dn = {
  copyIcon: Nj,
  list: jj,
  listItem: wj,
  collapsible: Cj,
  collapsibleIsOpen: Fj,
  collapsibleHeader: Ij,
  collapsibleIconTrue: Ej,
  collapsibleIconFalse: Tj
}, $j = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ct(Dn.collapsible, {
        [Dn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Dn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ae.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(He, { className: Dn.list, children: [
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(d).format(lt) })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(m).format(lt) })
          ] }) })
        ] })
      ]
    }
  );
}, Dj = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx($j, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Rj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ae.jsx(
      He.Text,
      {
        variant: "dense",
        className: Dn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: i }),
          rb(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Oj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      He.Text,
      {
        variant: "dense",
        className: Dn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Pn(a?.first).format(
                  lt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Pn(a?.last).format(
                  lt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, as = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: n ? null : l(), children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(ue, { size: 14, name: o(), color: s() }) }) });
}, Pj = "_wrapper_1xucg_1", Aj = "_externalLink_1xucg_7", rl = {
  wrapper: Pj,
  externalLink: Aj
}, Lj = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Xt(), { isCopied: i, copy: a } = Xt(), { isCopied: o, copy: s } = Xt(), { isCopied: l, copy: d } = Xt(), { isCopied: m, copy: u } = Xt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: S,
    home_city: N,
    country: F,
    email: I,
    phone: g,
    dob: q,
    created_at: $,
    email_subscribe: C,
    push_subscribe: D
  } = e, U = 14, Z = `${v || ""} ${S || ""}`.trim() || "A customer has no name", Q = `${N ? `${N} /` : ""} ${F || ""}`.trim(), ee = q ? Pn(q).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { className: rl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: rl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-2", children: Z }),
          ee && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    $ && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Pn($).format(lt) })
    ] }),
    Q && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "map-pin" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Q })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy location", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(Q),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "mail" }),
        /* @__PURE__ */ ae.jsx("span", { className: rl.externalLink, children: I })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(I),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "phone" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "user" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy Braze ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "tag" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ke, { content: "Copy External ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Dn.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(as, { state: C })
    ] }),
    D && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "bell" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(as, { isPush: !0, state: D })
    ] })
  ] }) });
}, Vj = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ct(Dn.collapsible, {
        [Dn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Dn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ae.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(He, { className: Dn.list, children: [
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ae.jsx(
              ue,
              {
                size: a,
                className: ct({
                  [Dn.collapsibleIconTrue]: d,
                  [Dn.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ke, { content: "For iOS", children: /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, zj = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Vj, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Xi = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, po = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = kn(), { useMutation: a } = mn(), [o, s] = se(!1), [l] = a(
    Sj,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Xi[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ae.jsx(Ke, { content: Xi[n].tooltipContent, children: /* @__PURE__ */ ae.jsx(
    Wn,
    {
      variant: "secondary",
      color: Xi[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(
          as,
          {
            noTooltip: !0,
            state: Xi[n].parameter
          }
        ),
        Xi[n].label
      ] })
    }
  ) });
}, Uj = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: /* @__PURE__ */ ae.jsx(He.Text, { variant: "dense", className: Dn.listItem, children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: 14, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(as, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
        /* @__PURE__ */ ae.jsx(
          po,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ae.jsx(
          po,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ae.jsx(
        po,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ae.jsx(
        po,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Mj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ae.jsx(He, { className: Dn.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      He.Text,
      {
        variant: "dense",
        className: Dn.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ke,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Pn(a?.first).format(
                  lt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Pn(a?.last).format(
                  lt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Bj = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), { useMutation: i } = mn(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, S = n.displayCustomAttributes ?? !1, N = n.displayCustomEvents ?? !1, F = n.displayPuchases ?? !1, I = n.displayDevices ?? !1, g = n.displayApps ?? !1, q = !h && !v && !S && !N && !F, [$, { error: C }] = i(
    xj,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Z = U?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), D = async () => {
    u || f ? await $({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (qe(() => {
    async function U() {
      m(!0), await D();
    }
    U().finally(() => m(!1));
  }, [u, f]), C) {
    const U = C.graphQLErrors;
    return gm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : km({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ae.jsx(wn, { error: C });
  }
  return d ? /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ae.jsx(un, {}) }) : q ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ae.jsx(Lj, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ ae.jsx(
          Uj,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await D()
          }
        ),
        S && !!a && /* @__PURE__ */ ae.jsx(Rj, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ ae.jsx(Oj, { customerDetails: a }),
        F && !!a && /* @__PURE__ */ ae.jsx(Mj, { customerDetails: a }),
        I && !!a && /* @__PURE__ */ ae.jsx(zj, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ ae.jsx(Dj, { apps: a?.apps })
      ]
    }
  );
}, qj = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => tb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Hj() {
  var e = Fi(!1), n = pt(function() {
    return e.current;
  }, []);
  return qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Wj = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = pt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, Kj = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, kf = function(e) {
  return SS(Kj, e);
}, il, vf;
function Gj() {
  return vf || (vf = 1, il = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), il;
}
var al, bf;
function Yj() {
  if (bf) return al;
  bf = 1;
  var e = Gj(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(N) {
        if (N.stopPropagation(), s.format)
          if (N.preventDefault(), typeof N.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var F = n[s.format] || n.default;
            window.clipboardData.setData(F, o);
          } else
            N.clipboardData.clearData(), N.clipboardData.setData(s.format, o);
        s.onCopy && (N.preventDefault(), s.onCopy(N.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var S = document.execCommand("copy");
      if (!S)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (N) {
      l && console.error("unable to copy using execCommand: ", N), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (F) {
        l && console.error("unable to copy using clipboardData: ", F), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return al = a, al;
}
var Jj = Yj();
const Qj = /* @__PURE__ */ Nm(Jj);
var qb = function() {
  var e = Hj(), n = Wj({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = pt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = Qj(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function Xj(e, n) {
  var r = Fi(!1), i = Fi(), a = Fi(e), o = pt(function() {
    return r.current;
  }, []), s = pt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = pt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return qe(function() {
    a.current = e;
  }, [e]), qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Ui(e, n, r) {
  r === void 0 && (r = []);
  var i = Xj(e, n), a = i[0], o = i[1], s = i[2];
  return qe(s, r), [a, o];
}
var Zj = function(e) {
  qe(e, []);
}, ew = function(e, n) {
  var r = Fi(function() {
  });
  qe(function() {
    r.current = e;
  }), qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, nw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = et(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return Gs(Gs({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = BS(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Gs({ get: pt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, tw = function(e) {
  var n = Fi(e);
  n.current = e, Zj(function() {
    return function() {
      return n.current();
    };
  });
}, no = (e) => e.type === "checkbox", si = (e) => e instanceof Date, Dt = (e) => e == null;
const Hb = (e) => typeof e == "object";
var at = (e) => !Dt(e) && !Array.isArray(e) && Hb(e) && !si(e), Wb = (e) => at(e) && e.target ? no(e.target) ? e.target.checked : e.target.value : e, rw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Kb = (e, n) => e.has(rw(n)), iw = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return at(n) && n.hasOwnProperty("isPrototypeOf");
}, Rm = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Rm && (e instanceof Blob || i)) && (r || at(e)))
    if (n = r ? [] : {}, !r && !iw(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = xt(e[a]));
  else
    return e;
  return n;
}
var Rs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], tt = (e) => e === void 0, Ye = (e, n, r) => {
  if (!n || !at(e))
    return r;
  const i = Rs(n.split(/[,[\].]+?/)).reduce((a, o) => Dt(a) ? a : a[o], e);
  return tt(i) || i === e ? tt(e[n]) ? r : e[n] : i;
}, Yt = (e) => typeof e == "boolean", Om = (e) => /^\w*$/.test(e), Gb = (e) => Rs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Kn = (e, n, r) => {
  let i = -1;
  const a = Om(n) ? [n] : Gb(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = at(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const os = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, mr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ar = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Yb = Se.createContext(null), Rr = () => Se.useContext(Yb), Pm = (e) => {
  const { children: n, ...r } = e;
  return Se.createElement(Yb.Provider, { value: r }, n);
};
var Jb = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== mr.all && (n._proxyFormState[s] = !i || mr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function aw(e) {
  const n = Rr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => Jb(s, r, d.current, !1), [s, r]);
}
var Ir = (e) => typeof e == "string", Qb = (e, n, r, i, a) => Ir(e) ? (i && n.watch.add(e), Ye(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(r, o))) : (i && (n.watchAll = !0), r);
function Ko(e) {
  const n = Rr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Qb(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function Am(e) {
  const n = Rr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Kb(a._names.array, r), l = Ko({
    control: a,
    name: r,
    defaultValue: Ye(a._formValues, r, Ye(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = aw({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Yt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ye(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((F) => u.current.onChange({
    target: {
      value: Wb(F),
      name: r
    },
    type: os.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Ye(a._formValues, r),
      name: r
    },
    type: os.BLUR
  }), [r, a._formValues]), S = Se.useCallback((F) => {
    const I = Ye(a._fields, r);
    I && F && (I._f.ref = {
      focus: () => F.focus(),
      select: () => F.select(),
      setCustomValidity: (g) => F.setCustomValidity(g),
      reportValidity: () => F.reportValidity()
    });
  }, [a._fields, r]), N = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Yt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: S
  }), [r, i, d.disabled, h, v, S, l]);
  return Se.useEffect(() => {
    const F = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Yt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const I = (g, q) => {
      const $ = Ye(a._fields, g);
      $ && $._f && ($._f.mount = q);
    };
    if (I(r, !0), F) {
      const g = xt(Ye(a._options.defaultValues, r));
      Kn(a._defaultValues, r, g), tt(Ye(a._formValues, r)) && Kn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? F && !a._state.action : F) ? a.unregister(r) : I(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const Pt = (e) => e.render(Am(e));
var ow = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ra = (e) => Array.isArray(e) ? e : [e], _f = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Wu = (e) => Dt(e) || !Hb(e);
function Gr(e, n) {
  if (Wu(e) || Wu(n))
    return e === n;
  if (si(e) && si(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (si(o) && si(s) || at(o) && at(s) || Array.isArray(o) && Array.isArray(s) ? !Gr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Et = (e) => at(e) && !Object.keys(e).length, Lm = (e) => e.type === "file", pr = (e) => typeof e == "function", ss = (e) => {
  if (!Rm)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Xb = (e) => e.type === "select-multiple", Vm = (e) => e.type === "radio", sw = (e) => Vm(e) || no(e), ol = (e) => ss(e) && e.isConnected;
function lw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = tt(e) ? i++ : e[n[i++]];
  return e;
}
function cw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !tt(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const r = Array.isArray(n) ? n : Om(n) ? [n] : Gb(n), i = r.length === 1 ? e : lw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (at(i) && Et(i) || Array.isArray(i) && cw(i)) && ft(e, r.slice(0, -1)), e;
}
var Zb = (e) => {
  for (const n in e)
    if (pr(e[n]))
      return !0;
  return !1;
};
function ls(e, n = {}) {
  const r = Array.isArray(e);
  if (at(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || at(e[i]) && !Zb(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ls(e[i], n[i])) : Dt(e[i]) || (n[i] = !0);
  return n;
}
function e_(e, n, r) {
  const i = Array.isArray(e);
  if (at(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || at(e[a]) && !Zb(e[a]) ? tt(n) || Wu(r[a]) ? r[a] = Array.isArray(e[a]) ? ls(e[a], []) : { ...ls(e[a]) } : e_(e[a], Dt(n) ? {} : n[a], r[a]) : r[a] = !Gr(e[a], n[a]);
  return r;
}
var Zi = (e, n) => e_(e, n, ls(n));
const xf = {
  value: !1,
  isValid: !1
}, Sf = { value: !0, isValid: !0 };
var n_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !tt(e[0].attributes.value) ? tt(e[0].value) || e[0].value === "" ? Sf : { value: e[0].value, isValid: !0 } : Sf
    ) : xf;
  }
  return xf;
}, t_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => tt(e) ? e : n ? e === "" ? NaN : e && +e : r && Ir(e) ? new Date(e) : i ? i(e) : e;
const Nf = {
  isValid: !1,
  value: null
};
var r_ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Nf) : Nf;
function jf(e) {
  const n = e.ref;
  return Lm(n) ? n.files : Vm(n) ? r_(e.refs).value : Xb(n) ? [...n.selectedOptions].map(({ value: r }) => r) : no(n) ? n_(e.refs).value : t_(tt(n.value) ? e.ref.value : n.value, e);
}
var dw = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Kn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, cs = (e) => e instanceof RegExp, ea = (e) => tt(e) ? e : cs(e) ? e.source : at(e) ? cs(e.value) ? e.value.source : e.value : e, wf = (e) => ({
  isOnSubmit: !e || e === mr.onSubmit,
  isOnBlur: e === mr.onBlur,
  isOnChange: e === mr.onChange,
  isOnAll: e === mr.all,
  isOnTouch: e === mr.onTouched
});
const Cf = "AsyncFunction";
var uw = (e) => !!e && !!e.validate && !!(pr(e.validate) && e.validate.constructor.name === Cf || at(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Cf)), mw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Ff = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Oa = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Oa(l, n))
          break;
      } else if (at(l) && Oa(l, n))
        break;
    }
  }
};
function If(e, n, r) {
  const i = Ye(e, r);
  if (i || Om(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var pw = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Et(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || mr.all));
}, fw = (e, n, r) => !e || !n || e === n || Ra(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), hw = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, yw = (e, n) => !Rs(Ye(e, n)).length && ft(e, n), gw = (e, n, r) => {
  const i = Ra(Ye(e, r));
  return Kn(i, "root", n[r]), Kn(e, r, i), e;
}, Go = (e) => Ir(e);
function Ef(e, n, r = "validate") {
  if (Go(e) || Array.isArray(e) && e.every(Go) || Yt(e) && !e)
    return {
      type: r,
      message: Go(e) ? e : "",
      ref: n
    };
}
var vi = (e) => at(e) && !cs(e) ? e : {
  value: e,
  message: ""
}, Tf = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: S, name: N, valueAsNumber: F, mount: I } = e._f, g = Ye(r, N);
  if (!I || n.has(N))
    return {};
  const q = l ? l[0] : s, $ = (G) => {
    a && q.reportValidity && (q.setCustomValidity(Yt(G) ? "" : G || ""), q.reportValidity());
  }, C = {}, D = Vm(s), U = no(s), Z = D || U, Q = (F || Lm(s)) && tt(s.value) && tt(g) || ss(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = ow.bind(null, N, i, C), J = (G, P, W, ne = Ar.maxLength, ke = Ar.minLength) => {
    const me = G ? P : W;
    C[N] = {
      type: G ? ne : ke,
      message: me,
      ref: s,
      ...ee(G ? ne : ke, me)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Dt(g)) || Yt(g) && !g || U && !n_(l).isValid || D && !r_(l).isValid)) {
    const { value: G, message: P } = Go(d) ? { value: !!d, message: d } : vi(d);
    if (G && (C[N] = {
      type: Ar.required,
      message: P,
      ref: q,
      ...ee(Ar.required, P)
    }, !i))
      return $(P), C;
  }
  if (!Q && (!Dt(f) || !Dt(h))) {
    let G, P;
    const W = vi(h), ne = vi(f);
    if (!Dt(g) && !isNaN(g)) {
      const ke = s.valueAsNumber || g && +g;
      Dt(W.value) || (G = ke > W.value), Dt(ne.value) || (P = ke < ne.value);
    } else {
      const ke = s.valueAsDate || new Date(g), me = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), de = s.type == "time", he = s.type == "week";
      Ir(W.value) && g && (G = de ? me(g) > me(W.value) : he ? g > W.value : ke > new Date(W.value)), Ir(ne.value) && g && (P = de ? me(g) < me(ne.value) : he ? g < ne.value : ke < new Date(ne.value));
    }
    if ((G || P) && (J(!!G, W.message, ne.message, Ar.max, Ar.min), !i))
      return $(C[N].message), C;
  }
  if ((m || u) && !Q && (Ir(g) || o && Array.isArray(g))) {
    const G = vi(m), P = vi(u), W = !Dt(G.value) && g.length > +G.value, ne = !Dt(P.value) && g.length < +P.value;
    if ((W || ne) && (J(W, G.message, P.message), !i))
      return $(C[N].message), C;
  }
  if (v && !Q && Ir(g)) {
    const { value: G, message: P } = vi(v);
    if (cs(G) && !g.match(G) && (C[N] = {
      type: Ar.pattern,
      message: P,
      ref: s,
      ...ee(Ar.pattern, P)
    }, !i))
      return $(P), C;
  }
  if (S) {
    if (pr(S)) {
      const G = await S(g, r), P = Ef(G, q);
      if (P && (C[N] = {
        ...P,
        ...ee(Ar.validate, P.message)
      }, !i))
        return $(P.message), C;
    } else if (at(S)) {
      let G = {};
      for (const P in S) {
        if (!Et(G) && !i)
          break;
        const W = Ef(await S[P](g, r), q, P);
        W && (G = {
          ...W,
          ...ee(P, W.message)
        }, $(W.message), i && (C[N] = G));
      }
      if (!Et(G) && (C[N] = {
        ref: q,
        ...G
      }, !i))
        return C;
    }
  }
  return $(!0), C;
};
const kw = {
  mode: mr.onSubmit,
  reValidateMode: mr.onChange,
  shouldFocusError: !0
};
function vw(e = {}) {
  let n = {
    ...kw,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: pr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = at(n.defaultValues) || at(n.values) ? xt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : xt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: _f(),
    state: _f()
  }, v = wf(n.mode), S = wf(n.reValidateMode), N = n.criteriaMode === mr.all, F = (_) => (T) => {
    clearTimeout(m), m = setTimeout(_, T);
  }, I = async (_) => {
    if (!n.disabled && (u.isValid || f.isValid || _)) {
      const T = n.resolver ? Et((await Q()).errors) : await J(i, !0);
      T !== r.isValid && h.state.next({
        isValid: T
      });
    }
  }, g = (_, T) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((Y) => {
      Y && (T ? Kn(r.validatingFields, Y, T) : ft(r.validatingFields, Y));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Et(r.validatingFields)
    }));
  }, q = (_, T = [], Y, X, O = !0, B = !0) => {
    if (X && Y && !n.disabled) {
      if (s.action = !0, B && Array.isArray(Ye(i, _))) {
        const ie = Y(Ye(i, _), X.argA, X.argB);
        O && Kn(i, _, ie);
      }
      if (B && Array.isArray(Ye(r.errors, _))) {
        const ie = Y(Ye(r.errors, _), X.argA, X.argB);
        O && Kn(r.errors, _, ie), yw(r.errors, _);
      }
      if ((u.touchedFields || f.touchedFields) && B && Array.isArray(Ye(r.touchedFields, _))) {
        const ie = Y(Ye(r.touchedFields, _), X.argA, X.argB);
        O && Kn(r.touchedFields, _, ie);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Zi(a, o)), h.state.next({
        name: _,
        isDirty: P(_, T),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Kn(o, _, T);
  }, $ = (_, T) => {
    Kn(r.errors, _, T), h.state.next({
      errors: r.errors
    });
  }, C = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (_, T, Y, X) => {
    const O = Ye(i, _);
    if (O) {
      const B = Ye(o, _, tt(Y) ? Ye(a, _) : Y);
      tt(B) || X && X.defaultChecked || T ? Kn(o, _, T ? B : jf(O._f)) : ke(_, B), s.mount && I();
    }
  }, U = (_, T, Y, X, O) => {
    let B = !1, ie = !1;
    const fe = {
      name: _
    };
    if (!n.disabled) {
      if (!Y || X) {
        (u.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = fe.isDirty = P(), B = ie !== fe.isDirty);
        const _e = Gr(Ye(a, _), T);
        ie = !!Ye(r.dirtyFields, _), _e ? ft(r.dirtyFields, _) : Kn(r.dirtyFields, _, !0), fe.dirtyFields = r.dirtyFields, B = B || (u.dirtyFields || f.dirtyFields) && ie !== !_e;
      }
      if (Y) {
        const _e = Ye(r.touchedFields, _);
        _e || (Kn(r.touchedFields, _, Y), fe.touchedFields = r.touchedFields, B = B || (u.touchedFields || f.touchedFields) && _e !== Y);
      }
      B && O && h.state.next(fe);
    }
    return B ? fe : {};
  }, Z = (_, T, Y, X) => {
    const O = Ye(r.errors, _), B = (u.isValid || f.isValid) && Yt(T) && r.isValid !== T;
    if (n.delayError && Y ? (d = F(() => $(_, Y)), d(n.delayError)) : (clearTimeout(m), d = null, Y ? Kn(r.errors, _, Y) : ft(r.errors, _)), (Y ? !Gr(O, Y) : O) || !Et(X) || B) {
      const ie = {
        ...X,
        ...B && Yt(T) ? { isValid: T } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, Q = async (_) => {
    g(_, !0);
    const T = await n.resolver(o, n.context, dw(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(_), T;
  }, ee = async (_) => {
    const { errors: T } = await Q(_);
    if (_)
      for (const Y of _) {
        const X = Ye(T, Y);
        X ? Kn(r.errors, Y, X) : ft(r.errors, Y);
      }
    else
      r.errors = T;
    return T;
  }, J = async (_, T, Y = {
    valid: !0
  }) => {
    for (const X in _) {
      const O = _[X];
      if (O) {
        const { _f: B, ...ie } = O;
        if (B) {
          const fe = l.array.has(B.name), _e = O._f && uw(O._f);
          _e && u.validatingFields && g([X], !0);
          const en = await Tf(O, l.disabled, o, N, n.shouldUseNativeValidation && !T, fe);
          if (_e && u.validatingFields && g([X]), en[B.name] && (Y.valid = !1, T))
            break;
          !T && (Ye(en, B.name) ? fe ? gw(r.errors, en, B.name) : Kn(r.errors, B.name, en[B.name]) : ft(r.errors, B.name));
        }
        !Et(ie) && await J(ie, T, Y);
      }
    }
    return Y.valid;
  }, G = () => {
    for (const _ of l.unMount) {
      const T = Ye(i, _);
      T && (T._f.refs ? T._f.refs.every((Y) => !ol(Y)) : !ol(T._f.ref)) && Le(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (_, T) => !n.disabled && (_ && T && Kn(o, _, T), !Gr(Ce(), a)), W = (_, T, Y) => Qb(_, l, {
    ...s.mount ? o : tt(T) ? a : Ir(_) ? { [_]: T } : T
  }, Y, T), ne = (_) => Rs(Ye(s.mount ? o : a, _, n.shouldUnregister ? Ye(a, _, []) : [])), ke = (_, T, Y = {}) => {
    const X = Ye(i, _);
    let O = T;
    if (X) {
      const B = X._f;
      B && (!B.disabled && Kn(o, _, t_(T, B)), O = ss(B.ref) && Dt(T) ? "" : T, Xb(B.ref) ? [...B.ref.options].forEach((ie) => ie.selected = O.includes(ie.value)) : B.refs ? no(B.ref) ? B.refs.length > 1 ? B.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(O) ? !!O.find((fe) => fe === ie.value) : O === ie.value)) : B.refs[0] && (B.refs[0].checked = !!O) : B.refs.forEach((ie) => ie.checked = ie.value === O) : Lm(B.ref) ? B.ref.value = "" : (B.ref.value = O, B.ref.type || h.state.next({
        name: _,
        values: xt(o)
      })));
    }
    (Y.shouldDirty || Y.shouldTouch) && U(_, O, Y.shouldTouch, Y.shouldDirty, !0), Y.shouldValidate && be(_);
  }, me = (_, T, Y) => {
    for (const X in T) {
      const O = T[X], B = `${_}.${X}`, ie = Ye(i, B);
      (l.array.has(_) || at(O) || ie && !ie._f) && !si(O) ? me(B, O, Y) : ke(B, O, Y);
    }
  }, de = (_, T, Y = {}) => {
    const X = Ye(i, _), O = l.array.has(_), B = xt(T);
    Kn(o, _, B), O ? (h.array.next({
      name: _,
      values: xt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && Y.shouldDirty && h.state.next({
      name: _,
      dirtyFields: Zi(a, o),
      isDirty: P(_, B)
    })) : X && !X._f && !Dt(B) ? me(_, B, Y) : ke(_, B, Y), Ff(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: xt(o)
    });
  }, he = async (_) => {
    s.mount = !0;
    const T = _.target;
    let Y = T.name, X = !0;
    const O = Ye(i, Y), B = (ie) => {
      X = Number.isNaN(ie) || si(ie) && isNaN(ie.getTime()) || Gr(ie, Ye(o, Y, ie));
    };
    if (O) {
      let ie, fe;
      const _e = T.type ? jf(O._f) : Wb(_), en = _.type === os.BLUR || _.type === os.FOCUS_OUT, dn = !mw(O._f) && !n.resolver && !Ye(r.errors, Y) && !O._f.deps || hw(en, Ye(r.touchedFields, Y), r.isSubmitted, S, v), tn = Ff(Y, l, en);
      Kn(o, Y, _e), en ? (O._f.onBlur && O._f.onBlur(_), d && d(0)) : O._f.onChange && O._f.onChange(_);
      const sn = U(Y, _e, en), fn = !Et(sn) || tn;
      if (!en && h.state.next({
        name: Y,
        type: _.type,
        values: xt(o)
      }), dn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? en && I() : en || I()), fn && h.state.next({ name: Y, ...tn ? {} : sn });
      if (!en && tn && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Q([Y]);
        if (B(_e), X) {
          const yn = If(r.errors, i, Y), Xe = If(pn, i, yn.name || Y);
          ie = Xe.error, Y = Xe.name, fe = Et(pn);
        }
      } else
        g([Y], !0), ie = (await Tf(O, l.disabled, o, N, n.shouldUseNativeValidation))[Y], g([Y]), B(_e), X && (ie ? fe = !1 : (u.isValid || f.isValid) && (fe = await J(i, !0)));
      X && (O._f.deps && be(O._f.deps), Z(Y, fe, ie, sn));
    }
  }, H = (_, T) => {
    if (Ye(r.errors, T) && _.focus)
      return _.focus(), 1;
  }, be = async (_, T = {}) => {
    let Y, X;
    const O = Ra(_);
    if (n.resolver) {
      const B = await ee(tt(_) ? _ : O);
      Y = Et(B), X = _ ? !O.some((ie) => Ye(B, ie)) : Y;
    } else _ ? (X = (await Promise.all(O.map(async (B) => {
      const ie = Ye(i, B);
      return await J(ie && ie._f ? { [B]: ie } : ie);
    }))).every(Boolean), !(!X && !r.isValid) && I()) : X = Y = await J(i);
    return h.state.next({
      ...!Ir(_) || (u.isValid || f.isValid) && Y !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: Y } : {},
      errors: r.errors
    }), T.shouldFocus && !X && Oa(i, H, _ ? O : l.mount), X;
  }, Ce = (_) => {
    const T = {
      ...s.mount ? o : a
    };
    return tt(_) ? T : Ir(_) ? Ye(T, _) : _.map((Y) => Ye(T, Y));
  }, K = (_, T) => ({
    invalid: !!Ye((T || r).errors, _),
    isDirty: !!Ye((T || r).dirtyFields, _),
    error: Ye((T || r).errors, _),
    isValidating: !!Ye(r.validatingFields, _),
    isTouched: !!Ye((T || r).touchedFields, _)
  }), ze = (_) => {
    _ && Ra(_).forEach((T) => ft(r.errors, T)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Be = (_, T, Y) => {
    const X = (Ye(i, _, { _f: {} })._f || {}).ref, O = Ye(r.errors, _) || {}, { ref: B, message: ie, type: fe, ..._e } = O;
    Kn(r.errors, _, {
      ..._e,
      ...T,
      ref: X
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), Y && Y.shouldFocus && X && X.focus && X.focus();
  }, Pe = (_, T) => pr(_) ? h.state.subscribe({
    next: (Y) => _(W(void 0, T), Y)
  }) : W(_, T, !0), Me = (_) => h.state.subscribe({
    next: (T) => {
      fw(_.name, T.name, _.exact) && pw(T, _.formState || u, Ee, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...T
      });
    }
  }).unsubscribe, Ie = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Me({
    ..._,
    formState: f
  })), Le = (_, T = {}) => {
    for (const Y of _ ? Ra(_) : l.mount)
      l.mount.delete(Y), l.array.delete(Y), T.keepValue || (ft(i, Y), ft(o, Y)), !T.keepError && ft(r.errors, Y), !T.keepDirty && ft(r.dirtyFields, Y), !T.keepTouched && ft(r.touchedFields, Y), !T.keepIsValidating && ft(r.validatingFields, Y), !n.shouldUnregister && !T.keepDefaultValue && ft(a, Y);
    h.state.next({
      values: xt(o)
    }), h.state.next({
      ...r,
      ...T.keepDirty ? { isDirty: P() } : {}
    }), !T.keepIsValid && I();
  }, De = ({ disabled: _, name: T }) => {
    (Yt(_) && s.mount || _ || l.disabled.has(T)) && (_ ? l.disabled.add(T) : l.disabled.delete(T));
  }, rn = (_, T = {}) => {
    let Y = Ye(i, _);
    const X = Yt(T.disabled) || Yt(n.disabled);
    return Kn(i, _, {
      ...Y || {},
      _f: {
        ...Y && Y._f ? Y._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...T
      }
    }), l.mount.add(_), Y ? De({
      disabled: Yt(T.disabled) ? T.disabled : n.disabled,
      name: _
    }) : D(_, !0, T.value), {
      ...X ? { disabled: T.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!T.required,
        min: ea(T.min),
        max: ea(T.max),
        minLength: ea(T.minLength),
        maxLength: ea(T.maxLength),
        pattern: ea(T.pattern)
      } : {},
      name: _,
      onChange: he,
      onBlur: he,
      ref: (O) => {
        if (O) {
          rn(_, T), Y = Ye(i, _);
          const B = tt(O.value) && O.querySelectorAll && O.querySelectorAll("input,select,textarea")[0] || O, ie = sw(B), fe = Y._f.refs || [];
          if (ie ? fe.find((_e) => _e === B) : B === Y._f.ref)
            return;
          Kn(i, _, {
            _f: {
              ...Y._f,
              ...ie ? {
                refs: [
                  ...fe.filter(ol),
                  B,
                  ...Array.isArray(Ye(a, _)) ? [{}] : []
                ],
                ref: { type: B.type, name: _ }
              } : { ref: B }
            }
          }), D(_, !1, void 0, B);
        } else
          Y = Ye(i, _, {}), Y._f && (Y._f.mount = !1), (n.shouldUnregister || T.shouldUnregister) && !(Kb(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, je = () => n.shouldFocusError && Oa(i, H, l.mount), We = (_) => {
    Yt(_) && (h.state.next({ disabled: _ }), Oa(i, (T, Y) => {
      const X = Ye(i, Y);
      X && (T.disabled = X._f.disabled || _, Array.isArray(X._f.refs) && X._f.refs.forEach((O) => {
        O.disabled = X._f.disabled || _;
      }));
    }, 0, !1));
  }, Ge = (_, T) => async (Y) => {
    let X;
    Y && (Y.preventDefault && Y.preventDefault(), Y.persist && Y.persist());
    let O = xt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: B, values: ie } = await Q();
      r.errors = B, O = ie;
    } else
      await J(i);
    if (l.disabled.size)
      for (const B of l.disabled)
        Kn(O, B, void 0);
    if (ft(r.errors, "root"), Et(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(O, Y);
      } catch (B) {
        X = B;
      }
    } else
      T && await T({ ...r.errors }, Y), je(), setTimeout(je);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Et(r.errors) && !X,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), X)
      throw X;
  }, pe = (_, T = {}) => {
    Ye(i, _) && (tt(T.defaultValue) ? de(_, xt(Ye(a, _))) : (de(_, T.defaultValue), Kn(a, _, xt(T.defaultValue))), T.keepTouched || ft(r.touchedFields, _), T.keepDirty || (ft(r.dirtyFields, _), r.isDirty = T.defaultValue ? P(_, xt(Ye(a, _))) : P()), T.keepError || (ft(r.errors, _), u.isValid && I()), h.state.next({ ...r }));
  }, le = (_, T = {}) => {
    const Y = _ ? xt(_) : a, X = xt(Y), O = Et(_), B = O ? a : X;
    if (T.keepDefaultValues || (a = Y), !T.keepValues) {
      if (T.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Zi(a, o))
        ]);
        for (const fe of Array.from(ie))
          Ye(r.dirtyFields, fe) ? Kn(B, fe, Ye(o, fe)) : de(fe, Ye(B, fe));
      } else {
        if (Rm && tt(_))
          for (const ie of l.mount) {
            const fe = Ye(i, ie);
            if (fe && fe._f) {
              const _e = Array.isArray(fe._f.refs) ? fe._f.refs[0] : fe._f.ref;
              if (ss(_e)) {
                const en = _e.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          de(ie, Ye(B, ie));
      }
      o = xt(B), h.array.next({
        values: { ...B }
      }), h.state.next({
        values: { ...B }
      });
    }
    l = {
      mount: T.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!T.keepIsValid || !!T.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: T.keepSubmitCount ? r.submitCount : 0,
      isDirty: O ? !1 : T.keepDirty ? r.isDirty : !!(T.keepDefaultValues && !Gr(_, a)),
      isSubmitted: T.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: O ? {} : T.keepDirtyValues ? T.keepDefaultValues && o ? Zi(a, o) : r.dirtyFields : T.keepDefaultValues && _ ? Zi(a, _) : T.keepDirty ? r.dirtyFields : {},
      touchedFields: T.keepTouched ? r.touchedFields : {},
      errors: T.keepErrors ? r.errors : {},
      isSubmitSuccessful: T.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (_, T) => le(pr(_) ? _(o) : _, T), Ae = (_, T = {}) => {
    const Y = Ye(i, _), X = Y && Y._f;
    if (X) {
      const O = X.refs ? X.refs[0] : X.ref;
      O.focus && (O.focus(), T.shouldSelect && pr(O.select) && O.select());
    }
  }, Ee = (_) => {
    r = {
      ...r,
      ..._
    };
  }, j = {
    control: {
      register: rn,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Ge,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: W,
      _getDirty: P,
      _setValid: I,
      _setFieldArray: q,
      _setDisabledField: De,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: le,
      _resetDefaultValues: () => pr(n.defaultValues) && n.defaultValues().then((_) => {
        Ne(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: G,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: Ie,
    trigger: be,
    register: rn,
    handleSubmit: Ge,
    watch: Pe,
    setValue: de,
    getValues: Ce,
    reset: Ne,
    resetField: pe,
    clearErrors: ze,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...j,
    formControl: j
  };
}
function sr(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: pr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: pr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : vw(e),
    formState: i
  }, e.formControl && e.defaultValues && !pr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Gr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Et(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Jb(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var sl = { exports: {} }, na = {}, $f;
function bw() {
  if ($f) return na;
  $f = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return na.Fragment = r, na.jsx = s, na.jsxs = s, na;
}
var fo = {}, Df;
function _w() {
  return Df || (Df = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    fo.Fragment = i, fo.jsx = Bn, fo.jsxs = qn;
  })()), fo;
}
var Rf;
function xw() {
  return Rf || (Rf = 1, process.env.NODE_ENV === "production" ? sl.exports = bw() : sl.exports = _w()), sl.exports;
}
var xe = xw();
const Sw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Nw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, jw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, ww = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, Cw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, Fw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, Iw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Ew = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Tw = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": jw,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": ww,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": Cw,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Sw,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Nw,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Fw,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Iw,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Ew
};
function Mi(e) {
  return Tw[e] ?? {};
}
const $w = Mi(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), Dw = Mi(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Rw = Mi(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Of = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, nr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, Ow = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Pf = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Ku = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function Pw({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: S, executeQuery: N } = mn(), { track: F } = kn(), {
    loading: I,
    data: g,
    error: q,
    store: $
  } = vm(e ?? null), C = g?.github?.issues || [], D = g?.github?.pullRequests || [], [U, Z] = se(!1), [Q, ee] = se();
  qe(
    () => h(q || Q || void 0),
    [q, Q]
  ), qe(
    () => {
      !I && (C?.length || D?.length) ? (a(C), s(D), G(C, D)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const J = async (he, H) => {
    await $(he).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: H.success.title,
        text: H.success.text
      });
    }).catch((be) => {
      v({
        title: H.error.title,
        text: `${H.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, G = (he, H) => {
    if (!he?.length && !H?.length) {
      d([]), u([]);
      return;
    }
    const be = (he || []).map(
      (ze) => N(Dw, {
        owner: ze.owner,
        repositoryName: ze.repository,
        issueNumber: ze.number
      })
    ), Ce = (H || []).map(
      (ze) => N(Rw, {
        owner: ze.owner,
        repositoryName: ze.repository,
        prNumber: ze.number
      })
    ), K = [...be, ...Ce];
    Z(!0), Promise.all(K).then((ze) => {
      const Be = [], Pe = [];
      ze.forEach((Me) => {
        const Ie = Me?.data?.GitHub;
        if (!Ie) {
          d([]), u([]);
          return;
        }
        Object.keys(Ie).forEach((Le) => {
          if (Le.startsWith("repository")) {
            const De = Ie[Le];
            Object.keys(De).forEach((rn) => {
              const je = De[rn], We = {
                number: je?.number,
                owner: je?.repository?.owner?.login,
                repository: je?.repository?.name
              };
              rn.startsWith("issue") && Be.push({
                ...je,
                type: "ISSUE",
                key: We
              }), rn.startsWith("pullRequest") && Pe.push({
                ...je,
                type: "PR",
                key: We
              });
            });
          }
        });
      }), d(Be), u(Pe);
    }).catch(ee).finally(() => {
      Z(!1);
    });
  }, P = ({ key: he, type: H }) => {
    F("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (C.length || D.length) ? g : r, Ce = H === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ce] = Array.from(
      new Set(be.github[Ce]).add(he)
    ), J(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${nr(
          he
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${nr(he)} failed. Please try again.`
      }
    });
  }, W = async ({ key: he, type: H }) => {
    F("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (C.length || D.length) ? g : r, Ce = H === "ISSUE" ? "issues" : "pullRequests";
    be.github[Ce] = Array.from(
      new Set(be.github[Ce]).add(he)
    ), await $(be).catch((K) => {
      v({
        title: "Linking failed",
        text: `Linking ${he} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ne = ({ key: he, type: H }) => {
    F("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = H === "ISSUE" ? "issue" : "pull request";
    S({
      headline: `Unlink ${be} ${nr(he)}?`,
      text: `You are about to unlink the ${be} ${nr(
        he
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ce = H === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const K = {
          ...g,
          github: {
            ...g?.github,
            [Ce]: g?.github?.[Ce].filter(
              (ze) => ze.number !== he.number || ze.owner !== he.owner || ze.repository !== he.repository
            )
          }
        };
        F("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), J(K, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${nr(
              he
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${nr(he)} failed.`
          }
        });
      },
      onCancel: () => {
        F("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ke = () => {
    F("github:unlink:all:clicked", {
      githubOrganization: n
    }), S({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        F("github:unlink:all:confirmed", {
          githubOrganization: n
        }), J(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        F("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, me = C.filter(
    (he) => !i?.includes(he)
  ) || [], de = D.filter(
    (he) => !o?.includes(he)
  ) || [];
  return {
    linkGithubItem: P,
    linkGithubItemQuietly: W,
    unlinkGithubItem: ne,
    loadGithubItems: G,
    removeDanglingGithubItemLinks: () => {
      const he = {
        ...g,
        github: {
          ...g?.github,
          issues: C.filter(
            (H) => !me.includes(H)
          ) || [],
          pullRequests: D.filter(
            (H) => !de.includes(H)
          ) || []
        }
      };
      $(he);
    },
    unlinkAllGithubItems: ke,
    isLoadingGithubItemLinks: I,
    danglingIssueLinks: me,
    danglingPullRequestLinks: de,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const Aw = "_contentWrapper_1vx3c_1", Lw = "_contentWrapperHeadline_1vx3c_4", Vw = "_contentWrapperBody_1vx3c_11", zw = "_contentWrapperAssigneeIcon_1vx3c_15", Uw = "_contentWrapperStatusTag_1vx3c_20", Lr = {
  contentWrapper: Aw,
  contentWrapperHeadline: Lw,
  contentWrapperBody: Vw,
  contentWrapperAssigneeIcon: zw,
  contentWrapperStatusTag: Uw
}, i_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(Jn, { className: Lr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(Jn, { className: Lr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(Jn, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: Lr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(Jn, { className: Lr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      On,
      {
        className: Lr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), Mw = "_collapse_1bdjy_1", Bw = "_collapseHeader_1bdjy_10", qw = "_collapseHeaderKey_1bdjy_31", Hw = "_collapseHeaderKeyIcon_1bdjy_36", Ww = "_collapseHeaderKeyLink_1bdjy_41", Kw = "_collapseHeaderIcon_1bdjy_44", Gw = "_collapseHeaderTitle_1bdjy_49", Yw = "_collapseContent_1bdjy_57", Jw = "_collapseContentButtonSpacer_1bdjy_60", Qw = "_collapseContentButtonLink_1bdjy_63", Sr = {
  collapse: Mw,
  collapseHeader: Bw,
  collapseHeaderKey: qw,
  collapseHeaderKeyIcon: Hw,
  collapseHeaderKeyLink: Ww,
  collapseHeaderIcon: Kw,
  collapseHeaderTitle: Gw,
  collapseContent: Yw,
  collapseContentButtonSpacer: Jw,
  collapseContentButtonLink: Qw
}, Xw = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: S,
      type: N,
      state: F,
      assignees: I,
      labels: g
    } = d, q = a[m];
    return /* @__PURE__ */ xe.jsxs(
      rr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: q,
        className: Sr.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(rr.Header, { className: Sr.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(Jn, { children: /* @__PURE__ */ xe.jsxs(Jn, { as: "span", className: Sr.collapseHeaderKey, children: [
                  Ku(
                    N,
                    F,
                    Sr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: Of(f),
                      className: Sr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: ($) => {
                        $.stopPropagation();
                      },
                      children: [
                        nr(f),
                        /* @__PURE__ */ xe.jsx(
                          ue,
                          {
                            className: Sr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(Jn, { className: Sr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(rr.Content, { className: Sr.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              i_,
              {
                description: v,
                assignees: I,
                labels: g
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Sr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: S?.owner.login,
                    repository: d.repository.name
                  },
                  type: N
                }),
                children: [
                  "Unlink ",
                  Pf(N)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              jt,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: Sr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Of(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Pf(N),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, Zw = "_result_1uaom_1", eC = "_resultName_1uaom_21", nC = "_resultItemIcon_1uaom_29", tC = "_resultDescription_1uaom_34", rC = "_resultLinkIcon_1uaom_46", iC = "_tooltip_1uaom_55", aC = "_tooltipName_1uaom_61", oC = "_tooltipTag_1uaom_71", Vr = {
  result: Zw,
  resultName: eC,
  resultItemIcon: nC,
  resultDescription: tC,
  resultLinkIcon: rC,
  tooltip: iC,
  tooltipName: aC,
  tooltipTag: oC
}, sC = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ xe.jsx(
    Ke,
    {
      className: Vr.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(Jn, { as: "span", className: Vr.tooltipName, children: [
                Ku(a, o, Vr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(On, { className: Vr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          i_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: Vr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(Jn, { as: "span", className: Vr.resultName, children: [
                    Ku(a, o, Vr.resultItemIcon),
                    nr(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(Jn, { className: Vr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              ue,
              {
                className: Vr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, lC = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), ds = "[a-zA-z0-9_.-]+", a_ = "[0-9]+", cC = new RegExp(
  `(${ds})/(${ds})/(?:issues|pull)/(${a_})`,
  "i"
), Af = new RegExp(`^${cC.source}$`), Lf = new RegExp(
  `https://github.com/(${ds})/(${ds})/(?:issues|pull)/(${a_})`,
  "i"
), dC = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = et(() => r?.map((D) => D.id) || [], [r]), o = et(() => i?.map((D) => D.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = mn(), [m, u] = se(), [f, { loading: h, error: v, data: S, networkStatus: N }] = d($w, {
    notifyOnNetworkStatusChange: !0
  });
  Ui(
    () => {
      !h && m && N === ar.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), qe(() => {
    let D = S?.GitHub?.issues?.nodes || [], U = S?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (D = D.filter((Z) => !a.includes(Z.id))), o.length > 0 && (U = U.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...D.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...U.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [S, a, o]);
  function F(D) {
    const U = D?.trim();
    if (Af.test(U)) {
      const [Z, Q, ee, J] = U.match(Af) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
    if (Lf.test(U)) {
      const [Z, Q, ee, J] = U.match(Lf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
  }
  const I = (D) => {
    e({
      key: Ow(D),
      type: D.type
    }), u(void 0);
  }, g = (D) => {
    const U = F(D);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${D}`
    );
  }, q = () => {
    u(void 0);
  }, $ = ({ className: D, searched: U }) => /* @__PURE__ */ xe.jsx(
    lC,
    {
      className: D,
      searched: U,
      githubOrganization: n
    }
  ), C = ({ item: D, onSelect: U }) => /* @__PURE__ */ xe.jsx(sC, { item: D, onSelect: U });
  return !h && v ? /* @__PURE__ */ xe.jsx(wn, { error: v }) : /* @__PURE__ */ xe.jsx(
    br,
    {
      items: s?.map((D) => ({ name: D.title, ...D })),
      loading: h,
      onSearch: g,
      onSelect: I,
      onClear: q,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: $,
      itemComponent: C,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, uC = "_itemButton_3sxfy_1", mC = "_result_3sxfy_6", pC = "_resultName_3sxfy_30", fC = "_resultCheckIcon_3sxfy_38", hC = "_resultAssigneeIcon_3sxfy_41", ta = {
  itemButton: uC,
  result: mC,
  resultName: pC,
  resultCheckIcon: fC,
  resultAssigneeIcon: hC
}, o_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ta.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: ta.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(Jn, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: ta.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(Jn, { className: ta.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(Jn, { className: ta.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(ue, { name: "done" }) })
        ] })
      }
    )
  }
), yC = Mi(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), gC = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: S }] = a(
    yC,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Ui(
    () => {
      !f && l && l.length >= m && S === ar.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const N = v?.GitHub?.organization?.teams || { edges: [] }, F = [];
    N?.edges?.forEach((I) => {
      const g = I?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((q) => {
        const $ = q?.node;
        $ && ($?.id && F.find((C) => C.id === $.id) || F.push($));
      });
    }), s(
      F.sort((I, g) => {
        const q = I.name?.toLowerCase() || I.login?.toLowerCase(), $ = g.name?.toLowerCase() || g.login?.toLowerCase();
        return q.localeCompare($, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ xe.jsx(wn, { error: h }) : /* @__PURE__ */ xe.jsx(
    br,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: N, name: F, login: I, avatarUrl: g }) => ({
        id: N,
        name: F || I,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (N) => d(N),
      onChange: (N, F) => {
        const I = N.id;
        i ? (F && !n.find(
          (g) => g.id === I
        ) && n.push(N), F || (n = n.filter(
          (g) => g.id !== I
        ))) : n = F ? [N] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: N, onSelect: F, checked: I }) => /* @__PURE__ */ xe.jsx(
        o_,
        {
          item: N,
          checked: I,
          onSelectItem: F
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, kC = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(kr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        br,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Cs,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(kr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        br,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(kr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Au, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        gC,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, vC = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  Pt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      An,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: kC({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), bC = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(ue, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(An, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          kr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, _C = "_modalBody_1hk1o_1", xC = "_modalBodyFormFields_1hk1o_4", ll = {
  modalBody: _C,
  modalBodyFormFields: xC
}, SC = Mi(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), NC = Mi(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), jC = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], wC = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = mn(), { track: d } = kn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = sr(), [S, N] = se(""), [F, I] = se([]), [g, q] = se(), [$, C] = se(!1), [D, U] = se(!1), [Z, Q] = qb(), [
    ee,
    {
      loading: J,
      error: G,
      networkStatus: P
    }
  ] = s(SC, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ce) => {
      I(
        Ce.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), I([]);
    }
  });
  Ui(
    () => {
      !J && S && P === ar.ready ? ee({
        variables: {
          query: S,
          maxResults: 10
        }
      }) : I([]);
    },
    500,
    [S]
  );
  const [W, { error: ne }] = l(
    NC,
    {
      onError: (Ce) => {
        C(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ce);
      },
      onCompleted: (Ce) => {
        C(!1);
        const K = Ce.GitHub.createIssue?.issue;
        q(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ke = (Ce) => {
    N(`org:${a} ${Ce}`);
  }, me = (Ce, K) => {
    K(Ce), N("");
  }, de = () => {
    N("");
  }, he = (Ce) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), C(!0), W({
      variables: {
        input: {
          repositoryId: Ce.repository.id,
          title: Ce.title,
          body: Ce.body,
          assigneeIds: Ce.assignees?.length > 0 ? Ce.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  qe(() => {
    const Ce = D ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ce);
  }, [D]);
  const H = () => {
    N(""), I([]), q(void 0), C(!1), U(!1);
  }, be = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), H(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    gt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ xe.jsx(
          kt,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ xe.jsxs(vt, { className: ll.modalBody, children: [
          !J && G && /* @__PURE__ */ xe.jsx(wn, { error: G }),
          !$ && ne && /* @__PURE__ */ xe.jsx(wn, { error: ne }),
          g ? /* @__PURE__ */ xe.jsx(
            bC,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: D,
              setIssueLinkCopied: U,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(he),
              children: /* @__PURE__ */ xe.jsxs(zt, { children: [
                /* @__PURE__ */ xe.jsx(nn, { children: /* @__PURE__ */ xe.jsx(An, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  Pt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ce, value: K } }) => /* @__PURE__ */ xe.jsx(
                      br,
                      {
                        className: ll.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: J,
                        onSearch: ke,
                        onSelect: (ze) => me(ze, Ce),
                        onClear: de,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: G ? "No repositories found" : "No repositories available",
                        items: F || [],
                        itemComponent: ({ item: ze, onSelect: Be, checked: Pe }) => /* @__PURE__ */ xe.jsx(
                          o_,
                          {
                            item: ze,
                            checked: Pe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(nn, { className: ll.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  vC,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: jC
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          wt,
          {
            confirmOnClick: g ? be : u(he),
            confirmProps: {
              isLoading: $,
              loadingIndicator: /* @__PURE__ */ xe.jsx(un, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : be
          }
        )
      ]
    }
  );
}, CC = "_wrapper_19v8w_1", FC = "_inputWrapper_19v8w_6", IC = "_buttonLink_19v8w_19", EC = "_noItemsFound_19v8w_23", TC = "_createIssueButton_19v8w_28", bi = {
  wrapper: CC,
  inputWrapper: FC,
  buttonLink: IC,
  noItemsFound: EC,
  createIssueButton: TC
}, $C = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = kn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: S,
    danglingPullRequestLinks: N,
    isLoadingGithubItems: F,
    issues: I,
    pullRequests: g,
    error: q
  } = Pw({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), $ = (Q) => d({ key: Q, type: "ISSUE" }), C = !(!!I?.length).valueOf() && !(!!g?.length).valueOf() && !(!!S?.length).valueOf() && !(!!N?.length).valueOf(), D = !v && !F && !!S?.length && !!N?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Z = !!I?.length || !!g?.length;
  return !F && q ? /* @__PURE__ */ xe.jsx(wn, { error: q, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: bi.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: bi.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: bi.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: bi.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          dC,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: I,
            linkedPullRequests: g
          }
        )
      ] }),
      F ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(un, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ xe.jsx(
        Xw,
        {
          items: [...I, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx(A.Paragraph, { align: "center", className: bi.noItemsFound, children: "No linked items found." }),
      D && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              S.map((Q) => /* @__PURE__ */ xe.jsx(
                On,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: nr(Q)
                },
                nr(Q)
              )),
              N.map((Q) => /* @__PURE__ */ xe.jsx(
                On,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: nr(Q)
                },
                nr(Q)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ xe.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: C,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: bi.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      wC,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: $,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, DC = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var cl = { exports: {} }, ra = {}, Vf;
function RC() {
  if (Vf) return ra;
  Vf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ra.Fragment = r, ra.jsx = s, ra.jsxs = s, ra;
}
var ho = {}, zf;
function OC() {
  return zf || (zf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    ho.Fragment = i, ho.jsx = Bn, ho.jsxs = qn;
  })()), ho;
}
var Uf;
function PC() {
  return Uf || (Uf = 1, process.env.NODE_ENV === "production" ? cl.exports = RC() : cl.exports = OC()), cl.exports;
}
var Te = PC(), Ta = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Ta || {}), ri = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ri || {}), Ut = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Ut || {});
const AC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, LC = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": AC
};
function VC(e) {
  return LC[e] ?? {};
}
const zC = VC(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Mf = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, s_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, UC = "_listItem_16pij_4", MC = "_clickableIcon_16pij_15", us = {
  listItem: UC,
  clickableIcon: MC
}, l_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ Te.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ Te.jsx(ue, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: us.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ Te.jsx(
              ue,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ Te.jsx(He, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, S = l.currency ?? r;
      return /* @__PURE__ */ Te.jsx(
        He.Item,
        {
          contentLeft: /* @__PURE__ */ Te.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: s_(f / 100, S) })
          ] }),
          contentRight: h && /* @__PURE__ */ Te.jsx(Li, { src: h, alt: m ?? "Product image" }),
          className: us.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, BC = "_boxWrapper_89s7l_1", qC = "_trackButton_89s7l_10", Bf = {
  boxWrapper: BC,
  trackButton: qC
}, HC = {
  [Ut.StepUnknown]: "Unknown",
  [Ut.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Ut.StepPreparedByMerchant]: "Prepared by merchant",
  [Ut.StepSubmittedToCarrier]: "Submitted to carrier",
  [Ut.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Ut.StepOnRoute]: "On route",
  [Ut.StepDeliveredToPickupPoint]: "At pickup point",
  [Ut.StepDeliveredToConsumer]: "Delivered to customer",
  [Ut.StepDeliveredToMerchant]: "Returned to merchant",
  [Ut.StepReturnRequested]: "Return requested",
  [Ut.StepSentBack]: "Sent back",
  [Ut.StepTerminated]: "Terminated",
  [Ut.StepAwaitingSupplier]: "Awaiting supplier"
}, WC = {
  [ri.Delivery]: "Home delivery",
  [ri.Pickup]: "Pickup point",
  [ri.Instore]: "In-store pickup",
  [ri.Mailbox]: "Mailbox",
  [ri.Inwarehouse]: "Warehouse",
  [ri.Unknown]: "Unknown"
}, KC = {
  [Ta.Outbound]: "From merchant to customer",
  [Ta.Return]: "Return from customer to merchant",
  [Ta.Unspecified]: "Unspecified",
  [Ta.UnknownDirectionType]: "Unknown"
}, GC = (e) => e ? HC[e] ?? e : "", YC = (e) => e ? WC[e] ?? e : "", JC = (e) => e ? KC[e] ?? e : "", QC = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, XC = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Xt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, S = a?.filter(($) => $?.time !== ""), N = GC(S?.[0]?.step), F = YC(u), I = JC(f), g = QC(e.location?.address), q = 14;
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Bf.boxWrapper,
      children: [
        /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Te.jsx(
              ue,
              {
                size: q,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ Te.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Te.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ Te.jsx(
            ue,
            {
              size: q,
              name: n ? "done" : "copy",
              className: us.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        N && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(ue, { size: q, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        I && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(ue, { size: q, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: I })
          ] })
        ] }),
        h && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(ue, { size: q, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Mf(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Mf(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(ue, { size: q, name: "info", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: F })
          ] })
        ] }),
        g && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(ue, { size: q, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ Te.jsx(l_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ Te.jsxs(
          jt,
          {
            variant: "secondary",
            className: Bf.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ Te.jsx(ue, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, ZC = "_order_135ze_1", e1 = "_orderIsOpen_135ze_9", n1 = "_orderHeader_135ze_12", dl = {
  order: ZC,
  orderIsOpen: e1,
  orderHeader: n1
}, t1 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = Xt();
  if (!e)
    return null;
  const {
    cart: s,
    parcels: l,
    external_id: d,
    sender_name: m,
    tos_id: u
  } = e, f = s?.currency || "", h = s?.prices?.total?.price ?? 0, v = s_(h / 100, f), S = 14, N = m && m.trim() !== "" ? m : "unknown sender";
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      className: ct(dl.order, {
        [dl.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: dl.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  N
                ] }),
                /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "3", children: [
                  "#",
                  d
                ] })
              ] }),
              /* @__PURE__ */ Te.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Te.jsx(
                ue,
                {
                  size: S,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !u && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  u && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: u })
                ] })
              ] })
            ] }),
            u && /* @__PURE__ */ Te.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Te.jsx(Ke, { content: "Copy tracking ID", children: /* @__PURE__ */ Te.jsx(
              ue,
              {
                size: S,
                name: a ? "done" : "copy",
                className: us.clickableIcon,
                onClick: () => o(u)
              }
            ) }) })
          ] }),
          m && /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Te.jsx(ue, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: m })
            ] })
          ] }),
          /* @__PURE__ */ Te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Te.jsx(ue, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: v })
            ] })
          ] }),
          /* @__PURE__ */ Te.jsx(
            l_,
            {
              openByDefault: !0,
              title: "Order items",
              items: s?.items?.map((F) => F),
              currency: s?.currency
            }
          ),
          l && /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              l.length > 0 && /* @__PURE__ */ Te.jsx(Un, { variant: "success", size: "small", children: l.length })
            ] }),
            l.length === 0 && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            l.map((F, I) => /* @__PURE__ */ Te.jsx(
              XC,
              {
                parcel: F
              },
              `parcel-${I}-${F?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, r1 = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, i1 = ({
  customerEmail: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(zC, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? kS({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? ib({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(r1(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(un, {}) }) : m || !d && !l ? /* @__PURE__ */ Te.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ Te.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ Te.jsx(wn, { error: l }) : /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ Te.jsx(Un, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ Te.jsx(
      t1,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, a1 = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ Te.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ Te.jsx(i1, { customerEmail: n })
    }
  );
}, o1 = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ul = { exports: {} }, ia = {}, qf;
function s1() {
  if (qf) return ia;
  qf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ia.Fragment = r, ia.jsx = s, ia.jsxs = s, ia;
}
var yo = {}, Hf;
function l1() {
  return Hf || (Hf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    yo.Fragment = i, yo.jsx = Bn, yo.jsxs = qn;
  })()), yo;
}
var Wf;
function c1() {
  return Wf || (Wf = 1, process.env.NODE_ENV === "production" ? ul.exports = s1() : ul.exports = l1()), ul.exports;
}
var ye = c1();
const zm = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => zm(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, d1 = "_jiraCode_h30p6_1", u1 = "_jiraCodeInline_h30p6_8", ml = {
  jiraCode: d1,
  jiraCodeInline: u1
}, c_ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ye.jsx(ye.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ye.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ye.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ye.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ye.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ye.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ye.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ye.jsx("pre", { children: /* @__PURE__ */ ye.jsx("code", { className: ml.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ye.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ye.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ye.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ye.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ye.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ye.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ye.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ye.jsx("code", { className: ct(ml.jiraCode, ml.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ms = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ye.jsx(ue, { size: r, name: "question", className: n }) : /* @__PURE__ */ ye.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, m1 = "_collapse_m2gjh_1", p1 = "_collapseHeader_m2gjh_10", f1 = "_collapseHeaderLink_m2gjh_31", h1 = "_collapseHeaderStatus_m2gjh_40", y1 = "_collapseHeaderTitle_m2gjh_51", g1 = "_collapseContent_m2gjh_59", k1 = "_collapseContentHeadline_m2gjh_62", v1 = "_collapseContentButtonSpacer_m2gjh_68", b1 = "_collapseContentButtonLink_m2gjh_71", _1 = "_collapseContentStatusTag_m2gjh_74", x1 = "_collapseContentDescription_m2gjh_77", dr = {
  collapse: m1,
  collapseHeader: p1,
  collapseHeaderLink: f1,
  collapseHeaderStatus: h1,
  collapseHeaderTitle: y1,
  collapseContent: g1,
  collapseContentHeadline: k1,
  collapseContentButtonSpacer: v1,
  collapseContentButtonLink: b1,
  collapseContentStatusTag: _1,
  collapseContentDescription: x1
}, d_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, S1 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = d_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), S = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ye.jsxs(
      rr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: S,
        className: dr.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(rr.Header, { className: dr.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ye.jsx(ms, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ ye.jsx(
                      "a",
                      {
                        className: dr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (N) => {
                          N.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ye.jsx(ue, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ye.jsx("span", { className: dr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ye.jsx(On, { className: dr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ye.jsx("div", { className: dr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(rr.Content, { className: dr.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx("div", { className: dr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ye.jsx(Jn, { className: dr.collapseContentDescription, children: u ? zm(u, c_) : "" }),
            /* @__PURE__ */ ye.jsx(
              Wn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: dr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ye.jsx(
              jt,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: dr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, N1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, j1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, w1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, C1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, F1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, I1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, E1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, T1 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': N1,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": j1,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": w1,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": C1,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': F1,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': I1,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": E1
};
function hi(e) {
  return T1[e] ?? {};
}
const u_ = hi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), $1 = hi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), D1 = hi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), R1 = hi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), O1 = hi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), P1 = hi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), A1 = hi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Um = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), L1 = new RegExp(`^${Um.source}$`), V1 = new RegExp(`/${Um.source}$`), Kf = new RegExp(
  `.+?[&?]selectedIssue=(${Um.source})[&?]?.*`
);
function m_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = kn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = mn(), {
    loading: S,
    data: N,
    error: F,
    store: I
  } = vm(e ?? null), [
    g,
    { loading: q, error: $, data: C }
  ] = h(u_, {
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    const de = C?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    de?.length && (s(de), a(de.map((he) => he?.key).filter(Boolean)));
  }, [C]), qe(
    () => d(F || $ || void 0),
    [F, $]
  ), qe(
    () => {
      S || G();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N?.jira?.issues, S]
  );
  const D = async (de, he) => {
    await I(de).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: he.success.title,
        text: he.success.text
      });
    }).catch((H) => {
      u({
        title: he.error.title,
        text: `${he.error.text} ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = v($1, {
    onError: (de) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${de.message && " (" + de.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (de, he) => {
    const H = window.location.href, be = he ? H.replace(
      e?.toString() ?? "",
      he?.toString()
    ) : H, Ce = he ? `# ${he}` : `# ${e}`;
    U({
      variables: {
        issueKey: de,
        title: Ce,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [Q] = v(D1, {
    onError: (de) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${de.message && " (" + de.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ee = (de) => {
    const he = window.location.href;
    Q({
      variables: {
        issueKey: de,
        globalId: `system=${he}`
      }
    });
  }, J = (de) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: de
  }), G = () => {
    N && N.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${N?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, P = async (de, he) => {
    m("jira:issue:link:clicked", J(de));
    const H = N?.jira?.issues ? N : r;
    H.jira.issues = Array.from(
      new Set(H.jira.issues).add(de)
    ), await I(H, he?.toString()).then(() => Z(de, he)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${de} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, W = (de) => {
    m("jira:issue:link:clicked", J(de));
    const he = N?.jira?.issues ? N : r;
    he.jira.issues = Array.from(
      new Set(he.jira.issues).add(de)
    ), D(he, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${de} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${de} failed. Please try again.`
      }
    }).then(() => Z(de));
  }, ne = (de) => {
    m("jira:issue:unlink:clicked", J(de)), f({
      headline: `Unlink issue ${de}?`,
      text: `You are about to unlink the issue ${de}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", J(de));
        const he = {
          ...N,
          jira: {
            ...N?.jira,
            issues: N?.jira?.issues.filter((H) => H !== de) || []
          }
        };
        D(he, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${de}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${de} failed.`
          }
        }).then(() => ee(de));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", J(de))
    });
  }, ke = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((de) => de?.key && ee(de.key)), D(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, me = N?.jira?.issues?.filter(
    (de) => !i?.includes(de)
  ) || [];
  return {
    linkIssue: W,
    linkIssueQuietly: P,
    unlinkIssue: ne,
    loadIssues: G,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const de = {
        ...N,
        jira: {
          ...N?.jira,
          issues: N?.jira?.issues.filter(
            (he) => !me.includes(he)
          ) || []
        }
      };
      I(de);
    },
    unlinkAllIssues: ke,
    maybeExtractIssueKey: (de) => {
      const he = de.replace(/\s/g, "");
      if (L1.test(he))
        return he;
      if (Kf.test(de))
        return de.match(Kf)?.[1];
      if (de.startsWith(n) && V1.test(de))
        return de.substring(de.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: S,
    danglingIssueLinks: me,
    isLoadingIssues: q,
    issues: o,
    error: l
  };
}
function z1(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const U1 = "_result_axxxc_48", M1 = "_resultName_axxxc_68", B1 = "_resultNameIcon_axxxc_76", q1 = "_resultDescription_axxxc_81", H1 = "_resultLinkIcon_axxxc_93", W1 = "_tooltip_axxxc_102", K1 = "_tooltipContent_axxxc_108", G1 = "_tooltipName_axxxc_115", Y1 = "_tooltipNameIcon_axxxc_120", J1 = "_tooltipDescription_axxxc_125", Q1 = "_tooltipSummary_axxxc_133", X1 = "_tooltipTag_axxxc_137", er = {
  result: U1,
  resultName: M1,
  resultNameIcon: B1,
  resultDescription: q1,
  resultLinkIcon: H1,
  tooltip: W1,
  tooltipContent: K1,
  tooltipName: G1,
  tooltipNameIcon: Y1,
  tooltipDescription: J1,
  tooltipSummary: Q1,
  tooltipTag: X1
}, Z1 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = d_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ye.jsx(
    Ke,
    {
      disabled: i,
      className: er.tooltip,
      content: /* @__PURE__ */ ye.jsxs("div", { className: er.tooltipContent, children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ye.jsxs("span", { className: er.tooltipName, children: [
                /* @__PURE__ */ ye.jsx(
                  ms,
                  {
                    width: 16,
                    iconUrl: h,
                    className: er.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ye.jsx(On, { className: er.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ye.jsx("div", { className: er.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ye.jsx("div", { className: er.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          ...a,
          className: er.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs("span", { className: er.resultName, children: [
                    /* @__PURE__ */ ye.jsx(
                      ms,
                      {
                        width: 16,
                        iconUrl: h,
                        className: er.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ye.jsx("div", { className: er.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ye.jsx(
              ue,
              {
                className: er.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, eF = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ye.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), nF = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(u_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: S } = m_(null, n);
  Ui(
    () => {
      !u && l && v === ar.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const $ = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      $.map((C) => ({
        id: C?.key ?? "",
        name: C?.key ?? "",
        description: C?.fields.summary,
        status: C?.fields.status,
        issuetype: C?.fields.issuetype,
        text: C?.fields.description ? zm(C?.fields.description, c_) : /* @__PURE__ */ ye.jsx(ye.Fragment, {})
      }))
    );
  }, [h]);
  const N = ($) => {
    e($.id), d("");
  }, F = ($) => {
    const C = $.trim(), D = S(C);
    if (D) {
      const U = D.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else C !== "" && d(
      `text ~ '${C}'${r ? " and project = " + r : ""}`
    );
  }, I = () => {
    d("");
  }, g = ($) => /* @__PURE__ */ ye.jsx(eF, { ...$, jiraInstanceUrl: n }), q = ($) => /* @__PURE__ */ ye.jsx(
    Z1,
    {
      ...$,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ye.jsx(wn, { error: f }) : /* @__PURE__ */ ye.jsx(
    br,
    {
      items: o,
      loading: u,
      onSearch: F,
      onSelect: N,
      onClear: I,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: q,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, tF = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ye.jsx(
    br,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, rF = "_itemButton_1hl53_1", iF = "_result_1hl53_6", aF = "_resultIcon_1hl53_26", oF = "_resultName_1hl53_30", sF = "_resultCheckIcon_1hl53_38", aa = {
  itemButton: rF,
  result: iF,
  resultIcon: aF,
  resultName: oF,
  resultCheckIcon: sF
}, Gu = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ye.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ye.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: aa.itemButton,
          children: /* @__PURE__ */ ye.jsxs(b, { className: aa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ye.jsx(
              ms,
              {
                width: 36,
                iconUrl: o || "",
                className: aa.resultIcon
              }
            ),
            /* @__PURE__ */ ye.jsx(Jn, { className: aa.resultName, children: e.name }),
            n && /* @__PURE__ */ ye.jsx(Jn, { className: aa.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(ue, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, lF = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: S }] = a(A1, {
    notifyOnNetworkStatusChange: !0
  });
  return Ui(
    () => {
      !f && l && l.length >= m && S === ar.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((N) => {
      if (N?.data?.Jira.findUsers?.length === 1) {
        const F = N?.data?.Jira?.findUsers[0];
        r(F.accountId), s([
          {
            id: F.accountId,
            name: F.displayName
          }
        ]);
      }
    });
  }, []), qe(() => {
    const N = v?.Jira?.findUsers || [];
    s(
      N.filter(({ active: F }) => F).map(({ accountId: F, displayName: I, avatarUrls: g, active: q }) => ({
        id: F,
        name: I,
        avatarUrls: g,
        active: q
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ ye.jsx(wn, { error: h }) : /* @__PURE__ */ ye.jsx(
    br,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (N) => d(N),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: N, onSelect: F, checked: I }) => /* @__PURE__ */ ye.jsx(
        Gu,
        {
          item: N,
          checked: I,
          onSelectItem: F,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Gf = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = qb();
  return qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ye.jsx(b, { children: /* @__PURE__ */ ye.jsx(ue, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ye.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ye.jsx(Ke, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ye.jsx(
      Kt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, cF = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ye.jsx(Gf, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ye.jsx(Au, { onChange: n, value: r }) : /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(Au, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ye.jsx(kr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        lF,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ye.jsx(
        br,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ye.jsx(tF, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ye.jsx(Gf, { field: e });
  }
}, dF = ["description", "reporter", "summary"], uF = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || dF.includes(o)
).map((o) => /* @__PURE__ */ ye.jsx(
  Pt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      An,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: cF({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), mF = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ye.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ye.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ye.jsx(ue, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ye.jsx(An, { label: "Jira issue link", children: /* @__PURE__ */ ye.jsx(
        kr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), pF = "_modalBody_1hk1o_1", fF = "_modalBodyFormFields_1hk1o_4", Yf = {
  modalBody: pF,
  modalBodyFormFields: fF
}, hF = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), yF = (e) => e?.custom?.split(":")?.[1] || null, gF = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, kF = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = gF(a, n), l = yF(s) ?? a;
        return r.includes(l) ? i[a] = hF(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, vF = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, S] = se([]), [N, F] = se([]), [I, g] = se(!1), [q, $] = se(!1), [C, D] = se({}), { track: U } = kn(), { isCopied: Z, copyToClipboard: Q } = z1(), ee = et(() => i?.conversationId, [e]), { useMutation: J, useLazyQuery: G, showNotification: P } = mn(), {
    control: W,
    handleSubmit: ne,
    formState: { errors: ke },
    reset: me,
    setValue: de,
    getValues: he
  } = sr({
    defaultValues: s
  }), H = N.length > 0, be = `${a}/browse`, Ce = Object.keys(C).length > 0, [K, { loading: ze, error: Be }] = G(R1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      d(le.Jira.getAllProjects);
    },
    onError: (le) => {
      P({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", le), d([]);
    }
  }), [
    Pe,
    { loading: Me, error: Ie }
  ] = G(O1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      h(0);
      const Ne = le?.Jira?.getCreateIssueMeta?.projects[0];
      if (Ne) {
        const Ae = Ne?.issuetypes.filter(
          ({ subtask: Ee }) => !Ee
        );
        S(Ae || []), de(
          "issuetype",
          Ae.length > 0 ? Ae[0] : void 0
        );
      } else
        P({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), S([]), F([]);
    },
    onError: (le) => {
      P({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", le), S([]), F([]), h(0);
    }
  }), [Le, { error: De }] = J(
    P1,
    {
      onError: () => {
        g(!1), P({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (le) => {
        if (g(!1), le?.Jira && "key" in le.Jira.createIssue)
          u(le?.Jira?.createIssue), P({
            title: "Success",
            text: `Jira issue '${le.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: le.Jira.createIssue.key
          }), ee && r(
            le.Jira.createIssue.key,
            ee
          );
        else if ("errorMessages" in le.Jira.createIssue || "errors" in le.Jira.createIssue) {
          const Ne = le?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Ne), P({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), rn = (le) => {
    g(!0), D({}), Le({
      variables: {
        input: kF(le, N)
      }
    });
  };
  qe(() => {
    if (e)
      try {
        K();
      } catch (le) {
        console.warn("Error when fetching initial projects", le);
      }
  }, [e]), qe(() => {
    const le = q ? window.setTimeout(() => $(!1), 2e3) : void 0;
    return () => window.clearTimeout(le);
  }, [q]), qe(() => {
    if (v?.length > 0) {
      de("issuetype", v[f]);
      const le = v[f]?.fields?.additionalProperties;
      if (le?.length > 0) {
        const Ne = le.map(
          ({ value: j }) => j
        ), Ae = (o ? Ne.sort(({ name: j }, { name: _ }) => j.localeCompare(_)) : Ne).sort(
          ({ required: j }, { required: _ }) => Number(_) - Number(j)
        ), { project: Ee, issuetype: cn } = he();
        me({ project: Ee, issuetype: cn }), F(Ae);
      }
    } else
      F([]), de("issuetype", void 0);
  }, [v, de, f]), qe(() => {
    if (De && cb(De)) {
      if (De?.graphQLErrors?.length > 0) {
        const { graphQLErrors: le } = De, Ne = le[0].extensions?.integration?.responseBody;
        try {
          const Ae = JSON.parse(Ne);
          if (Ae?.errors) {
            const Ee = Object.keys(Ae.errors).reduce(
              (cn, j) => ({
                ...cn,
                [j]: {
                  type: "required",
                  message: Ae.errors[j],
                  ref: {
                    name: j
                  }
                }
              }),
              {}
            );
            D(Ee);
          }
        } catch {
        }
      }
    } else
      D({});
  }, [De]);
  const je = () => {
    d([]), F([]), S([]), u(void 0), h(0), g(!1), D({});
  }, We = () => {
    je(), me(s), n();
  }, Ge = (le) => {
    le && Pe({
      variables: {
        projectKey: le
      }
    });
  }, pe = (le) => {
    const Ne = v.map((Ae) => Ae.id).indexOf(le);
    h(Ne ?? 0);
  };
  return /* @__PURE__ */ ye.jsxs(
    gt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: We,
      children: [
        /* @__PURE__ */ ye.jsx(
          kt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: We
          }
        ),
        /* @__PURE__ */ ye.jsxs(vt, { className: Yf.modalBody, children: [
          !ze && Be && /* @__PURE__ */ ye.jsx(wn, { error: Be, retry: K }),
          !Me && Ie && /* @__PURE__ */ ye.jsx(
            wn,
            {
              error: Ie,
              retry: Pe
            }
          ),
          !I && Ce && /* @__PURE__ */ ye.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ye.jsx(
            Ja,
            {
              variant: "warning",
              description: /* @__PURE__ */ ye.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ye.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ye.jsx(
                      Wn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(N, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ye.jsx(
            mF,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: q,
              setIssueLinkCopied: $,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ne(rn),
              children: /* @__PURE__ */ ye.jsxs(zt, { children: [
                /* @__PURE__ */ ye.jsx(nn, { span: 3, children: /* @__PURE__ */ ye.jsx(An, { label: "Project", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Pt,
                  {
                    control: W,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: le, value: Ne } }) => /* @__PURE__ */ ye.jsx(
                      br,
                      {
                        searchable: !0,
                        loading: ze,
                        onSelect: (Ae) => {
                          Ge(Ae.key), le(Ae);
                        },
                        selectedItems: [Ne],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ae, onSelect: Ee, checked: cn }) => /* @__PURE__ */ ye.jsx(
                          Gu,
                          {
                            item: Ae,
                            checked: cn,
                            onSelectItem: Ee,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(nn, { span: 3, children: /* @__PURE__ */ ye.jsx(An, { label: "Issue type", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Pt,
                  {
                    control: W,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: le, value: Ne } }) => /* @__PURE__ */ ye.jsx(
                      br,
                      {
                        disabled: v.length === 0,
                        loading: Me,
                        onSelect: (Ae) => {
                          pe(Ae.id), le(Ae);
                        },
                        selectedItems: [Ne],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Ie ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Ae, onSelect: Ee, checked: cn }) => /* @__PURE__ */ ye.jsx(
                          Gu,
                          {
                            item: Ae,
                            checked: cn,
                            onSelectItem: Ee,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                H && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ye.jsx(nn, { className: Yf.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  uF,
                  {
                    control: W,
                    errors: { ...ke, ...C },
                    getValues: he,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: N
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          wt,
          {
            confirmOnClick: m ? We : ne(rn),
            confirmProps: {
              disabled: !H,
              isLoading: I,
              loadingIndicator: /* @__PURE__ */ ye.jsx(un, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : We
          }
        )
      ]
    }
  );
}, bF = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, _F = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, xF = "_wrapper_1bylq_1", SF = "_inputWrapper_1bylq_6", NF = "_inputSeparator_1bylq_18", jF = "_buttonLink_1bylq_23", wF = "_noIssuesFound_1bylq_27", oa = {
  wrapper: xF,
  inputWrapper: SF,
  inputSeparator: NF,
  buttonLink: jF,
  noIssuesFound: wF
}, CF = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), i = bF(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: S,
    isLoadingIssues: N,
    issues: F,
    error: I
  } = m_(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, q = !!n?.enableSortIssueTypeByLabel, $ = !!(F?.length || v?.length), C = !!n?.enableRemoveAllLinks && $, D = !S && !N && v?.length > 0 && !!n?.showDanglingLinks;
  return !N && I ? /* @__PURE__ */ ye.jsx(wn, { error: I, retry: () => f() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: oa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: oa.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Wn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: oa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          nF,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      N ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ye.jsx(un, { "data-testid": "jira-widget-issue-spinner" }) }) : F?.length ? /* @__PURE__ */ ye.jsx(
        S1,
        {
          issues: F,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ye.jsx(A.Paragraph, { align: "center", className: oa.noIssuesFound, children: "No linked issues found" }),
      C && F?.length > 0 && /* @__PURE__ */ ye.jsx(
        Wn,
        {
          variant: "secondary",
          disabled: !F?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      D && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((U) => /* @__PURE__ */ ye.jsx(On, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ ye.jsx(
              Wn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ye.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: oa.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ye.jsx(
      vF,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: q
      }
    )
  ] });
}, Jf = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => _F(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pl = { exports: {} }, sa = {}, Qf;
function FF() {
  if (Qf) return sa;
  Qf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return sa.Fragment = r, sa.jsx = s, sa.jsxs = s, sa;
}
var go = {}, Xf;
function IF() {
  return Xf || (Xf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    go.Fragment = i, go.jsx = Bn, go.jsxs = qn;
  })()), go;
}
var Zf;
function EF() {
  return Zf || (Zf = 1, process.env.NODE_ENV === "production" ? pl.exports = FF() : pl.exports = IF()), pl.exports;
}
var $e = EF();
function TF({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = mn(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((S) => {
        const N = setTimeout(S, r);
        d([...l, N]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
const $F = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, DF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, RF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, OF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, PF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, AF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, LF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, VF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, zF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, UF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, MF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qF = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": $F,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": DF,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": OF,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": PF,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": RF,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": AF,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": LF,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": VF,
  "\n  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": zF,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": UF,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": MF,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": BF
};
function Br(e) {
  return qF[e] ?? {};
}
const HF = Br(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), WF = Br(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), KF = Br(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), GF = Br(
  /* GraphQL */
  `
  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), YF = Br(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), JF = Br(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), QF = Br(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), XF = Br(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ZF = Br(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function Yu(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function eh(e) {
  return Yu(e) && e?.attributes?.event_properties?.$message;
}
function eI(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function nh(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function nI(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function tI(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function rI(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function iI(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function aI(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function oI(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function th(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function sI(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function lI(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const cI = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function dI(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function uI(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function mI({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = mn(), { track: a } = kn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, S] = se(
    null
  ), [N, F] = se([]), {
    data: I,
    error: g,
    loading: q,
    networkStatus: $
  } = i(KF, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    C,
    {
      data: D,
      error: U,
      loading: Z,
      networkStatus: Q
    }
  ] = r(HF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return qe(() => {
    if (I && !q && $ === ar.ready) {
      const ee = nI(I);
      s(
        ee.find((J) => J?.attributes?.name === "Received Email")?.id || null
      ), d(
        ee.find((J) => J?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ee.find((J) => J?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ee.find((J) => J?.attributes?.name === "Bounced Email")?.id || null
      ), S(
        ee.find((J) => J?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), S(null);
  }, [I]), qe(() => {
    o && l && m && f && v && !Z && Q === ar.ready ? C({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : F([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), qe(() => {
    if (!Z && D) {
      const ee = tI(D), J = iI(
        D
      ).map(
        (me) => me?.attributes?.event_properties.$message
      ), G = aI(
        D
      ).map(
        (me) => me?.attributes?.event_properties.$message
      );
      ee.forEach((me) => {
        const de = me.attributes?.event_properties.$message;
        me.opened = J.includes(de), me.clicked = G.includes(de);
      });
      const P = rI(D), W = oI(D), ne = [
        ...ee,
        ...W,
        ...P
      ].sort((me, de) => {
        const he = nh(me), H = nh(de);
        return he == null && H == null ? 0 : he == null ? 1 : H == null ? -1 : H - he;
      }).slice(0, n);
      F(ne);
      const ke = ne.map((me) => me.id);
      a("klaviyo:messages:received", {
        emailsReceived: ee.filter(
          (me) => ke.includes(me.id)
        ).length,
        emailsBounced: W.filter(
          (me) => ke.includes(me.id)
        ).length,
        smsReceived: P.filter(
          (me) => ke.includes(me.id)
        ).length,
        total: ke.length
      });
    } else
      F([]);
  }, [Z, D]), et(
    () => ({
      receivedMessages: N,
      isLoading: q || Z,
      error: g || U
    }),
    [
      N,
      q,
      Z,
      g,
      U
    ]
  );
}
function pI({ profileId: e }) {
  const { useQuery: n } = mn(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(YF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  qe(() => {
    l && o(l);
  }, [l]), qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return et(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function fI({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = kn(), { useLazyQuery: i } = mn(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(GF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, S = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, S);
    }
  }, [f, m]);
  const h = (v, S) => {
    const N = v?.data?.length === 1 && v.data[0]?.id || void 0, F = S?.data?.length === 1 && S.data[0]?.id || void 0, I = N || F, g = !N || !F || N === F;
    if (I && g) {
      o(N || F), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${N}) and phone number ${n} (profile ID ${F}).`
      )
    );
  };
  return et(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const rh = 800, hI = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, yI = 3, gI = 1.5, kI = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = yI,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = se(0), [d, m] = se(n || rh), [u, f] = se(r || hI), [h, v] = se(!1), [S, N] = se(!1), F = a || !!r, I = F ? o(u) : n || rh, [g, q] = se(I);
  ew(
    async () => {
      const U = s + 1, Z = gI ** U;
      l(U), q(
        (F ? o(u) : d) * Z
      ), await e().then(() => {
        N(!0), D();
      });
    },
    h ? g : null
  ), tw(() => D());
  const $ = pt(() => {
    l(0), q(I);
  }, [I]), C = pt(
    (U = {}) => {
      const { delay: Z, delayRange: Q } = U;
      N(!1), $(), Q && (f(Q), q(o(Q))), Z && (m(Z), q(Z)), v(!0);
    },
    [$]
  ), D = pt(() => {
    v(!1), $();
  }, [$]);
  return qe(() => {
    s >= i && D();
  }, [s, i, D]), et(
    () => ({ isRunning: h, isSuccessful: S, start: C, stop: D }),
    [h, S, C, D]
  );
}, vI = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, bI = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function _I({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = mn(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? JF : QF,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: S
  } = kI({
    query: u,
    useDelayRange: !0
  }), N = m || h;
  return qe(() => {
    if (d)
      if (_S({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const F = vI(d);
          v({
            ...F && {
              delayRange: bI(F)
            }
          });
        }
      } else
        s(d);
  }, [d]), qe(() => {
    if (!m && l?.Klaviyo) {
      let F = {}, I = {};
      n === "lists" && (F = l?.Klaviyo?.get_profile_lists), n === "segments" && (I = l?.Klaviyo?.get_profile_segments), (F?.data || I?.data) && (S(), a(
        (n === "lists" ? F?.data : I?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), et(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: N,
      error: o,
      networkStatus: f
    }),
    [i, N, o, f, v]
  );
}
const xI = "_notificationText_1polx_1", Mm = {
  notificationText: xI
}, Os = ({ error: e }) => {
  const { track: n } = kn();
  let r = e;
  if (cb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && ib({ error: i[0] }), o = i.length === 1 && bS({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ $e.jsx(wn, { error: e });
  }
  return /* @__PURE__ */ $e.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ $e.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ $e.jsx(ue, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, SI = "_message_1vrar_48", NI = "_messageIsOpen_1vrar_56", jI = "_messageHeader_1vrar_59", wI = "_messageLabel_1vrar_65", CI = "_messageText_1vrar_68", Ti = {
  message: SI,
  messageIsOpen: NI,
  messageHeader: jI,
  messageLabel: wI,
  messageText: CI
}, FI = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && sI(e.flowMessage);
  return /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Ti.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ $e.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ $e.jsx(un, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ $e.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Ti.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Ti.messageText, children: i })
        ]
      }
    )
  ] });
}, II = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ $e.jsx($e.Fragment, { children: /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ $e.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, EI = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = et(
    () => () => l ? Pn(l).format(m) : d ? Pn.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, S = f && e.clicked, N = f && o?.event_properties.Subject, F = h && o?.event_properties["Message Name"], I = f ? "mail" : "sms";
  return /* @__PURE__ */ $e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ct(Ti.message, {
        [Ti.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ $e.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Ti.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ $e.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ $e.jsx(ue, { size: 16, name: I }),
                  " ",
                  cI(s),
                  u && /* @__PURE__ */ $e.jsx(Un, { size: "small", variant: "info", children: u })
                ] }),
                N && N,
                F && F
              ] }),
              /* @__PURE__ */ $e.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ $e.jsx(bm, {}),
          eI(e) && /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(Un, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
            /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ $e.jsx(On, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  ue,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ $e.jsx(On, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  ue,
                  {
                    size: 16,
                    color: S ? "green.400" : "red.400",
                    name: S ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ $e.jsx(FI, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ $e.jsx(II, { event: e })
        ] })
      ]
    }
  );
}, TI = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, $I = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = mI({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = TF({
    query: WF,
    options: TI,
    delayMs: 1e3
  }), [m, u] = se([]);
  qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => Yu(v)).map((v) => eh(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && Yu(h) && !h.flowMessage) {
          const v = eh(h), S = d.find((F) => (F.data && th(F.data))?.id === v), N = S?.data && th(S.data);
          if (N)
            return {
              ...lI(h),
              flowMessage: N
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ $e.jsx(
    wn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ $e.jsx(
    Os,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(un, {}) }) : /* @__PURE__ */ $e.jsx($e.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ $e.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ $e.jsx(
      EI,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ $e.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Mm.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, DI = "_list_ld0hf_1", RI = "_listItem_ld0hf_4", $a = {
  list: DI,
  listItem: RI
}, ih = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = _I({ profileId: e, query: n });
  qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ $e.jsx(Os, { error: o }) : s ? /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsx(un, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ $e.jsx(On, { children: ws(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ $e.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ $e.jsx(ue, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ $e.jsx(Ke, { content: "Refresh lists and segments", children: /* @__PURE__ */ $e.jsx(Wn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: $a.listItem, children: /* @__PURE__ */ $e.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ $e.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, OI = "_tagHover_kzbzk_1", PI = "_channelUnsubscribed_kzbzk_6", ah = {
  tagHover: OI,
  channelUnsubscribed: PI
}, oh = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ $e.jsx(
    Ke,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ $e.jsx(
        On,
        {
          className: ah.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ $e.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ct({
                [ah.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ $e.jsx(un, { size: 16 }) : /* @__PURE__ */ $e.jsx(ue, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, AI = "_subscriptionError_1qhhx_1", LI = {
  subscriptionError: AI
}, VI = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = kn(), [v, S] = nw({
    channel: null,
    request: null
  }), N = dI(n), F = uI(n), I = !!e, { useMutation: g } = mn(), [q] = g(
    XF
  ), [$] = g(
    ZF
  ), C = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), S.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => q({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: "profile",
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  phone_number: i,
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, D = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), S.setAll({
      channel: Z,
      request: "unsubscribed"
    }), $({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: "profile",
                attributes: {
                  ...Z === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: ee,
    isSubscriptionRequest: J
  }) => {
    const G = ee?.networkError, P = G ? G?.statusCode : NaN, W = Q?.errors, ne = !!W && ab({
      errors: W
    });
    P === 202 ? (h(
      J ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ne ? (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${J ? "opt-in" : "opt-out"}.`
    )) : (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: G?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${J ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return qe(() => {
    if (v.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), S.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), S.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ $e.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(
            oh,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: N,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: I,
              handleAction: () => {
                l(!0), f(void 0), N ? D("EMAIL") : C("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ $e.jsx(
            oh,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: F,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: I,
              handleAction: () => {
                m(!0), f(void 0), F ? D("SMS") : C("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ $e.jsx(b, { className: LI.subscriptionError, children: u })
      ] })
    }
  );
}, zI = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: d,
    error: m,
    isLoading: u,
    refetchProfile: f
  } = pI({ profileId: e });
  return m ? /* @__PURE__ */ $e.jsx(Os, { error: m }) : u ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(un, {}) }) : !d && !u ? /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Mm.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ $e.jsxs(He, { className: $a.list, children: [
        i && /* @__PURE__ */ $e.jsx(ih, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ $e.jsx(
          ih,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ $e.jsx(
      VI,
      {
        profile: d,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: r
      }
    ),
    /* @__PURE__ */ $e.jsx(
      $I,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, UI = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: m,
    getProfileId: u,
    isLoading: f,
    error: h
  } = fI({ email: r, phoneNumber: i });
  return NS(() => {
    (r || i) && u({
      variables: {
        emailFilter: `equals(email,"${r}")`,
        phoneNumberFilter: `equals(phone_number,"${i}")`
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(un, {}) }) : h ? /* @__PURE__ */ $e.jsx(Os, { error: h }) : m ? /* @__PURE__ */ $e.jsx(
    zI,
    {
      profileId: m,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Mm.notificationText,
      children: "No profile ID found"
    }
  );
}, MI = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
function BI(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const qI = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, HI = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, WI = {};
function sh(e, n) {
  return (WI.jsx ? HI : qI).test(e);
}
const KI = /[ \t\n\f\r]/g;
function GI(e) {
  return typeof e == "object" ? e.type === "text" ? lh(e.value) : !1 : lh(e);
}
function lh(e) {
  return e.replace(KI, "") === "";
}
class to {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
to.prototype.property = {};
to.prototype.normal = {};
to.prototype.space = null;
function p_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new to(r, i, n);
}
function Ju(e) {
  return e.toLowerCase();
}
class lr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
lr.prototype.space = null;
lr.prototype.boolean = !1;
lr.prototype.booleanish = !1;
lr.prototype.overloadedBoolean = !1;
lr.prototype.number = !1;
lr.prototype.commaSeparated = !1;
lr.prototype.spaceSeparated = !1;
lr.prototype.commaOrSpaceSeparated = !1;
lr.prototype.mustUseProperty = !1;
lr.prototype.defined = !1;
let YI = 0;
const Cn = yi(), ut = yi(), f_ = yi(), Ve = yi(), Xn = yi(), $i = yi(), Gt = yi();
function yi() {
  return 2 ** ++YI;
}
const Qu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Cn,
  booleanish: ut,
  commaOrSpaceSeparated: Gt,
  commaSeparated: $i,
  number: Ve,
  overloadedBoolean: f_,
  spaceSeparated: Xn
}, Symbol.toStringTag, { value: "Module" })), fl = Object.keys(Qu);
class Bm extends lr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), ch(this, "space", a), typeof i == "number")
      for (; ++o < fl.length; ) {
        const s = fl[o];
        ch(this, fl[o], (i & Qu[s]) === Qu[s]);
      }
  }
}
Bm.prototype.defined = !0;
function ch(e, n, r) {
  r && (e[n] = r);
}
const JI = {}.hasOwnProperty;
function Bi(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (JI.call(e.properties, i)) {
      const a = e.properties[i], o = new Bm(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Ju(i)] = i, r[Ju(o.attribute)] = i;
    }
  return new to(n, r, e.space);
}
const h_ = Bi({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), y_ = Bi({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function g_(e, n) {
  return n in e ? e[n] : n;
}
function k_(e, n) {
  return g_(e, n.toLowerCase());
}
const v_ = Bi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: k_,
  properties: { xmlns: null, xmlnsXLink: null }
}), b_ = Bi({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ut,
    ariaAutoComplete: null,
    ariaBusy: ut,
    ariaChecked: ut,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Xn,
    ariaCurrent: null,
    ariaDescribedBy: Xn,
    ariaDetails: null,
    ariaDisabled: ut,
    ariaDropEffect: Xn,
    ariaErrorMessage: null,
    ariaExpanded: ut,
    ariaFlowTo: Xn,
    ariaGrabbed: ut,
    ariaHasPopup: null,
    ariaHidden: ut,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Xn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: ut,
    ariaMultiLine: ut,
    ariaMultiSelectable: ut,
    ariaOrientation: null,
    ariaOwns: Xn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: ut,
    ariaReadOnly: ut,
    ariaRelevant: null,
    ariaRequired: ut,
    ariaRoleDescription: Xn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: ut,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), QI = Bi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: k_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: $i,
    acceptCharset: Xn,
    accessKey: Xn,
    action: null,
    allow: null,
    allowFullScreen: Cn,
    allowPaymentRequest: Cn,
    allowUserMedia: Cn,
    alt: null,
    as: null,
    async: Cn,
    autoCapitalize: null,
    autoComplete: Xn,
    autoFocus: Cn,
    autoPlay: Cn,
    blocking: Xn,
    capture: null,
    charSet: null,
    checked: Cn,
    cite: null,
    className: Xn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: ut,
    controls: Cn,
    controlsList: Xn,
    coords: Ve | $i,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Cn,
    defer: Cn,
    dir: null,
    dirName: null,
    disabled: Cn,
    download: f_,
    draggable: ut,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Cn,
    formTarget: null,
    headers: Xn,
    height: Ve,
    hidden: Cn,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Xn,
    httpEquiv: Xn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Cn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Cn,
    itemId: null,
    itemProp: Xn,
    itemRef: Xn,
    itemScope: Cn,
    itemType: Xn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Cn,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: Cn,
    muted: Cn,
    name: null,
    nonce: null,
    noModule: Cn,
    noValidate: Cn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Cn,
    optimum: Ve,
    pattern: null,
    ping: Xn,
    placeholder: null,
    playsInline: Cn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Cn,
    referrerPolicy: null,
    rel: Xn,
    required: Cn,
    reversed: Cn,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Xn,
    scope: null,
    scoped: Cn,
    seamless: Cn,
    selected: Cn,
    shadowRootClonable: Cn,
    shadowRootDelegatesFocus: Cn,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: ut,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Cn,
    useMap: null,
    value: ut,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Xn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Cn,
    // Lists. Use CSS to reduce space between items instead
    declare: Cn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: Cn,
    // `<frame>`
    noHref: Cn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Cn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Cn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ut,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Cn,
    disableRemotePlayback: Cn,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), XI = Bi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: g_,
  properties: {
    about: Gt,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Xn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: Cn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: $i,
    g2: $i,
    glyphName: $i,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: Gt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Xn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Gt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Gt,
    rev: Gt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Gt,
    requiredFeatures: Gt,
    requiredFonts: Gt,
    requiredFormats: Gt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: Gt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Gt,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Gt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), ZI = /^data[-\w.:]+$/i, dh = /-[a-z]/g, eE = /[A-Z]/g;
function nE(e, n) {
  const r = Ju(n);
  let i = n, a = lr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && ZI.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(dh, rE);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!dh.test(o)) {
        let s = o.replace(eE, tE);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Bm;
  }
  return new a(i, n);
}
function tE(e) {
  return "-" + e.toLowerCase();
}
function rE(e) {
  return e.charAt(1).toUpperCase();
}
const iE = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, aE = p_([y_, h_, v_, b_, QI], "html"), qm = p_([y_, h_, v_, b_, XI], "svg");
function oE(e) {
  return e.join(" ").trim();
}
var _i = {}, hl, uh;
function sE() {
  if (uh) return hl;
  uh = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  hl = function(N, F) {
    if (typeof N != "string")
      throw new TypeError("First argument must be a string");
    if (!N) return [];
    F = F || {};
    var I = 1, g = 1;
    function q(P) {
      var W = P.match(n);
      W && (I += W.length);
      var ne = P.lastIndexOf(d);
      g = ~ne ? P.length - ne : g + P.length;
    }
    function $() {
      var P = { line: I, column: g };
      return function(W) {
        return W.position = new C(P), Z(), W;
      };
    }
    function C(P) {
      this.start = P, this.end = { line: I, column: g }, this.source = F.source;
    }
    C.prototype.content = N;
    function D(P) {
      var W = new Error(
        F.source + ":" + I + ":" + g + ": " + P
      );
      if (W.reason = P, W.filename = F.source, W.line = I, W.column = g, W.source = N, !F.silent) throw W;
    }
    function U(P) {
      var W = P.exec(N);
      if (W) {
        var ne = W[0];
        return q(ne), N = N.slice(ne.length), W;
      }
    }
    function Z() {
      U(r);
    }
    function Q(P) {
      var W;
      for (P = P || []; W = ee(); )
        W !== !1 && P.push(W);
      return P;
    }
    function ee() {
      var P = $();
      if (!(m != N.charAt(0) || u != N.charAt(1))) {
        for (var W = 2; f != N.charAt(W) && (u != N.charAt(W) || m != N.charAt(W + 1)); )
          ++W;
        if (W += 2, f === N.charAt(W - 1))
          return D("End of comment missing");
        var ne = N.slice(2, W - 2);
        return g += 2, q(ne), N = N.slice(W), g += 2, P({
          type: h,
          comment: ne
        });
      }
    }
    function J() {
      var P = $(), W = U(i);
      if (W) {
        if (ee(), !U(a)) return D("property missing ':'");
        var ne = U(o), ke = P({
          type: v,
          property: S(W[0].replace(e, f)),
          value: ne ? S(ne[0].replace(e, f)) : f
        });
        return U(s), ke;
      }
    }
    function G() {
      var P = [];
      Q(P);
      for (var W; W = J(); )
        W !== !1 && (P.push(W), Q(P));
      return P;
    }
    return Z(), G();
  };
  function S(N) {
    return N ? N.replace(l, f) : f;
  }
  return hl;
}
var mh;
function lE() {
  if (mh) return _i;
  mh = 1;
  var e = _i && _i.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(_i, "__esModule", { value: !0 }), _i.default = r;
  var n = e(sE());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return _i;
}
var cE = lE();
const ph = /* @__PURE__ */ Nm(cE), dE = ph.default || ph, __ = x_("end"), Hm = x_("start");
function x_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function uE(e) {
  const n = Hm(e), r = __(e);
  if (n && r)
    return { start: n, end: r };
}
function Pa(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? fh(e.position) : "start" in e || "end" in e ? fh(e) : "line" in e || "column" in e ? Xu(e) : "";
}
function Xu(e) {
  return hh(e && e.line) + ":" + hh(e && e.column);
}
function fh(e) {
  return Xu(e && e.start) + "-" + Xu(e && e.end);
}
function hh(e) {
  return e && typeof e == "number" ? e : 1;
}
class Ft extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Pa(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Ft.prototype.file = "";
Ft.prototype.name = "";
Ft.prototype.reason = "";
Ft.prototype.message = "";
Ft.prototype.stack = "";
Ft.prototype.column = void 0;
Ft.prototype.line = void 0;
Ft.prototype.ancestors = void 0;
Ft.prototype.cause = void 0;
Ft.prototype.fatal = void 0;
Ft.prototype.place = void 0;
Ft.prototype.ruleId = void 0;
Ft.prototype.source = void 0;
const Wm = {}.hasOwnProperty, mE = /* @__PURE__ */ new Map(), pE = /[A-Z]/g, fE = /-([a-z])/g, hE = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), yE = /* @__PURE__ */ new Set(["td", "th"]), S_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function gE(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = jE(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = NE(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? qm : aE,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = N_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function N_(e, n, r) {
  if (n.type === "element")
    return kE(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return vE(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return _E(e, n, r);
  if (n.type === "mdxjsEsm")
    return bE(e, n);
  if (n.type === "root")
    return xE(e, n, r);
  if (n.type === "text")
    return SE(e, n);
}
function kE(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = qm, e.schema = a), e.ancestors.push(n);
  const o = w_(e, n.tagName, !1), s = wE(e, n);
  let l = Gm(e, n);
  return hE.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !GI(d) : !0;
  })), j_(e, s, o, n), Km(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function vE(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Wa(e, n.position);
}
function bE(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Wa(e, n.position);
}
function _E(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = qm, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : w_(e, n.name, !0), s = CE(e, n), l = Gm(e, n);
  return j_(e, s, o, n), Km(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function xE(e, n, r) {
  const i = {};
  return Km(i, Gm(e, n)), e.create(n, e.Fragment, i, r);
}
function SE(e, n) {
  return n.value;
}
function j_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Km(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function NE(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function jE(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Hm(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function wE(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Wm.call(n.properties, a)) {
      const o = FE(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && yE.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function CE(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Wa(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Wa(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function Gm(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : mE;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = N_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function FE(e, n, r) {
  const i = nE(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? BI(r) : oE(r)), i.property === "style") {
      let a = typeof r == "object" ? r : IE(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = EE(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? iE[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function IE(e, n) {
  const r = {};
  try {
    dE(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Ft("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = S_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(fE, $E)), r[s] = o;
  }
}
function w_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = sh(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = sh(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Wm.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Wa(e);
}
function Wa(e, n) {
  const r = new Ft(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = S_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function EE(e) {
  const n = {};
  let r;
  for (r in e)
    Wm.call(e, r) && (n[TE(r)] = e[r]);
  return n;
}
function TE(e) {
  let n = e.replace(pE, DE);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function $E(e, n) {
  return n.toUpperCase();
}
function DE(e) {
  return "-" + e.toLowerCase();
}
const yl = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, RE = {};
function OE(e, n) {
  const r = RE, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return C_(e, i, a);
}
function C_(e, n, r) {
  if (PE(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return yh(e.children, n, r);
  }
  return Array.isArray(e) ? yh(e, n, r) : "";
}
function yh(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = C_(e[a], n, r);
  return i.join("");
}
function PE(e) {
  return !!(e && typeof e == "object");
}
const gh = document.createElement("i");
function Ym(e) {
  const n = "&" + e + ";";
  gh.innerHTML = n;
  const r = gh.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Dr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function tr(e, n) {
  return e.length > 0 ? (Dr(e, e.length, 0, n), e) : n;
}
const kh = {}.hasOwnProperty;
function AE(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    LE(n, e[r]);
  return n;
}
function LE(e, n) {
  let r;
  for (r in n) {
    const a = (kh.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        kh.call(a, s) || (a[s] = []);
        const l = o[s];
        VE(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function VE(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Dr(e, 0, 0, i);
}
function F_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Di(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Cr = Xr(/[A-Za-z]/), Zt = Xr(/[\dA-Za-z]/), zE = Xr(/[#-'*+\--9=?A-Z^-~]/);
function Zu(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const em = Xr(/\d/), UE = Xr(/[\dA-Fa-f]/), ME = Xr(/[!-/:-@[-`{-~]/);
function hn(e) {
  return e !== null && e < -2;
}
function Wt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const BE = Xr(new RegExp("\\p{P}|\\p{S}", "u")), qE = Xr(/\s/);
function Xr(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function qi(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && Zt(e.charCodeAt(r + 1)) && Zt(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function Zn(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const HE = {
  tokenize: WE
};
function WE(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Zn(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return hn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const KE = {
  tokenize: GE
}, vh = {
  tokenize: YE
};
function GE(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(q) {
    if (i < r.length) {
      const $ = r[i];
      return n.containerState = $[1], e.attempt($[0].continuation, d, m)(q);
    }
    return m(q);
  }
  function d(q) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const $ = n.events.length;
      let C = $, D;
      for (; C--; )
        if (n.events[C][0] === "exit" && n.events[C][1].type === "chunkFlow") {
          D = n.events[C][1].end;
          break;
        }
      I(i);
      let U = $;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...D
        }, U++;
      return Dr(n.events, C + 1, 0, n.events.slice($)), n.events.length = U, m(q);
    }
    return l(q);
  }
  function m(q) {
    if (i === r.length) {
      if (!a)
        return h(q);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return S(q);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(vh, u, f)(q);
  }
  function u(q) {
    return a && g(), I(i), h(q);
  }
  function f(q) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, S(q);
  }
  function h(q) {
    return n.containerState = {}, e.attempt(vh, v, S)(q);
  }
  function v(q) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(q);
  }
  function S(q) {
    if (q === null) {
      a && g(), I(0), e.consume(q);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), N(q);
  }
  function N(q) {
    if (q === null) {
      F(e.exit("chunkFlow"), !0), I(0), e.consume(q);
      return;
    }
    return hn(q) ? (e.consume(q), F(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(q), N);
  }
  function F(q, $) {
    const C = n.sliceStream(q);
    if ($ && C.push(null), q.previous = o, o && (o.next = q), o = q, a.defineSkip(q.start), a.write(C), n.parser.lazy[q.start.line]) {
      let D = a.events.length;
      for (; D--; )
        if (
          // The token starts before the line ending…
          a.events[D][1].start.offset < s && // …and either is not ended yet…
          (!a.events[D][1].end || // …or ends after it.
          a.events[D][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Z = U, Q, ee;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            ee = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (I(i), D = U; D < n.events.length; )
        n.events[D][1].end = {
          ...ee
        }, D++;
      Dr(n.events, Z + 1, 0, n.events.slice(U)), n.events.length = D;
    }
  }
  function I(q) {
    let $ = r.length;
    for (; $-- > q; ) {
      const C = r[$];
      n.containerState = C[1], C[0].exit.call(n, e);
    }
    r.length = q;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function YE(e, n, r) {
  return Zn(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function bh(e) {
  if (e === null || Wt(e) || qE(e))
    return 1;
  if (BE(e))
    return 2;
}
function Jm(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const nm = {
  name: "attention",
  resolveAll: JE,
  tokenize: QE
};
function JE(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          _h(f, -d), _h(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = tr(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = tr(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = tr(m, Jm(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = tr(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = tr(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Dr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function QE(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = bh(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = bh(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function _h(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const XE = {
  name: "autolink",
  tokenize: ZE
};
function ZE(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Cr(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || Zt(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || Zt(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || Zu(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : zE(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return Zt(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || Zt(v)) && i++ < 63) {
      const S = v === 45 ? h : f;
      return e.consume(v), S;
    }
    return r(v);
  }
}
const Ps = {
  partial: !0,
  tokenize: eT
};
function eT(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? Zn(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || hn(o) ? n(o) : r(o);
  }
}
const I_ = {
  continuation: {
    tokenize: tT
  },
  exit: rT,
  name: "blockQuote",
  tokenize: nT
};
function nT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function tT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? Zn(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(I_, n, r)(s);
  }
}
function rT(e) {
  e.exit("blockQuote");
}
const E_ = {
  name: "characterEscape",
  tokenize: iT
};
function iT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return ME(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const T_ = {
  name: "characterReference",
  tokenize: aT
};
function aT(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = Zt, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = UE, u) : (e.enter("characterReferenceValue"), o = 7, s = em, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === Zt && !Ym(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const xh = {
  partial: !0,
  tokenize: sT
}, Sh = {
  concrete: !0,
  name: "codeFenced",
  tokenize: oT
};
function oT(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: C
  };
  let o = 0, s = 0, l;
  return d;
  function d(D) {
    return m(D);
  }
  function m(D) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = D, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(D);
  }
  function u(D) {
    return D === l ? (s++, e.consume(D), u) : s < 3 ? r(D) : (e.exit("codeFencedFenceSequence"), zn(D) ? Zn(e, f, "whitespace")(D) : f(D));
  }
  function f(D) {
    return D === null || hn(D) ? (e.exit("codeFencedFence"), i.interrupt ? n(D) : e.check(xh, N, $)(D)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(D));
  }
  function h(D) {
    return D === null || hn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(D)) : zn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Zn(e, v, "whitespace")(D)) : D === 96 && D === l ? r(D) : (e.consume(D), h);
  }
  function v(D) {
    return D === null || hn(D) ? f(D) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), S(D));
  }
  function S(D) {
    return D === null || hn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(D)) : D === 96 && D === l ? r(D) : (e.consume(D), S);
  }
  function N(D) {
    return e.attempt(a, $, F)(D);
  }
  function F(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), I;
  }
  function I(D) {
    return o > 0 && zn(D) ? Zn(e, g, "linePrefix", o + 1)(D) : g(D);
  }
  function g(D) {
    return D === null || hn(D) ? e.check(xh, N, $)(D) : (e.enter("codeFlowValue"), q(D));
  }
  function q(D) {
    return D === null || hn(D) ? (e.exit("codeFlowValue"), g(D)) : (e.consume(D), q);
  }
  function $(D) {
    return e.exit("codeFenced"), n(D);
  }
  function C(D, U, Z) {
    let Q = 0;
    return ee;
    function ee(ne) {
      return D.enter("lineEnding"), D.consume(ne), D.exit("lineEnding"), J;
    }
    function J(ne) {
      return D.enter("codeFencedFence"), zn(ne) ? Zn(D, G, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : G(ne);
    }
    function G(ne) {
      return ne === l ? (D.enter("codeFencedFenceSequence"), P(ne)) : Z(ne);
    }
    function P(ne) {
      return ne === l ? (Q++, D.consume(ne), P) : Q >= s ? (D.exit("codeFencedFenceSequence"), zn(ne) ? Zn(D, W, "whitespace")(ne) : W(ne)) : Z(ne);
    }
    function W(ne) {
      return ne === null || hn(ne) ? (D.exit("codeFencedFence"), U(ne)) : Z(ne);
    }
  }
}
function sT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const gl = {
  name: "codeIndented",
  tokenize: cT
}, lT = {
  partial: !0,
  tokenize: dT
};
function cT(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), Zn(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : hn(m) ? e.attempt(lT, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || hn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function dT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : hn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : Zn(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : hn(s) ? a(s) : r(s);
  }
}
const uT = {
  name: "codeText",
  previous: pT,
  resolve: mT,
  tokenize: fT
};
function mT(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function pT(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function fT(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : hn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || hn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class hT {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && la(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), la(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), la(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        la(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        la(this.left, r.reverse());
      }
  }
}
function la(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function $_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new hT(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, yT(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Dr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function yT(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, S = 0, N = 0;
  const F = [N];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (N = h + 1, F.push(N), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : F.pop(), h = F.length; h--; ) {
    const I = l.slice(F[h], F[h + 1]), g = o.pop();
    d.push([g, g + I.length - 1]), e.splice(g, 2, I);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[S + d[h][0]] = S + d[h][1], S += d[h][1] - d[h][0] - 1;
  return m;
}
const gT = {
  resolve: vT,
  tokenize: bT
}, kT = {
  partial: !0,
  tokenize: _T
};
function vT(e) {
  return $_(e), e;
}
function bT(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : hn(l) ? e.check(kT, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function _T(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Zn(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || hn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function D_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(I) {
    return I === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(I), e.exit(o), h) : I === null || I === 32 || I === 41 || Zu(I) ? r(I) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), N(I));
  }
  function h(I) {
    return I === 62 ? (e.enter(o), e.consume(I), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(I));
  }
  function v(I) {
    return I === 62 ? (e.exit("chunkString"), e.exit(l), h(I)) : I === null || I === 60 || hn(I) ? r(I) : (e.consume(I), I === 92 ? S : v);
  }
  function S(I) {
    return I === 60 || I === 62 || I === 92 ? (e.consume(I), v) : v(I);
  }
  function N(I) {
    return !u && (I === null || I === 41 || Wt(I)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(I)) : u < m && I === 40 ? (e.consume(I), u++, N) : I === 41 ? (e.consume(I), u--, N) : I === null || I === 32 || I === 40 || Zu(I) ? r(I) : (e.consume(I), I === 92 ? F : N);
  }
  function F(I) {
    return I === 40 || I === 41 || I === 92 ? (e.consume(I), N) : N(I);
  }
}
function R_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : hn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || hn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function O_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : hn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), Zn(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || hn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Aa(e, n) {
  let r;
  return i;
  function i(a) {
    return hn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? Zn(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const xT = {
  name: "definition",
  tokenize: NT
}, ST = {
  partial: !0,
  tokenize: jT
};
function NT(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return R_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = Di(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Wt(v) ? Aa(e, m)(v) : m(v);
  }
  function m(v) {
    return D_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(ST, f, f)(v);
  }
  function f(v) {
    return zn(v) ? Zn(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || hn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function jT(e, n, r) {
  return i;
  function i(l) {
    return Wt(l) ? Aa(e, a)(l) : r(l);
  }
  function a(l) {
    return O_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? Zn(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || hn(l) ? n(l) : r(l);
  }
}
const wT = {
  name: "hardBreakEscape",
  tokenize: CT
};
function CT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return hn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const FT = {
  name: "headingAtx",
  resolve: IT,
  tokenize: ET
};
function IT(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Dr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function ET(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Wt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || hn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? Zn(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Wt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const TT = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Nh = ["pre", "script", "style", "textarea"], $T = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: OT,
  tokenize: PT
}, DT = {
  partial: !0,
  tokenize: LT
}, RT = {
  partial: !0,
  tokenize: AT
};
function OT(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function PT(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, N) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : H) : Cr(K) ? (e.consume(K), s = String.fromCharCode(K), F) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, v) : K === 91 ? (e.consume(K), a = 5, l = 0, S) : Cr(K) ? (e.consume(K), a = 4, i.interrupt ? n : H) : r(K);
  }
  function v(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : H) : r(K);
  }
  function S(K) {
    const ze = "CDATA[";
    return K === ze.charCodeAt(l++) ? (e.consume(K), l === ze.length ? i.interrupt ? n : G : S) : r(K);
  }
  function N(K) {
    return Cr(K) ? (e.consume(K), s = String.fromCharCode(K), F) : r(K);
  }
  function F(K) {
    if (K === null || K === 47 || K === 62 || Wt(K)) {
      const ze = K === 47, Be = s.toLowerCase();
      return !ze && !o && Nh.includes(Be) ? (a = 1, i.interrupt ? n(K) : G(K)) : TT.includes(s.toLowerCase()) ? (a = 6, ze ? (e.consume(K), I) : i.interrupt ? n(K) : G(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? g(K) : q(K));
    }
    return K === 45 || Zt(K) ? (e.consume(K), s += String.fromCharCode(K), F) : r(K);
  }
  function I(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : G) : r(K);
  }
  function g(K) {
    return zn(K) ? (e.consume(K), g) : ee(K);
  }
  function q(K) {
    return K === 47 ? (e.consume(K), ee) : K === 58 || K === 95 || Cr(K) ? (e.consume(K), $) : zn(K) ? (e.consume(K), q) : ee(K);
  }
  function $(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || Zt(K) ? (e.consume(K), $) : C(K);
  }
  function C(K) {
    return K === 61 ? (e.consume(K), D) : zn(K) ? (e.consume(K), C) : q(K);
  }
  function D(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, U) : zn(K) ? (e.consume(K), D) : Z(K);
  }
  function U(K) {
    return K === d ? (e.consume(K), d = null, Q) : K === null || hn(K) ? r(K) : (e.consume(K), U);
  }
  function Z(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Wt(K) ? C(K) : (e.consume(K), Z);
  }
  function Q(K) {
    return K === 47 || K === 62 || zn(K) ? q(K) : r(K);
  }
  function ee(K) {
    return K === 62 ? (e.consume(K), J) : r(K);
  }
  function J(K) {
    return K === null || hn(K) ? G(K) : zn(K) ? (e.consume(K), J) : r(K);
  }
  function G(K) {
    return K === 45 && a === 2 ? (e.consume(K), ke) : K === 60 && a === 1 ? (e.consume(K), me) : K === 62 && a === 4 ? (e.consume(K), be) : K === 63 && a === 3 ? (e.consume(K), H) : K === 93 && a === 5 ? (e.consume(K), he) : hn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(DT, Ce, P)(K)) : K === null || hn(K) ? (e.exit("htmlFlowData"), P(K)) : (e.consume(K), G);
  }
  function P(K) {
    return e.check(RT, W, Ce)(K);
  }
  function W(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ne;
  }
  function ne(K) {
    return K === null || hn(K) ? P(K) : (e.enter("htmlFlowData"), G(K));
  }
  function ke(K) {
    return K === 45 ? (e.consume(K), H) : G(K);
  }
  function me(K) {
    return K === 47 ? (e.consume(K), s = "", de) : G(K);
  }
  function de(K) {
    if (K === 62) {
      const ze = s.toLowerCase();
      return Nh.includes(ze) ? (e.consume(K), be) : G(K);
    }
    return Cr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), de) : G(K);
  }
  function he(K) {
    return K === 93 ? (e.consume(K), H) : G(K);
  }
  function H(K) {
    return K === 62 ? (e.consume(K), be) : K === 45 && a === 2 ? (e.consume(K), H) : G(K);
  }
  function be(K) {
    return K === null || hn(K) ? (e.exit("htmlFlowData"), Ce(K)) : (e.consume(K), be);
  }
  function Ce(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function AT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return hn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function LT(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Ps, n, r);
  }
}
const VT = {
  name: "htmlText",
  tokenize: zT
};
function zT(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(H) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(H), d;
  }
  function d(H) {
    return H === 33 ? (e.consume(H), m) : H === 47 ? (e.consume(H), C) : H === 63 ? (e.consume(H), q) : Cr(H) ? (e.consume(H), Z) : r(H);
  }
  function m(H) {
    return H === 45 ? (e.consume(H), u) : H === 91 ? (e.consume(H), o = 0, S) : Cr(H) ? (e.consume(H), g) : r(H);
  }
  function u(H) {
    return H === 45 ? (e.consume(H), v) : r(H);
  }
  function f(H) {
    return H === null ? r(H) : H === 45 ? (e.consume(H), h) : hn(H) ? (s = f, me(H)) : (e.consume(H), f);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), v) : f(H);
  }
  function v(H) {
    return H === 62 ? ke(H) : H === 45 ? h(H) : f(H);
  }
  function S(H) {
    const be = "CDATA[";
    return H === be.charCodeAt(o++) ? (e.consume(H), o === be.length ? N : S) : r(H);
  }
  function N(H) {
    return H === null ? r(H) : H === 93 ? (e.consume(H), F) : hn(H) ? (s = N, me(H)) : (e.consume(H), N);
  }
  function F(H) {
    return H === 93 ? (e.consume(H), I) : N(H);
  }
  function I(H) {
    return H === 62 ? ke(H) : H === 93 ? (e.consume(H), I) : N(H);
  }
  function g(H) {
    return H === null || H === 62 ? ke(H) : hn(H) ? (s = g, me(H)) : (e.consume(H), g);
  }
  function q(H) {
    return H === null ? r(H) : H === 63 ? (e.consume(H), $) : hn(H) ? (s = q, me(H)) : (e.consume(H), q);
  }
  function $(H) {
    return H === 62 ? ke(H) : q(H);
  }
  function C(H) {
    return Cr(H) ? (e.consume(H), D) : r(H);
  }
  function D(H) {
    return H === 45 || Zt(H) ? (e.consume(H), D) : U(H);
  }
  function U(H) {
    return hn(H) ? (s = U, me(H)) : zn(H) ? (e.consume(H), U) : ke(H);
  }
  function Z(H) {
    return H === 45 || Zt(H) ? (e.consume(H), Z) : H === 47 || H === 62 || Wt(H) ? Q(H) : r(H);
  }
  function Q(H) {
    return H === 47 ? (e.consume(H), ke) : H === 58 || H === 95 || Cr(H) ? (e.consume(H), ee) : hn(H) ? (s = Q, me(H)) : zn(H) ? (e.consume(H), Q) : ke(H);
  }
  function ee(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || Zt(H) ? (e.consume(H), ee) : J(H);
  }
  function J(H) {
    return H === 61 ? (e.consume(H), G) : hn(H) ? (s = J, me(H)) : zn(H) ? (e.consume(H), J) : Q(H);
  }
  function G(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? r(H) : H === 34 || H === 39 ? (e.consume(H), a = H, P) : hn(H) ? (s = G, me(H)) : zn(H) ? (e.consume(H), G) : (e.consume(H), W);
  }
  function P(H) {
    return H === a ? (e.consume(H), a = void 0, ne) : H === null ? r(H) : hn(H) ? (s = P, me(H)) : (e.consume(H), P);
  }
  function W(H) {
    return H === null || H === 34 || H === 39 || H === 60 || H === 61 || H === 96 ? r(H) : H === 47 || H === 62 || Wt(H) ? Q(H) : (e.consume(H), W);
  }
  function ne(H) {
    return H === 47 || H === 62 || Wt(H) ? Q(H) : r(H);
  }
  function ke(H) {
    return H === 62 ? (e.consume(H), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(H);
  }
  function me(H) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), de;
  }
  function de(H) {
    return zn(H) ? Zn(e, he, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : he(H);
  }
  function he(H) {
    return e.enter("htmlTextData"), s(H);
  }
}
const Qm = {
  name: "labelEnd",
  resolveAll: qT,
  resolveTo: HT,
  tokenize: WT
}, UT = {
  tokenize: KT
}, MT = {
  tokenize: GT
}, BT = {
  tokenize: YT
};
function qT(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Dr(e, 0, e.length, r), e;
}
function HT(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = tr(l, e.slice(o + 1, o + i + 3)), l = tr(l, [["enter", u, n]]), l = tr(l, Jm(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = tr(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = tr(l, e.slice(s + 1)), l = tr(l, [["exit", d, n]]), Dr(e, o, e.length, l), e;
}
function WT(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Di(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(UT, u, s ? u : f)(h) : h === 91 ? e.attempt(MT, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(BT, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function KT(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Wt(f) ? Aa(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : D_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Wt(f) ? Aa(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? O_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Wt(f) ? Aa(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function GT(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return R_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Di(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function YT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const JT = {
  name: "labelStartImage",
  resolveAll: Qm.resolveAll,
  tokenize: QT
};
function QT(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const XT = {
  name: "labelStartLink",
  resolveAll: Qm.resolveAll,
  tokenize: ZT
};
function ZT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const kl = {
  name: "lineEnding",
  tokenize: e$
};
function e$(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), Zn(e, n, "linePrefix");
  }
}
const Yo = {
  name: "thematicBreak",
  tokenize: n$
};
function n$(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || hn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? Zn(e, l, "whitespace")(m) : l(m));
  }
}
const Mt = {
  continuation: {
    tokenize: a$
  },
  exit: s$,
  name: "list",
  tokenize: i$
}, t$ = {
  partial: !0,
  tokenize: l$
}, r$ = {
  partial: !0,
  tokenize: o$
};
function i$(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const S = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (S === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : em(v)) {
      if (i.containerState.type || (i.containerState.type = S, e.enter(S, {
        _container: !0
      })), S === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(Yo, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return em(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Ps,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(t$, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function a$(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Ps, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Zn(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(r$, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Zn(e, e.attempt(Mt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function o$(e, n, r) {
  const i = this;
  return Zn(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function s$(e) {
  e.exit(this.containerState.type);
}
function l$(e, n, r) {
  const i = this;
  return Zn(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const jh = {
  name: "setextUnderline",
  resolveTo: c$,
  tokenize: d$
};
function c$(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function d$(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? Zn(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || hn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const u$ = {
  tokenize: m$
};
function m$(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Ps,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, Zn(e, e.attempt(this.parser.constructs.flow, a, e.attempt(gT, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const p$ = {
  resolveAll: A_()
}, f$ = P_("string"), h$ = P_("text");
function P_(e) {
  return {
    resolveAll: A_(e === "text" ? y$ : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function A_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function y$(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const g$ = {
  42: Mt,
  43: Mt,
  45: Mt,
  48: Mt,
  49: Mt,
  50: Mt,
  51: Mt,
  52: Mt,
  53: Mt,
  54: Mt,
  55: Mt,
  56: Mt,
  57: Mt,
  62: I_
}, k$ = {
  91: xT
}, v$ = {
  [-2]: gl,
  [-1]: gl,
  32: gl
}, b$ = {
  35: FT,
  42: Yo,
  45: [jh, Yo],
  60: $T,
  61: jh,
  95: Yo,
  96: Sh,
  126: Sh
}, _$ = {
  38: T_,
  92: E_
}, x$ = {
  [-5]: kl,
  [-4]: kl,
  [-3]: kl,
  33: JT,
  38: T_,
  42: nm,
  60: [XE, VT],
  91: XT,
  92: [wT, E_],
  93: Qm,
  95: nm,
  96: uT
}, S$ = {
  null: [nm, p$]
}, N$ = {
  null: [42, 95]
}, j$ = {
  null: []
}, w$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: N$,
  contentInitial: k$,
  disable: j$,
  document: g$,
  flow: b$,
  flowInitial: v$,
  insideSpan: S$,
  string: _$,
  text: x$
}, Symbol.toStringTag, { value: "Module" }));
function C$(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(C),
    check: U(D),
    consume: g,
    enter: q,
    exit: $,
    interrupt: U(D, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: N,
    events: [],
    now: S,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(J) {
    return s = tr(s, J), F(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = Jm(o, m.events, m), m.events);
  }
  function h(J, G) {
    return I$(v(J), G);
  }
  function v(J) {
    return F$(s, J);
  }
  function S() {
    const {
      _bufferIndex: J,
      _index: G,
      line: P,
      column: W,
      offset: ne
    } = i;
    return {
      _bufferIndex: J,
      _index: G,
      line: P,
      column: W,
      offset: ne
    };
  }
  function N(J) {
    a[J.line] = J.column, ee();
  }
  function F() {
    let J;
    for (; i._index < s.length; ) {
      const G = s[i._index];
      if (typeof G == "string")
        for (J = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === J && i._bufferIndex < G.length; )
          I(G.charCodeAt(i._bufferIndex));
      else
        I(G);
    }
  }
  function I(J) {
    u = u(J);
  }
  function g(J) {
    hn(J) ? (i.line++, i.column = 1, i.offset += J === -3 ? 2 : 1, ee()) : J !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = J;
  }
  function q(J, G) {
    const P = G || {};
    return P.type = J, P.start = S(), m.events.push(["enter", P, m]), l.push(P), P;
  }
  function $(J) {
    const G = l.pop();
    return G.end = S(), m.events.push(["exit", G, m]), G;
  }
  function C(J, G) {
    Z(J, G.from);
  }
  function D(J, G) {
    G.restore();
  }
  function U(J, G) {
    return P;
    function P(W, ne, ke) {
      let me, de, he, H;
      return Array.isArray(W) ? (
        /* c8 ignore next 1 */
        Ce(W)
      ) : "tokenize" in W ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          W
        ])
      ) : be(W);
      function be(Pe) {
        return Me;
        function Me(Ie) {
          const Le = Ie !== null && Pe[Ie], De = Ie !== null && Pe.null, rn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(De) ? De : De ? [De] : []
          ];
          return Ce(rn)(Ie);
        }
      }
      function Ce(Pe) {
        return me = Pe, de = 0, Pe.length === 0 ? ke : K(Pe[de]);
      }
      function K(Pe) {
        return Me;
        function Me(Ie) {
          return H = Q(), he = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Be() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            G ? Object.assign(Object.create(m), G) : m,
            d,
            ze,
            Be
          )(Ie);
        }
      }
      function ze(Pe) {
        return J(he, H), ne;
      }
      function Be(Pe) {
        return H.restore(), ++de < me.length ? K(me[de]) : ke;
      }
    }
  }
  function Z(J, G) {
    J.resolveAll && !o.includes(J) && o.push(J), J.resolve && Dr(m.events, G, m.events.length - G, J.resolve(m.events.slice(G), m)), J.resolveTo && (m.events = J.resolveTo(m.events, m));
  }
  function Q() {
    const J = S(), G = m.previous, P = m.currentConstruct, W = m.events.length, ne = Array.from(l);
    return {
      from: W,
      restore: ke
    };
    function ke() {
      i = J, m.previous = G, m.currentConstruct = P, m.events.length = W, l = ne, ee();
    }
  }
  function ee() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function F$(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function I$(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function E$(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      AE([w$, ...(e || {}).extensions || []])
    ),
    content: a(HE),
    defined: [],
    document: a(KE),
    flow: a(u$),
    lazy: {},
    string: a(f$),
    text: a(h$)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return C$(i, o, l);
    }
  }
}
function T$(e) {
  for (; !$_(e); )
    ;
  return e;
}
const wh = /[\0\t\n\r]/g;
function $$() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (wh.lastIndex = f, m = wh.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const D$ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function R$(e) {
  return e.replace(D$, O$);
}
function O$(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return F_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Ym(r) || e;
}
const L_ = {}.hasOwnProperty;
function P$(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), A$(r)(T$(E$(r).document().write($$()(e, n, !0))));
}
function A$(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Ee),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(pe),
      blockQuote: o(De),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(rn),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(rn, s),
      codeText: o(je, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(We),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ge),
      hardBreakEscape: o(le),
      hardBreakTrailing: o(le),
      htmlFlow: o(Ne, s),
      htmlFlowData: Q,
      htmlText: o(Ne, s),
      htmlTextData: Q,
      image: o(Ae),
      label: s,
      link: o(Ee),
      listItem: o(j),
      listItemValue: h,
      listOrdered: o(cn, f),
      listUnordered: o(cn),
      paragraph: o(_),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(pe),
      strong: o(T),
      thematicBreak: o(X)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: C,
      autolink: d(),
      autolinkEmail: Le,
      autolinkProtocol: Ie,
      blockQuote: d(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Pe,
      characterReference: Me,
      codeFenced: d(F),
      codeFencedFence: N,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: S,
      codeFlowValue: ee,
      codeIndented: d(I),
      codeText: d(ne),
      codeTextData: ee,
      data: ee,
      definition: d(),
      definitionDestinationString: $,
      definitionLabelString: g,
      definitionTitleString: q,
      emphasis: d(),
      hardBreakEscape: d(G),
      hardBreakTrailing: d(G),
      htmlFlow: d(P),
      htmlFlowData: ee,
      htmlText: d(W),
      htmlTextData: ee,
      image: d(me),
      label: he,
      labelText: de,
      lineEnding: J,
      link: d(ke),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: ze,
      resourceDestinationString: H,
      resourceTitleString: be,
      resource: Ce,
      setextHeading: d(Z),
      setextHeadingLineSequence: U,
      setextHeadingText: D,
      strong: d(),
      thematicBreak: d()
    }
  };
  V_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(O) {
    let B = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [B],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, fe = [];
    let _e = -1;
    for (; ++_e < O.length; )
      if (O[_e][1].type === "listOrdered" || O[_e][1].type === "listUnordered")
        if (O[_e][0] === "enter")
          fe.push(_e);
        else {
          const en = fe.pop();
          _e = a(O, en, _e);
        }
    for (_e = -1; ++_e < O.length; ) {
      const en = n[O[_e][0]];
      L_.call(en, O[_e][1].type) && en[O[_e][1].type].call(Object.assign({
        sliceSerialize: O[_e][2].sliceSerialize
      }, ie), O[_e][1]);
    }
    if (ie.tokenStack.length > 0) {
      const en = ie.tokenStack[ie.tokenStack.length - 1];
      (en[1] || Ch).call(ie, void 0, en[0]);
    }
    for (B.position = {
      start: Hr(O.length > 0 ? O[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Hr(O.length > 0 ? O[O.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, _e = -1; ++_e < n.transforms.length; )
      B = n.transforms[_e](B) || B;
    return B;
  }
  function a(O, B, ie) {
    let fe = B - 1, _e = -1, en = !1, dn, tn, sn, fn;
    for (; ++fe <= ie; ) {
      const pn = O[fe];
      switch (pn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          pn[0] === "enter" ? _e++ : _e--, fn = void 0;
          break;
        }
        case "lineEndingBlank": {
          pn[0] === "enter" && (dn && !fn && !_e && !sn && (sn = fe), fn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          fn = void 0;
      }
      if (!_e && pn[0] === "enter" && pn[1].type === "listItemPrefix" || _e === -1 && pn[0] === "exit" && (pn[1].type === "listUnordered" || pn[1].type === "listOrdered")) {
        if (dn) {
          let yn = fe;
          for (tn = void 0; yn--; ) {
            const Xe = O[yn];
            if (Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank") {
              if (Xe[0] === "exit") continue;
              tn && (O[tn][1].type = "lineEndingBlank", en = !0), Xe[1].type = "lineEnding", tn = yn;
            } else if (!(Xe[1].type === "linePrefix" || Xe[1].type === "blockQuotePrefix" || Xe[1].type === "blockQuotePrefixWhitespace" || Xe[1].type === "blockQuoteMarker" || Xe[1].type === "listItemIndent")) break;
          }
          sn && (!tn || sn < tn) && (dn._spread = !0), dn.end = Object.assign({}, tn ? O[tn][1].start : pn[1].end), O.splice(tn || fe, 0, ["exit", dn, pn[2]]), fe++, ie++;
        }
        if (pn[1].type === "listItemPrefix") {
          const yn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, pn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          dn = yn, O.splice(fe, 0, ["enter", yn, pn[2]]), fe++, ie++, sn = void 0, fn = !0;
        }
      }
    }
    return O[B][1]._spread = en, ie;
  }
  function o(O, B) {
    return ie;
    function ie(fe) {
      l.call(this, O(fe), fe), B && B.call(this, fe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(O, B, ie) {
    this.stack[this.stack.length - 1].children.push(O), this.stack.push(O), this.tokenStack.push([B, ie || void 0]), O.position = {
      start: Hr(B.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(O) {
    return B;
    function B(ie) {
      O && O.call(this, ie), m.call(this, ie);
    }
  }
  function m(O, B) {
    const ie = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== O.type && (B ? B.call(this, O, fe[0]) : (fe[1] || Ch).call(this, O, fe[0]));
    else throw new Error("Cannot close `" + O.type + "` (" + Pa({
      start: O.start,
      end: O.end
    }) + "): it’s not open");
    ie.position.end = Hr(O.end);
  }
  function u() {
    return OE(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(O) {
    if (this.data.expectingFirstListItemValue) {
      const B = this.stack[this.stack.length - 2];
      B.start = Number.parseInt(this.sliceSerialize(O), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.lang = O;
  }
  function S() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.meta = O;
  }
  function N() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function F() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function I() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O.replace(/(\r?\n|\r)$/g, "");
  }
  function g(O) {
    const B = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = B, ie.identifier = Di(this.sliceSerialize(O)).toLowerCase();
  }
  function q() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = O;
  }
  function $() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = O;
  }
  function C(O) {
    const B = this.stack[this.stack.length - 1];
    if (!B.depth) {
      const ie = this.sliceSerialize(O).length;
      B.depth = ie;
    }
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(O) {
    const B = this.stack[this.stack.length - 1];
    B.depth = this.sliceSerialize(O).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(O) {
    const ie = this.stack[this.stack.length - 1].children;
    let fe = ie[ie.length - 1];
    (!fe || fe.type !== "text") && (fe = Y(), fe.position = {
      start: Hr(O.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(fe)), this.stack.push(fe);
  }
  function ee(O) {
    const B = this.stack.pop();
    B.value += this.sliceSerialize(O), B.position.end = Hr(O.end);
  }
  function J(O) {
    const B = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = B.children[B.children.length - 1];
      ie.position.end = Hr(O.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(B.type) && (Q.call(this, O), ee.call(this, O));
  }
  function G() {
    this.data.atHardBreak = !0;
  }
  function P() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O;
  }
  function W() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O;
  }
  function ne() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = O;
  }
  function ke() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = B, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function me() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = B, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function de(O) {
    const B = this.sliceSerialize(O), ie = this.stack[this.stack.length - 2];
    ie.label = R$(B), ie.identifier = Di(B).toLowerCase();
  }
  function he() {
    const O = this.stack[this.stack.length - 1], B = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const fe = O.children;
      ie.children = fe;
    } else
      ie.alt = B;
  }
  function H() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = O;
  }
  function be() {
    const O = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = O;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function ze(O) {
    const B = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = B, ie.identifier = Di(this.sliceSerialize(O)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(O) {
    this.data.characterReferenceType = O.type;
  }
  function Pe(O) {
    const B = this.sliceSerialize(O), ie = this.data.characterReferenceType;
    let fe;
    ie ? (fe = F_(B, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = Ym(B);
    const _e = this.stack[this.stack.length - 1];
    _e.value += fe;
  }
  function Me(O) {
    const B = this.stack.pop();
    B.position.end = Hr(O.end);
  }
  function Ie(O) {
    ee.call(this, O);
    const B = this.stack[this.stack.length - 1];
    B.url = this.sliceSerialize(O);
  }
  function Le(O) {
    ee.call(this, O);
    const B = this.stack[this.stack.length - 1];
    B.url = "mailto:" + this.sliceSerialize(O);
  }
  function De() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function rn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function je() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ge() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function pe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function le() {
    return {
      type: "break"
    };
  }
  function Ne() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ae() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ee() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function cn(O) {
    return {
      type: "list",
      ordered: O.type === "listOrdered",
      start: null,
      spread: O._spread,
      children: []
    };
  }
  function j(O) {
    return {
      type: "listItem",
      spread: O._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function T() {
    return {
      type: "strong",
      children: []
    };
  }
  function Y() {
    return {
      type: "text",
      value: ""
    };
  }
  function X() {
    return {
      type: "thematicBreak"
    };
  }
}
function Hr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function V_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? V_(e, i) : L$(e, i);
  }
}
function L$(e, n) {
  let r;
  for (r in n)
    if (L_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Ch(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Pa({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Pa({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Pa({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function V$(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return P$(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function z$(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function U$(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function M$(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function B$(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function q$(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function H$(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = qi(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function W$(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function K$(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function z_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function G$(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return z_(e, n);
  const a = { src: qi(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function Y$(e, n) {
  const r = { src: qi(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function J$(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function Q$(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return z_(e, n);
  const a = { href: qi(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function X$(e, n) {
  const r = { href: qi(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function Z$(e, n, r) {
  const i = e.all(n), a = r ? eD(r) : U_(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function eD(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = U_(r[i]);
  }
  return n;
}
function U_(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function nD(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function tD(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function rD(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function iD(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function aD(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Hm(n.children[1]), d = __(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function oD(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let S = { type: "element", tagName: o, properties: h, children: [] };
    f && (S.children = e.all(f), e.patch(f, S), S = e.applyData(f, S)), m.push(S);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function sD(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Fh = 9, Ih = 32;
function lD(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Eh(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Eh(n.slice(a), a > 0, !1)), o.join("");
}
function Eh(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Fh || o === Ih; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Fh || o === Ih; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function cD(e, n) {
  const r = { type: "text", value: lD(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function dD(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const uD = {
  blockquote: z$,
  break: U$,
  code: M$,
  delete: B$,
  emphasis: q$,
  footnoteReference: H$,
  heading: W$,
  html: K$,
  imageReference: G$,
  image: Y$,
  inlineCode: J$,
  linkReference: Q$,
  link: X$,
  listItem: Z$,
  list: nD,
  paragraph: tD,
  // @ts-expect-error: root is different, but hard to type.
  root: rD,
  strong: iD,
  table: aD,
  tableCell: sD,
  tableRow: oD,
  text: cD,
  thematicBreak: dD,
  toml: ko,
  yaml: ko,
  definition: ko,
  footnoteDefinition: ko
};
function ko() {
}
const M_ = -1, As = 0, ps = 1, fs = 2, Xm = 3, Zm = 4, ep = 5, np = 6, B_ = 7, q_ = 8, Th = typeof self == "object" ? self : globalThis, mD = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case As:
      case M_:
        return r(s, a);
      case ps: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case fs: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Xm:
        return r(new Date(s), a);
      case Zm: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case ep: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case np: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case B_: {
        const { name: l, message: d } = s;
        return r(new Th[l](d), a);
      }
      case q_:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Th[o](s), a);
  };
  return i;
}, $h = (e) => mD(/* @__PURE__ */ new Map(), e)(0), xi = "", { toString: pD } = {}, { keys: fD } = Object, ca = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [As, n];
  const r = pD.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [ps, xi];
    case "Object":
      return [fs, xi];
    case "Date":
      return [Xm, xi];
    case "RegExp":
      return [Zm, xi];
    case "Map":
      return [ep, xi];
    case "Set":
      return [np, xi];
  }
  return r.includes("Array") ? [ps, r] : r.includes("Error") ? [B_, r] : [fs, r];
}, vo = ([e, n]) => e === As && (n === "function" || n === "symbol"), hD = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = ca(s);
    switch (l) {
      case As: {
        let u = s;
        switch (d) {
          case "bigint":
            l = q_, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([M_], s);
        }
        return a([l, u], s);
      }
      case ps: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case fs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of fD(s))
          (e || !vo(ca(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Xm:
        return a([l, s.toISOString()], s);
      case Zm: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case ep: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(vo(ca(h)) || vo(ca(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case np: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !vo(ca(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Dh = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return hD(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, hs = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? $h(Dh(e, n)) : structuredClone(e)
) : (e, n) => $h(Dh(e, n));
function yD(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function gD(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function kD(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || yD, i = e.options.footnoteBackLabel || gD, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = qi(f.toLowerCase());
    let v = 0;
    const S = [], N = e.footnoteCounts.get(f);
    for (; N !== void 0 && ++v <= N; ) {
      S.length > 0 && S.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, v);
      typeof g == "string" && (g = { type: "text", value: g }), S.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const F = u[u.length - 1];
    if (F && F.type === "element" && F.tagName === "p") {
      const g = F.children[F.children.length - 1];
      g && g.type === "text" ? g.value += " " : F.children.push({ type: "text", value: " " }), F.children.push(...S);
    } else
      u.push(...S);
    const I = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, I), l.push(I);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...hs(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const H_ = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return xD;
    if (typeof e == "function")
      return Ls(e);
    if (typeof e == "object")
      return Array.isArray(e) ? vD(e) : bD(e);
    if (typeof e == "string")
      return _D(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function vD(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = H_(e[r]);
  return Ls(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function bD(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Ls(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function _D(e) {
  return Ls(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Ls(e) {
  return n;
  function n(r, i, a) {
    return !!(SD(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function xD() {
  return !0;
}
function SD(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const W_ = [], ND = !0, Rh = !1, jD = "skip";
function wD(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = H_(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = W_, S, N, F;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = CD(r(d, u)), v[0] === Rh))
        return v;
      if ("children" in d && d.children) {
        const I = (
          /** @type {UnistParent} */
          d
        );
        if (I.children && v[0] !== jD)
          for (N = (i ? I.children.length : -1) + s, F = u.concat(I); N > -1 && N < I.children.length; ) {
            const g = I.children[N];
            if (S = l(g, N, F)(), S[0] === Rh)
              return S;
            N = typeof S[1] == "number" ? S[1] : N + s;
          }
      }
      return v;
    }
  }
}
function CD(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [ND, e] : e == null ? W_ : [e];
}
function K_(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), wD(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const tm = {}.hasOwnProperty, FD = {};
function ID(e, n) {
  const r = n || FD, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...uD, ...r.handlers }, l = {
    all: m,
    applyData: TD,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: ED,
    wrap: DD
  };
  return K_(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (tm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: N, ...F } = u, I = hs(F);
        return I.children = l.all(u), I;
      }
      return hs(u);
    }
    return (l.options.unknownHandler || $D)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const S = l.one(h[v], u);
        if (S) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(S) && S.type === "text" && (S.value = Oh(S.value)), !Array.isArray(S) && S.type === "element")) {
            const N = S.children[0];
            N && N.type === "text" && (N.value = Oh(N.value));
          }
          Array.isArray(S) ? f.push(...S) : f.push(S);
        }
      }
    }
    return f;
  }
}
function ED(e, n) {
  e.position && (n.position = uE(e));
}
function TD(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, hs(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function $D(e, n) {
  const r = n.data || {}, i = "value" in n && !(tm.call(r, "hProperties") || tm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function DD(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Oh(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Ph(e, n) {
  const r = ID(e, n), i = r.one(e, void 0), a = kD(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function RD(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Ph(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Ph(r, { file: i, ...e || n })
    );
  };
}
function Ah(e) {
  if (e)
    throw e;
}
var vl, Lh;
function OD() {
  if (Lh) return vl;
  Lh = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return vl = function d() {
    var m, u, f, h, v, S, N = arguments[0], F = 1, I = arguments.length, g = !1;
    for (typeof N == "boolean" && (g = N, N = arguments[1] || {}, F = 2), (N == null || typeof N != "object" && typeof N != "function") && (N = {}); F < I; ++F)
      if (m = arguments[F], m != null)
        for (u in m)
          f = l(N, u), h = l(m, u), N !== h && (g && h && (o(h) || (v = a(h))) ? (v ? (v = !1, S = f && a(f) ? f : []) : S = f && o(f) ? f : {}, s(N, { name: u, newValue: d(g, S, h) })) : typeof h < "u" && s(N, { name: u, newValue: h }));
    return N;
  }, vl;
}
var PD = OD();
const bl = /* @__PURE__ */ Nm(PD);
function rm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function AD() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? LD(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function LD(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Nr = { basename: VD, dirname: zD, extname: UD, join: MD, sep: "/" };
function VD(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  ro(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function zD(e) {
  if (ro(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function UD(e) {
  ro(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function MD(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    ro(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : BD(r);
}
function BD(e) {
  ro(e);
  const n = e.codePointAt(0) === 47;
  let r = qD(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function qD(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function ro(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const HD = { cwd: WD };
function WD() {
  return "/";
}
function im(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function KD(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!im(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return GD(e);
}
function GD(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const _l = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class G_ {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? im(n) ? r = { path: n } : typeof n == "string" || YD(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : HD.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < _l.length; ) {
      const o = _l[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      _l.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Nr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Sl(n, "basename"), xl(n, "basename"), this.path = Nr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Nr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Vh(this.basename, "dirname"), this.path = Nr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Nr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (xl(n, "extname"), Vh(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Nr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    im(n) && (n = KD(n)), Sl(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Nr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Sl(n, "stem"), xl(n, "stem"), this.path = Nr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Ft(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function xl(e, n) {
  if (e && e.includes(Nr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Nr.sep + "`"
    );
}
function Sl(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Vh(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function YD(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const JD = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), QD = {}.hasOwnProperty;
class tp extends JD {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = AD();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new tp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(bl(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (wl("data", this.frozen), this.namespace[n] = r, this) : QD.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (wl("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = bo(n), i = this.parser || this.Parser;
    return Nl("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Nl("process", this.parser || this.Parser), jl("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = bo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), S = i.stringify(v, h);
        eR(S) ? h.value = S : h.result = S, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Nl("processSync", this.parser || this.Parser), jl("processSync", this.compiler || this.Compiler), this.process(n, a), Uh("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Ah(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    zh(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = bo(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Uh("runSync", "run", i), a;
    function o(s, l) {
      Ah(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = bo(r), a = this.compiler || this.Compiler;
    return jl("stringify", a), zh(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (wl("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = bl(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...S] = u;
        const N = i[h][1];
        rm(N) && rm(v) && (v = bl(!0, N, v)), i[h] = [m, v, ...S];
      }
    }
  }
}
const XD = new tp().freeze();
function Nl(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function jl(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function wl(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function zh(e) {
  if (!rm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Uh(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function bo(e) {
  return ZD(e) ? e : new G_(e);
}
function ZD(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function eR(e) {
  return typeof e == "string" || nR(e);
}
function nR(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const tR = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Mh = [], Bh = { allowDangerousHtml: !0 }, rR = /^(https?|ircs?|mailto|xmpp)$/i, iR = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function aR(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Mh, d = e.remarkPlugins || Mh, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Bh } : Bh, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || oR, v = XD().use(V$).use(d).use(RD, m).use(l), S = new G_();
  typeof i == "string" && (S.value = i);
  for (const g of iR)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + tR + g.id, void 0);
  const N = v.parse(S);
  let F = v.runSync(N, S);
  return a && (F = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      F.type === "root" ? F.children : [F]
    )
  }), K_(F, I), gE(F, {
    Fragment: Ue.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ue.jsx,
    jsxs: Ue.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function I(g, q, $) {
    if (g.type === "raw" && $ && typeof q == "number")
      return u ? $.children.splice(q, 1) : $.children[q] = { type: "text", value: g.value }, q;
    if (g.type === "element") {
      let C;
      for (C in yl)
        if (Object.hasOwn(yl, C) && Object.hasOwn(g.properties, C)) {
          const D = g.properties[C], U = yl[C];
          (U === null || U.includes(g.tagName)) && (g.properties[C] = h(String(D || ""), C, g));
        }
    }
    if (g.type === "element") {
      let C = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!C && r && typeof q == "number" && (C = !r(g, q, $)), C && $ && typeof q == "number")
        return f && g.children ? $.children.splice(q, 1, ...g.children) : $.children.splice(q, 1), q;
    }
  }
}
function oR(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    rR.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cl = { exports: {} }, da = {}, qh;
function sR() {
  if (qh) return da;
  qh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return da.Fragment = r, da.jsx = s, da.jsxs = s, da;
}
var _o = {}, Hh;
function lR() {
  return Hh || (Hh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    _o.Fragment = i, _o.jsx = Bn, _o.jsxs = qn;
  })()), _o;
}
var Wh;
function cR() {
  return Wh || (Wh = 1, process.env.NODE_ENV === "production" ? Cl.exports = sR() : Cl.exports = lR()), Cl.exports;
}
var oe = cR();
const dR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, uR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, mR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, pR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, fR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, hR = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": dR,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": uR,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": mR,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": pR,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": fR
};
function io(e) {
  return hR[e] ?? {};
}
const yR = io(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), gR = io(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), xo = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), kR = "_issueAvatar_kc0sw_1", vR = "_issueField_kc0sw_9", bR = "_issueDescription_kc0sw_12", So = {
  issueAvatar: kR,
  issueField: vR,
  issueDescription: bR
}, Y_ = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(xo, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: So.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          _m,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(xo, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: So.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(xo, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: So.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(xo, { title: "Description", children: /* @__PURE__ */ oe.jsx(aR, { className: So.issueDescription, children: e.description }) })
] }), _R = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), xR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), SR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), NR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), jR = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), J_ = {
  0: _R,
  1: jR,
  2: NR,
  3: SR,
  4: xR
}, wR = (e) => e in J_, ys = ({ priority: e }) => wR(e) ? J_[e] : /* @__PURE__ */ oe.jsx(On, { "data-testid": "defaultPriorityTag", children: e }), CR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), FR = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), IR = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), ER = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), TR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), $R = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), am = {
  backlog: (e, n) => CR(e, n),
  unstarted: (e, n) => FR(e, n),
  started: (e, n) => IR(e, n),
  done: (e, n) => ER(e, n),
  canceled: (e, n) => TR(e, n),
  completed: (e, n) => $R(e, n)
}, DR = (e) => e in am, gs = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => DR(e) ? am[e](n, r) : am.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), RR = "_wrapper_e0qj3_1", OR = "_resultTitle_e0qj3_21", PR = "_resultTooltipTitle_e0qj3_28", AR = "_resultLinkIcon_e0qj3_31", ua = {
  wrapper: RR,
  resultTitle: OR,
  resultTooltipTitle: PR,
  resultLinkIcon: AR
}, LR = ({
  issue: e
}) => {
  const [n, r] = se(!1);
  return /* @__PURE__ */ oe.jsx(
    Ke,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: ua.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              gs,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(ys, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(On, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ua.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(Y_, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        mt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ua.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    gs,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(ys, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", className: ua.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  ue,
                  {
                    className: ua.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, VR = "_loader_13xpk_1", zR = "_dropdown_13xpk_8", UR = "_loadMore_13xpk_13", Fl = {
  loader: VR,
  dropdown: zR,
  loadMore: UR
}, MR = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = mn(), [f, { data: h, loading: v, networkStatus: S }] = u(
    yR,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Ui(
    () => {
      !v && s !== "" && S === ar.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), qe(() => {
    v || o([]);
  }, [s]), qe(() => {
    if (h && Object.keys(h).length > 0) {
      const F = h.Linear.searchIssues.edges.map(
        ({ node: $ }) => $
      ), I = a.filter(
        ($) => !n.find((C) => C.id === $.id)
      ), g = I.filter(
        ($) => !F.find(
          (C) => C.id === $.id
        )
      ), q = F.filter(
        ($) => !n.find((C) => C.id === $.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...q] : q
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...I, ...F] : F
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const N = () => {
    !v && s !== "" && S === ar.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    Kr,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (F) => F?.title,
      onChange: (F) => e(F.selectedValues[0]),
      dropdownProps: { className: Fl.dropdown },
      filter: {
        value: s,
        onChange: (F) => {
          const I = F.target.value;
          l(I);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((F) => /* @__PURE__ */ oe.jsx(LR, { issue: F }, F.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => N(),
            className: Fl.loadMore,
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Fl.loader, children: /* @__PURE__ */ oe.jsx(un, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, BR = "_collapse_su0f9_1", qR = "_collapseHeader_su0f9_8", HR = "_collapseContent_su0f9_31", WR = "_url_su0f9_35", KR = "_externalLink_su0f9_51", GR = "_emptyState_su0f9_55", Wr = {
  collapse: BR,
  collapseHeader: qR,
  collapseContent: HR,
  url: WR,
  externalLink: KR,
  emptyState: GR
}, YR = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = kn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Wr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Wr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            rr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Wr.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(rr.Header, { className: Wr.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        gs,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        A.ExternalLink,
                        {
                          className: Wr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(ue, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ke, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(ys, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(On, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(rr.Content, { className: Wr.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(On, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(Y_, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    Wn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    jt,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
                      variant: "tertiary",
                      className: Wr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Wn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Wr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, JR = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, Q_ = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Q_(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, QR = "_modalBody_iv3ua_1", XR = "_error_iv3ua_5", ZR = "_dropdown_iv3ua_16", Si = {
  modalBody: QR,
  error: XR,
  dropdown: ZR
}, eO = io(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), nO = io(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), tO = io(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), rO = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = mn(), { control: m, handleSubmit: u, reset: f } = sr(), [h, v] = se([]), [S, N] = se(), [F, I] = se([]), [g, q] = se(), [$, C] = se([]), [D, U] = se(), [Z, Q] = se([]), [ee, J] = se(), [G, P] = se([]), [W, ne] = se(), [ke, me] = se(!1), { useMutation: de } = mn(), { track: he } = kn(), [H, { loading: be }] = de(
    eO,
    {
      onError: () => {
        me(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (je) => {
        const We = {
          identifier: je.Linear?.issueCreate?.issue?.identifier,
          url: je.Linear?.issueCreate?.issue?.url
        };
        je.Linear && je.Linear?.issueCreate?.issue?.id && (a(je.Linear?.issueCreate?.issue?.id), Le(We), me(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${je.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), he("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ce,
    { data: K, loading: ze, error: Be }
  ] = l(nO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (je) => {
      const We = je.Linear.teams.edges.map(
        ({ node: Ge }) => Ge
      );
      v(We), Q(je.Linear.issuePriorityValues), s(`${mO}${je.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Me, loading: Ie }] = l(tO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (je) => {
      const We = je?.Linear?.team?.projects?.edges?.map(
        ({ node: le }) => le
      );
      I(We);
      const Ge = je?.Linear?.team?.states?.edges?.map(
        ({ node: le }) => le
      );
      C(Ge);
      const pe = je?.Linear?.team?.templates?.edges?.map(
        ({ node: le }) => le
      );
      P(
        pe.filter(
          (le) => le.type === "issue"
        )
      );
    }
  }), Le = (je) => {
    r(!1), q(void 0), N(void 0), U(void 0), J(void 0), ne(void 0), je && (e(je), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, De = (je) => {
    K && !ze && (H({
      variables: {
        issueTitle: je.title,
        issueDescription: je?.description,
        teamId: je.team.id,
        projectId: je?.project?.id,
        statusId: je?.status?.id,
        priority: je?.priority?.priority
      }
    }), me(!0));
  };
  qe(() => {
    n && Ce();
  }, [n]);
  const rn = () => {
    he("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    gt,
    {
      isOpen: n,
      onClose: () => {
        rn(), Le();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          kt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              rn(), Le();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          vt,
          {
            className: Si.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ oe.jsx(wn, { error: Be }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u(De), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(zt, { children: [
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: je, onChange: We },
                    fieldState: { error: Ge }
                  }) => /* @__PURE__ */ oe.jsx(
                    An,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Ge?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        Kr,
                        {
                          dropdownProps: { className: Si.dropdown },
                          placeholder: "Select Linear team",
                          className: ct({ [Si.error]: Ge }),
                          getItemTitleByValue: (pe) => pe?.name,
                          onChange: (pe) => {
                            q(void 0), U(void 0), J(void 0), ne(void 0), N(pe.selectedValues[0]), Pe({
                              variables: { teamId: pe.selectedValues[0].id }
                            }), We(pe.selectedValues[0]);
                          },
                          value: S ? [je] : void 0,
                          children: h?.map((pe) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.name })
                            },
                            pe.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: je, onChange: We } }) => {
                    const Ge = Ie ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(An, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      Kr,
                      {
                        dropdownProps: { className: Si.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (pe) => pe?.name,
                        disabled: S === void 0,
                        placeholder: S ? "Select Linear project" : "Select a Team first",
                        onChange: (pe) => {
                          q(pe.selectedValues[0]), We(pe.selectedValues[0]);
                        },
                        value: g ? [je] : Ge,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Ie && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !Ie && F.map((pe) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.name })
                            },
                            pe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 6, children: /* @__PURE__ */ oe.jsx(An, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                Kr,
                {
                  clearable: !0,
                  dropdownProps: { className: Si.dropdown },
                  disabled: !S || Ie,
                  placeholder: S ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (je) => je?.name,
                  onChange: (je) => {
                    if (je.selectedValues.length > 0) {
                      ne(je.selectedValues[0]);
                      const We = JSON.parse(
                        je.selectedValues[0].templateData
                      ), Ge = Z.filter(
                        (Ae) => Ae.priority === We.priority
                      );
                      J(
                        Ge ? Ge[0] : void 0
                      );
                      const pe = $.filter(
                        (Ae) => Ae.id === We.stateId
                      );
                      U(
                        pe ? pe[0] : void 0
                      );
                      const le = F.filter(
                        (Ae) => Ae.id === We.projectId
                      );
                      q(
                        le ? le[0] : void 0
                      );
                      const Ne = We.description;
                      f({
                        title: We?.title,
                        priority: Ge[0],
                        status: pe[0],
                        project: le[0],
                        description: Ne ? Q_(Ne, JR) : "",
                        team: S
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: S
                      }), q(void 0), J(void 0), U(void 0), ne(void 0);
                  },
                  value: W ? [W] : void 0,
                  children: G?.map((je) => /* @__PURE__ */ oe.jsx(
                    mt.Item,
                    {
                      value: je,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: je.name })
                    },
                    je.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 6, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: je, value: We },
                    fieldState: { error: Ge }
                  }) => /* @__PURE__ */ oe.jsx(
                    ir,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: We || "",
                        onChange: je
                      },
                      meta: {
                        error: Ge?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: je, onChange: We } }) => {
                    const Ge = Ie ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(An, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      Kr,
                      {
                        dropdownProps: { className: Si.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (pe) => pe?.name,
                        disabled: S === void 0,
                        placeholder: S ? "Select Issue status" : "Select a Team first",
                        onChange: (pe) => {
                          U(pe.selectedValues[0]), We(pe.selectedValues[0]);
                        },
                        value: D ? [je] : Ge,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Ie && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !Ie && $.map((pe) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      gs,
                                      {
                                        type: pe.type,
                                        color: pe.color,
                                        name: pe.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.name })
                                  ]
                                }
                              )
                            },
                            pe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: je, onChange: We } }) => {
                    const Ge = ze ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(An, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      Kr,
                      {
                        clearable: !0,
                        getItemTitleByValue: (pe) => pe?.label,
                        disabled: S === void 0,
                        placeholder: S ? "Select Issue priority" : "Select a Team first",
                        onChange: (pe) => {
                          J(pe.selectedValues[0]), We(pe.selectedValues[0]);
                        },
                        value: ee ? [je] : Ge,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Ie && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(un, { size: 24 })
                            }
                          ),
                          K && !ze && Z.map((pe) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: pe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      ys,
                                      {
                                        priority: pe.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: pe.label })
                                  ]
                                }
                              )
                            },
                            pe.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(nn, { children: /* @__PURE__ */ oe.jsx(
                Pt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: je, value: We },
                    fieldState: { error: Ge }
                  }) => /* @__PURE__ */ oe.jsx(
                    FS,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: We || "",
                        onChange: je
                      },
                      meta: {
                        error: Ge?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            confirmOnClick: u(De),
            confirmProps: {
              disabled: be || !K,
              isLoading: ke || ze || Ie,
              loadingIndicator: /* @__PURE__ */ oe.jsx(un, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              rn(), Le();
            }
          }
        )
      ]
    }
  );
}, iO = "_modalWrapper_4kh9u_1", aO = "_copyButton_4kh9u_6", oO = "_copyWrapper_4kh9u_15", sO = "_copyField_4kh9u_24", lO = "_externalLink_4kh9u_47", cO = "_externalLinkIcon_4kh9u_52", dO = "_textWrapper_4kh9u_56", ei = {
  modalWrapper: iO,
  copyButton: aO,
  copyWrapper: oO,
  copyField: sO,
  externalLink: lO,
  externalLinkIcon: cO,
  textWrapper: dO
}, uO = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  gt,
  {
    isOpen: !!n && e,
    className: ei.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        kt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(vt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(A.Paragraph, { className: ei.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ei.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(ue, { name: "external-link", className: ei.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(An, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ei.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    kr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ei.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    IS,
                    {
                      className: ei.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        wt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), mO = "https://linear.app/", pO = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: S } = mn(), [N, F] = se(""), I = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: q } = kn(), {
    loading: $,
    data: C,
    error: D,
    store: U
  } = vm(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: ee,
      networkStatus: J,
      error: G
    }
  ] = S(gR, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    !$ && !D && C && C?.linear?.issues?.length > 0 ? (o(C.linear.issues), Z({
      variables: {
        linkedIssues: C.linear.issues
      }
    })) : !$ && !D && (i([]), o([]));
  }, [C, $, D]), qe(() => {
    Q && Q?.Linear && !ee && J === ar.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: me }) => me));
  }, [Q, ee, J]);
  const P = (me) => {
    me && me?.team?.organization?.urlKey && q("linear:link:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: me.id
    });
    const de = (he) => he.id === me?.id;
    r.some((he) => he && de(he)) || (C && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, me.id]
      }
    }));
  }, W = (me) => {
    const de = C?.linear.issues.filter((he) => he !== me) || [];
    q("linear:unlink:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: me
    }), i(r.filter(({ id: he }) => he !== me)), o(de), U({
      linear: {
        issues: de
      }
    });
  }, ne = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ke = $ || ee || !C && !D || (C?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !$ && !ee && (G || D) ? /* @__PURE__ */ oe.jsx(wn, { error: G || D }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      gt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            kt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(vt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            wt,
            {
              confirmOnClick: () => ne(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      rO,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (me) => m(me),
        setIsCreationSuccessfulModalOpen: (me) => f(me),
        addToLinkedIssueIds: (me) => {
          U({
            linear: {
              issues: [...a, me]
            }
          });
        },
        setCreatedIssue: (me) => v(me),
        organizationUrl: N,
        setOrganizationUrl: (me) => F(me)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      uO,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (me) => f(me),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          I && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Wn,
              {
                variant: "primary",
                onClick: () => {
                  q("linear:create:new:issue:clicked", {
                    linearInstanceUrl: N
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(MR, { handleSelect: P, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      YR,
      {
        linkedIssues: r,
        isLoading: ke,
        handleUnlinkIssue: W,
        showUnlinkAllModal: (me) => l(me),
        showUnlinkAllButton: g,
        organizationUrl: N
      }
    )
  ] });
}, fO = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Il = { exports: {} }, ma = {}, Kh;
function hO() {
  if (Kh) return ma;
  Kh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ma.Fragment = r, ma.jsx = s, ma.jsxs = s, ma;
}
var No = {}, Gh;
function yO() {
  return Gh || (Gh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    No.Fragment = i, No.jsx = Bn, No.jsxs = qn;
  })()), No;
}
var Yh;
function gO() {
  return Yh || (Yh = 1, process.env.NODE_ENV === "production" ? Il.exports = hO() : Il.exports = yO()), Il.exports;
}
var Re = gO();
const kO = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, vO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, bO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, _O = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, xO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, SO = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": kO,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": vO,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": bO,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": _O,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": xO
};
function Vs(e) {
  return SO[e] ?? {};
}
const NO = Vs(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), jO = Vs(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), wO = Vs(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), CO = Vs(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function El(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const FO = "_wrapper_27vny_1", IO = "_copyIcon_27vny_12", pa = {
  wrapper: FO,
  copyIcon: IO
}, EO = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = El(), { isCopied: i, copy: a } = El(), { isCopied: o, copy: s } = El();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: S,
    referral_url: N
  } = e, F = f ? Pn(f).isSame(Date.now(), "day") : !1, { name: I, first_name: g, last_name: q } = m ?? {}, $ = I ?? (`${g} ${q}`.trim() || "A customer has no name"), C = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Re.jsxs(b, { className: pa.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: pa.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Re.jsx(A.Heading, { variant: "heading-2", children: $ }),
          F && /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Pn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Re.jsx(b, { gap: "200", children: /* @__PURE__ */ Re.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Pn(S).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(ue, { size: l, name: "mail" }),
        /* @__PURE__ */ Re.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Re.jsx(Ke, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        ue,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: pa.copyIcon
        }
      ) })
    ] }),
    C && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(ue, { size: l, name: "link" }),
        /* @__PURE__ */ Re.jsx(Ke, { content: "Shopify shop", children: /* @__PURE__ */ Re.jsx(
          A.ExternalLink,
          {
            href: C,
            target: "_blank",
            rel: "noreferrer",
            children: C.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Re.jsx(Ke, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        ue,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: pa.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Re.jsx(ue, { size: l, name: "external-link" }),
        /* @__PURE__ */ Re.jsx(Ke, { content: "Referral link", children: /* @__PURE__ */ Re.jsx(
          A.ExternalLink,
          {
            href: N,
            target: "_blank",
            rel: "noreferrer",
            children: N.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Re.jsx(Ke, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Re.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: pa.copyIcon
        }
      ) })
    ] })
  ] }) });
}, TO = "_list_1q5b5_5", $O = "_listItem_1q5b5_8", DO = "_listItemEdit_1q5b5_15", RO = "_notificationText_1q5b5_19", Ai = {
  list: TO,
  listItem: $O,
  listItemEdit: DO,
  notificationText: RO
}, OO = "_modalBody_1clhs_1", PO = {
  modalBody: OO
}, AO = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [S, { loading: N }] = o(
    wO,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), J();
      }
    }
  ), [F, { loading: I }] = o(CO), g = N || I, q = !!h, $ = n === d ? "Change the value to update the points" : "", C = isNaN(d), D = C ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Z = U ? "Points can not exceed 1,000,000" : "", Q = () => {
    d > n && S({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((G) => {
      const P = G?.networkError;
      (P ? P?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && F({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((G) => {
      G.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : "errors" in G && (l("loyaltylion:remove:points:failed"), v(
        G.errors?.map((P) => P.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ee = () => {
    C && m(n), f(""), i();
  }, J = () => {
    a(), ee();
  };
  return /* @__PURE__ */ Re.jsxs(
    gt,
    {
      isOpen: e,
      onClose: ee,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Re.jsx(kt, { title: "Change points", onClose: ee }),
        /* @__PURE__ */ Re.jsxs(vt, { className: PO.modalBody, children: [
          /* @__PURE__ */ Re.jsxs(zt, { children: [
            /* @__PURE__ */ Re.jsx(nn, { span: 6, children: /* @__PURE__ */ Re.jsx(
              ir,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || D,
                  warning: $
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (G) => m(G?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Re.jsx(nn, { span: 6, children: /* @__PURE__ */ Re.jsx(
              ir,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (G) => f(G?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && q && /* @__PURE__ */ Re.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Re.jsx(He, { children: h?.map((G, P) => /* @__PURE__ */ Re.jsx(
            He.Item,
            {
              variant: "dense",
              title: G,
              contentLeft: /* @__PURE__ */ Re.jsx(
                ue,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            P
          )) }) })
        ] }),
        /* @__PURE__ */ Re.jsx(
          wt,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: g,
              disabled: C || U || n === d,
              loadingIndicator: /* @__PURE__ */ Re.jsx(un, { size: 16 })
            },
            cancelOnClick: ee
          }
        )
      ]
    }
  );
}, LO = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Re.jsx(He.Text, { variant: "dense", className: Ai.listItem, children: /* @__PURE__ */ Re.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(ue, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Re.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Re.jsx(Ke, { content: "Edit points", children: /* @__PURE__ */ Re.jsx(
        ue,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Ai.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Re.jsx(Un, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, VO = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Re.jsx(He, { className: Ai.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Re.jsx(
      LO,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ Re.jsx(
      AO,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, zO = "_reward_1wxia_1", UO = {
  reward: zO
}, MO = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Re.jsx(b, { gap: "100", flexDirection: "column", className: UO.reward, children: /* @__PURE__ */ Re.jsx(Ke, { content: a ?? "No description", children: /* @__PURE__ */ Re.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Re.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Re.jsx(ue, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Re.jsxs(Un, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Re.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(ue, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Re.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, BO = ({ customer: e }) => {
  const { useQuery: n } = mn(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(jO, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return Ya({ errors: d }) ? /* @__PURE__ */ Re.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ai.notificationText,
        children: "No rewards found"
      }
    ) : ab({ errors: d }) ? /* @__PURE__ */ Re.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ai.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Re.jsx(wn, { error: s });
  }
  return /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Re.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Re.jsx(un, {}) }) : /* @__PURE__ */ Re.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Re.jsx(MO, { reward: d }, d.id)) })
  ] });
}, qO = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Re.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(On, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(
        ue,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(On, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(ue, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Re.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Re.jsx(Ke, { content: "Insights segment", children: /* @__PURE__ */ Re.jsx(On, { children: /* @__PURE__ */ Re.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Re.jsx(ue, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, HO = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = kn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: S,
    refetch: N
  } = r(NO, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return qe(() => {
    if (S && !h) {
      const F = (S?.LoyaltyLion?.getCustomers).customers;
      F && F.length > 0 && (o(F[0]), i("loyaltylion:customer:received"));
    }
  }, [S, h]), s?.email ? v ? Ya({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Re.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ai.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Re.jsx(wn, { error: v }) : h ? /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Re.jsx(un, {}) }) : f ? /* @__PURE__ */ Re.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Re.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Re.jsxs(Re.Fragment, { children: [
        l && /* @__PURE__ */ Re.jsx(EO, { customer: a }),
        d && /* @__PURE__ */ Re.jsx(qO, { customer: a }),
        m && /* @__PURE__ */ Re.jsx(
          VO,
          {
            customer: a,
            refetchCustomerData: N
          }
        ),
        u && /* @__PURE__ */ Re.jsx(BO, { customer: a })
      ] }) : /* @__PURE__ */ Re.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Re.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, WO = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Tl = { exports: {} }, fa = {}, Jh;
function KO() {
  if (Jh) return fa;
  Jh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return fa.Fragment = r, fa.jsx = s, fa.jsxs = s, fa;
}
var jo = {}, Qh;
function GO() {
  return Qh || (Qh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    jo.Fragment = i, jo.jsx = Bn, jo.jsxs = qn;
  })()), jo;
}
var Xh;
function YO() {
  return Xh || (Xh = 1, process.env.NODE_ENV === "production" ? Tl.exports = KO() : Tl.exports = GO()), Tl.exports;
}
var jn = YO();
const JO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, QO = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": JO
};
function XO(e) {
  return QO[e] ?? {};
}
const {
  entries: X_,
  setPrototypeOf: Zh,
  isFrozen: ZO,
  getPrototypeOf: eP,
  getOwnPropertyDescriptor: nP
} = Object;
let {
  freeze: Lt,
  seal: or,
  create: Z_
} = Object, {
  apply: om,
  construct: sm
} = typeof Reflect < "u" && Reflect;
Lt || (Lt = function(e) {
  return e;
});
or || (or = function(e) {
  return e;
});
om || (om = function(e, n, r) {
  return e.apply(n, r);
});
sm || (sm = function(e, n) {
  return new e(...n);
});
const wo = Vt(Array.prototype.forEach), tP = Vt(Array.prototype.lastIndexOf), ey = Vt(Array.prototype.pop), ha = Vt(Array.prototype.push), rP = Vt(Array.prototype.splice), Jo = Vt(String.prototype.toLowerCase), $l = Vt(String.prototype.toString), ny = Vt(String.prototype.match), ya = Vt(String.prototype.replace), iP = Vt(String.prototype.indexOf), aP = Vt(String.prototype.trim), ur = Vt(Object.prototype.hasOwnProperty), It = Vt(RegExp.prototype.test), ga = oP(TypeError);
function Vt(e) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return om(e, n, i);
  };
}
function oP(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return sm(e, r);
  };
}
function Tn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Jo;
  Zh && Zh(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (ZO(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function sP(e) {
  for (let n = 0; n < e.length; n++)
    ur(e, n) || (e[n] = null);
  return e;
}
function ii(e) {
  const n = Z_(null);
  for (const [r, i] of X_(e))
    ur(e, r) && (Array.isArray(i) ? n[r] = sP(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = ii(i) : n[r] = i);
  return n;
}
function ka(e, n) {
  for (; e !== null; ) {
    const i = nP(e, n);
    if (i) {
      if (i.get)
        return Vt(i.get);
      if (typeof i.value == "function")
        return Vt(i.value);
    }
    e = eP(e);
  }
  function r() {
    return null;
  }
  return r;
}
const ty = Lt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Dl = Lt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Rl = Lt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), lP = Lt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ol = Lt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), cP = Lt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), ry = Lt(["#text"]), iy = Lt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Pl = Lt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), ay = Lt(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Co = Lt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), dP = or(/\{\{[\w\W]*|[\w\W]*\}\}/gm), uP = or(/<%[\w\W]*|[\w\W]*%>/gm), mP = or(/\$\{[\w\W]*/gm), pP = or(/^data-[\-\w.\u00B7-\uFFFF]+$/), fP = or(/^aria-[\-\w]+$/), ex = or(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), hP = or(/^(?:\w+script|data):/i), yP = or(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), nx = or(/^html$/i), gP = or(/^[a-z][.\w]*(-[.\w]+)+$/i);
var oy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: fP,
  ATTR_WHITESPACE: yP,
  CUSTOM_ELEMENT: gP,
  DATA_ATTR: pP,
  DOCTYPE_NAME: nx,
  ERB_EXPR: uP,
  IS_ALLOWED_URI: ex,
  IS_SCRIPT_OR_DATA: hP,
  MUSTACHE_EXPR: dP,
  TMPLIT_EXPR: mP
});
const va = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, kP = function() {
  return typeof window > "u" ? null : window;
}, vP = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, sy = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function tx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : kP();
  const n = (E) => tx(E);
  if (n.version = "3.2.4", n.removed = [], !e || !e.document || e.document.nodeType !== va.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, S = d.prototype, N = ka(S, "cloneNode"), F = ka(S, "remove"), I = ka(S, "nextSibling"), g = ka(S, "childNodes"), q = ka(S, "parentNode");
  if (typeof s == "function") {
    const E = r.createElement("template");
    E.content && E.content.ownerDocument && (r = E.content.ownerDocument);
  }
  let $, C = "";
  const {
    implementation: D,
    createNodeIterator: U,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = r, {
    importNode: ee
  } = i;
  let J = sy();
  n.isSupported = typeof X_ == "function" && typeof q == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: G,
    ERB_EXPR: P,
    TMPLIT_EXPR: W,
    DATA_ATTR: ne,
    ARIA_ATTR: ke,
    IS_SCRIPT_OR_DATA: me,
    ATTR_WHITESPACE: de,
    CUSTOM_ELEMENT: he
  } = oy;
  let {
    IS_ALLOWED_URI: H
  } = oy, be = null;
  const Ce = Tn({}, [...ty, ...Dl, ...Rl, ...Ol, ...ry]);
  let K = null;
  const ze = Tn({}, [...iy, ...Pl, ...ay, ...Co]);
  let Be = Object.seal(Z_(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Me = null, Ie = !0, Le = !0, De = !1, rn = !0, je = !1, We = !0, Ge = !1, pe = !1, le = !1, Ne = !1, Ae = !1, Ee = !1, cn = !0, j = !1;
  const _ = "user-content-";
  let T = !0, Y = !1, X = {}, O = null;
  const B = Tn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ie = null;
  const fe = Tn({}, ["audio", "video", "img", "source", "image", "track"]);
  let _e = null;
  const en = Tn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), dn = "http://www.w3.org/1998/Math/MathML", tn = "http://www.w3.org/2000/svg", sn = "http://www.w3.org/1999/xhtml";
  let fn = sn, pn = !1, yn = null;
  const Xe = Tn({}, [dn, tn, sn], $l);
  let gn = Tn({}, ["mi", "mo", "mn", "ms", "mtext"]), Oe = Tn({}, ["annotation-xml"]);
  const ln = Tn({}, ["title", "style", "font", "a", "script"]);
  let an = null;
  const _n = ["application/xhtml+xml", "text/html"], Hn = "text/html";
  let on = null, Rn = null;
  const xn = r.createElement("form"), vn = function(E) {
    return E instanceof RegExp || E instanceof Function;
  }, Vn = function() {
    let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Rn && Rn === E)) {
      if ((!E || typeof E != "object") && (E = {}), E = ii(E), an = // eslint-disable-next-line unicorn/prefer-includes
      _n.indexOf(E.PARSER_MEDIA_TYPE) === -1 ? Hn : E.PARSER_MEDIA_TYPE, on = an === "application/xhtml+xml" ? $l : Jo, be = ur(E, "ALLOWED_TAGS") ? Tn({}, E.ALLOWED_TAGS, on) : Ce, K = ur(E, "ALLOWED_ATTR") ? Tn({}, E.ALLOWED_ATTR, on) : ze, yn = ur(E, "ALLOWED_NAMESPACES") ? Tn({}, E.ALLOWED_NAMESPACES, $l) : Xe, _e = ur(E, "ADD_URI_SAFE_ATTR") ? Tn(ii(en), E.ADD_URI_SAFE_ATTR, on) : en, ie = ur(E, "ADD_DATA_URI_TAGS") ? Tn(ii(fe), E.ADD_DATA_URI_TAGS, on) : fe, O = ur(E, "FORBID_CONTENTS") ? Tn({}, E.FORBID_CONTENTS, on) : B, Pe = ur(E, "FORBID_TAGS") ? Tn({}, E.FORBID_TAGS, on) : {}, Me = ur(E, "FORBID_ATTR") ? Tn({}, E.FORBID_ATTR, on) : {}, X = ur(E, "USE_PROFILES") ? E.USE_PROFILES : !1, Ie = E.ALLOW_ARIA_ATTR !== !1, Le = E.ALLOW_DATA_ATTR !== !1, De = E.ALLOW_UNKNOWN_PROTOCOLS || !1, rn = E.ALLOW_SELF_CLOSE_IN_ATTR !== !1, je = E.SAFE_FOR_TEMPLATES || !1, We = E.SAFE_FOR_XML !== !1, Ge = E.WHOLE_DOCUMENT || !1, Ne = E.RETURN_DOM || !1, Ae = E.RETURN_DOM_FRAGMENT || !1, Ee = E.RETURN_TRUSTED_TYPE || !1, le = E.FORCE_BODY || !1, cn = E.SANITIZE_DOM !== !1, j = E.SANITIZE_NAMED_PROPS || !1, T = E.KEEP_CONTENT !== !1, Y = E.IN_PLACE || !1, H = E.ALLOWED_URI_REGEXP || ex, fn = E.NAMESPACE || sn, gn = E.MATHML_TEXT_INTEGRATION_POINTS || gn, Oe = E.HTML_INTEGRATION_POINTS || Oe, Be = E.CUSTOM_ELEMENT_HANDLING || {}, E.CUSTOM_ELEMENT_HANDLING && vn(E.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Be.tagNameCheck = E.CUSTOM_ELEMENT_HANDLING.tagNameCheck), E.CUSTOM_ELEMENT_HANDLING && vn(E.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Be.attributeNameCheck = E.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), E.CUSTOM_ELEMENT_HANDLING && typeof E.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = E.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), je && (Le = !1), Ae && (Ne = !0), X && (be = Tn({}, ry), K = [], X.html === !0 && (Tn(be, ty), Tn(K, iy)), X.svg === !0 && (Tn(be, Dl), Tn(K, Pl), Tn(K, Co)), X.svgFilters === !0 && (Tn(be, Rl), Tn(K, Pl), Tn(K, Co)), X.mathMl === !0 && (Tn(be, Ol), Tn(K, ay), Tn(K, Co))), E.ADD_TAGS && (be === Ce && (be = ii(be)), Tn(be, E.ADD_TAGS, on)), E.ADD_ATTR && (K === ze && (K = ii(K)), Tn(K, E.ADD_ATTR, on)), E.ADD_URI_SAFE_ATTR && Tn(_e, E.ADD_URI_SAFE_ATTR, on), E.FORBID_CONTENTS && (O === B && (O = ii(O)), Tn(O, E.FORBID_CONTENTS, on)), T && (be["#text"] = !0), Ge && Tn(be, ["html", "head", "body"]), be.table && (Tn(be, ["tbody"]), delete Pe.tbody), E.TRUSTED_TYPES_POLICY) {
        if (typeof E.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ga('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof E.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ga('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        $ = E.TRUSTED_TYPES_POLICY, C = $.createHTML("");
      } else
        $ === void 0 && ($ = vP(v, a)), $ !== null && typeof C == "string" && (C = $.createHTML(""));
      Lt && Lt(E), Rn = E;
    }
  }, Mn = Tn({}, [...Dl, ...Rl, ...lP]), bn = Tn({}, [...Ol, ...cP]), Sn = function(E) {
    let V = q(E);
    (!V || !V.tagName) && (V = {
      namespaceURI: fn,
      tagName: "template"
    });
    const z = Jo(E.tagName), re = Jo(V.tagName);
    return yn[E.namespaceURI] ? E.namespaceURI === tn ? V.namespaceURI === sn ? z === "svg" : V.namespaceURI === dn ? z === "svg" && (re === "annotation-xml" || gn[re]) : !!Mn[z] : E.namespaceURI === dn ? V.namespaceURI === sn ? z === "math" : V.namespaceURI === tn ? z === "math" && Oe[re] : !!bn[z] : E.namespaceURI === sn ? V.namespaceURI === tn && !Oe[re] || V.namespaceURI === dn && !gn[re] ? !1 : !bn[z] && (ln[z] || !Mn[z]) : !!(an === "application/xhtml+xml" && yn[E.namespaceURI]) : !1;
  }, $n = function(E) {
    ha(n.removed, {
      element: E
    });
    try {
      q(E).removeChild(E);
    } catch {
      F(E);
    }
  }, Ln = function(E, V) {
    try {
      ha(n.removed, {
        attribute: V.getAttributeNode(E),
        from: V
      });
    } catch {
      ha(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(E), E === "is")
      if (Ne || Ae)
        try {
          $n(V);
        } catch {
        }
      else
        try {
          V.setAttribute(E, "");
        } catch {
        }
  }, Bn = function(E) {
    let V = null, z = null;
    if (le)
      E = "<remove></remove>" + E;
    else {
      const ve = ny(E, /^[\r\n\t ]+/);
      z = ve && ve[0];
    }
    an === "application/xhtml+xml" && fn === sn && (E = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + E + "</body></html>");
    const re = $ ? $.createHTML(E) : E;
    if (fn === sn)
      try {
        V = new h().parseFromString(re, an);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = D.createDocument(fn, "template", null);
      try {
        V.documentElement.innerHTML = pn ? C : re;
      } catch {
      }
    }
    const we = V.body || V.documentElement;
    return E && z && we.insertBefore(r.createTextNode(z), we.childNodes[0] || null), fn === sn ? Q.call(V, Ge ? "html" : "body")[0] : Ge ? V.documentElement : we;
  }, qn = function(E) {
    return U.call(
      E.ownerDocument || E,
      E,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, t = function(E) {
    return E instanceof f && (typeof E.nodeName != "string" || typeof E.textContent != "string" || typeof E.removeChild != "function" || !(E.attributes instanceof u) || typeof E.removeAttribute != "function" || typeof E.setAttribute != "function" || typeof E.namespaceURI != "string" || typeof E.insertBefore != "function" || typeof E.hasChildNodes != "function");
  }, c = function(E) {
    return typeof l == "function" && E instanceof l;
  };
  function p(E, V, z) {
    wo(E, (re) => {
      re.call(n, V, z, Rn);
    });
  }
  const y = function(E) {
    let V = null;
    if (p(J.beforeSanitizeElements, E, null), t(E))
      return $n(E), !0;
    const z = on(E.nodeName);
    if (p(J.uponSanitizeElement, E, {
      tagName: z,
      allowedTags: be
    }), E.hasChildNodes() && !c(E.firstElementChild) && It(/<[/\w]/g, E.innerHTML) && It(/<[/\w]/g, E.textContent) || E.nodeType === va.progressingInstruction || We && E.nodeType === va.comment && It(/<[/\w]/g, E.data))
      return $n(E), !0;
    if (!be[z] || Pe[z]) {
      if (!Pe[z] && L(z) && (Be.tagNameCheck instanceof RegExp && It(Be.tagNameCheck, z) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(z)))
        return !1;
      if (T && !O[z]) {
        const re = q(E) || E.parentNode, we = g(E) || E.childNodes;
        if (we && re) {
          const ve = we.length;
          for (let te = ve - 1; te >= 0; --te) {
            const Ze = N(we[te], !0);
            Ze.__removalCount = (E.__removalCount || 0) + 1, re.insertBefore(Ze, I(E));
          }
        }
      }
      return $n(E), !0;
    }
    return E instanceof d && !Sn(E) || (z === "noscript" || z === "noembed" || z === "noframes") && It(/<\/no(script|embed|frames)/i, E.innerHTML) ? ($n(E), !0) : (je && E.nodeType === va.text && (V = E.textContent, wo([G, P, W], (re) => {
      V = ya(V, re, " ");
    }), E.textContent !== V && (ha(n.removed, {
      element: E.cloneNode()
    }), E.textContent = V)), p(J.afterSanitizeElements, E, null), !1);
  }, R = function(E, V, z) {
    if (cn && (V === "id" || V === "name") && (z in r || z in xn))
      return !1;
    if (!(Le && !Me[V] && It(ne, V)) && !(Ie && It(ke, V))) {
      if (!K[V] || Me[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(L(E) && (Be.tagNameCheck instanceof RegExp && It(Be.tagNameCheck, E) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(E)) && (Be.attributeNameCheck instanceof RegExp && It(Be.attributeNameCheck, V) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(V)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && It(Be.tagNameCheck, z) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(z)))
        ) return !1;
      } else if (!_e[V] && !It(H, ya(z, de, "")) && !((V === "src" || V === "xlink:href" || V === "href") && E !== "script" && iP(z, "data:") === 0 && ie[E]) && !(De && !It(me, ya(z, de, ""))) && z)
        return !1;
    }
    return !0;
  }, L = function(E) {
    return E !== "annotation-xml" && ny(E, he);
  }, w = function(E) {
    p(J.beforeSanitizeAttributes, E, null);
    const {
      attributes: V
    } = E;
    if (!V || t(E))
      return;
    const z = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let re = V.length;
    for (; re--; ) {
      const we = V[re], {
        name: ve,
        namespaceURI: te,
        value: Ze
      } = we, In = on(ve);
      let Nn = ve === "value" ? Ze : aP(Ze);
      if (z.attrName = In, z.attrValue = Nn, z.keepAttr = !0, z.forceKeepAttr = void 0, p(J.uponSanitizeAttribute, E, z), Nn = z.attrValue, j && (In === "id" || In === "name") && (Ln(ve, E), Nn = _ + Nn), We && It(/((--!?|])>)|<\/(style|title)/i, Nn)) {
        Ln(ve, E);
        continue;
      }
      if (z.forceKeepAttr || (Ln(ve, E), !z.keepAttr))
        continue;
      if (!rn && It(/\/>/i, Nn)) {
        Ln(ve, E);
        continue;
      }
      je && wo([G, P, W], (dS) => {
        Nn = ya(Nn, dS, " ");
      });
      const Pp = on(E.nodeName);
      if (R(Pp, In, Nn)) {
        if ($ && typeof v == "object" && typeof v.getAttributeType == "function" && !te)
          switch (v.getAttributeType(Pp, In)) {
            case "TrustedHTML": {
              Nn = $.createHTML(Nn);
              break;
            }
            case "TrustedScriptURL": {
              Nn = $.createScriptURL(Nn);
              break;
            }
          }
        try {
          te ? E.setAttributeNS(te, ve, Nn) : E.setAttribute(ve, Nn), t(E) ? $n(E) : ey(n.removed);
        } catch {
        }
      }
    }
    p(J.afterSanitizeAttributes, E, null);
  }, x = function E(V) {
    let z = null;
    const re = qn(V);
    for (p(J.beforeSanitizeShadowDOM, V, null); z = re.nextNode(); )
      p(J.uponSanitizeShadowNode, z, null), y(z), w(z), z.content instanceof o && E(z.content);
    p(J.afterSanitizeShadowDOM, V, null);
  };
  return n.sanitize = function(E) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = null, re = null, we = null, ve = null;
    if (pn = !E, pn && (E = "<!-->"), typeof E != "string" && !c(E))
      if (typeof E.toString == "function") {
        if (E = E.toString(), typeof E != "string")
          throw ga("dirty is not a string, aborting");
      } else
        throw ga("toString is not a function");
    if (!n.isSupported)
      return E;
    if (pe || Vn(V), n.removed = [], typeof E == "string" && (Y = !1), Y) {
      if (E.nodeName) {
        const In = on(E.nodeName);
        if (!be[In] || Pe[In])
          throw ga("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (E instanceof l)
      z = Bn("<!---->"), re = z.ownerDocument.importNode(E, !0), re.nodeType === va.element && re.nodeName === "BODY" || re.nodeName === "HTML" ? z = re : z.appendChild(re);
    else {
      if (!Ne && !je && !Ge && // eslint-disable-next-line unicorn/prefer-includes
      E.indexOf("<") === -1)
        return $ && Ee ? $.createHTML(E) : E;
      if (z = Bn(E), !z)
        return Ne ? null : Ee ? C : "";
    }
    z && le && $n(z.firstChild);
    const te = qn(Y ? E : z);
    for (; we = te.nextNode(); )
      y(we), w(we), we.content instanceof o && x(we.content);
    if (Y)
      return E;
    if (Ne) {
      if (Ae)
        for (ve = Z.call(z.ownerDocument); z.firstChild; )
          ve.appendChild(z.firstChild);
      else
        ve = z;
      return (K.shadowroot || K.shadowrootmode) && (ve = ee.call(i, ve, !0)), ve;
    }
    let Ze = Ge ? z.outerHTML : z.innerHTML;
    return Ge && be["!doctype"] && z.ownerDocument && z.ownerDocument.doctype && z.ownerDocument.doctype.name && It(nx, z.ownerDocument.doctype.name) && (Ze = "<!DOCTYPE " + z.ownerDocument.doctype.name + `>
` + Ze), je && wo([G, P, W], (In) => {
      Ze = ya(Ze, In, " ");
    }), $ && Ee ? $.createHTML(Ze) : Ze;
  }, n.setConfig = function() {
    let E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(E), pe = !0;
  }, n.clearConfig = function() {
    Rn = null, pe = !1;
  }, n.isValidAttribute = function(E, V, z) {
    Rn || Vn({});
    const re = on(E), we = on(V);
    return R(re, we, z);
  }, n.addHook = function(E, V) {
    typeof V == "function" && ha(J[E], V);
  }, n.removeHook = function(E, V) {
    if (V !== void 0) {
      const z = tP(J[E], V);
      return z === -1 ? void 0 : rP(J[E], z, 1)[0];
    }
    return ey(J[E]);
  }, n.removeHooks = function(E) {
    J[E] = [];
  }, n.removeAllHooks = function() {
    J = sy();
  }, n;
}
var bP = tx();
const _P = "_messageContainer_1rxr4_1", xP = "_chip_1rxr4_7", SP = "_chipLabel_1rxr4_10", NP = "_chipValue_1rxr4_13", Fo = {
  messageContainer: _P,
  chip: xP,
  chipLabel: SP,
  chipValue: NP
}, ly = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, jP = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ jn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ jn.jsx(Ke, { content: "Conversation Attributes", children: /* @__PURE__ */ jn.jsx(
        _m,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ jn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ jn.jsx(On, { className: Fo.chip, children: /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(Jn, { className: Fo.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ jn.jsx(Jn, { className: Fo.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ jn.jsx(
      b,
      {
        className: Fo.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? ly[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? ly[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ jn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ jn.jsx(ES, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ jn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: bP.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ jn.jsx(
      TS,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ jn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, wP = "_conversation_1draa_1", CP = "_conversationSubLine_1draa_9", FP = "_modal_1draa_14", Al = {
  conversation: wP,
  conversationSubLine: CP,
  modal: FP
}, IP = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), EP = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), TP = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ jn.jsxs(b, { className: Al.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ jn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ jn.jsx(Un, { size: "small", variant: "info", children: Pn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ jn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Al.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ jn.jsx(On, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ jn.jsx(Ke, { content: "Show conversation preview", children: /* @__PURE__ */ jn.jsx(
        Kt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ jn.jsxs(
      gt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Al.modal,
        children: [
          /* @__PURE__ */ jn.jsx(
            kt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ jn.jsx(vt, { children: /* @__PURE__ */ jn.jsx(
            jP,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: IP(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: EP(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, $P = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = et(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ jn.jsx(
      TP,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ jn.jsxs(
      Wn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, DP = XO(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), RP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = mn(), { data: l, loading: d, error: m } = s(DP, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ jn.jsx(wn, { error: m }) : d ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ jn.jsx(un, {}) }) : r?.length === 0 ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ jn.jsx(
    $P,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, OP = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ll = { exports: {} }, ba = {}, cy;
function PP() {
  if (cy) return ba;
  cy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ba.Fragment = r, ba.jsx = s, ba.jsxs = s, ba;
}
var Io = {}, dy;
function AP() {
  return dy || (dy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Io.Fragment = i, Io.jsx = Bn, Io.jsxs = qn;
  })()), Io;
}
var uy;
function LP() {
  return uy || (uy = 1, process.env.NODE_ENV === "production" ? Ll.exports = PP() : Ll.exports = AP()), Ll.exports;
}
var Fe = LP();
const VP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, zP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, UP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, MP = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": VP,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": zP,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": UP
};
function rp(e) {
  return MP[e] ?? {};
}
const BP = rp(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), qP = rp(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), HP = rp(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function lm(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const WP = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, rx = "DD MMM YYYY @ HH:mm", KP = "_list_2c4dq_1", GP = "_listItem_2c4dq_4", YP = "_copyIcon_2c4dq_12", ui = {
  list: KP,
  listItem: GP,
  copyIcon: YP
}, cm = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = lm(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: S
  } = e ?? {}, N = `${d} ${m}`.trim() || void 0, F = `${h} ${v}`.trim() || void 0, I = [N, u, f, F, S].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(un, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: I.map((g, q) => /* @__PURE__ */ Fe.jsx(Jn, { children: g }, q)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Ke, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: "exclamation",
          className: ui.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(I.join(", ")),
          className: ui.copyIcon
        }
      ) })
    ] })
  ] });
}, JP = "_wrapper_1nher_1", QP = {
  wrapper: JP
}, XP = ({
  customer: e,
  store: n
}) => {
  const { track: r } = kn(), { isCopied: i, copy: a } = lm(), { isCopied: o, copy: s } = lm(), { useQuery: l } = mn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(qP, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, S = (h?.addresses?.length ?? 0) > 1;
  if (qe(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ Fe.jsx(wn, { error: u });
  if (!e)
    return null;
  const {
    id: N,
    phone: F,
    email: I,
    first_name: g,
    last_name: q,
    created_at: $,
    has_valid_payment_method: C
  } = e, D = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${N}` : null, Z = `${g || ""} ${q || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: QP.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-2", children: Z }),
    $ && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: Pn($).format(rx) })
    ] }),
    I && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(A.ExternalLink, { href: `mailto:${I}`, children: I })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: ui.copyIcon
        }
      ) })
    ] }),
    F && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: F })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: o ? "done" : "copy",
          onClick: () => s(F),
          className: ui.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      cm,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: S
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: D,
          name: C ? "check-circle" : "close-circle-filled",
          color: C ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: D, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, ZP = "_order_1dlaa_1", eA = "_orderIsOpen_1dlaa_9", nA = "_orderHeader_1dlaa_12", tA = "_note_1dlaa_16", Eo = {
  order: ZP,
  orderIsOpen: eA,
  orderHeader: nA,
  note: tA
}, rA = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = kn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: S,
    is_prepaid: N
  } = e, F = 14, I = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: ct(Eo.order, {
        [Eo.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Eo.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: Pn(f).format(rx) }) }),
                /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Fe.jsx(Ke, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Eo.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: F, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: WP(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: F, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: F, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: F, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "4", children: [
                S,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            cm,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            cm,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          I && /* @__PURE__ */ Fe.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(I, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, iA = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = kn(), { useQuery: i } = mn(), {
    loading: a,
    error: o,
    data: s
  } = i(HP, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Fe.jsx(wn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Fe.jsx(Un, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(un, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Fe.jsx(
        rA,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Fe.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, aA = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(He, { className: ui.list, children: [
      /* @__PURE__ */ Fe.jsx(He.Text, { variant: "dense", className: ui.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(He.Text, { variant: "dense", className: ui.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, oA = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(BP, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return gm({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : km({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Fe.jsx(wn, { error: m });
  }
  return d ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(un, {}) }) : f ? l ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Fe.jsx(XP, { customer: f, store: h }),
        o && /* @__PURE__ */ Fe.jsx(aA, { customer: f }),
        s && /* @__PURE__ */ Fe.jsx(iA, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, sA = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var To = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ix(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vl = { exports: {} }, _a = {}, my;
function lA() {
  if (my) return _a;
  my = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return _a.Fragment = r, _a.jsx = s, _a.jsxs = s, _a;
}
var $o = {}, py;
function cA() {
  return py || (py = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    $o.Fragment = i, $o.jsx = Bn, $o.jsxs = qn;
  })()), $o;
}
var fy;
function dA() {
  return fy || (fy = 1, process.env.NODE_ENV === "production" ? Vl.exports = lA() : Vl.exports = cA()), Vl.exports;
}
var mi = dA();
function uA(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var zl, hy;
function Zr() {
  if (hy) return zl;
  hy = 1;
  var e = Array.isArray;
  return zl = e, zl;
}
var Ul, yy;
function ax() {
  if (yy) return Ul;
  yy = 1;
  var e = typeof To == "object" && To && To.Object === Object && To;
  return Ul = e, Ul;
}
var Ml, gy;
function Or() {
  if (gy) return Ml;
  gy = 1;
  var e = ax(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Ml = r, Ml;
}
var Bl, ky;
function ao() {
  if (ky) return Bl;
  ky = 1;
  var e = Or(), n = e.Symbol;
  return Bl = n, Bl;
}
var ql, vy;
function mA() {
  if (vy) return ql;
  vy = 1;
  var e = ao(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return ql = o, ql;
}
var Hl, by;
function pA() {
  if (by) return Hl;
  by = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Hl = r, Hl;
}
var Wl, _y;
function Hi() {
  if (_y) return Wl;
  _y = 1;
  var e = ao(), n = mA(), r = pA(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Wl = s, Wl;
}
var Kl, xy;
function gi() {
  if (xy) return Kl;
  xy = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Kl = e, Kl;
}
var Gl, Sy;
function ip() {
  if (Sy) return Gl;
  Sy = 1;
  var e = Hi(), n = gi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Gl = i, Gl;
}
var Yl, Ny;
function fA() {
  if (Ny) return Yl;
  Ny = 1;
  var e = Zr(), n = ip(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Yl = a, Yl;
}
var Jl, jy;
function Wi() {
  if (jy) return Jl;
  jy = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Jl = e, Jl;
}
var Ql, wy;
function ox() {
  if (wy) return Ql;
  wy = 1;
  var e = Hi(), n = Wi(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Ql = s, Ql;
}
var Xl, Cy;
function hA() {
  if (Cy) return Xl;
  Cy = 1;
  var e = Or(), n = e["__core-js_shared__"];
  return Xl = n, Xl;
}
var Zl, Fy;
function yA() {
  if (Fy) return Zl;
  Fy = 1;
  var e = hA(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Zl = r, Zl;
}
var ec, Iy;
function sx() {
  if (Iy) return ec;
  Iy = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return ec = r, ec;
}
var nc, Ey;
function gA() {
  if (Ey) return nc;
  Ey = 1;
  var e = ox(), n = yA(), r = Wi(), i = sx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return nc = f, nc;
}
var tc, Ty;
function kA() {
  if (Ty) return tc;
  Ty = 1;
  function e(n, r) {
    return n?.[r];
  }
  return tc = e, tc;
}
var rc, $y;
function ki() {
  if ($y) return rc;
  $y = 1;
  var e = gA(), n = kA();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return rc = r, rc;
}
var ic, Dy;
function zs() {
  if (Dy) return ic;
  Dy = 1;
  var e = ki(), n = e(Object, "create");
  return ic = n, ic;
}
var ac, Ry;
function vA() {
  if (Ry) return ac;
  Ry = 1;
  var e = zs();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return ac = n, ac;
}
var oc, Oy;
function bA() {
  if (Oy) return oc;
  Oy = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return oc = e, oc;
}
var sc, Py;
function _A() {
  if (Py) return sc;
  Py = 1;
  var e = zs(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return sc = a, sc;
}
var lc, Ay;
function xA() {
  if (Ay) return lc;
  Ay = 1;
  var e = zs(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return lc = i, lc;
}
var cc, Ly;
function SA() {
  if (Ly) return cc;
  Ly = 1;
  var e = zs(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return cc = r, cc;
}
var dc, Vy;
function NA() {
  if (Vy) return dc;
  Vy = 1;
  var e = vA(), n = bA(), r = _A(), i = xA(), a = SA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, dc = o, dc;
}
var uc, zy;
function jA() {
  if (zy) return uc;
  zy = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return uc = e, uc;
}
var mc, Uy;
function lx() {
  if (Uy) return mc;
  Uy = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return mc = e, mc;
}
var pc, My;
function Us() {
  if (My) return pc;
  My = 1;
  var e = lx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return pc = n, pc;
}
var fc, By;
function wA() {
  if (By) return fc;
  By = 1;
  var e = Us(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return fc = i, fc;
}
var hc, qy;
function CA() {
  if (qy) return hc;
  qy = 1;
  var e = Us();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return hc = n, hc;
}
var yc, Hy;
function FA() {
  if (Hy) return yc;
  Hy = 1;
  var e = Us();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return yc = n, yc;
}
var gc, Wy;
function IA() {
  if (Wy) return gc;
  Wy = 1;
  var e = Us();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return gc = n, gc;
}
var kc, Ky;
function Ms() {
  if (Ky) return kc;
  Ky = 1;
  var e = jA(), n = wA(), r = CA(), i = FA(), a = IA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, kc = o, kc;
}
var vc, Gy;
function ap() {
  if (Gy) return vc;
  Gy = 1;
  var e = ki(), n = Or(), r = e(n, "Map");
  return vc = r, vc;
}
var bc, Yy;
function EA() {
  if (Yy) return bc;
  Yy = 1;
  var e = NA(), n = Ms(), r = ap();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return bc = i, bc;
}
var _c, Jy;
function TA() {
  if (Jy) return _c;
  Jy = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return _c = e, _c;
}
var xc, Qy;
function Bs() {
  if (Qy) return xc;
  Qy = 1;
  var e = TA();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return xc = n, xc;
}
var Sc, Xy;
function $A() {
  if (Xy) return Sc;
  Xy = 1;
  var e = Bs();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Sc = n, Sc;
}
var Nc, Zy;
function DA() {
  if (Zy) return Nc;
  Zy = 1;
  var e = Bs();
  function n(r) {
    return e(this, r).get(r);
  }
  return Nc = n, Nc;
}
var jc, eg;
function RA() {
  if (eg) return jc;
  eg = 1;
  var e = Bs();
  function n(r) {
    return e(this, r).has(r);
  }
  return jc = n, jc;
}
var wc, ng;
function OA() {
  if (ng) return wc;
  ng = 1;
  var e = Bs();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return wc = n, wc;
}
var Cc, tg;
function cx() {
  if (tg) return Cc;
  tg = 1;
  var e = EA(), n = $A(), r = DA(), i = RA(), a = OA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Cc = o, Cc;
}
var Fc, rg;
function PA() {
  if (rg) return Fc;
  rg = 1;
  var e = cx(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Fc = r, Fc;
}
var Ic, ig;
function AA() {
  if (ig) return Ic;
  ig = 1;
  var e = PA(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Ic = r, Ic;
}
var Ec, ag;
function LA() {
  if (ag) return Ec;
  ag = 1;
  var e = AA(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Ec = i, Ec;
}
var Tc, og;
function dx() {
  if (og) return Tc;
  og = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Tc = e, Tc;
}
var $c, sg;
function VA() {
  if (sg) return $c;
  sg = 1;
  var e = ao(), n = dx(), r = Zr(), i = ip(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return $c = s, $c;
}
var Dc, lg;
function zA() {
  if (lg) return Dc;
  lg = 1;
  var e = VA();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Dc = n, Dc;
}
var Rc, cg;
function Ki() {
  if (cg) return Rc;
  cg = 1;
  var e = Zr(), n = fA(), r = LA(), i = zA();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Rc = a, Rc;
}
var Oc, dg;
function qs() {
  if (dg) return Oc;
  dg = 1;
  var e = ip();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Oc = n, Oc;
}
var Pc, ug;
function ux() {
  if (ug) return Pc;
  ug = 1;
  var e = Ki(), n = qs();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Pc = r, Pc;
}
var Ac, mg;
function mx() {
  if (mg) return Ac;
  mg = 1;
  var e = ki(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Ac = n, Ac;
}
var Lc, pg;
function px() {
  if (pg) return Lc;
  pg = 1;
  var e = mx();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Lc = n, Lc;
}
var Vc, fg;
function op() {
  if (fg) return Vc;
  fg = 1;
  var e = px(), n = lx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Vc = a, Vc;
}
var zc, hg;
function sp() {
  if (hg) return zc;
  hg = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return zc = r, zc;
}
var Uc, yg;
function UA() {
  if (yg) return Uc;
  yg = 1;
  var e = op(), n = Ki(), r = sp(), i = Wi(), a = qs();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var S = a(l[u]), N = d;
      if (S === "__proto__" || S === "constructor" || S === "prototype")
        return s;
      if (u != h) {
        var F = v[S];
        N = m ? m(F, S, v) : void 0, N === void 0 && (N = i(F) ? F : r(l[u + 1]) ? [] : {});
      }
      e(v, S, N), v = v[S];
    }
    return s;
  }
  return Uc = o, Uc;
}
var Mc, gg;
function MA() {
  if (gg) return Mc;
  gg = 1;
  var e = ux(), n = UA(), r = Ki();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Mc = i, Mc;
}
var Bc, kg;
function BA() {
  if (kg) return Bc;
  kg = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Bc = e, Bc;
}
var qc, vg;
function qA() {
  if (vg) return qc;
  vg = 1;
  var e = Hi(), n = gi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return qc = i, qc;
}
var Hc, bg;
function lp() {
  if (bg) return Hc;
  bg = 1;
  var e = qA(), n = gi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Hc = o, Hc;
}
var Wc, _g;
function cp() {
  if (_g) return Wc;
  _g = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Wc = n, Wc;
}
var Kc, xg;
function HA() {
  if (xg) return Kc;
  xg = 1;
  var e = Ki(), n = lp(), r = Zr(), i = sp(), a = cp(), o = qs();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Kc = s, Kc;
}
var Gc, Sg;
function WA() {
  if (Sg) return Gc;
  Sg = 1;
  var e = BA(), n = HA();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Gc = r, Gc;
}
var Yc, Ng;
function KA() {
  if (Ng) return Yc;
  Ng = 1;
  var e = MA(), n = WA();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Yc = r, Yc;
}
var Jc, jg;
function dp() {
  if (jg) return Jc;
  jg = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Jc = e, Jc;
}
var Qc, wg;
function GA() {
  if (wg) return Qc;
  wg = 1;
  var e = ao(), n = lp(), r = Zr(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Qc = a, Qc;
}
var Xc, Cg;
function YA() {
  if (Cg) return Xc;
  Cg = 1;
  var e = dp(), n = GA();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Xc = r, Xc;
}
var Zc, Fg;
function JA() {
  if (Fg) return Zc;
  Fg = 1;
  var e = YA();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Zc = n, Zc;
}
var ed, Ig;
function QA() {
  if (Ig) return ed;
  Ig = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return ed = e, ed;
}
var nd, Eg;
function XA() {
  if (Eg) return nd;
  Eg = 1;
  var e = QA(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return nd = r, nd;
}
var td, Tg;
function ZA() {
  if (Tg) return td;
  Tg = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return td = e, td;
}
var rd, $g;
function fx() {
  if ($g) return rd;
  $g = 1;
  function e(n) {
    return n;
  }
  return rd = e, rd;
}
var id, Dg;
function e2() {
  if (Dg) return id;
  Dg = 1;
  var e = ZA(), n = mx(), r = fx(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return id = i, id;
}
var ad, Rg;
function n2() {
  if (Rg) return ad;
  Rg = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ad = i, ad;
}
var od, Og;
function t2() {
  if (Og) return od;
  Og = 1;
  var e = e2(), n = n2(), r = n(e);
  return od = r, od;
}
var sd, Pg;
function hx() {
  if (Pg) return sd;
  Pg = 1;
  var e = JA(), n = XA(), r = t2();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return sd = i, sd;
}
var ld, Ag;
function r2() {
  if (Ag) return ld;
  Ag = 1;
  var e = KA(), n = hx(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return ld = r, ld;
}
var i2 = r2();
const yx = /* @__PURE__ */ ix(i2), a2 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function gx(e) {
  const n = yx(e, a2);
  return {
    controller: Am(n),
    controllerProps: n
  };
}
const o2 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function kx(e) {
  const { controller: n, controllerProps: r } = gx(e), i = {
    ...yx(e, o2),
    required: uA(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var cd, Lg;
function s2() {
  if (Lg) return cd;
  Lg = 1;
  var e = Ms();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return cd = n, cd;
}
var dd, Vg;
function l2() {
  if (Vg) return dd;
  Vg = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return dd = e, dd;
}
var ud, zg;
function c2() {
  if (zg) return ud;
  zg = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return ud = e, ud;
}
var md, Ug;
function d2() {
  if (Ug) return md;
  Ug = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return md = e, md;
}
var pd, Mg;
function u2() {
  if (Mg) return pd;
  Mg = 1;
  var e = Ms(), n = ap(), r = cx(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return pd = a, pd;
}
var fd, Bg;
function m2() {
  if (Bg) return fd;
  Bg = 1;
  var e = Ms(), n = s2(), r = l2(), i = c2(), a = d2(), o = u2();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, fd = s, fd;
}
var hd, qg;
function p2() {
  if (qg) return hd;
  qg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return hd = e, hd;
}
var yd, Hg;
function oo() {
  if (Hg) return yd;
  Hg = 1;
  var e = op(), n = px();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return yd = r, yd;
}
var gd, Wg;
function f2() {
  if (Wg) return gd;
  Wg = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return gd = e, gd;
}
var Qo = { exports: {} }, kd, Kg;
function h2() {
  if (Kg) return kd;
  Kg = 1;
  function e() {
    return !1;
  }
  return kd = e, kd;
}
Qo.exports;
var Gg;
function vx() {
  return Gg || (Gg = 1, (function(e, n) {
    var r = Or(), i = h2(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(Qo, Qo.exports)), Qo.exports;
}
var vd, Yg;
function y2() {
  if (Yg) return vd;
  Yg = 1;
  var e = Hi(), n = cp(), r = gi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", S = "[object String]", N = "[object WeakMap]", F = "[object ArrayBuffer]", I = "[object DataView]", g = "[object Float32Array]", q = "[object Float64Array]", $ = "[object Int8Array]", C = "[object Int16Array]", D = "[object Int32Array]", U = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ee = "[object Uint32Array]", J = {};
  J[g] = J[q] = J[$] = J[C] = J[D] = J[U] = J[Z] = J[Q] = J[ee] = !0, J[i] = J[a] = J[F] = J[o] = J[I] = J[s] = J[l] = J[d] = J[m] = J[u] = J[f] = J[h] = J[v] = J[S] = J[N] = !1;
  function G(P) {
    return r(P) && n(P.length) && !!J[e(P)];
  }
  return vd = G, vd;
}
var bd, Jg;
function up() {
  if (Jg) return bd;
  Jg = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return bd = e, bd;
}
var Xo = { exports: {} };
Xo.exports;
var Qg;
function mp() {
  return Qg || (Qg = 1, (function(e, n) {
    var r = ax(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Xo, Xo.exports)), Xo.exports;
}
var _d, Xg;
function g2() {
  if (Xg) return _d;
  Xg = 1;
  var e = y2(), n = up(), r = mp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return _d = a, _d;
}
var xd, Zg;
function bx() {
  if (Zg) return xd;
  Zg = 1;
  var e = f2(), n = lp(), r = Zr(), i = vx(), a = sp(), o = g2(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), S = !f && !h && !v && o(m), N = f || h || v || S, F = N ? e(m.length, String) : [], I = F.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      S && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, I))) && F.push(g);
    return F;
  }
  return xd = d, xd;
}
var Sd, ek;
function pp() {
  if (ek) return Sd;
  ek = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Sd = n, Sd;
}
var Nd, nk;
function _x() {
  if (nk) return Nd;
  nk = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Nd = e, Nd;
}
var jd, tk;
function k2() {
  if (tk) return jd;
  tk = 1;
  var e = _x(), n = e(Object.keys, Object);
  return jd = n, jd;
}
var wd, rk;
function v2() {
  if (rk) return wd;
  rk = 1;
  var e = pp(), n = k2(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return wd = a, wd;
}
var Cd, ik;
function xx() {
  if (ik) return Cd;
  ik = 1;
  var e = ox(), n = cp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Cd = r, Cd;
}
var Fd, ak;
function fp() {
  if (ak) return Fd;
  ak = 1;
  var e = bx(), n = v2(), r = xx();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Fd = i, Fd;
}
var Id, ok;
function b2() {
  if (ok) return Id;
  ok = 1;
  var e = oo(), n = fp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Id = r, Id;
}
var Ed, sk;
function _2() {
  if (sk) return Ed;
  sk = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Ed = e, Ed;
}
var Td, lk;
function x2() {
  if (lk) return Td;
  lk = 1;
  var e = Wi(), n = pp(), r = _2(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Td = o, Td;
}
var $d, ck;
function hp() {
  if (ck) return $d;
  ck = 1;
  var e = bx(), n = x2(), r = xx();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return $d = i, $d;
}
var Dd, dk;
function S2() {
  if (dk) return Dd;
  dk = 1;
  var e = oo(), n = hp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Dd = r, Dd;
}
var Zo = { exports: {} };
Zo.exports;
var uk;
function N2() {
  return uk || (uk = 1, (function(e, n) {
    var r = Or(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(Zo, Zo.exports)), Zo.exports;
}
var Rd, mk;
function j2() {
  if (mk) return Rd;
  mk = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Rd = e, Rd;
}
var Od, pk;
function w2() {
  if (pk) return Od;
  pk = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Od = e, Od;
}
var Pd, fk;
function Sx() {
  if (fk) return Pd;
  fk = 1;
  function e() {
    return [];
  }
  return Pd = e, Pd;
}
var Ad, hk;
function yp() {
  if (hk) return Ad;
  hk = 1;
  var e = w2(), n = Sx(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Ad = o, Ad;
}
var Ld, yk;
function C2() {
  if (yk) return Ld;
  yk = 1;
  var e = oo(), n = yp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Ld = r, Ld;
}
var Vd, gk;
function gp() {
  if (gk) return Vd;
  gk = 1;
  var e = _x(), n = e(Object.getPrototypeOf, Object);
  return Vd = n, Vd;
}
var zd, kk;
function Nx() {
  if (kk) return zd;
  kk = 1;
  var e = dp(), n = gp(), r = yp(), i = Sx(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return zd = o, zd;
}
var Ud, vk;
function F2() {
  if (vk) return Ud;
  vk = 1;
  var e = oo(), n = Nx();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Ud = r, Ud;
}
var Md, bk;
function jx() {
  if (bk) return Md;
  bk = 1;
  var e = dp(), n = Zr();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Md = r, Md;
}
var Bd, _k;
function I2() {
  if (_k) return Bd;
  _k = 1;
  var e = jx(), n = yp(), r = fp();
  function i(a) {
    return e(a, r, n);
  }
  return Bd = i, Bd;
}
var qd, xk;
function wx() {
  if (xk) return qd;
  xk = 1;
  var e = jx(), n = Nx(), r = hp();
  function i(a) {
    return e(a, r, n);
  }
  return qd = i, qd;
}
var Hd, Sk;
function E2() {
  if (Sk) return Hd;
  Sk = 1;
  var e = ki(), n = Or(), r = e(n, "DataView");
  return Hd = r, Hd;
}
var Wd, Nk;
function T2() {
  if (Nk) return Wd;
  Nk = 1;
  var e = ki(), n = Or(), r = e(n, "Promise");
  return Wd = r, Wd;
}
var Kd, jk;
function $2() {
  if (jk) return Kd;
  jk = 1;
  var e = ki(), n = Or(), r = e(n, "Set");
  return Kd = r, Kd;
}
var Gd, wk;
function D2() {
  if (wk) return Gd;
  wk = 1;
  var e = ki(), n = Or(), r = e(n, "WeakMap");
  return Gd = r, Gd;
}
var Yd, Ck;
function kp() {
  if (Ck) return Yd;
  Ck = 1;
  var e = E2(), n = ap(), r = T2(), i = $2(), a = D2(), o = Hi(), s = sx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), S = s(n), N = s(r), F = s(i), I = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(q) {
    var $ = o(q), C = $ == d ? q.constructor : void 0, D = C ? s(C) : "";
    if (D)
      switch (D) {
        case v:
          return h;
        case S:
          return l;
        case N:
          return m;
        case F:
          return u;
        case I:
          return f;
      }
    return $;
  }), Yd = g, Yd;
}
var Jd, Fk;
function R2() {
  if (Fk) return Jd;
  Fk = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Jd = r, Jd;
}
var Qd, Ik;
function O2() {
  if (Ik) return Qd;
  Ik = 1;
  var e = Or(), n = e.Uint8Array;
  return Qd = n, Qd;
}
var Xd, Ek;
function vp() {
  if (Ek) return Xd;
  Ek = 1;
  var e = O2();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Xd = n, Xd;
}
var Zd, Tk;
function P2() {
  if (Tk) return Zd;
  Tk = 1;
  var e = vp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Zd = n, Zd;
}
var eu, $k;
function A2() {
  if ($k) return eu;
  $k = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return eu = n, eu;
}
var nu, Dk;
function L2() {
  if (Dk) return nu;
  Dk = 1;
  var e = ao(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return nu = i, nu;
}
var tu, Rk;
function V2() {
  if (Rk) return tu;
  Rk = 1;
  var e = vp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return tu = n, tu;
}
var ru, Ok;
function z2() {
  if (Ok) return ru;
  Ok = 1;
  var e = vp(), n = P2(), r = A2(), i = L2(), a = V2(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", S = "[object DataView]", N = "[object Float32Array]", F = "[object Float64Array]", I = "[object Int8Array]", g = "[object Int16Array]", q = "[object Int32Array]", $ = "[object Uint8Array]", C = "[object Uint8ClampedArray]", D = "[object Uint16Array]", U = "[object Uint32Array]";
  function Z(Q, ee, J) {
    var G = Q.constructor;
    switch (ee) {
      case v:
        return e(Q);
      case o:
      case s:
        return new G(+Q);
      case S:
        return n(Q, J);
      case N:
      case F:
      case I:
      case g:
      case q:
      case $:
      case C:
      case D:
      case U:
        return a(Q, J);
      case l:
        return new G();
      case d:
      case f:
        return new G(Q);
      case m:
        return r(Q);
      case u:
        return new G();
      case h:
        return i(Q);
    }
  }
  return ru = Z, ru;
}
var iu, Pk;
function U2() {
  if (Pk) return iu;
  Pk = 1;
  var e = Wi(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return iu = r, iu;
}
var au, Ak;
function M2() {
  if (Ak) return au;
  Ak = 1;
  var e = U2(), n = gp(), r = pp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return au = i, au;
}
var ou, Lk;
function B2() {
  if (Lk) return ou;
  Lk = 1;
  var e = kp(), n = gi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return ou = i, ou;
}
var su, Vk;
function q2() {
  if (Vk) return su;
  Vk = 1;
  var e = B2(), n = up(), r = mp(), i = r && r.isMap, a = i ? n(i) : e;
  return su = a, su;
}
var lu, zk;
function H2() {
  if (zk) return lu;
  zk = 1;
  var e = kp(), n = gi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return lu = i, lu;
}
var cu, Uk;
function W2() {
  if (Uk) return cu;
  Uk = 1;
  var e = H2(), n = up(), r = mp(), i = r && r.isSet, a = i ? n(i) : e;
  return cu = a, cu;
}
var du, Mk;
function K2() {
  if (Mk) return du;
  Mk = 1;
  var e = m2(), n = p2(), r = op(), i = b2(), a = S2(), o = N2(), s = j2(), l = C2(), d = F2(), m = I2(), u = wx(), f = kp(), h = R2(), v = z2(), S = M2(), N = Zr(), F = vx(), I = q2(), g = Wi(), q = W2(), $ = fp(), C = hp(), D = 1, U = 2, Z = 4, Q = "[object Arguments]", ee = "[object Array]", J = "[object Boolean]", G = "[object Date]", P = "[object Error]", W = "[object Function]", ne = "[object GeneratorFunction]", ke = "[object Map]", me = "[object Number]", de = "[object Object]", he = "[object RegExp]", H = "[object Set]", be = "[object String]", Ce = "[object Symbol]", K = "[object WeakMap]", ze = "[object ArrayBuffer]", Be = "[object DataView]", Pe = "[object Float32Array]", Me = "[object Float64Array]", Ie = "[object Int8Array]", Le = "[object Int16Array]", De = "[object Int32Array]", rn = "[object Uint8Array]", je = "[object Uint8ClampedArray]", We = "[object Uint16Array]", Ge = "[object Uint32Array]", pe = {};
  pe[Q] = pe[ee] = pe[ze] = pe[Be] = pe[J] = pe[G] = pe[Pe] = pe[Me] = pe[Ie] = pe[Le] = pe[De] = pe[ke] = pe[me] = pe[de] = pe[he] = pe[H] = pe[be] = pe[Ce] = pe[rn] = pe[je] = pe[We] = pe[Ge] = !0, pe[P] = pe[W] = pe[K] = !1;
  function le(Ne, Ae, Ee, cn, j, _) {
    var T, Y = Ae & D, X = Ae & U, O = Ae & Z;
    if (Ee && (T = j ? Ee(Ne, cn, j, _) : Ee(Ne)), T !== void 0)
      return T;
    if (!g(Ne))
      return Ne;
    var B = N(Ne);
    if (B) {
      if (T = h(Ne), !Y)
        return s(Ne, T);
    } else {
      var ie = f(Ne), fe = ie == W || ie == ne;
      if (F(Ne))
        return o(Ne, Y);
      if (ie == de || ie == Q || fe && !j) {
        if (T = X || fe ? {} : S(Ne), !Y)
          return X ? d(Ne, a(T, Ne)) : l(Ne, i(T, Ne));
      } else {
        if (!pe[ie])
          return j ? Ne : {};
        T = v(Ne, ie, Y);
      }
    }
    _ || (_ = new e());
    var _e = _.get(Ne);
    if (_e)
      return _e;
    _.set(Ne, T), q(Ne) ? Ne.forEach(function(tn) {
      T.add(le(tn, Ae, Ee, tn, Ne, _));
    }) : I(Ne) && Ne.forEach(function(tn, sn) {
      T.set(sn, le(tn, Ae, Ee, sn, Ne, _));
    });
    var en = O ? X ? u : m : X ? C : $, dn = B ? void 0 : en(Ne);
    return n(dn || Ne, function(tn, sn) {
      dn && (sn = tn, tn = Ne[sn]), r(T, sn, le(tn, Ae, Ee, sn, Ne, _));
    }), T;
  }
  return du = le, du;
}
var uu, Bk;
function G2() {
  if (Bk) return uu;
  Bk = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return uu = e, uu;
}
var mu, qk;
function Y2() {
  if (qk) return mu;
  qk = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return mu = e, mu;
}
var pu, Hk;
function J2() {
  if (Hk) return pu;
  Hk = 1;
  var e = ux(), n = Y2();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return pu = r, pu;
}
var fu, Wk;
function Q2() {
  if (Wk) return fu;
  Wk = 1;
  var e = Ki(), n = G2(), r = J2(), i = qs(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (var f = l == null || typeof l != "object" && typeof l != "function"; ++m < u; ) {
      var h = d[m];
      if (typeof h == "string") {
        if (h === "__proto__" && !o.call(l, "__proto__"))
          return !1;
        if (h === "constructor" && m + 1 < u && typeof d[m + 1] == "string" && d[m + 1] === "prototype") {
          if (f && m === 0)
            continue;
          return !1;
        }
      }
    }
    var v = r(l, d);
    return v == null || delete v[i(n(d))];
  }
  return fu = s, fu;
}
var hu, Kk;
function X2() {
  if (Kk) return hu;
  Kk = 1;
  var e = Hi(), n = gp(), r = gi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return hu = m, hu;
}
var yu, Gk;
function Z2() {
  if (Gk) return yu;
  Gk = 1;
  var e = X2();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return yu = n, yu;
}
var gu, Yk;
function eL() {
  if (Yk) return gu;
  Yk = 1;
  var e = dx(), n = K2(), r = Q2(), i = Ki(), a = oo(), o = Z2(), s = hx(), l = wx(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var S = {};
    if (h == null)
      return S;
    var N = !1;
    v = e(v, function(I) {
      return I = i(I, h), N || (N = I.length > 1), I;
    }), a(h, l(h), S), N && (S = n(S, d | m | u, o));
    for (var F = v.length; F--; )
      r(S, v[F]);
    return S;
  });
  return gu = f, gu;
}
eL();
const vr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = kx(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ mi.jsx(An, { ...a, children: /* @__PURE__ */ mi.jsx(
    Kr,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: An.getStatus(a.meta),
      children: e
    }
  ) });
};
var nL = fx();
const tL = /* @__PURE__ */ ix(nL), ku = ({
  transformValue: e = tL,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = gx(a);
  return /* @__PURE__ */ mi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ mi.jsx(
      Lu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ mi.jsx($S, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Bt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = kx(e);
  return /* @__PURE__ */ mi.jsx(An, { ...i, children: /* @__PURE__ */ mi.jsx(
    kr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: An.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._link_egbmi_1{color:var(--dixa-typography-color-link);text-decoration-line:none;cursor:pointer}._link_egbmi_1:hover,._link_egbmi_1:focus{color:var(--dixa-color-blue-700);text-decoration-line:underline}._link_egbmi_1:active{color:var(--dixa-color-blue-900)}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vu = { exports: {} }, xa = {}, Jk;
function rL() {
  if (Jk) return xa;
  Jk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return xa.Fragment = r, xa.jsx = s, xa.jsxs = s, xa;
}
var Do = {}, Qk;
function iL() {
  return Qk || (Qk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Do.Fragment = i, Do.jsx = Bn, Do.jsxs = qn;
  })()), Do;
}
var Xk;
function aL() {
  return Xk || (Xk = 1, process.env.NODE_ENV === "production" ? vu.exports = rL() : vu.exports = iL()), vu.exports;
}
var k = aL();
const oL = "_link_egbmi_1", sL = {
  link: oL
}, lL = "https://apps.shopify.com/dixa-dashboard", cL = (e) => ({
  install: {
    variant: "info",
    description: "To connect your Shopify store, install the Dixa app from the Shopify App Store. The app will automatically set up the connection for you.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        "Copy an API Token from the",
        " ",
        /* @__PURE__ */ k.jsx("span", { className: sL.link, onClick: e.onNavigateToApiTokens, children: "API tokens tab" })
      ] }),
      "Click the button below to go to the Shopify App Store",
      "Install the Dixa app on your Shopify store",
      "In the app, paste your Dixa API token to complete the connection",
      "In case you have already one or more Shopify integrations configured in Dixa, you can select one (or create a new one) to connect your store to",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install from Shopify App Store",
    buttonVariant: "primary"
  },
  migration: {
    variant: "warning",
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "secondary"
  }
}), dL = "/settings/integrations/api-tokens", Cx = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const r = qS(), i = cL({
    onNavigateToApiTokens: () => {
      r(dL);
    }
  })[n], a = () => {
    window.open(lL, "_blank", "noopener,noreferrer");
  }, o = i.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
    Ja,
    {
      variant: i.variant,
      headline: e,
      description: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: i.description }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: i.listHeading }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(o, { style: { margin: 0, paddingLeft: "1.25rem" }, children: i.listItems.map((s, l) => /* @__PURE__ */ k.jsx("li", { children: s }, l)) }) })
        ] }),
        /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            onClick: a,
            icon: "external-link",
            variant: i.buttonVariant,
            children: i.buttonText
          }
        ) })
      ] })
    }
  ) });
}, uL = (e) => /* @__PURE__ */ k.jsx(Cx, { ...e, bannerVariant: "install" }), mL = (e) => /* @__PURE__ */ k.jsx(Cx, { ...e, bannerVariant: "migration" }), pL = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], fL = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], hL = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: uL
  }
], yL = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], Zk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: mL
  }
], Fx = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], ev = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => tb(e)
  },
  ...Fx
];
var Ci = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ci || {}), pi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(pi || {}), Fr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Fr || {}), Ix = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(Ix || {}), ai = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(ai || {}), jr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(jr || {}), es = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(es || {});
const gL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, kL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, vL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, bL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, _L = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, xL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, SL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, NL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, jL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, wL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, CL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, FL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, IL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, EL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, TL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, $L = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, DL = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": gL,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": kL,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": vL,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": bL,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": _L,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": xL,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": SL,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": NL,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": jL,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": wL,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": CL,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": FL,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": IL,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": EL,
  "\n  query getProducts($productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": TL,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": $L
};
function cr(e) {
  return DL[e] ?? {};
}
const RL = cr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), OL = cr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  image {
                    url
                  }
                  product {
                    id
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), PL = cr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), AL = cr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), bp = cr(
  /* GraphQL */
  `
  query getProducts($productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), LL = cr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), VL = cr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), zL = cr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), UL = cr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), ML = cr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), BL = cr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), qL = cr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), Ex = Qr`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, HL = Qr`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, WL = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(RL, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, KL = () => {
  const { useLazyQuery: e } = mn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(OL);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Ka(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const GL = "_list_alvh6_1", YL = "_listItem_alvh6_4", JL = "_fullWidth_alvh6_15", QL = "_boxWrapper_alvh6_19", At = {
  list: GL,
  listItem: YL,
  fullWidth: JL,
  boxWrapper: QL
}, XL = "_modal_1vkwz_1", ZL = "_disabled_1vkwz_5", bu = {
  modal: XL,
  disabled: ZL
}, nv = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: pi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: pi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: pi.Unknown
  }
], tv = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Fr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Fr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Fr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Fr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Fr.Unsubscribed
  }
], eV = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = kn(), { useMutation: l, showNotification: d } = mn(), [m, u] = se(), [f, h] = se(), [v, S] = kf(!0), [N, F] = kf(!0), I = !!m, g = e.customer?.email, q = e.customer?.phone_number, $ = e.customer?.given_name, C = e.customer?.family_name, D = {
    email: g ?? "",
    phone: q ?? "",
    firstName: $ ?? "",
    lastName: C ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = sr({
    defaultValues: D
  });
  qe(() => {
    f?.forEach((P) => {
      const W = P?.field?.[0];
      W && (U.setError(W, {
        type: "server",
        message: P.message
      }), U.setFocus(W));
    });
  }, [f, U]);
  const [Z, { error: Q, reset: ee }] = l(BL, {
    onError: (P) => {
      u(P.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (P) => {
      const W = P?.Shopify?.customerCreate?.userErrors || [];
      W.length > 0 ? (h(W), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), J = pt(
    (P) => {
      a(!0), u(void 0), Z({
        variables: {
          input: {
            firstName: P.firstName,
            lastName: P.lastName,
            defaultEmailAddress: {
              ...v && { emailAddress: P.email }
            },
            defaultPhoneNumber: {
              ...N && { phoneNumber: P.phone },
              marketingState: P.smsMarketingState,
              marketingOptInLevel: P.smsMarketingOptInLevel
            }
          }
        }
      });
    },
    [Z, a, N, v]
  ), G = () => {
    r(!1), ee(), u(void 0), U.reset(D);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: n, onClose: G, className: bu.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: "Create new customer", onClose: G }),
    /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsxs(zt, { children: [
      /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: ct({
              [bu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Lu,
                {
                  disabled: !N,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => S()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: N ? "Phone is required" : void 0
          },
          componentProps: {
            className: ct({
              [bu.disabled]: !N
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Lu,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: N,
                  onChange: () => F()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (P, W) => P === W,
            getItemTitleByValue: (P) => {
              const W = tv.find(
                (ne) => ne.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: W.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: W.description })
                  ]
                }
              );
            }
          },
          children: tv.map((P) => /* @__PURE__ */ k.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (P, W) => P === W,
            getItemTitleByValue: (P) => {
              const W = nv.find(
                (ne) => ne.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: W.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: W.description })
                  ]
                }
              );
            }
          },
          children: nv.map((P) => /* @__PURE__ */ k.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      I && /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(J),
        cancelOnClick: G,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, nV = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "user-plus", color: "green.500" }),
        className: At.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      eV,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, _p = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, dm = "DD MMM YYYY @ HH:mm", tV = "_wrapper_10fld_1", rV = "_copyIcon_10fld_7", Ro = {
  wrapper: tV,
  copyIcon: rV
}, iV = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Ka(), { isCopied: l, copy: d } = Ka(), { track: m } = kn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: S = [],
    verifiedEmail: N
  } = e, F = h?.emailAddress, I = v?.phoneNumber, g = _p(u), q = `https://${n}/admin/customers/${g ?? ""}`, $ = i && a === ar.refetch, C = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Ro.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        $ ? /* @__PURE__ */ k.jsx(un, { size: C }) : /* @__PURE__ */ k.jsx(Ke, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: C,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Ro.copyIcon
          }
        ) })
      ] }),
      F && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: C, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${F}`, children: F }),
          /* @__PURE__ */ k.jsx(
            Ke,
            {
              content: N ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                ue,
                {
                  size: C,
                  color: N ? "green.500" : "red.500",
                  name: N ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: C,
            name: o ? "done" : "copy",
            onClick: () => s(F),
            className: Ro.copyIcon
          }
        ) })
      ] }),
      I && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: C, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${I}`, children: I })
        ] }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: C,
            name: l ? "done" : "copy",
            onClick: () => d(I),
            className: Ro.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(ue, { size: C, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: q,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    S.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: S.map((D) => /* @__PURE__ */ k.jsx(On, { children: D }, `${u}-${D}`)) })
    ] })
  ] });
}, aV = "_creationModal_pbe64_1", oV = "_detailsModal_pbe64_5", sV = "_percentageSuffix_pbe64_9", _u = {
  creationModal: aV,
  detailsModal: oV,
  percentageSuffix: sV
}, lV = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, cV = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: Ix.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, rv = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], iv = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], av = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], dV = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Xt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(He, { children: [
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            ue,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Pn(e?.startsAt).format(lt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(An, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      kr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, uV = "shopify-discount-code-form", ov = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, mV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = kn(), { useMutation: i, showNotification: a } = mn(), [o, s] = se(
    []
  ), [l, d] = se(), m = sr({
    mode: "all",
    defaultValues: ov
  });
  qe(() => {
    o?.forEach((C) => {
      const D = C?.field?.[1];
      D && m.setError(D, {
        type: "server",
        message: C.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = et(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    S,
    {
      loading: N,
      error: F,
      reset: I
    }
  ] = i(qL, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (C) => {
      const D = C?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (D && D.length > 0)
        s(D);
      else {
        const U = C?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", lV(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, q = (C) => {
    S({
      variables: {
        input: cV(C)
      }
    });
  }, $ = () => {
    m.reset(ov), s([]), I(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: e,
      onClose: $,
      className: ct({
        [_u.creationModal]: !u,
        [_u.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          kt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: $
          }
        ),
        /* @__PURE__ */ k.jsxs(vt, { children: [
          u && /* @__PURE__ */ k.jsx(dV, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: uV, onSubmit: m.handleSubmit(q), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Ja,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(zt, { children: [
              /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                vr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (C, D) => C === D,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (C) => {
                      const D = rv.find(
                        (U) => U.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: rv.map((C) => /* @__PURE__ */ k.jsx(mt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (C) => {
                      if (C) {
                        if (h === "percentage" && (C < 0 || C > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && C < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: _u.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                vr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (C, D) => C === D,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (C) => {
                      const D = iv.find(
                        (U) => U.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: iv.map((C) => /* @__PURE__ */ k.jsx(mt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (C) => {
                      if (C && f !== "none" && C < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
                vr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (C, D) => C === D,
                    getItemTitleByValue: (C) => {
                      const D = av.find(
                        (U) => U.value === C
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: av.map((C) => /* @__PURE__ */ k.jsx(mt.Item, { value: C.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) })
            ] })
          ] }),
          F && /* @__PURE__ */ k.jsx(wn, { error: F })
        ] }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? $ : m.handleSubmit(q),
            cancelOnClick: u ? void 0 : $
          }
        )
      ]
    }
  );
}, pV = ({ code: e }) => {
  const { isCopied: n, copy: r } = Ka();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(ue, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          Kt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, fV = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(He, { children: i.map((a) => /* @__PURE__ */ k.jsx(He.Item, { className: At.listItem, children: /* @__PURE__ */ k.jsx(pV, { code: a.code }, a.id) }, a.id)) })
  ] });
}, hV = "_modal_11d6e_1", yV = "_modalBody_11d6e_4", gV = "_codeContainer_11d6e_9", xu = {
  modal: hV,
  modalBody: yV,
  codeContainer: gV
}, kV = [50, 100, 250], Tx = 50, vV = {
  maxNumberOfCodesToDisplay: Tx
}, bV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    Tx
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = sr({
    mode: "all",
    defaultValues: vV
  }), { loading: u, error: f } = r(LL, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const S = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      S && S.length > 0 && s(S);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: e, onClose: h, className: xu.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(vt, { className: xu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(zt, { children: /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: kV.map((v) => /* @__PURE__ */ k.jsx(mt.Item, { value: v, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        xm,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: xu.codeContainer, children: /* @__PURE__ */ k.jsx(fV, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(wt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, _V = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Wn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      bV,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      mV,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, xV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? ws(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Ci.Invalid:
      case Ci.NotSubscribed:
      case Fr.NotSubscribed:
        return "red.500";
      case Ci.Pending:
      case Fr.Pending:
      case Ci.Unsubscribed:
      case Fr.Unsubscribed:
        return "orange.500";
      case Ci.Subscribed:
      case Fr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case pi.SingleOptIn:
      case pi.ConfirmedOptIn:
        return "green.500";
      case pi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: Pn(l).format(dm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(On, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(On, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: Pn(u).format(dm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ke, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(On, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ke, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(On, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, SV = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a || void 0,
          kind: "REFUND",
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    tags: r.tags,
    refunds: r.refunds
  }));
}, sv = [
  {
    value: jr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: jr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: jr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: jr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: jr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: jr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: jr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], lv = [
  {
    value: es.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: es.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: es.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], Oo = (e) => um(NV(e)), um = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), NV = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ni = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Pt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      ir,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), jV = "_modal_1wlra_1", wV = {
  modal: jV
};
function cv(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const dv = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], uv = "shopify-shiping-address-form", CV = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = mn(), { track: f } = kn(), [h, v] = se(!1), [S, N] = se({}), F = !l, [
    I,
    { error: g, reset: q }
  ] = m(VL, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (J) => {
      v(!1);
      const G = J?.Shopify?.orderUpdate?.userErrors;
      if (G?.length > 0) {
        const P = G.reduce((W, ne) => (W[ne.field[ne.field.length - 1]] = ne.message, W), {});
        N(P);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ee();
    }
  }), $ = pt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: dv.find(
        (J) => J === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: C, handleSubmit: D, formState: U, reset: Z } = sr({
    mode: "all",
    defaultValues: $()
  }), Q = D((J) => {
    if (F) {
      v(!0), o && a && f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: G, ...P } = J, W = { ...P, countryCode: G };
      I({
        variables: {
          input: {
            id: a,
            shippingAddress: W
          }
        }
      });
    } else
      l(J), ee();
  });
  qe(() => {
    r && Z($());
  }, [r, n, Z, $]);
  const ee = () => {
    Z($()), N({}), q(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: r,
      onClose: ee,
      className: wV.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(kt, { title: e, onClose: () => ee() }),
        /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: uv, onSubmit: Q, children: [
          g && /* @__PURE__ */ k.jsx(wn, { error: g }),
          /* @__PURE__ */ k.jsxs(zt, { children: [
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: C,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: C,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                control: C,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: C,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                control: C,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: C,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ni,
              {
                required: !0,
                control: C,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: S
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 6, children: /* @__PURE__ */ k.jsx(
              vr,
              {
                name: "countryCodeV2",
                control: C,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (J) => J ? cv(J) : ""
                },
                children: dv.filter((J) => s.includes(J)).map((J) => /* @__PURE__ */ k.jsx(mt.Item, { value: J, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: cv(J) }) }, J))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: uv,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmOnClick: () => {
              g && ee();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ee();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, FV = "_clickableIcon_33mqm_1", Su = {
  clickableIcon: FV
}, mv = ({
  formFieldName: e,
  ...n
}) => {
  const r = Rr(), { field: i } = Am({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    mm,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, mm = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: S, copy: N } = Ka(), { track: F } = kn(), I = 14, g = o && (!!r || !!l), q = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), $ = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), C = n?.countryCodeV2 && xS(n.countryCodeV2), D = pt(() => [
    $,
    n?.company,
    n?.address1,
    n?.address2,
    q,
    n?.province,
    C
  ].filter(Boolean).join(`
`), [n, $, q, C]);
  if (!n)
    return null;
  const U = () => {
    i && r && F("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: I, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Su.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  ue,
                  {
                    size: I,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            $ && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: $ }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            q && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: q }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            C && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: C })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ k.jsx(Ke, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: I,
            name: "pen",
            onClick: () => U(),
            className: Su.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: I,
            name: S ? "done" : "copy",
            onClick: () => N(D()),
            className: Su.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ k.jsx(
      CV,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, xp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Rr(), i = Ko({ control: r.control, name: "lineItems" }), a = Ko({
    control: r.control,
    name: "billingAddress"
  }), o = Ko({
    control: r.control,
    name: "shippingAddress"
  }), s = et(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = et(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        mv,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        mv,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, IV = "_productTableHeader_6h6pl_1", EV = "_productImage_6h6pl_5", La = {
  productTableHeader: IV,
  productImage: EV
}, Sp = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, TV = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Rr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Sp(e);
  return /* @__PURE__ */ k.jsxs(Qn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Li,
        {
          src: d,
          alt: e.title,
          className: La.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(
      Bt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(Kt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, $V = ({
  products: e,
  isLoadingProducts: n
}) => {
  const [r, i] = se(""), a = Rr(), o = et(() => {
    if (!r.trim())
      return e;
    const l = r.toLowerCase();
    return e.filter(
      (d) => d.title.toLowerCase().includes(l)
    );
  }, [e, r]), s = !o.length && !n;
  return /* @__PURE__ */ k.jsx(
    vr,
    {
      noAlert: !0,
      label: "Product selection",
      control: a.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: n ? "Loading products..." : "Select or search products",
        tabIndex: 0,
        getItemTitleByValue: (l) => {
          const d = e.find((m) => m.id === l);
          return d ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: d.title }) : null;
        },
        filter: {
          value: r,
          onChange: (l) => {
            i(l.target.value);
          }
        },
        onToggleDropdown: (l) => {
          !l && r !== "" && i("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        n && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(un, {}) }) }),
        !n && o.map((l) => {
          const d = l.totalInventory <= 0, m = Sp(l);
          return /* @__PURE__ */ k.jsx(
            mt.Item,
            {
              value: l.id,
              isDisabled: d,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  m && /* @__PURE__ */ k.jsx(
                    Li,
                    {
                      src: m,
                      alt: l.title,
                      className: La.productImage
                    }
                  ),
                  r ? /* @__PURE__ */ k.jsx(
                    DS,
                    {
                      text: l.title,
                      highlight: r
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: l.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: d ? "Out of stock" : `${l.totalInventory} in stock` })
              ] })
            },
            l.id
          );
        }),
        s && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          xm,
          {
            title: "No products found",
            description: r ? "Try changing your search criteria." : "No products available."
          }
        ) })
      ] })
    }
  );
}, Np = ({
  isAlreadyLoadedProducts: e = !1,
  contextProducts: n = [],
  selectionMode: r = !1,
  hideDeleteButton: i = !1,
  selectedProductIds: a = [],
  onToggleSelect: o,
  onToggleSelectAll: s
}) => {
  const { useQuery: l } = mn(), d = Rr(), m = d.watch("lineItems"), u = d.watch("selectedProductId"), f = m && m?.length > 0, h = r && f ? m.every((q) => a.includes(q?.id)) : !1, v = r && f ? m.some(
    (q) => a.includes(q?.id)
  ) && !h : !1, {
    data: S,
    loading: N,
    error: F
  } = l(bp, {
    skip: e || n.length > 0,
    variables: {
      productCount: 250,
      mediaCount: 1
    }
  }), I = et(() => {
    const q = S?.Shopify?.products?.nodes || n;
    return !q || q.length === 0 ? [] : q.filter(($) => !!$).sort(($, C) => $.title.localeCompare(C.title));
  }, [S, n]);
  if (qe(() => {
    if (!u) return;
    const q = I.find(
      (C) => C.id === u
    );
    if (!q) {
      d.setValue("selectedProductId", void 0);
      return;
    }
    const $ = m.findIndex(
      (C) => C?.id === q.id
    );
    if ($ > -1) {
      const C = d.getValues(`lineItems.${$}.quantity`) || 0, D = [...m];
      D[$] = {
        ...q,
        quantity: C + 1
      }, d.setValue("lineItems", D);
    } else
      d.setValue("lineItems", [
        ...m,
        { ...q, quantity: 1 }
      ]);
    d.setValue("selectedProductId", void 0);
  }, [u, I, d, m]), F)
    return /* @__PURE__ */ k.jsx(wn, { error: F });
  const g = e || N;
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx($V, { products: I, isLoadingProducts: g }),
    !f && !g && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: At.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          xm,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    (f || g) && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Qn,
      {
        hoverable: !0,
        loading: g,
        framed: !1,
        headerWithBackground: !1,
        className: La.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Qn.Thead, { className: La.productTableHeader, children: /* @__PURE__ */ k.jsxs(Qn.Tr, { children: [
            r && /* @__PURE__ */ k.jsx(Qn.Th, { children: /* @__PURE__ */ k.jsx(
              Ap,
              {
                checked: h,
                indeterminate: v,
                onChange: () => s?.(!h)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Qn.Th, { children: "Total" }),
            !i && /* @__PURE__ */ k.jsx(Qn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Qn.Tbody, { children: m?.map((q, $) => {
            if (!r)
              return /* @__PURE__ */ k.jsx(
                TV,
                {
                  product: q,
                  index: $,
                  onRemove: () => {
                    const P = m.filter(
                      (W, ne) => ne !== $
                    );
                    d.setValue("lineItems", P);
                  }
                },
                `${q?.id}-${$}`
              );
            const C = q, D = C.priceRangeV2.minVariantPrice.amount, U = C.priceRangeV2.minVariantPrice.currencyCode, Z = `lineItems.${$}.quantity`, Q = d.watch(Z) || 0, ee = D * Q, J = Sp(C), G = a.includes(C.id);
            return /* @__PURE__ */ k.jsxs(Qn.Tr, { children: [
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(
                Ap,
                {
                  checked: G,
                  onChange: () => o?.(C.id, !G)
                }
              ) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                J && /* @__PURE__ */ k.jsx(
                  Li,
                  {
                    src: J,
                    alt: C.title,
                    className: La.productImage
                  }
                ),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: C.title })
              ] }) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: C.totalInventory }) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${D} ${U}` }) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(
                Bt,
                {
                  noLabel: !0,
                  noAlert: !0,
                  name: Z,
                  control: d.control,
                  componentProps: {
                    type: "number",
                    min: 1,
                    max: C.totalInventory,
                    tabIndex: 0
                  }
                },
                `${Z}-${d.watch(Z)}`
              ) }),
              /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${ee} ${U}` }) }),
              !i && /* @__PURE__ */ k.jsx(Qn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                Kt,
                {
                  icon: "trash",
                  variant: "secondary",
                  onClick: () => {
                    const P = m.filter(
                      (W, ne) => ne !== $
                    );
                    d.setValue("lineItems", P), G && o?.(C.id, !1);
                  }
                }
              ) }) })
            ] }, `${C.id}-${$}`);
          }) })
        ]
      }
    ) })
  ] });
}, $x = () => {
  const e = Rr();
  return /* @__PURE__ */ k.jsx(
    vr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: e.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = sv.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  r.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: sv.map((n) => /* @__PURE__ */ k.jsx(mt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, Dx = () => {
  const e = Rr();
  return /* @__PURE__ */ k.jsx(
    vr,
    {
      label: "Fulfillment Status",
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = lv.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: lv.map((n) => /* @__PURE__ */ k.jsx(mt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, DV = "_modal_1mprq_1", RV = {
  modal: DV
}, Nu = "create-shopify-order-form", OV = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: jr.Pending,
    fulfillmentStatus: void 0
  }, [S, N] = se([]), F = sr({
    mode: "all",
    defaultValues: v
  }), I = F.watch("lineItems").length > 0, g = () => {
    F.reset(v), N([]), i(!1);
  };
  qe(() => {
    S.length > 0 && F.setValue("tags", S, { shouldDirty: !0 });
  }, [S, F]);
  const [q, { error: $ }] = o(
    Ex,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), g();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), g();
      }
    }
  ), [C, { error: D }] = o(
    HL,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), U = (Q) => {
    const ee = Q.lineItems.map((P) => ({
      productId: P.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: P.priceRangeV2.maxVariantPrice.amount,
          currencyCode: P.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: P.quantity
    }));
    m(!0);
    const J = Oo(Q?.billingAddress), G = Oo(
      Q?.shippingAddress
    );
    q({
      variables: {
        order: {
          lineItems: ee,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: G,
          billingAddress: J
        }
      }
    });
  }, Z = (Q) => {
    const ee = Q.lineItems.map((P) => ({
      title: P.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: P.priceRangeV2.maxVariantPrice.amount,
        currencyCode: P.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: P.quantity
    }));
    f(!0);
    const J = Oo(Q?.billingAddress), G = Oo(
      Q?.shippingAddress
    );
    C({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: ee,
          shippingAddress: G,
          billingAddress: J
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: e,
      onClose: g,
      className: RV.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(kt, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ k.jsxs(vt, { children: [
          /* @__PURE__ */ k.jsx(Pm, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: Nu, children: /* @__PURE__ */ k.jsxs(zt, { children: [
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(Np, {}) }),
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
              Pt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ k.jsx(
                  An,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ee) => {
                          ee.key === "Enter" && (ee.preventDefault(), ee.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Cs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: S,
                            onChange: (ee) => {
                              N(ee);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx($x, {}),
              /* @__PURE__ */ k.jsx(Dx, {}),
              /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(nn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: At.boxWrapper,
                children: /* @__PURE__ */ k.jsx(xp, {})
              }
            ) }) })
          ] }) }) }),
          ($ || D) && /* @__PURE__ */ k.jsx(wn, { error: $ || D })
        ] }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              type: "submit",
              form: Nu,
              disabled: !I || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: F.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                F.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Nu,
                disabled: !I || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, PV = "_modal_al73g_1", AV = {
  modal: PV
}, pv = [
  {
    label: "Customer",
    value: ai.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: ai.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: ai.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: ai.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: ai.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: ai.Staff,
    description: "Staff made an error."
  }
], LV = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = kn(), { useMutation: d, showNotification: m } = mn(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, S = sr({
    defaultValues: v
  }), [N, { error: F, reset: I }] = d(UL, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async ($) => {
      const C = $.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (C.length > 0)
        o(!1), f(C), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const D = $.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, D ? 0 : 4e3), m({
          title: "Success",
          text: `${D ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = pt(
    ($) => {
      o(!0), N({
        variables: $
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), q = () => {
    i(!1), I(), f([]), S.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: n, onClose: q, className: AV.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: `Cancel order ${r}`, onClose: q }),
    /* @__PURE__ */ k.jsx(vt, { children: /* @__PURE__ */ k.jsxs(zt, { children: [
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        vr,
        {
          control: S.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: ($, C) => $ === C,
            getItemTitleByValue: ($) => {
              if (!$)
                return "";
              const C = pv.find(
                (D) => D.value === $
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: C.description })
              ] });
            }
          },
          children: pv.map(($) => /* @__PURE__ */ k.jsx(mt.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: $.description })
          ] }) }, $.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(An, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        ku,
        {
          control: S.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(An, { label: "Restock items", children: /* @__PURE__ */ k.jsx(ku, { control: S.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(An, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(ku, { control: S.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Bt,
        {
          name: "staffNote",
          label: "Staff note",
          control: S.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map(($) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              $.field?.join(","),
              ") ",
              $.message
            ] })
          ]
        },
        $.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(S.formState.isValid && S.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: S.handleSubmit(g),
        cancelOnClick: q,
        confirmName: F ? "Close" : "Cancel order",
        cancelName: F ? void 0 : "Cancel"
      }
    )
  ] });
}, VV = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: At.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      LV,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, zV = "_modal_1mprq_1", UV = {
  modal: zV
}, MV = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = mn(), { track: m } = kn(), [u, f] = se(!1), [h, v] = se(e?.tags || []), S = "duplicate-shopify-order-form", N = (ee) => ({
    firstName: ee?.firstName,
    lastName: ee?.lastName,
    address1: ee?.address1,
    address2: ee?.address2,
    city: ee?.city,
    provinceCode: ee?.provinceCode,
    zip: ee?.zip,
    countryCode: ee?.countryCodeV2
  }), F = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: N(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: N(e?.shippingAddress),
    financialStatus: jr.Pending,
    fulfillmentStatus: void 0
  }, I = sr({
    mode: "all",
    defaultValues: F
  }), g = I.watch("lineItems").length > 0, { data: q, loading: $ } = d(
    bp,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), C = et(() => {
    const ee = q?.Shopify?.products?.nodes;
    return !ee || ee.length === 0 ? [] : ee.filter((J) => !!J).sort((J, G) => J.title.localeCompare(G.title));
  }, [q]);
  qe(() => {
    if (!r || !C?.length || I.getValues("lineItems")?.length)
      return;
    const ee = [];
    e?.lineItems?.forEach((J) => {
      const G = C.find(
        (P) => P.id === J.product?.id
      );
      G && ee.push({ ...G, quantity: J.quantity || 1 });
    }), ee.length > 0 && I.setValue("lineItems", ee, { shouldDirty: !0 });
  }, [r, C, e, I]), qe(() => {
    (h.length > 0 || (I.getValues("tags") || []).length > 0) && I.setValue("tags", h, { shouldDirty: !0 });
  }, [h, I]);
  const [D, { error: U }] = s(
    Ex,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Q();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Q();
      }
    }
  ), Z = (ee) => {
    const J = ee.lineItems.map((G) => ({
      productId: G.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: G.priceRangeV2.maxVariantPrice.amount,
          currencyCode: G.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: G.quantity
    }));
    f(!0), D({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: J,
          note: ee.customNote,
          tags: ee.tags,
          financialStatus: ee.financialStatus,
          fulfillmentStatus: ee.fulfillmentStatus,
          shippingAddress: um(ee?.shippingAddress),
          billingAddress: um(ee?.billingAddress)
        }
      }
    });
  }, Q = () => {
    I.reset(F), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    gt,
    {
      isOpen: r,
      onClose: Q,
      className: UV.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(kt, { title: `Duplicate order ${n}`, onClose: Q }),
        /* @__PURE__ */ k.jsxs(vt, { children: [
          /* @__PURE__ */ k.jsx(Pm, { ...I, children: /* @__PURE__ */ k.jsx("form", { id: S, children: /* @__PURE__ */ k.jsxs(zt, { children: [
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
              Np,
              {
                isAlreadyLoadedProducts: $,
                contextProducts: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
              Pt,
              {
                name: "tags",
                render: ({ fieldState: { error: ee } }) => /* @__PURE__ */ k.jsx(
                  An,
                  {
                    label: "Tags",
                    meta: {
                      error: ee?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (J) => {
                          J.key === "Enter" && (J.preventDefault(), J.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Cs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (J) => {
                              v(J);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(nn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx($x, {}),
              /* @__PURE__ */ k.jsx(Dx, {}),
              /* @__PURE__ */ k.jsx(
                Bt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(nn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: At.boxWrapper,
                children: /* @__PURE__ */ k.jsx(xp, {})
              }
            ) }) })
          ] }) }) }),
          U && /* @__PURE__ */ k.jsx(wn, { error: U })
        ] }),
        /* @__PURE__ */ k.jsx(
          wt,
          {
            confirmProps: {
              type: "submit",
              form: S,
              disabled: !g || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: I.handleSubmit(Z)
          }
        )
      ]
    }
  );
}, BV = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(ue, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(On, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(He, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        He.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ k.jsx(Li, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, qV = Qr`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, HV = "_modal_21e62_1", WV = {
  modal: HV
}, fv = "partial-refund-shopify-order-form", KV = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), { useQuery: d } = mn(), [m, u] = se(!1), [f, h] = se([]), { data: v, loading: S } = d(
    bp,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), N = et(() => {
    const U = v?.Shopify?.products?.nodes;
    return !U || U.length === 0 ? [] : U.filter((Z) => !!Z).sort((Z, Q) => Z.title.localeCompare(Q.title));
  }, [v]), F = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, I = sr({
    mode: "all",
    defaultValues: F
  }), g = f.length > 0, [q, { error: $ }] = o(
    qV,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), D();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), D();
      }
    }
  );
  qe(() => {
    if (!r || !N?.length || I.getValues("lineItems")?.length)
      return;
    const U = [];
    e?.lineItems?.forEach((Z) => {
      const Q = N.find(
        (ee) => ee.id === Z.product?.id
      );
      Q && U.push({ ...Q, quantity: Z.quantity || 1 });
    }), U.length > 0 && (I.setValue("lineItems", U, { shouldDirty: !0 }), h([]));
  }, [r, N, e, I]);
  const C = (U) => {
    u(!0);
    const Z = (U.lineItems || []).filter(
      (Q) => f.includes(Q.id)
    ).map((Q) => {
      const ee = e?.lineItems?.find(
        (P) => P.product?.id === Q.id
      ), J = ee?.quantity || 0, G = Math.max(
        0,
        Math.min(J, Q.quantity || 0)
      );
      return ee && G > 0 ? { lineItemId: ee.id, quantity: G } : void 0;
    }).filter((Q) => !!Q);
    q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: Z,
          note: U.customNote || void 0,
          notify: !0
        }
      }
    });
  }, D = () => {
    I.reset(F), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: r, onClose: D, className: WV.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: `Refund order ${n}`, onClose: D }),
    /* @__PURE__ */ k.jsxs(vt, { children: [
      /* @__PURE__ */ k.jsx(Pm, { ...I, children: /* @__PURE__ */ k.jsx("form", { id: fv, children: /* @__PURE__ */ k.jsxs(zt, { children: [
        /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
          Np,
          {
            selectionMode: !0,
            hideDeleteButton: !0,
            isAlreadyLoadedProducts: S,
            contextProducts: N,
            selectedProductIds: f,
            onToggleSelect: (U, Z) => {
              h((Q) => Z ? Array.from(/* @__PURE__ */ new Set([...Q, U])) : Q.filter((ee) => ee !== U));
            },
            onToggleSelectAll: (U) => {
              const Z = (I.getValues("lineItems") || []).map((Q) => Q.id);
              h(U ? Z : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(nn, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Bt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(nn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: At.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              xp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      $ && /* @__PURE__ */ k.jsx(wn, { error: $ })
    ] }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          type: "submit",
          form: fv,
          disabled: !g || m,
          isLoading: m,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: I.handleSubmit(C)
      }
    )
  ] });
}, GV = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = mn(), { track: l } = kn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, [h] = a(zL, {
    onError: (N) => {
      setTimeout(() => S(N), 500);
    },
    onCompleted: (N) => {
      const F = N.Shopify?.refundCreate?.userErrors;
      F && F.length > 0 ? S(
        new zS({
          graphQLErrors: F.map((I) => ({
            message: I.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), v = pt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: N, ...F } = d;
    s({
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        N,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), h({
          variables: {
            input: F
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    });
  }, [n, u]), S = pt(
    (N) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(wn, { error: N }),
          /* @__PURE__ */ k.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Wn,
    {
      variant: "secondary",
      onClick: v,
      disabled: d?.refundLineItems?.length === 0,
      slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "undo" }),
      className: At.fullWidth,
      children: "Full refund"
    }
  ) });
}, YV = "_modal_al73g_1", JV = {
  modal: YV
}, QV = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = kn(), { useMutation: s, showNotification: l } = mn(), [d, m] = se(n), [u, f] = se(!1), h = sr({
    defaultValues: {
      tags: n
    }
  });
  qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: S, reset: N }] = s(ML, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), F = pt(
    (g) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((q) => {
        h.reset({ tags: q.data.Shopify.orderUpdate.order.tags });
      });
    },
    [e]
  ), I = () => {
    i(!1), N();
  };
  return /* @__PURE__ */ k.jsxs(gt, { isOpen: r, onClose: I, className: JV.modal, children: [
    /* @__PURE__ */ k.jsx(kt, { title: "Manage tags for order", onClose: I }),
    /* @__PURE__ */ k.jsxs(vt, { children: [
      /* @__PURE__ */ k.jsx(zt, { children: /* @__PURE__ */ k.jsx(nn, { children: /* @__PURE__ */ k.jsx(
        Pt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ k.jsx(
            An,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Cs,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (q) => m(q)
                }
              )
            }
          )
        }
      ) }) }),
      S && /* @__PURE__ */ k.jsx(wn, { error: S })
    ] }),
    /* @__PURE__ */ k.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(F),
        cancelOnClick: I,
        confirmName: S ? "Close" : "Save",
        cancelName: S ? void 0 : "Cancel"
      }
    )
  ] });
}, XV = "_editIcon_1dntr_1", ZV = {
  editIcon: XV
}, ez = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Ke, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: o,
          name: "pen",
          className: ZV.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      QV,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, nz = "_icon_cddi1_1", tz = "_link_cddi1_6", hv = {
  icon: nz,
  link: tz
}, rz = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Ka(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: hv.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: hv.icon
        }
      ) })
    }
  );
}, iz = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(ue, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(He, { children: e.map((n) => /* @__PURE__ */ k.jsx(rz, { trackingInfo: n }, n.number)) })
] }), az = "_order_135ze_1", oz = "_orderIsOpen_135ze_9", sz = "_orderHeader_135ze_12", ju = {
  order: az,
  orderIsOpen: oz,
  orderHeader: sz
}, lz = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, cz = (e) => {
  const n = {}, r = lz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, dz = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = kn(), [h, v] = se(!1), [S, N] = se(!1), [F, I] = se(r), {
    id: g,
    name: q,
    createdAt: $,
    status: C,
    currentTotalPriceSet: D,
    currencyCode: U,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: ee,
    trackingInfos: J,
    tags: G
  } = e, P = !!ee, W = _p(g), ne = `https://${l}/admin/orders/${W ?? ""}`, ke = D?.shopMoney?.amount ?? 0, me = C.includes("cancelled"), de = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: U
  }).format(ke), he = e?.refunds ? cz(e) : {};
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: ct(ju.order, {
        [ju.orderIsOpen]: F
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ju.orderHeader,
            onClick: () => I(!F),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                $ && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Pn($).format(dm) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  q
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: F ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        F && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: C })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: de })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            ez,
            {
              orderId: g,
              tags: G,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            mm,
            {
              openByDefault: !P,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            mm,
            {
              openByDefault: P,
              shopifyId: n,
              orderId: g,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ee,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            BV,
            {
              orderId: g,
              lineItems: Z,
              refundedQuantities: he
            }
          ),
          /* @__PURE__ */ k.jsx(iz, { trackingInfos: J }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              GV,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: ne
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => N(!0),
                className: At.fullWidth,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Wn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: At.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              VV,
              {
                orderId: g,
                orderName: q,
                disabled: me,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ne, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: g
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          MV,
          {
            order: e,
            shopifyId: n,
            orderName: q,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: u
          }
        ),
        S && /* @__PURE__ */ k.jsx(
          KV,
          {
            order: e,
            orderName: q,
            isOpen: S,
            setIsOpen: N,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, uz = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = kn(), [f, h] = se([]), [v, S] = se(!1), N = _p(m?.id), F = `https://${n}/admin/orders?customer_id=${N ?? ""}`, {
    getCustomerOrders: I,
    isCustomerOrdersLoading: g,
    customerOrdersError: q,
    customerOrders: $,
    refetchCustomerOrders: C
  } = KL();
  return qe(() => {
    !g && N && I({
      variables: {
        query: `customer_id:${N}`
      }
    });
  }, [N]), qe(() => {
    const D = $?.Shopify?.orders?.edges;
    D && h(SV({ ordersData: D }));
  }, [$]), m ? q ? /* @__PURE__ */ k.jsx(wn, { error: q }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Wn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => S(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((D, U) => /* @__PURE__ */ k.jsx(
        dz,
        {
          order: D,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: C,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${D.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(F, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      OV,
      {
        isOpen: v,
        setIsOpen: S,
        shopifyCustomer: m,
        refetchCustomerOrders: C,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, mz = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(He, { className: At.list, children: [
      /* @__PURE__ */ k.jsx(He.Text, { variant: "dense", className: At.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { variant: "dense", className: At.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, pz = "_segmentName_1dkhk_1", fz = {
  segmentName: pz
}, hz = 100, Po = 10, yz = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = mn(), [i, a] = se([]), [o, s] = se(Po), [l, d] = se(!1), m = et(
    () => i.filter((N) => N.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    PL,
    {
      skip: !e,
      variables: {
        first: hz
      },
      onCompleted: (N) => {
        const F = N?.Shopify?.segments?.edges;
        if (F && F.length > 0) {
          const I = F.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, q) => g.name.localeCompare(q.name));
          a(I), h({
            variables: {
              customerId: e,
              segmentIds: I.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: S }
  ] = r(AL, {
    onCompleted: (N) => {
      const F = N?.Shopify?.customerSegmentMembership?.memberships;
      if (F && F.length > 0) {
        const I = i.map((g) => {
          const q = F.find(
            ($) => $.segmentId === g.id
          );
          return {
            ...g,
            ...q?.isMember && { isMember: q.isMember }
          };
        }).sort(
          (g, q) => g.isMember === q.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(I);
      }
    }
  });
  return qe(() => {
    s(l ? i.length : Po);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(wn, { error: f }),
    S && /* @__PURE__ */ k.jsx(wn, { error: S }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(He, { className: At.list, children: [
      i.slice(0, o).map(({ id: N, name: F, isMember: I }) => /* @__PURE__ */ k.jsx(He.Text, { className: At.listItem, children: /* @__PURE__ */ k.jsx(
        Ke,
        {
          content: `${I ? "Member of" : "Not a member of"} ${F}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: fz.segmentName, children: F }),
            v && /* @__PURE__ */ k.jsx(un, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              ue,
              {
                color: I ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, N)),
      i.length > Po && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Wn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Po} more`
        }
      ) })
    ] })
  ] }) : null;
}, gz = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = WL({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, S = n.enableEditShippingAddress ?? !1, N = n.displayEmailMarketingConsent ?? !1, F = n.displayOrdersOverview ?? !1, I = n.displaySegmentMembership ?? !1, g = n.displayDiscountCodeCreation ?? !1, q = n.displayDiscountCodes ?? !1, $ = n.displayCreateOrder ?? !1, C = n.displayDuplicateOrder ?? !1, D = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (qe(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Z)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(wn, { error: i, retry: o });
  if (!r && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              nV,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              jt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== ar.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(un, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          iV,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        F && /* @__PURE__ */ k.jsx(
          mz,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        I && /* @__PURE__ */ k.jsx(yz, { shopifyId: l?.id }),
        N && /* @__PURE__ */ k.jsx(xV, { customer: l }),
        q && /* @__PURE__ */ k.jsx(
          _V,
          {
            displayDiscountCodeCreation: g
          }
        ),
        /* @__PURE__ */ k.jsx(
          uz,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: $,
            displayCreateDraftOrder: D,
            enableEditShippingAddress: S,
            customerCountryCodes: m,
            displayDuplicateOrder: C,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, _t = [];
for (let e = 0; e < 256; ++e)
  _t.push((e + 256).toString(16).slice(1));
function kz(e, n = 0) {
  return (_t[e[n + 0]] + _t[e[n + 1]] + _t[e[n + 2]] + _t[e[n + 3]] + "-" + _t[e[n + 4]] + _t[e[n + 5]] + "-" + _t[e[n + 6]] + _t[e[n + 7]] + "-" + _t[e[n + 8]] + _t[e[n + 9]] + "-" + _t[e[n + 10]] + _t[e[n + 11]] + _t[e[n + 12]] + _t[e[n + 13]] + _t[e[n + 14]] + _t[e[n + 15]]).toLowerCase();
}
let wu;
const vz = new Uint8Array(16);
function bz() {
  if (!wu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    wu = crypto.getRandomValues.bind(crypto);
  }
  return wu(vz);
}
const _z = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), yv = { randomUUID: _z };
function xz(e, n, r) {
  if (yv.randomUUID && !e)
    return yv.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? bz();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, kz(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cu = { exports: {} }, Sa = {}, gv;
function Sz() {
  if (gv) return Sa;
  gv = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Sa.Fragment = r, Sa.jsx = s, Sa.jsxs = s, Sa;
}
var Ao = {}, kv;
function Nz() {
  return kv || (kv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    Ao.Fragment = i, Ao.jsx = Bn, Ao.jsxs = qn;
  })()), Ao;
}
var vv;
function jz() {
  return vv || (vv = 1, process.env.NODE_ENV === "production" ? Cu.exports = Sz() : Cu.exports = Nz()), Cu.exports;
}
var M = jz(), Rx = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(Rx || {}), pm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(pm || {});
const wz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, Cz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Fz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, Iz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, Ez = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, Tz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, $z = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, Dz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, Rz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, Oz = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": wz,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": Cz,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": Fz,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": Iz,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": Ez,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": Tz,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": $z,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Dz,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": Rz
};
function qr(e) {
  return Oz[e] ?? {};
}
const Pz = qr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), Az = qr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), Lz = qr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), Vz = qr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), zz = qr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), Uz = qr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), Mz = qr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), Bz = qr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), qz = qr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), Hz = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(Pz, {
    skip: !e,
    variables: { contactId: e }
  });
  return qe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (S) => S !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), et(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function ns(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const Wz = {
  count: 0,
  items: []
}, Kz = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(Wz), {
    loading: o,
    error: s,
    data: l
  } = n(Vz, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, Gz = {
  count: 0,
  totalCount: 0,
  items: []
}, Yz = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: r } = kn(), [i, a] = se(
    Gz
  ), {
    loading: o,
    error: s,
    data: l
  } = n(zz, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, Jz = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(Lz, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, Qz = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = mn(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(Az, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), et(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, Xz = "_pointer_ls8kj_48", Zz = "_list_ls8kj_53", e3 = "_listItem_ls8kj_63", nt = {
  pointer: Xz,
  list: Zz,
  listItem: e3
};
var so = (e) => e.type === "checkbox", li = (e) => e instanceof Date, Rt = (e) => e == null;
const Ox = (e) => typeof e == "object";
var ot = (e) => !Rt(e) && !Array.isArray(e) && Ox(e) && !li(e), Px = (e) => ot(e) && e.target ? so(e.target) ? e.target.checked : e.target.value : e, n3 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Ax = (e, n) => e.has(n3(n)), t3 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ot(n) && n.hasOwnProperty("isPrototypeOf");
}, jp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function St(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(jp && (e instanceof Blob || i)) && (r || ot(e)))
    if (n = r ? [] : {}, !r && !t3(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = St(e[a]));
  else
    return e;
  return n;
}
var Hs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !ot(e))
    return r;
  const i = Hs(n.split(/[,[\].]+?/)).reduce((a, o) => Rt(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? r : e[n] : i;
}, Jt = (e) => typeof e == "boolean", wp = (e) => /^\w*$/.test(e), Lx = (e) => Hs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = wp(n) ? [n] : Lx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ot(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ks = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, r3 = Se.createContext(null), Cp = () => Se.useContext(r3);
var Vx = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== fr.all && (n._proxyFormState[s] = !i || fr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function i3(e) {
  const n = Cp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => Vx(s, r, d.current, !1), [s, r]);
}
var Er = (e) => typeof e == "string", zx = (e, n, r, i, a) => Er(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function Ux(e) {
  const n = Cp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(zx(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function a3(e) {
  const n = Cp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Ax(a._names.array, r), l = Ux({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = i3({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Jt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((F) => u.current.onChange({
    target: {
      value: Px(F),
      name: r
    },
    type: ks.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: ks.BLUR
  }), [r, a._formValues]), S = Se.useCallback((F) => {
    const I = Je(a._fields, r);
    I && F && (I._f.ref = {
      focus: () => F.focus(),
      select: () => F.select(),
      setCustomValidity: (g) => F.setCustomValidity(g),
      reportValidity: () => F.reportValidity()
    });
  }, [a._fields, r]), N = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Jt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: S
  }), [r, i, d.disabled, h, v, S, l]);
  return Se.useEffect(() => {
    const F = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Jt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const I = (g, q) => {
      const $ = Je(a._fields, g);
      $ && $._f && ($._f.mount = q);
    };
    if (I(r, !0), F) {
      const g = St(Je(a._options.defaultValues, r));
      Gn(a._defaultValues, r, g), rt(Je(a._formValues, r)) && Gn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? F && !a._state.action : F) ? a.unregister(r) : I(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const bv = (e) => e.render(a3(e));
var o3 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Va = (e) => Array.isArray(e) ? e : [e], _v = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, fm = (e) => Rt(e) || !Ox(e);
function Yr(e, n) {
  if (fm(e) || fm(n))
    return e === n;
  if (li(e) && li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (li(o) && li(s) || ot(o) && ot(s) || Array.isArray(o) && Array.isArray(s) ? !Yr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Tt = (e) => ot(e) && !Object.keys(e).length, Fp = (e) => e.type === "file", hr = (e) => typeof e == "function", vs = (e) => {
  if (!jp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Mx = (e) => e.type === "select-multiple", Ip = (e) => e.type === "radio", s3 = (e) => Ip(e) || so(e), Fu = (e) => vs(e) && e.isConnected;
function l3(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function c3(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : wp(n) ? [n] : Lx(n), i = r.length === 1 ? e : l3(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ot(i) && Tt(i) || Array.isArray(i) && c3(i)) && ht(e, r.slice(0, -1)), e;
}
var Bx = (e) => {
  for (const n in e)
    if (hr(e[n]))
      return !0;
  return !1;
};
function bs(e, n = {}) {
  const r = Array.isArray(e);
  if (ot(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ot(e[i]) && !Bx(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, bs(e[i], n[i])) : Rt(e[i]) || (n[i] = !0);
  return n;
}
function qx(e, n, r) {
  const i = Array.isArray(e);
  if (ot(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ot(e[a]) && !Bx(e[a]) ? rt(n) || fm(r[a]) ? r[a] = Array.isArray(e[a]) ? bs(e[a], []) : { ...bs(e[a]) } : qx(e[a], Rt(n) ? {} : n[a], r[a]) : r[a] = !Yr(e[a], n[a]);
  return r;
}
var Na = (e, n) => qx(e, n, bs(n));
const xv = {
  value: !1,
  isValid: !1
}, Sv = { value: !0, isValid: !0 };
var Hx = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? Sv : { value: e[0].value, isValid: !0 } : Sv
    ) : xv;
  }
  return xv;
}, Wx = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : r && Er(e) ? new Date(e) : i ? i(e) : e;
const Nv = {
  isValid: !1,
  value: null
};
var Kx = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Nv) : Nv;
function jv(e) {
  const n = e.ref;
  return Fp(n) ? n.files : Ip(n) ? Kx(e.refs).value : Mx(n) ? [...n.selectedOptions].map(({ value: r }) => r) : so(n) ? Hx(e.refs).value : Wx(rt(n.value) ? e.ref.value : n.value, e);
}
var d3 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, _s = (e) => e instanceof RegExp, ja = (e) => rt(e) ? e : _s(e) ? e.source : ot(e) ? _s(e.value) ? e.value.source : e.value : e, wv = (e) => ({
  isOnSubmit: !e || e === fr.onSubmit,
  isOnBlur: e === fr.onBlur,
  isOnChange: e === fr.onChange,
  isOnAll: e === fr.all,
  isOnTouch: e === fr.onTouched
});
const Cv = "AsyncFunction";
var u3 = (e) => !!e && !!e.validate && !!(hr(e.validate) && e.validate.constructor.name === Cv || ot(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Cv)), m3 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Fv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const za = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (za(l, n))
          break;
      } else if (ot(l) && za(l, n))
        break;
    }
  }
};
function Iv(e, n, r) {
  const i = Je(e, r);
  if (i || wp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var p3 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Tt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || fr.all));
}, f3 = (e, n, r) => !e || !n || e === n || Va(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), h3 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, y3 = (e, n) => !Hs(Je(e, n)).length && ht(e, n), g3 = (e, n, r) => {
  const i = Va(Je(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, ts = (e) => Er(e);
function Ev(e, n, r = "validate") {
  if (ts(e) || Array.isArray(e) && e.every(ts) || Jt(e) && !e)
    return {
      type: r,
      message: ts(e) ? e : "",
      ref: n
    };
}
var Ni = (e) => ot(e) && !_s(e) ? e : {
  value: e,
  message: ""
}, Tv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: S, name: N, valueAsNumber: F, mount: I } = e._f, g = Je(r, N);
  if (!I || n.has(N))
    return {};
  const q = l ? l[0] : s, $ = (G) => {
    a && q.reportValidity && (q.setCustomValidity(Jt(G) ? "" : G || ""), q.reportValidity());
  }, C = {}, D = Ip(s), U = so(s), Z = D || U, Q = (F || Fp(s)) && rt(s.value) && rt(g) || vs(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = o3.bind(null, N, i, C), J = (G, P, W, ne = zr.maxLength, ke = zr.minLength) => {
    const me = G ? P : W;
    C[N] = {
      type: G ? ne : ke,
      message: me,
      ref: s,
      ...ee(G ? ne : ke, me)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Rt(g)) || Jt(g) && !g || U && !Hx(l).isValid || D && !Kx(l).isValid)) {
    const { value: G, message: P } = ts(d) ? { value: !!d, message: d } : Ni(d);
    if (G && (C[N] = {
      type: zr.required,
      message: P,
      ref: q,
      ...ee(zr.required, P)
    }, !i))
      return $(P), C;
  }
  if (!Q && (!Rt(f) || !Rt(h))) {
    let G, P;
    const W = Ni(h), ne = Ni(f);
    if (!Rt(g) && !isNaN(g)) {
      const ke = s.valueAsNumber || g && +g;
      Rt(W.value) || (G = ke > W.value), Rt(ne.value) || (P = ke < ne.value);
    } else {
      const ke = s.valueAsDate || new Date(g), me = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), de = s.type == "time", he = s.type == "week";
      Er(W.value) && g && (G = de ? me(g) > me(W.value) : he ? g > W.value : ke > new Date(W.value)), Er(ne.value) && g && (P = de ? me(g) < me(ne.value) : he ? g < ne.value : ke < new Date(ne.value));
    }
    if ((G || P) && (J(!!G, W.message, ne.message, zr.max, zr.min), !i))
      return $(C[N].message), C;
  }
  if ((m || u) && !Q && (Er(g) || o && Array.isArray(g))) {
    const G = Ni(m), P = Ni(u), W = !Rt(G.value) && g.length > +G.value, ne = !Rt(P.value) && g.length < +P.value;
    if ((W || ne) && (J(W, G.message, P.message), !i))
      return $(C[N].message), C;
  }
  if (v && !Q && Er(g)) {
    const { value: G, message: P } = Ni(v);
    if (_s(G) && !g.match(G) && (C[N] = {
      type: zr.pattern,
      message: P,
      ref: s,
      ...ee(zr.pattern, P)
    }, !i))
      return $(P), C;
  }
  if (S) {
    if (hr(S)) {
      const G = await S(g, r), P = Ev(G, q);
      if (P && (C[N] = {
        ...P,
        ...ee(zr.validate, P.message)
      }, !i))
        return $(P.message), C;
    } else if (ot(S)) {
      let G = {};
      for (const P in S) {
        if (!Tt(G) && !i)
          break;
        const W = Ev(await S[P](g, r), q, P);
        W && (G = {
          ...W,
          ...ee(P, W.message)
        }, $(W.message), i && (C[N] = G));
      }
      if (!Tt(G) && (C[N] = {
        ref: q,
        ...G
      }, !i))
        return C;
    }
  }
  return $(!0), C;
};
const k3 = {
  mode: fr.onSubmit,
  reValidateMode: fr.onChange,
  shouldFocusError: !0
};
function v3(e = {}) {
  let n = {
    ...k3,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: hr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ot(n.defaultValues) || ot(n.values) ? St(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : St(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: _v(),
    state: _v()
  }, v = wv(n.mode), S = wv(n.reValidateMode), N = n.criteriaMode === fr.all, F = (j) => (_) => {
    clearTimeout(m), m = setTimeout(j, _);
  }, I = async (j) => {
    if (!n.disabled && (u.isValid || f.isValid || j)) {
      const _ = n.resolver ? Tt((await Q()).errors) : await J(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (j, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((j || Array.from(l.mount)).forEach((T) => {
      T && (_ ? Gn(r.validatingFields, T, _) : ht(r.validatingFields, T));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Tt(r.validatingFields)
    }));
  }, q = (j, _ = [], T, Y, X = !0, O = !0) => {
    if (Y && T && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Je(i, j))) {
        const B = T(Je(i, j), Y.argA, Y.argB);
        X && Gn(i, j, B);
      }
      if (O && Array.isArray(Je(r.errors, j))) {
        const B = T(Je(r.errors, j), Y.argA, Y.argB);
        X && Gn(r.errors, j, B), y3(r.errors, j);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Je(r.touchedFields, j))) {
        const B = T(Je(r.touchedFields, j), Y.argA, Y.argB);
        X && Gn(r.touchedFields, j, B);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Na(a, o)), h.state.next({
        name: j,
        isDirty: P(j, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, j, _);
  }, $ = (j, _) => {
    Gn(r.errors, j, _), h.state.next({
      errors: r.errors
    });
  }, C = (j) => {
    r.errors = j, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (j, _, T, Y) => {
    const X = Je(i, j);
    if (X) {
      const O = Je(o, j, rt(T) ? Je(a, j) : T);
      rt(O) || Y && Y.defaultChecked || _ ? Gn(o, j, _ ? O : jv(X._f)) : ke(j, O), s.mount && I();
    }
  }, U = (j, _, T, Y, X) => {
    let O = !1, B = !1;
    const ie = {
      name: j
    };
    if (!n.disabled) {
      if (!T || Y) {
        (u.isDirty || f.isDirty) && (B = r.isDirty, r.isDirty = ie.isDirty = P(), O = B !== ie.isDirty);
        const fe = Yr(Je(a, j), _);
        B = !!Je(r.dirtyFields, j), fe ? ht(r.dirtyFields, j) : Gn(r.dirtyFields, j, !0), ie.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && B !== !fe;
      }
      if (T) {
        const fe = Je(r.touchedFields, j);
        fe || (Gn(r.touchedFields, j, T), ie.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== T);
      }
      O && X && h.state.next(ie);
    }
    return O ? ie : {};
  }, Z = (j, _, T, Y) => {
    const X = Je(r.errors, j), O = (u.isValid || f.isValid) && Jt(_) && r.isValid !== _;
    if (n.delayError && T ? (d = F(() => $(j, T)), d(n.delayError)) : (clearTimeout(m), d = null, T ? Gn(r.errors, j, T) : ht(r.errors, j)), (T ? !Yr(X, T) : X) || !Tt(Y) || O) {
      const B = {
        ...Y,
        ...O && Jt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: j
      };
      r = {
        ...r,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (j) => {
    g(j, !0);
    const _ = await n.resolver(o, n.context, d3(j || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(j), _;
  }, ee = async (j) => {
    const { errors: _ } = await Q(j);
    if (j)
      for (const T of j) {
        const Y = Je(_, T);
        Y ? Gn(r.errors, T, Y) : ht(r.errors, T);
      }
    else
      r.errors = _;
    return _;
  }, J = async (j, _, T = {
    valid: !0
  }) => {
    for (const Y in j) {
      const X = j[Y];
      if (X) {
        const { _f: O, ...B } = X;
        if (O) {
          const ie = l.array.has(O.name), fe = X._f && u3(X._f);
          fe && u.validatingFields && g([Y], !0);
          const _e = await Tv(X, l.disabled, o, N, n.shouldUseNativeValidation && !_, ie);
          if (fe && u.validatingFields && g([Y]), _e[O.name] && (T.valid = !1, _))
            break;
          !_ && (Je(_e, O.name) ? ie ? g3(r.errors, _e, O.name) : Gn(r.errors, O.name, _e[O.name]) : ht(r.errors, O.name));
        }
        !Tt(B) && await J(B, _, T);
      }
    }
    return T.valid;
  }, G = () => {
    for (const j of l.unMount) {
      const _ = Je(i, j);
      _ && (_._f.refs ? _._f.refs.every((T) => !Fu(T)) : !Fu(_._f.ref)) && Le(j);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (j, _) => !n.disabled && (j && _ && Gn(o, j, _), !Yr(Ce(), a)), W = (j, _, T) => zx(j, l, {
    ...s.mount ? o : rt(_) ? a : Er(j) ? { [j]: _ } : _
  }, T, _), ne = (j) => Hs(Je(s.mount ? o : a, j, n.shouldUnregister ? Je(a, j, []) : [])), ke = (j, _, T = {}) => {
    const Y = Je(i, j);
    let X = _;
    if (Y) {
      const O = Y._f;
      O && (!O.disabled && Gn(o, j, Wx(_, O)), X = vs(O.ref) && Rt(_) ? "" : _, Mx(O.ref) ? [...O.ref.options].forEach((B) => B.selected = X.includes(B.value)) : O.refs ? so(O.ref) ? O.refs.length > 1 ? O.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((ie) => ie === B.value) : X === B.value)) : O.refs[0] && (O.refs[0].checked = !!X) : O.refs.forEach((B) => B.checked = B.value === X) : Fp(O.ref) ? O.ref.value = "" : (O.ref.value = X, O.ref.type || h.state.next({
        name: j,
        values: St(o)
      })));
    }
    (T.shouldDirty || T.shouldTouch) && U(j, X, T.shouldTouch, T.shouldDirty, !0), T.shouldValidate && be(j);
  }, me = (j, _, T) => {
    for (const Y in _) {
      const X = _[Y], O = `${j}.${Y}`, B = Je(i, O);
      (l.array.has(j) || ot(X) || B && !B._f) && !li(X) ? me(O, X, T) : ke(O, X, T);
    }
  }, de = (j, _, T = {}) => {
    const Y = Je(i, j), X = l.array.has(j), O = St(_);
    Gn(o, j, O), X ? (h.array.next({
      name: j,
      values: St(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && T.shouldDirty && h.state.next({
      name: j,
      dirtyFields: Na(a, o),
      isDirty: P(j, O)
    })) : Y && !Y._f && !Rt(O) ? me(j, O, T) : ke(j, O, T), Fv(j, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? j : void 0,
      values: St(o)
    });
  }, he = async (j) => {
    s.mount = !0;
    const _ = j.target;
    let T = _.name, Y = !0;
    const X = Je(i, T), O = (B) => {
      Y = Number.isNaN(B) || li(B) && isNaN(B.getTime()) || Yr(B, Je(o, T, B));
    };
    if (X) {
      let B, ie;
      const fe = _.type ? jv(X._f) : Px(j), _e = j.type === ks.BLUR || j.type === ks.FOCUS_OUT, en = !m3(X._f) && !n.resolver && !Je(r.errors, T) && !X._f.deps || h3(_e, Je(r.touchedFields, T), r.isSubmitted, S, v), dn = Fv(T, l, _e);
      Gn(o, T, fe), _e ? (X._f.onBlur && X._f.onBlur(j), d && d(0)) : X._f.onChange && X._f.onChange(j);
      const tn = U(T, fe, _e), sn = !Tt(tn) || dn;
      if (!_e && h.state.next({
        name: T,
        type: j.type,
        values: St(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && I() : _e || I()), sn && h.state.next({ name: T, ...dn ? {} : tn });
      if (!_e && dn && h.state.next({ ...r }), n.resolver) {
        const { errors: fn } = await Q([T]);
        if (O(fe), Y) {
          const pn = Iv(r.errors, i, T), yn = Iv(fn, i, pn.name || T);
          B = yn.error, T = yn.name, ie = Tt(fn);
        }
      } else
        g([T], !0), B = (await Tv(X, l.disabled, o, N, n.shouldUseNativeValidation))[T], g([T]), O(fe), Y && (B ? ie = !1 : (u.isValid || f.isValid) && (ie = await J(i, !0)));
      Y && (X._f.deps && be(X._f.deps), Z(T, ie, B, tn));
    }
  }, H = (j, _) => {
    if (Je(r.errors, _) && j.focus)
      return j.focus(), 1;
  }, be = async (j, _ = {}) => {
    let T, Y;
    const X = Va(j);
    if (n.resolver) {
      const O = await ee(rt(j) ? j : X);
      T = Tt(O), Y = j ? !X.some((B) => Je(O, B)) : T;
    } else j ? (Y = (await Promise.all(X.map(async (O) => {
      const B = Je(i, O);
      return await J(B && B._f ? { [O]: B } : B);
    }))).every(Boolean), !(!Y && !r.isValid) && I()) : Y = T = await J(i);
    return h.state.next({
      ...!Er(j) || (u.isValid || f.isValid) && T !== r.isValid ? {} : { name: j },
      ...n.resolver || !j ? { isValid: T } : {},
      errors: r.errors
    }), _.shouldFocus && !Y && za(i, H, j ? X : l.mount), Y;
  }, Ce = (j) => {
    const _ = {
      ...s.mount ? o : a
    };
    return rt(j) ? _ : Er(j) ? Je(_, j) : j.map((T) => Je(_, T));
  }, K = (j, _) => ({
    invalid: !!Je((_ || r).errors, j),
    isDirty: !!Je((_ || r).dirtyFields, j),
    error: Je((_ || r).errors, j),
    isValidating: !!Je(r.validatingFields, j),
    isTouched: !!Je((_ || r).touchedFields, j)
  }), ze = (j) => {
    j && Va(j).forEach((_) => ht(r.errors, _)), h.state.next({
      errors: j ? r.errors : {}
    });
  }, Be = (j, _, T) => {
    const Y = (Je(i, j, { _f: {} })._f || {}).ref, X = Je(r.errors, j) || {}, { ref: O, message: B, type: ie, ...fe } = X;
    Gn(r.errors, j, {
      ...fe,
      ..._,
      ref: Y
    }), h.state.next({
      name: j,
      errors: r.errors,
      isValid: !1
    }), T && T.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (j, _) => hr(j) ? h.state.subscribe({
    next: (T) => j(W(void 0, _), T)
  }) : W(j, _, !0), Me = (j) => h.state.subscribe({
    next: (_) => {
      f3(j.name, _.name, j.exact) && p3(_, j.formState || u, Ee, j.reRenderRoot) && j.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, Ie = (j) => (s.mount = !0, f = {
    ...f,
    ...j.formState
  }, Me({
    ...j,
    formState: f
  })), Le = (j, _ = {}) => {
    for (const T of j ? Va(j) : l.mount)
      l.mount.delete(T), l.array.delete(T), _.keepValue || (ht(i, T), ht(o, T)), !_.keepError && ht(r.errors, T), !_.keepDirty && ht(r.dirtyFields, T), !_.keepTouched && ht(r.touchedFields, T), !_.keepIsValidating && ht(r.validatingFields, T), !n.shouldUnregister && !_.keepDefaultValue && ht(a, T);
    h.state.next({
      values: St(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: P() } : {}
    }), !_.keepIsValid && I();
  }, De = ({ disabled: j, name: _ }) => {
    (Jt(j) && s.mount || j || l.disabled.has(_)) && (j ? l.disabled.add(_) : l.disabled.delete(_));
  }, rn = (j, _ = {}) => {
    let T = Je(i, j);
    const Y = Jt(_.disabled) || Jt(n.disabled);
    return Gn(i, j, {
      ...T || {},
      _f: {
        ...T && T._f ? T._f : { ref: { name: j } },
        name: j,
        mount: !0,
        ..._
      }
    }), l.mount.add(j), T ? De({
      disabled: Jt(_.disabled) ? _.disabled : n.disabled,
      name: j
    }) : D(j, !0, _.value), {
      ...Y ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: ja(_.min),
        max: ja(_.max),
        minLength: ja(_.minLength),
        maxLength: ja(_.maxLength),
        pattern: ja(_.pattern)
      } : {},
      name: j,
      onChange: he,
      onBlur: he,
      ref: (X) => {
        if (X) {
          rn(j, _), T = Je(i, j);
          const O = rt(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = s3(O), ie = T._f.refs || [];
          if (B ? ie.find((fe) => fe === O) : O === T._f.ref)
            return;
          Gn(i, j, {
            _f: {
              ...T._f,
              ...B ? {
                refs: [
                  ...ie.filter(Fu),
                  O,
                  ...Array.isArray(Je(a, j)) ? [{}] : []
                ],
                ref: { type: O.type, name: j }
              } : { ref: O }
            }
          }), D(j, !1, void 0, O);
        } else
          T = Je(i, j, {}), T._f && (T._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(Ax(l.array, j) && s.action) && l.unMount.add(j);
      }
    };
  }, je = () => n.shouldFocusError && za(i, H, l.mount), We = (j) => {
    Jt(j) && (h.state.next({ disabled: j }), za(i, (_, T) => {
      const Y = Je(i, T);
      Y && (_.disabled = Y._f.disabled || j, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || j;
      }));
    }, 0, !1));
  }, Ge = (j, _) => async (T) => {
    let Y;
    T && (T.preventDefault && T.preventDefault(), T.persist && T.persist());
    let X = St(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: B } = await Q();
      r.errors = O, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Gn(X, O, void 0);
    if (ht(r.errors, "root"), Tt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await j(X, T);
      } catch (O) {
        Y = O;
      }
    } else
      _ && await _({ ...r.errors }, T), je(), setTimeout(je);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Tt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, pe = (j, _ = {}) => {
    Je(i, j) && (rt(_.defaultValue) ? de(j, St(Je(a, j))) : (de(j, _.defaultValue), Gn(a, j, St(_.defaultValue))), _.keepTouched || ht(r.touchedFields, j), _.keepDirty || (ht(r.dirtyFields, j), r.isDirty = _.defaultValue ? P(j, St(Je(a, j))) : P()), _.keepError || (ht(r.errors, j), u.isValid && I()), h.state.next({ ...r }));
  }, le = (j, _ = {}) => {
    const T = j ? St(j) : a, Y = St(T), X = Tt(j), O = X ? a : Y;
    if (_.keepDefaultValues || (a = T), !_.keepValues) {
      if (_.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Na(a, o))
        ]);
        for (const ie of Array.from(B))
          Je(r.dirtyFields, ie) ? Gn(O, ie, Je(o, ie)) : de(ie, Je(O, ie));
      } else {
        if (jp && rt(j))
          for (const B of l.mount) {
            const ie = Je(i, B);
            if (ie && ie._f) {
              const fe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (vs(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          de(B, Je(O, B));
      }
      o = St(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: X ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Yr(j, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: X ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Na(a, o) : r.dirtyFields : _.keepDefaultValues && j ? Na(a, j) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (j, _) => le(hr(j) ? j(o) : j, _), Ae = (j, _ = {}) => {
    const T = Je(i, j), Y = T && T._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), _.shouldSelect && hr(X.select) && X.select());
    }
  }, Ee = (j) => {
    r = {
      ...r,
      ...j
    };
  }, cn = {
    control: {
      register: rn,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Ge,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: W,
      _getDirty: P,
      _setValid: I,
      _setFieldArray: q,
      _setDisabledField: De,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: le,
      _resetDefaultValues: () => hr(n.defaultValues) && n.defaultValues().then((j) => {
        Ne(j, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: G,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(j) {
        s = j;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(j) {
        l = j;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(j) {
        n = {
          ...n,
          ...j
        };
      }
    },
    subscribe: Ie,
    trigger: be,
    register: rn,
    handleSubmit: Ge,
    watch: Pe,
    setValue: de,
    getValues: Ce,
    reset: Ne,
    resetField: pe,
    clearErrors: ze,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...cn,
    formControl: cn
  };
}
function b3(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: hr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: hr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : v3(e),
    formState: i
  }, e.formControl && e.defaultValues && !hr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Yr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Tt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Vx(i, o), n.current;
}
const _3 = "_modalBody_1clhs_1", x3 = {
  modalBody: _3
}, S3 = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = kn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = b3({
    defaultValues: u,
    mode: "onChange"
  }), S = Ux({ control: f }), N = parseInt(S?.balance ?? "0", 10), F = m === N, I = F ? "Change the value to update the points" : "", g = N < 0, q = g ? "Points can not be negative" : "", $ = S.description === "", C = $ ? "Description can not be empty" : "";
  qe(() => {
    N > m ? h(
      "transactionType",
      pm.Addition
    ) : N < m && h(
      "transactionType",
      pm.Deduction
    );
  }, [m, N, h]);
  const [D, { loading: U, error: Z, reset: Q }] = o(qz, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ee = () => {
    if (d) {
      const G = xz();
      D({
        variables: {
          input: {
            accountId: d,
            transactionId: G,
            amount: Math.abs(N - m),
            transactionType: S.transactionType,
            description: S.description,
            source: Rx.UpdateBalance
          }
        }
      }).then(async (P) => {
        P?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), J());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, J = () => {
    v(u), Q(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    gt,
    {
      isOpen: e,
      onClose: J,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx(kt, { title: "Update points balance", onClose: J }),
        /* @__PURE__ */ M.jsxs(vt, { className: x3.modalBody, children: [
          /* @__PURE__ */ M.jsxs(zt, { children: [
            /* @__PURE__ */ M.jsx(nn, { span: 6, children: /* @__PURE__ */ M.jsx(
              bv,
              {
                name: "balance",
                control: f,
                render: ({ field: G }) => /* @__PURE__ */ M.jsx(
                  ir,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: I || q
                    },
                    input: {
                      ...G,
                      value: G.value.toString(),
                      onChange: (P) => G.onChange(P)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(nn, { span: 6, children: /* @__PURE__ */ M.jsx(
              bv,
              {
                name: "description",
                control: f,
                render: ({ field: G }) => /* @__PURE__ */ M.jsx(
                  ir,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: G,
                    meta: {
                      warning: C
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ M.jsx(wn, { error: Z })
        ] }),
        /* @__PURE__ */ M.jsx(
          wt,
          {
            confirmName: "Save",
            confirmOnClick: () => ee(),
            confirmProps: {
              isLoading: U,
              disabled: F || g || $,
              loadingIndicator: /* @__PURE__ */ M.jsx(un, { size: 16 })
            },
            cancelOnClick: J
          }
        )
      ]
    }
  );
}, N3 = "_wrapper_1ge6c_1", j3 = "_block_1ge6c_12", $v = {
  wrapper: N3,
  block: j3
}, w3 = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = mn(), { isCopied: i, copy: a } = ns(), { isCopied: o, copy: s } = ns(), { isCopied: l, copy: d } = ns(), [m, u] = se(!1), [f, h] = se(), [v, S] = se(!1), {
    loading: N,
    data: F,
    refetch: I
  } = r(Mz, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  qe(() => {
    if (F) {
      const ne = F?.Voyado?.PointAccountV_GetPointAccounts;
      ne && ne?.length > 0 && h(ne[0]);
    }
  }, [F]);
  const g = !!f?.id, q = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: $,
    lastName: C,
    street: D,
    zipCode: U,
    city: Z,
    country: Q,
    isRegistrationCompleted: ee,
    email: J,
    mobilePhone: G
  } = e, P = 14, W = `${$ || ""} ${C || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: $v.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: $v.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: W }),
          N && /* @__PURE__ */ M.jsx(un, { size: 12 }),
          g && !N && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(Un, { size: "small", variant: "warning", children: [
              q,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(Ke, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              ue,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ M.jsx(Ke, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              ue,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (D || Z || U || Q || G || J) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      G && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(ue, { size: P, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: G })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(G),
            className: nt.pointer
          }
        )
      ] }),
      J && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(ue, { size: P, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            size: P,
            name: i ? "done" : "copy",
            onClick: () => a(J),
            className: nt.pointer
          }
        )
      ] }),
      (D || Z || U || Q) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(ue, { size: P, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(Jn, { children: D }),
            /* @__PURE__ */ M.jsxs(Jn, { children: [
              U,
              " ",
              Z
            ] }),
            /* @__PURE__ */ M.jsx(Jn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => d(`${D}, ${U} ${Z}, ${Q}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(ue, { size: P, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          ue,
          {
            name: ee ? "check-circle-filled" : "close-circle-filled",
            color: ee ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ M.jsx(
      S3,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: S,
        refetchPointsQuery: I
      }
    )
  ] });
}, C3 = "_list_yud4a_7", F3 = "_listItem_yud4a_11", I3 = "_listItemTooltip_yud4a_15", E3 = "_listItemTimestamp_yud4a_18", Lo = {
  list: C3,
  listItem: F3,
  listItemTooltip: I3,
  listItemTimestamp: E3
}, T3 = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(He, { className: Lo.list, children: e.map((n, r) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: Lo.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(Ke, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ct({
          [Lo.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: Lo.listItemTimestamp, children: Pn(n.date).format(lt) }),
          n?.comment && /* @__PURE__ */ M.jsx(ue, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      ue,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), $3 = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Pn(e.latestChange).format(lt) : null, o = e?.expires ? `${Pn(e.expires).fromNow()} (${Pn(e.expires).format(lt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(Ke, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        ue,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(He, { className: nt.list, children: [
      s && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, D3 = "_tagHover_kzbzk_1", R3 = "_channelUnsubscribed_kzbzk_6", Dv = {
  tagHover: D3,
  channelUnsubscribed: R3
}, Iu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = kn(), { useMutation: l } = mn(), [d, m] = se(!1), [u, { loading: f }] = l(Bz), h = async ({
    newPreference: S,
    isSubscribed: N,
    channelType: F
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...S
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? N ? s("voyado:channel:unsubscribe:succeeded", { channel: F }) : s("voyado:channel:subscribe:succeeded", { channel: F }) : N ? s("voyado:channel:unsubscribe:failed", { channel: F }) : s("voyado:channel:subscribe:failed", { channel: F }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ M.jsx(Ke, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    On,
    {
      className: Dv.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ct({
            [Dv.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ M.jsx(un, { size: 16 }) : /* @__PURE__ */ M.jsx(ue, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, O3 = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Iu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Iu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Iu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, P3 = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = Hz({ contactId: e }), {
    isLoading: v,
    error: S,
    memberLevel: N
  } = Qz({ contactId: e, skip: !s }), F = v || l, I = et(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || S ? Ya({
    errors: d?.graphQLErrors || S?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(wn, { error: d || S }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : F ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    r && /* @__PURE__ */ M.jsx(
      w3,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx($3, { memberLevel: N }),
    i && /* @__PURE__ */ M.jsx(
      O3,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(T3, { contactConsents: I })
  ] });
}, hm = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, A3 = "_list_zu4s7_1", L3 = "_listItem_zu4s7_4", V3 = "_listSum_zu4s7_7", Vo = {
  list: A3,
  listItem: L3,
  listSum: V3
}, z3 = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ M.jsxs(He, { className: Vo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: Vo.listItem, children: /* @__PURE__ */ M.jsx(Ke, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: hm(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    He.Text,
    {
      variant: "dense",
      className: ct(Vo.listItem, Vo.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: hm(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), U3 = "_transaction_1kr8d_1", M3 = "_transactionIsOpen_1kr8d_9", B3 = "_transactionHeader_1kr8d_12", q3 = "_transactionHeaderSubLine_1kr8d_15", H3 = "_transactionHeaderAlignItemRight_1kr8d_19", ji = {
  transaction: U3,
  transactionIsOpen: M3,
  transactionHeader: B3,
  transactionHeaderSubLine: q3,
  transactionHeaderAlignItemRight: H3
}, W3 = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, S = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ct(ji.transaction, {
        [ji.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ji.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: Pn(o).format(lt) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: ji.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ji.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: hm(v, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: ji.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(bm, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ M.jsx(
                  z3,
                  {
                    lineItems: S,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, K3 = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = Yz({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ M.jsx(wn, { error: r }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ M.jsx(
            W3,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, G3 = "_message_unsvt_48", Y3 = "_messageIsOpen_unsvt_56", J3 = "_messageHeader_unsvt_60", Q3 = "_messageText_unsvt_64", X3 = "_buttonLink_unsvt_86", wa = {
  message: G3,
  messageIsOpen: Y3,
  messageHeader: J3,
  messageText: Q3,
  buttonLink: X3
}, Eu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Tu = (e, n) => n && e in Eu && n in Eu[e] ? Eu[e][n] : null, Z3 = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = kn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Tu("type", l) : null, S = d ? Tu("source", d) : null, N = u ? Tu("status", u) : null, F = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ct(wa.message, {
        [wa.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: wa.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(ue, { name: v, size: 16 }),
                    " ",
                    F
                  ] }),
                  s && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: Pn(s).format(lt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(bm, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            N && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(ue, { name: N }),
              " ",
              u
            ] }) }),
            S && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(ue, { name: S }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ M.jsx(On, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(ue, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: wa.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            jt,
            {
              slotEnd: /* @__PURE__ */ M.jsx(ue, { name: "external-link" }),
              variant: "tertiary",
              className: wa.buttonLink,
              navigate: () => {
                F && a("voyado:message:external-link:opened", {
                  channel: F.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, eU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = Kz({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ M.jsx(wn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(Un, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ M.jsx(
        Z3,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Ws = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Rv = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = ns(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = pt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(ue, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(Ke, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      ue,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, nU = "_order_19t4p_1", tU = "_orderIsOpen_19t4p_9", rU = "_orderHeader_19t4p_12", iU = "_orderIconColor_19t4p_15", wr = {
  order: nU,
  orderIsOpen: tU,
  orderHeader: rU,
  orderIconColor: iU
}, aU = "_delivery_1m9nb_1", oU = "_deliveryCode_1m9nb_4", $u = {
  delivery: aU,
  deliveryCode: oU
}, sU = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Xt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      ue,
      {
        size: l,
        name: "eye",
        className: wr.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        Ke,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Pn(s).format(lt)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: $u.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(ue, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: ct($u.delivery, $u.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(Ke, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      ue,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, lU = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        ue,
        {
          size: 14,
          name: "file-text",
          className: wr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(He.Item, { className: nt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ws({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, cU = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        ue,
        {
          size: 14,
          name: "tag",
          className: wr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          Ke,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: Ws({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          Li,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, dU = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        ue,
        {
          size: 14,
          name: "credit-card",
          className: wr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: Pn(i?.paidAt).format(lt) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ws({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, uU = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: S
  } = e, N = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ct(wr.order, {
        [wr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: wr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Pn(m).format(lt) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              ue,
              {
                size: N,
                name: "activity",
                className: wr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(Ke, { content: "Internal status", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(Ke, { content: "External status", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(Ke, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: Pn(u).format(lt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              ue,
              {
                size: N,
                name: "chart-bar",
                className: wr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Ws({
                value: S,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              ue,
              {
                size: N,
                name: "channels",
                className: wr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(Rv, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            Rv,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ M.jsx(sU, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(cU, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(lU, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            dU,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, mU = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Ya({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(wn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: r }), pU = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), [r, i] = se([]), { track: a } = kn(), {
    loading: o,
    error: s,
    data: l
  } = n(Uz, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ M.jsx(Un, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsx(mU, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ M.jsx(
      uU,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, fU = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = Jz({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: S
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Ya({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(wn, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(P3, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(eU, { contactId: i }),
        v && /* @__PURE__ */ M.jsx(K3, { contactId: i }),
        S && /* @__PURE__ */ M.jsx(pU, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, hU = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Du = { exports: {} }, Ca = {}, Ov;
function yU() {
  if (Ov) return Ca;
  Ov = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ca.Fragment = r, Ca.jsx = s, Ca.jsxs = s, Ca;
}
var zo = {}, Pv;
function gU() {
  return Pv || (Pv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), S = Symbol.iterator, N = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = S && t[S] || t[N];
      return typeof c == "function" ? c : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        q("error", t, p);
      }
    }
    function q(t, c, p) {
      {
        var y = I.ReactDebugCurrentFrame, R = y.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(w) {
          return String(w);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, C = !1, D = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || $ || C || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return G(c) + ".Consumer";
          case s:
            var p = t;
            return G(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var R = t, L = R._payload, w = R._init;
            try {
              return P(w(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, ne = 0, ke, me, de, he, H, be, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function ze() {
      {
        if (ne === 0) {
          ke = console.log, me = console.info, de = console.warn, he = console.error, H = console.group, be = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function Be() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, t, {
              value: ke
            }),
            info: W({}, t, {
              value: me
            }),
            warn: W({}, t, {
              value: de
            }),
            error: W({}, t, {
              value: he
            }),
            group: W({}, t, {
              value: H
            }),
            groupCollapsed: W({}, t, {
              value: be
            }),
            groupEnd: W({}, t, {
              value: Ce
            })
          });
        }
        ne < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = I.ReactCurrentDispatcher, Me;
    function Ie(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (R) {
            var y = R.stack.trim().match(/\n( *(at )?)/);
            Me = y && y[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var Le = !1, De;
    {
      var rn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new rn();
    }
    function je(t, c) {
      if (!t || Le)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, ze();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var x = te.stack.split(`
`), E = y.stack.split(`
`), V = x.length - 1, z = E.length - 1; V >= 1 && z >= 0 && x[V] !== E[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (x[V] !== E[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || x[V] !== E[z]) {
                    var re = `
` + x[V].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = R;
      }
      var we = t ? t.displayName || t.name : "", ve = we ? Ie(we) : "";
      return typeof t == "function" && De.set(t, ve), ve;
    }
    function We(t, c, p) {
      return je(t, !1);
    }
    function Ge(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function pe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return je(t, Ge(t));
      if (typeof t == "string")
        return Ie(t);
      switch (t) {
        case m:
          return Ie("Suspense");
        case u:
          return Ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return pe(t.type, c, p);
          case h: {
            var y = t, R = y._payload, L = y._init;
            try {
              return pe(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Ne = {}, Ae = I.ReactDebugCurrentFrame;
    function Ee(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function cn(t, c, p, y, R) {
      {
        var L = Function.call.bind(le);
        for (var w in t)
          if (L(t, w)) {
            var x = void 0;
            try {
              if (typeof t[w] != "function") {
                var E = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              x = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              x = V;
            }
            x && !(x instanceof Error) && (Ee(R), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof x), Ee(null)), x instanceof Error && !(x.message in Ne) && (Ne[x.message] = !0, Ee(R), g("Failed %s type: %s", p, x.message), Ee(null));
          }
      }
    }
    var j = Array.isArray;
    function _(t) {
      return j(t);
    }
    function T(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function Y(t) {
      try {
        return X(t), !1;
      } catch {
        return !0;
      }
    }
    function X(t) {
      return "" + t;
    }
    function O(t) {
      if (Y(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", T(t)), X(t);
    }
    var B = I.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function dn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && B.current;
    }
    function sn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, p, y, R, L, w) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function yn(t, c, p, y, R) {
      {
        var L, w = {}, x = null, E = null;
        p !== void 0 && (O(p), x = "" + p), dn(c) && (O(c.key), x = "" + c.key), en(c) && (E = c.ref, tn(c));
        for (L in c)
          le.call(c, L) && !ie.hasOwnProperty(L) && (w[L] = c[L]);
        if (t && t.defaultProps) {
          var V = t.defaultProps;
          for (L in V)
            w[L] === void 0 && (w[L] = V[L]);
        }
        if (x || E) {
          var z = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && sn(w, z), E && fn(w, z);
        }
        return pn(t, x, E, R, y, B.current, w);
      }
    }
    var Xe = I.ReactCurrentOwner, gn = I.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = pe(t.type, t._source, c ? c.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function an(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var t = P(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var on = {};
    function Rn(t) {
      {
        var c = _n();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Rn(c);
        if (on[p])
          return;
        on[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Oe(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function vn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            an(y) && xn(y, c);
          }
        else if (an(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = F(t);
          if (typeof R == "function" && R !== t.entries)
            for (var L = R.call(t), w; !(w = L.next()).done; )
              an(w.value) && xn(w.value, c);
        }
      }
    }
    function Vn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          cn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var R = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function Sn(t, c, p, y, R, L) {
      {
        var w = ee(t);
        if (!w) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var E = Hn();
          E ? x += E : x += _n();
          var V;
          t === null ? V = "null" : _(t) ? V = "array" : t !== void 0 && t.$$typeof === n ? (V = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : V = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, x);
        }
        var z = yn(t, c, p, R, L);
        if (z == null)
          return z;
        if (w) {
          var re = c.children;
          if (re !== void 0)
            if (y)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  vn(re[we], t);
                Object.freeze && Object.freeze(re);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vn(re, t);
        }
        if (le.call(c, "key")) {
          var ve = P(t), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[ve + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, ve, In, ve), bn[ve + Ze] = !0;
          }
        }
        return t === i ? Mn(z) : Vn(z), z;
      }
    }
    function $n(t, c, p) {
      return Sn(t, c, p, !0);
    }
    function Ln(t, c, p) {
      return Sn(t, c, p, !1);
    }
    var Bn = Ln, qn = $n;
    zo.Fragment = i, zo.jsx = Bn, zo.jsxs = qn;
  })()), zo;
}
var Av;
function kU() {
  return Av || (Av = 1, process.env.NODE_ENV === "production" ? Du.exports = yU() : Du.exports = gU()), Du.exports;
}
var ce = kU();
const vU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, bU = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": vU
};
function _U(e) {
  return bU[e] ?? {};
}
const xU = _U(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), SU = "_copyIcon_nr4rl_48", NU = "_list_nr4rl_53", jU = "_listItem_nr4rl_63", $r = {
  copyIcon: SU,
  list: NU,
  listItem: jU
}, En = ({
  description: e,
  content: n,
  tooltip: r
}) => {
  if (n == null)
    return null;
  const i = jS(n);
  return /* @__PURE__ */ ce.jsx(He.Text, { variant: "dense", className: $r.listItem, children: /* @__PURE__ */ ce.jsx(Ke, { content: r, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : rb(n)
  ] }) }) });
}, Lv = ({
  channel: e
}) => {
  const n = (a) => ws(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: r } = e, i = "suppressions" in r && !!r.suppressions;
  return /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
    /* @__PURE__ */ ce.jsx(He.Text, { variant: "dense", className: $r.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(r?.timestamp).format(lt) }),
        r?.consent && /* @__PURE__ */ ce.jsx(Un, { variant: "primary", size: "small", children: n(r?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ ce.jsx(He.Text, { variant: "dense", className: $r.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r.suppressions?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Pn(r.suppressions?.timestamp).format(
          lt
        ) }),
        r.suppressions?.suppression_reason && /* @__PURE__ */ ce.jsx(Un, { variant: "warning", size: "small", children: r.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, wU = "_channelHeadline_yeqqp_1", Vv = {
  channelHeadline: wU
}, CU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: r, yotpo_sms: i } = e;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Vv.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "mail" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ ce.jsxs(He, { className: $r.list, children: [
        /* @__PURE__ */ ce.jsx(Lv, { channel: n?.email }),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: r?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: r?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: r?.last_delivered
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: r?.last_opened
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: r?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: r?.last_converted
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: r?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Vv.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ ce.jsxs(He, { className: $r.list, children: [
        /* @__PURE__ */ ce.jsx(Lv, { channel: n?.sms }),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          En,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, FU = "_wrapper_1xucg_1", IU = "_externalLink_1xucg_7", Ru = {
  wrapper: FU,
  externalLink: IU
}, EU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Xt(), { isCopied: i, copy: a } = Xt(), { isCopied: o, copy: s } = Xt();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: d,
    address: m,
    email: u,
    phone_number: f,
    account_created_at: h,
    account_status: v,
    accepts_sms_marketing: S,
    accepts_email_marketing: N
  } = e, F = 14, I = `${l || ""} ${d || ""}`.trim() || "A customer has no name", {
    address1: g,
    address2: q,
    city: $,
    company: C,
    state: D,
    zip: U,
    province_code: Z,
    country_code: Q
  } = m || {}, ee = [
    g,
    q,
    [U, $].filter(Boolean).join(", "),
    [Q, D, Z].filter(Boolean).join(", "),
    C
  ].filter(Boolean);
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { className: Ru.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Ru.block,
        alignItems: "center",
        children: /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-2", children: I })
      }
    ),
    h && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: Pn(h).format(lt) })
    ] }),
    u && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: F, name: "mail" }),
        /* @__PURE__ */ ce.jsx("span", { className: Ru.externalLink, children: u })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy email", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: F,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: $r.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: F, name: "phone" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy phone number", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: F,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: $r.copyIcon
        }
      ) }) })
    ] }),
    (g || $ || C || D || U || Q) && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: F, name: "home" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: ee.map((J) => /* @__PURE__ */ ce.jsx(Jn, { children: J }, J)) })
      ] }),
      /* @__PURE__ */ ce.jsx(Ke, { content: "Copy address", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: F,
          name: o ? "done" : "copy",
          onClick: () => s(ee.join(", ")),
          className: $r.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: F, name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: S ? "check-circle-filled" : "close-circle-filled",
          color: S ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: F, name: "paper-plane" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: N ? "check-circle-filled" : "close-circle-filled",
          color: N ? "green.500" : "red.500"
        }
      )
    ] }),
    v && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: F, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ ce.jsx(On, { children: ws(v) })
    ] })
  ] }) });
}, TU = ({
  loyalty: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ ce.jsxs(He, { className: $r.list, children: [
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), $U = ({ tags: e }) => {
  const n = e?.split(","), r = n && n.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !r && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    r && /* @__PURE__ */ ce.jsx(b, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ ce.jsx(On, { children: i }, a)) })
  ] });
}, DU = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ ce.jsxs(He, { className: $r.list, children: [
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Pn(e.last_review_date).format(
          lt
        )
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ ce.jsx(
      En,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ ce.jsx(Un, { variant: "info", size: "small", children: /* @__PURE__ */ ce.jsx(ce.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), RU = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = mn(), { track: i } = kn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showTags ?? !1, S = n?.showChannels ?? !1, N = n?.showUserGeneratedContent ?? !1, F = n?.displayLoyalty ?? !1, I = n?.displayEmailData ?? !1, g = n?.displaySmsData ?? !1, q = n?.displaySubscriptions ?? !1, $ = !h && !v && !S && !N && !F && !I && !g && !q, {
    loading: C,
    error: D,
    data: U
  } = r(xU, {
    skip: !d || !f,
    variables: {
      ...d && { email: d },
      // eslint-disable-next-line camelcase
      ...!d && m && { phone_number: m },
      storeId: f,
      expand: "all"
    }
  });
  if (qe(() => {
    const Z = U?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [U?.Yotpo, C]), u)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (s)
    return /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if ($)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (D) {
    const Z = D.graphQLErrors;
    return gm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : km({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ce.jsx(wn, { error: D });
  }
  return C ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ce.jsx(un, {}) }) : /* @__PURE__ */ ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ce.jsx(EU, { customerDetails: a }),
        v && /* @__PURE__ */ ce.jsx($U, { tags: a?.tags }),
        S && /* @__PURE__ */ ce.jsx(CU, { customerDetails: a }),
        N && /* @__PURE__ */ ce.jsx(
          DU,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        F && /* @__PURE__ */ ce.jsx(TU, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var lo = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, Ot = (e) => e == null;
const Gx = (e) => typeof e == "object";
var st = (e) => !Ot(e) && !Array.isArray(e) && Gx(e) && !ci(e), Yx = (e) => st(e) && e.target ? lo(e.target) ? e.target.checked : e.target.value : e, OU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Jx = (e, n) => e.has(OU(n)), PU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, Ep = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Nt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ep && (e instanceof Blob || i)) && (r || st(e)))
    if (n = r ? [] : {}, !r && !PU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Nt(e[a]));
  else
    return e;
  return n;
}
var Ks = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Qe = (e, n, r) => {
  if (!n || !st(e))
    return r;
  const i = Ks(n.split(/[,[\].]+?/)).reduce((a, o) => Ot(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? r : e[n] : i;
}, Qt = (e) => typeof e == "boolean", Tp = (e) => /^\w*$/.test(e), Qx = (e) => Ks(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Tp(n) ? [n] : Qx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const xs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, yr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, AU = Se.createContext(null), $p = () => Se.useContext(AU);
var Xx = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== yr.all && (n._proxyFormState[s] = !i || yr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function LU(e) {
  const n = $p(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => Xx(s, r, d.current, !1), [s, r]);
}
var Tr = (e) => typeof e == "string", Zx = (e, n, r, i, a) => Tr(e) ? (i && n.watch.add(e), Qe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Qe(r, o))) : (i && (n.watchAll = !0), r);
function eS(e) {
  const n = $p(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Zx(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function VU(e) {
  const n = $p(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Jx(a._names.array, r), l = eS({
    control: a,
    name: r,
    defaultValue: Qe(a._formValues, r, Qe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = LU({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Qt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((F) => u.current.onChange({
    target: {
      value: Yx(F),
      name: r
    },
    type: xs.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Qe(a._formValues, r),
      name: r
    },
    type: xs.BLUR
  }), [r, a._formValues]), S = Se.useCallback((F) => {
    const I = Qe(a._fields, r);
    I && F && (I._f.ref = {
      focus: () => F.focus(),
      select: () => F.select(),
      setCustomValidity: (g) => F.setCustomValidity(g),
      reportValidity: () => F.reportValidity()
    });
  }, [a._fields, r]), N = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Qt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: S
  }), [r, i, d.disabled, h, v, S, l]);
  return Se.useEffect(() => {
    const F = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Qt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const I = (g, q) => {
      const $ = Qe(a._fields, g);
      $ && $._f && ($._f.mount = q);
    };
    if (I(r, !0), F) {
      const g = Nt(Qe(a._options.defaultValues, r));
      Yn(a._defaultValues, r, g), it(Qe(a._formValues, r)) && Yn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? F && !a._state.action : F) ? a.unregister(r) : I(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const zv = (e) => e.render(VU(e));
var zU = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ua = (e) => Array.isArray(e) ? e : [e], Uv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ym = (e) => Ot(e) || !Gx(e);
function Jr(e, n) {
  if (ym(e) || ym(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !Jr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var $t = (e) => st(e) && !Object.keys(e).length, Dp = (e) => e.type === "file", gr = (e) => typeof e == "function", Ss = (e) => {
  if (!Ep)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, nS = (e) => e.type === "select-multiple", Rp = (e) => e.type === "radio", UU = (e) => Rp(e) || lo(e), Ou = (e) => Ss(e) && e.isConnected;
function MU(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function BU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const r = Array.isArray(n) ? n : Tp(n) ? [n] : Qx(n), i = r.length === 1 ? e : MU(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (st(i) && $t(i) || Array.isArray(i) && BU(i)) && yt(e, r.slice(0, -1)), e;
}
var tS = (e) => {
  for (const n in e)
    if (gr(e[n]))
      return !0;
  return !1;
};
function Ns(e, n = {}) {
  const r = Array.isArray(e);
  if (st(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !tS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ns(e[i], n[i])) : Ot(e[i]) || (n[i] = !0);
  return n;
}
function rS(e, n, r) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !tS(e[a]) ? it(n) || ym(r[a]) ? r[a] = Array.isArray(e[a]) ? Ns(e[a], []) : { ...Ns(e[a]) } : rS(e[a], Ot(n) ? {} : n[a], r[a]) : r[a] = !Jr(e[a], n[a]);
  return r;
}
var Fa = (e, n) => rS(e, n, Ns(n));
const Mv = {
  value: !1,
  isValid: !1
}, Bv = { value: !0, isValid: !0 };
var iS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? Bv : { value: e[0].value, isValid: !0 } : Bv
    ) : Mv;
  }
  return Mv;
}, aS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : r && Tr(e) ? new Date(e) : i ? i(e) : e;
const qv = {
  isValid: !1,
  value: null
};
var oS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, qv) : qv;
function Hv(e) {
  const n = e.ref;
  return Dp(n) ? n.files : Rp(n) ? oS(e.refs).value : nS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : lo(n) ? iS(e.refs).value : aS(it(n.value) ? e.ref.value : n.value, e);
}
var qU = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Qe(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, js = (e) => e instanceof RegExp, Ia = (e) => it(e) ? e : js(e) ? e.source : st(e) ? js(e.value) ? e.value.source : e.value : e, Wv = (e) => ({
  isOnSubmit: !e || e === yr.onSubmit,
  isOnBlur: e === yr.onBlur,
  isOnChange: e === yr.onChange,
  isOnAll: e === yr.all,
  isOnTouch: e === yr.onTouched
});
const Kv = "AsyncFunction";
var HU = (e) => !!e && !!e.validate && !!(gr(e.validate) && e.validate.constructor.name === Kv || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Kv)), WU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Gv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ma = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Qe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ma(l, n))
          break;
      } else if (st(l) && Ma(l, n))
        break;
    }
  }
};
function Yv(e, n, r) {
  const i = Qe(e, r);
  if (i || Tp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Qe(n, o), l = Qe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var KU = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return $t(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || yr.all));
}, GU = (e, n, r) => !e || !n || e === n || Ua(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), YU = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, JU = (e, n) => !Ks(Qe(e, n)).length && yt(e, n), QU = (e, n, r) => {
  const i = Ua(Qe(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, rs = (e) => Tr(e);
function Jv(e, n, r = "validate") {
  if (rs(e) || Array.isArray(e) && e.every(rs) || Qt(e) && !e)
    return {
      type: r,
      message: rs(e) ? e : "",
      ref: n
    };
}
var wi = (e) => st(e) && !js(e) ? e : {
  value: e,
  message: ""
}, Qv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: S, name: N, valueAsNumber: F, mount: I } = e._f, g = Qe(r, N);
  if (!I || n.has(N))
    return {};
  const q = l ? l[0] : s, $ = (G) => {
    a && q.reportValidity && (q.setCustomValidity(Qt(G) ? "" : G || ""), q.reportValidity());
  }, C = {}, D = Rp(s), U = lo(s), Z = D || U, Q = (F || Dp(s)) && it(s.value) && it(g) || Ss(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = zU.bind(null, N, i, C), J = (G, P, W, ne = Ur.maxLength, ke = Ur.minLength) => {
    const me = G ? P : W;
    C[N] = {
      type: G ? ne : ke,
      message: me,
      ref: s,
      ...ee(G ? ne : ke, me)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!Z && (Q || Ot(g)) || Qt(g) && !g || U && !iS(l).isValid || D && !oS(l).isValid)) {
    const { value: G, message: P } = rs(d) ? { value: !!d, message: d } : wi(d);
    if (G && (C[N] = {
      type: Ur.required,
      message: P,
      ref: q,
      ...ee(Ur.required, P)
    }, !i))
      return $(P), C;
  }
  if (!Q && (!Ot(f) || !Ot(h))) {
    let G, P;
    const W = wi(h), ne = wi(f);
    if (!Ot(g) && !isNaN(g)) {
      const ke = s.valueAsNumber || g && +g;
      Ot(W.value) || (G = ke > W.value), Ot(ne.value) || (P = ke < ne.value);
    } else {
      const ke = s.valueAsDate || new Date(g), me = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), de = s.type == "time", he = s.type == "week";
      Tr(W.value) && g && (G = de ? me(g) > me(W.value) : he ? g > W.value : ke > new Date(W.value)), Tr(ne.value) && g && (P = de ? me(g) < me(ne.value) : he ? g < ne.value : ke < new Date(ne.value));
    }
    if ((G || P) && (J(!!G, W.message, ne.message, Ur.max, Ur.min), !i))
      return $(C[N].message), C;
  }
  if ((m || u) && !Q && (Tr(g) || o && Array.isArray(g))) {
    const G = wi(m), P = wi(u), W = !Ot(G.value) && g.length > +G.value, ne = !Ot(P.value) && g.length < +P.value;
    if ((W || ne) && (J(W, G.message, P.message), !i))
      return $(C[N].message), C;
  }
  if (v && !Q && Tr(g)) {
    const { value: G, message: P } = wi(v);
    if (js(G) && !g.match(G) && (C[N] = {
      type: Ur.pattern,
      message: P,
      ref: s,
      ...ee(Ur.pattern, P)
    }, !i))
      return $(P), C;
  }
  if (S) {
    if (gr(S)) {
      const G = await S(g, r), P = Jv(G, q);
      if (P && (C[N] = {
        ...P,
        ...ee(Ur.validate, P.message)
      }, !i))
        return $(P.message), C;
    } else if (st(S)) {
      let G = {};
      for (const P in S) {
        if (!$t(G) && !i)
          break;
        const W = Jv(await S[P](g, r), q, P);
        W && (G = {
          ...W,
          ...ee(P, W.message)
        }, $(W.message), i && (C[N] = G));
      }
      if (!$t(G) && (C[N] = {
        ref: q,
        ...G
      }, !i))
        return C;
    }
  }
  return $(!0), C;
};
const XU = {
  mode: yr.onSubmit,
  reValidateMode: yr.onChange,
  shouldFocusError: !0
};
function ZU(e = {}) {
  let n = {
    ...XU,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: gr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? Nt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Nt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Uv(),
    state: Uv()
  }, v = Wv(n.mode), S = Wv(n.reValidateMode), N = n.criteriaMode === yr.all, F = (j) => (_) => {
    clearTimeout(m), m = setTimeout(j, _);
  }, I = async (j) => {
    if (!n.disabled && (u.isValid || f.isValid || j)) {
      const _ = n.resolver ? $t((await Q()).errors) : await J(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (j, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((j || Array.from(l.mount)).forEach((T) => {
      T && (_ ? Yn(r.validatingFields, T, _) : yt(r.validatingFields, T));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !$t(r.validatingFields)
    }));
  }, q = (j, _ = [], T, Y, X = !0, O = !0) => {
    if (Y && T && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Qe(i, j))) {
        const B = T(Qe(i, j), Y.argA, Y.argB);
        X && Yn(i, j, B);
      }
      if (O && Array.isArray(Qe(r.errors, j))) {
        const B = T(Qe(r.errors, j), Y.argA, Y.argB);
        X && Yn(r.errors, j, B), JU(r.errors, j);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Qe(r.touchedFields, j))) {
        const B = T(Qe(r.touchedFields, j), Y.argA, Y.argB);
        X && Yn(r.touchedFields, j, B);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Fa(a, o)), h.state.next({
        name: j,
        isDirty: P(j, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, j, _);
  }, $ = (j, _) => {
    Yn(r.errors, j, _), h.state.next({
      errors: r.errors
    });
  }, C = (j) => {
    r.errors = j, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (j, _, T, Y) => {
    const X = Qe(i, j);
    if (X) {
      const O = Qe(o, j, it(T) ? Qe(a, j) : T);
      it(O) || Y && Y.defaultChecked || _ ? Yn(o, j, _ ? O : Hv(X._f)) : ke(j, O), s.mount && I();
    }
  }, U = (j, _, T, Y, X) => {
    let O = !1, B = !1;
    const ie = {
      name: j
    };
    if (!n.disabled) {
      if (!T || Y) {
        (u.isDirty || f.isDirty) && (B = r.isDirty, r.isDirty = ie.isDirty = P(), O = B !== ie.isDirty);
        const fe = Jr(Qe(a, j), _);
        B = !!Qe(r.dirtyFields, j), fe ? yt(r.dirtyFields, j) : Yn(r.dirtyFields, j, !0), ie.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && B !== !fe;
      }
      if (T) {
        const fe = Qe(r.touchedFields, j);
        fe || (Yn(r.touchedFields, j, T), ie.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== T);
      }
      O && X && h.state.next(ie);
    }
    return O ? ie : {};
  }, Z = (j, _, T, Y) => {
    const X = Qe(r.errors, j), O = (u.isValid || f.isValid) && Qt(_) && r.isValid !== _;
    if (n.delayError && T ? (d = F(() => $(j, T)), d(n.delayError)) : (clearTimeout(m), d = null, T ? Yn(r.errors, j, T) : yt(r.errors, j)), (T ? !Jr(X, T) : X) || !$t(Y) || O) {
      const B = {
        ...Y,
        ...O && Qt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: j
      };
      r = {
        ...r,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (j) => {
    g(j, !0);
    const _ = await n.resolver(o, n.context, qU(j || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(j), _;
  }, ee = async (j) => {
    const { errors: _ } = await Q(j);
    if (j)
      for (const T of j) {
        const Y = Qe(_, T);
        Y ? Yn(r.errors, T, Y) : yt(r.errors, T);
      }
    else
      r.errors = _;
    return _;
  }, J = async (j, _, T = {
    valid: !0
  }) => {
    for (const Y in j) {
      const X = j[Y];
      if (X) {
        const { _f: O, ...B } = X;
        if (O) {
          const ie = l.array.has(O.name), fe = X._f && HU(X._f);
          fe && u.validatingFields && g([Y], !0);
          const _e = await Qv(X, l.disabled, o, N, n.shouldUseNativeValidation && !_, ie);
          if (fe && u.validatingFields && g([Y]), _e[O.name] && (T.valid = !1, _))
            break;
          !_ && (Qe(_e, O.name) ? ie ? QU(r.errors, _e, O.name) : Yn(r.errors, O.name, _e[O.name]) : yt(r.errors, O.name));
        }
        !$t(B) && await J(B, _, T);
      }
    }
    return T.valid;
  }, G = () => {
    for (const j of l.unMount) {
      const _ = Qe(i, j);
      _ && (_._f.refs ? _._f.refs.every((T) => !Ou(T)) : !Ou(_._f.ref)) && Le(j);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (j, _) => !n.disabled && (j && _ && Yn(o, j, _), !Jr(Ce(), a)), W = (j, _, T) => Zx(j, l, {
    ...s.mount ? o : it(_) ? a : Tr(j) ? { [j]: _ } : _
  }, T, _), ne = (j) => Ks(Qe(s.mount ? o : a, j, n.shouldUnregister ? Qe(a, j, []) : [])), ke = (j, _, T = {}) => {
    const Y = Qe(i, j);
    let X = _;
    if (Y) {
      const O = Y._f;
      O && (!O.disabled && Yn(o, j, aS(_, O)), X = Ss(O.ref) && Ot(_) ? "" : _, nS(O.ref) ? [...O.ref.options].forEach((B) => B.selected = X.includes(B.value)) : O.refs ? lo(O.ref) ? O.refs.length > 1 ? O.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((ie) => ie === B.value) : X === B.value)) : O.refs[0] && (O.refs[0].checked = !!X) : O.refs.forEach((B) => B.checked = B.value === X) : Dp(O.ref) ? O.ref.value = "" : (O.ref.value = X, O.ref.type || h.state.next({
        name: j,
        values: Nt(o)
      })));
    }
    (T.shouldDirty || T.shouldTouch) && U(j, X, T.shouldTouch, T.shouldDirty, !0), T.shouldValidate && be(j);
  }, me = (j, _, T) => {
    for (const Y in _) {
      const X = _[Y], O = `${j}.${Y}`, B = Qe(i, O);
      (l.array.has(j) || st(X) || B && !B._f) && !ci(X) ? me(O, X, T) : ke(O, X, T);
    }
  }, de = (j, _, T = {}) => {
    const Y = Qe(i, j), X = l.array.has(j), O = Nt(_);
    Yn(o, j, O), X ? (h.array.next({
      name: j,
      values: Nt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && T.shouldDirty && h.state.next({
      name: j,
      dirtyFields: Fa(a, o),
      isDirty: P(j, O)
    })) : Y && !Y._f && !Ot(O) ? me(j, O, T) : ke(j, O, T), Gv(j, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? j : void 0,
      values: Nt(o)
    });
  }, he = async (j) => {
    s.mount = !0;
    const _ = j.target;
    let T = _.name, Y = !0;
    const X = Qe(i, T), O = (B) => {
      Y = Number.isNaN(B) || ci(B) && isNaN(B.getTime()) || Jr(B, Qe(o, T, B));
    };
    if (X) {
      let B, ie;
      const fe = _.type ? Hv(X._f) : Yx(j), _e = j.type === xs.BLUR || j.type === xs.FOCUS_OUT, en = !WU(X._f) && !n.resolver && !Qe(r.errors, T) && !X._f.deps || YU(_e, Qe(r.touchedFields, T), r.isSubmitted, S, v), dn = Gv(T, l, _e);
      Yn(o, T, fe), _e ? (X._f.onBlur && X._f.onBlur(j), d && d(0)) : X._f.onChange && X._f.onChange(j);
      const tn = U(T, fe, _e), sn = !$t(tn) || dn;
      if (!_e && h.state.next({
        name: T,
        type: j.type,
        values: Nt(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? _e && I() : _e || I()), sn && h.state.next({ name: T, ...dn ? {} : tn });
      if (!_e && dn && h.state.next({ ...r }), n.resolver) {
        const { errors: fn } = await Q([T]);
        if (O(fe), Y) {
          const pn = Yv(r.errors, i, T), yn = Yv(fn, i, pn.name || T);
          B = yn.error, T = yn.name, ie = $t(fn);
        }
      } else
        g([T], !0), B = (await Qv(X, l.disabled, o, N, n.shouldUseNativeValidation))[T], g([T]), O(fe), Y && (B ? ie = !1 : (u.isValid || f.isValid) && (ie = await J(i, !0)));
      Y && (X._f.deps && be(X._f.deps), Z(T, ie, B, tn));
    }
  }, H = (j, _) => {
    if (Qe(r.errors, _) && j.focus)
      return j.focus(), 1;
  }, be = async (j, _ = {}) => {
    let T, Y;
    const X = Ua(j);
    if (n.resolver) {
      const O = await ee(it(j) ? j : X);
      T = $t(O), Y = j ? !X.some((B) => Qe(O, B)) : T;
    } else j ? (Y = (await Promise.all(X.map(async (O) => {
      const B = Qe(i, O);
      return await J(B && B._f ? { [O]: B } : B);
    }))).every(Boolean), !(!Y && !r.isValid) && I()) : Y = T = await J(i);
    return h.state.next({
      ...!Tr(j) || (u.isValid || f.isValid) && T !== r.isValid ? {} : { name: j },
      ...n.resolver || !j ? { isValid: T } : {},
      errors: r.errors
    }), _.shouldFocus && !Y && Ma(i, H, j ? X : l.mount), Y;
  }, Ce = (j) => {
    const _ = {
      ...s.mount ? o : a
    };
    return it(j) ? _ : Tr(j) ? Qe(_, j) : j.map((T) => Qe(_, T));
  }, K = (j, _) => ({
    invalid: !!Qe((_ || r).errors, j),
    isDirty: !!Qe((_ || r).dirtyFields, j),
    error: Qe((_ || r).errors, j),
    isValidating: !!Qe(r.validatingFields, j),
    isTouched: !!Qe((_ || r).touchedFields, j)
  }), ze = (j) => {
    j && Ua(j).forEach((_) => yt(r.errors, _)), h.state.next({
      errors: j ? r.errors : {}
    });
  }, Be = (j, _, T) => {
    const Y = (Qe(i, j, { _f: {} })._f || {}).ref, X = Qe(r.errors, j) || {}, { ref: O, message: B, type: ie, ...fe } = X;
    Yn(r.errors, j, {
      ...fe,
      ..._,
      ref: Y
    }), h.state.next({
      name: j,
      errors: r.errors,
      isValid: !1
    }), T && T.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (j, _) => gr(j) ? h.state.subscribe({
    next: (T) => j(W(void 0, _), T)
  }) : W(j, _, !0), Me = (j) => h.state.subscribe({
    next: (_) => {
      GU(j.name, _.name, j.exact) && KU(_, j.formState || u, Ee, j.reRenderRoot) && j.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, Ie = (j) => (s.mount = !0, f = {
    ...f,
    ...j.formState
  }, Me({
    ...j,
    formState: f
  })), Le = (j, _ = {}) => {
    for (const T of j ? Ua(j) : l.mount)
      l.mount.delete(T), l.array.delete(T), _.keepValue || (yt(i, T), yt(o, T)), !_.keepError && yt(r.errors, T), !_.keepDirty && yt(r.dirtyFields, T), !_.keepTouched && yt(r.touchedFields, T), !_.keepIsValidating && yt(r.validatingFields, T), !n.shouldUnregister && !_.keepDefaultValue && yt(a, T);
    h.state.next({
      values: Nt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: P() } : {}
    }), !_.keepIsValid && I();
  }, De = ({ disabled: j, name: _ }) => {
    (Qt(j) && s.mount || j || l.disabled.has(_)) && (j ? l.disabled.add(_) : l.disabled.delete(_));
  }, rn = (j, _ = {}) => {
    let T = Qe(i, j);
    const Y = Qt(_.disabled) || Qt(n.disabled);
    return Yn(i, j, {
      ...T || {},
      _f: {
        ...T && T._f ? T._f : { ref: { name: j } },
        name: j,
        mount: !0,
        ..._
      }
    }), l.mount.add(j), T ? De({
      disabled: Qt(_.disabled) ? _.disabled : n.disabled,
      name: j
    }) : D(j, !0, _.value), {
      ...Y ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ia(_.min),
        max: Ia(_.max),
        minLength: Ia(_.minLength),
        maxLength: Ia(_.maxLength),
        pattern: Ia(_.pattern)
      } : {},
      name: j,
      onChange: he,
      onBlur: he,
      ref: (X) => {
        if (X) {
          rn(j, _), T = Qe(i, j);
          const O = it(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = UU(O), ie = T._f.refs || [];
          if (B ? ie.find((fe) => fe === O) : O === T._f.ref)
            return;
          Yn(i, j, {
            _f: {
              ...T._f,
              ...B ? {
                refs: [
                  ...ie.filter(Ou),
                  O,
                  ...Array.isArray(Qe(a, j)) ? [{}] : []
                ],
                ref: { type: O.type, name: j }
              } : { ref: O }
            }
          }), D(j, !1, void 0, O);
        } else
          T = Qe(i, j, {}), T._f && (T._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(Jx(l.array, j) && s.action) && l.unMount.add(j);
      }
    };
  }, je = () => n.shouldFocusError && Ma(i, H, l.mount), We = (j) => {
    Qt(j) && (h.state.next({ disabled: j }), Ma(i, (_, T) => {
      const Y = Qe(i, T);
      Y && (_.disabled = Y._f.disabled || j, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || j;
      }));
    }, 0, !1));
  }, Ge = (j, _) => async (T) => {
    let Y;
    T && (T.preventDefault && T.preventDefault(), T.persist && T.persist());
    let X = Nt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: B } = await Q();
      r.errors = O, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Yn(X, O, void 0);
    if (yt(r.errors, "root"), $t(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await j(X, T);
      } catch (O) {
        Y = O;
      }
    } else
      _ && await _({ ...r.errors }, T), je(), setTimeout(je);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: $t(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, pe = (j, _ = {}) => {
    Qe(i, j) && (it(_.defaultValue) ? de(j, Nt(Qe(a, j))) : (de(j, _.defaultValue), Yn(a, j, Nt(_.defaultValue))), _.keepTouched || yt(r.touchedFields, j), _.keepDirty || (yt(r.dirtyFields, j), r.isDirty = _.defaultValue ? P(j, Nt(Qe(a, j))) : P()), _.keepError || (yt(r.errors, j), u.isValid && I()), h.state.next({ ...r }));
  }, le = (j, _ = {}) => {
    const T = j ? Nt(j) : a, Y = Nt(T), X = $t(j), O = X ? a : Y;
    if (_.keepDefaultValues || (a = T), !_.keepValues) {
      if (_.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Fa(a, o))
        ]);
        for (const ie of Array.from(B))
          Qe(r.dirtyFields, ie) ? Yn(O, ie, Qe(o, ie)) : de(ie, Qe(O, ie));
      } else {
        if (Ep && it(j))
          for (const B of l.mount) {
            const ie = Qe(i, B);
            if (ie && ie._f) {
              const fe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (Ss(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          de(B, Qe(O, B));
      }
      o = Nt(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: X ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Jr(j, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: X ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Fa(a, o) : r.dirtyFields : _.keepDefaultValues && j ? Fa(a, j) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ne = (j, _) => le(gr(j) ? j(o) : j, _), Ae = (j, _ = {}) => {
    const T = Qe(i, j), Y = T && T._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), _.shouldSelect && gr(X.select) && X.select());
    }
  }, Ee = (j) => {
    r = {
      ...r,
      ...j
    };
  }, cn = {
    control: {
      register: rn,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Ge,
      setError: Be,
      _subscribe: Me,
      _runSchema: Q,
      _getWatch: W,
      _getDirty: P,
      _setValid: I,
      _setFieldArray: q,
      _setDisabledField: De,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: le,
      _resetDefaultValues: () => gr(n.defaultValues) && n.defaultValues().then((j) => {
        Ne(j, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: G,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(j) {
        s = j;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(j) {
        l = j;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(j) {
        n = {
          ...n,
          ...j
        };
      }
    },
    subscribe: Ie,
    trigger: be,
    register: rn,
    handleSubmit: Ge,
    watch: Pe,
    setValue: de,
    getValues: Ce,
    reset: Ne,
    resetField: pe,
    clearErrors: ze,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...cn,
    formControl: cn
  };
}
function e4(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: gr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: gr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : ZU(e),
    formState: i
  }, e.formControl && e.defaultValues && !gr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Jr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !$t(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Xx(i, o), n.current;
}
const n4 = "_settingsWrapper_1ycvy_1", t4 = "_settingsWrapperHeader_1ycvy_6", r4 = "_settingsWrapperContent_1ycvy_10", i4 = "_settingsWrapperContentCode_1ycvy_18", a4 = "_settingsWrapperContentCURL_1ycvy_26", Ea = {
  settingsWrapper: n4,
  settingsWrapperHeader: t4,
  settingsWrapperContent: r4,
  settingsWrapperContentCode: i4,
  settingsWrapperContentCURL: a4
}, o4 = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = Xt(), { control: o } = e4({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = eS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = pt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsx(nn, { span: 6, children: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", className: Ea.settingsWrapper, children: [
    /* @__PURE__ */ ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Ea.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ ce.jsx(ue, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: Ea.settingsWrapperContent,
        children: [
          /* @__PURE__ */ ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ce.jsx(
            Ja,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ ce.jsxs("ol", { children: [
                /* @__PURE__ */ ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ ce.jsx("span", { className: Ea.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ ce.jsx(
            zv,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                ir,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ ce.jsx(
            zv,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                ir,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
            /* @__PURE__ */ ce.jsx(An, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Ea.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ ce.jsx(
              Ke,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ ce.jsx(
                  Wn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, s4 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], l4 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Ga
  }
], c4 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: o4
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], d4 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, u4 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, m4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: hL,
  featureSettings: []
} : n ? {
  authSettings: yL,
  featureSettings: [...Fx]
} : e ? {
  authSettings: [
    ...Zk,
    ...pL
  ],
  featureSettings: [...ev]
} : {
  authSettings: [
    ...Zk,
    ...fL
  ],
  featureSettings: [...ev]
}, p4 = ({
  hasYotpoOAuth: e = !1,
  isCreationMode: n = !1
}) => e || n ? l4 : c4, sS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = u4(a?.value, r), s = i !== void 0 ? i : d4(
    r
  );
  return o !== void 0 ? o : s;
}, lS = (e = {
  SHOPIFY: {},
  YOTPO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r } = e, {
    authSettings: i,
    featureSettings: a
  } = m4(n), o = p4(r);
  return {
    SHOPIFY: {
      widget: gz,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...i,
        ...a
      ]
    },
    JIRA: {
      widget: CF,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...Jf ? [...Jf] : []
      ]
    },
    GITHUB: {
      widget: $C,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...DC]
    },
    MIUROS: {
      widget: RP,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...OP]
    },
    KLAVIYO: {
      widget: UI,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...MI]
    },
    LINEAR: {
      widget: pO,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...fO]
    },
    VOYADO: {
      widget: fU,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...hU]
    },
    LOYALTYLION: {
      widget: HO,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...WO]
    },
    RECHARGE: {
      widget: oA,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...sA]
    },
    BRAZE: {
      widget: Bj,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...qj]
    },
    YOTPO: {
      widget: RU,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...o, ...s4]
    },
    INGRID: {
      widget: a1,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...o1]
    }
  };
}, f4 = (e) => {
  const n = lS();
  return e.map(
    ({ id: r, type: i, name: a, settings: o, misconfigured: s }) => {
      const d = n[i], { settingsConfiguration: m } = d, u = m?.filter(({ secret: f }) => !f)?.map(
        ({
          key: f,
          type: h,
          defaultValue: v
        }) => ({
          key: f,
          value: sS({
            key: f,
            configuration: o,
            settingType: h,
            settingDefault: v
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: u,
        misconfigured: s,
        icon: d.icon,
        iconColors: d.iconColors,
        widget: d.widget
      };
    }
  );
}, uM = ({
  configuration: e,
  conversationContext: n,
  showNotification: r,
  onToggleFn: i,
  isOpenFn: a,
  isMinimized: o
}) => {
  const { track: s } = kn(), { isLoading: l, widgets: d } = hj(
    e.baseUrl
  ), [m, u] = se([]);
  qe(() => {
    if (d?.length && !l) {
      const g = d.filter((q) => e.featureFlags[q.type]).filter((q) => q.enabled);
      u(
        // Mapping the widget from the backend (`widgets`) to our
        // `widgetDefinitions` configuration
        f4(g)
      );
    }
  }, [l]);
  const f = {
    headline: "",
    text: "",
    onConfirm: () => I(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [h, v] = se(f), [S, N] = se(!1), F = (g) => {
    N(!0), v(g);
  }, I = () => {
    N(!1), v(f);
  };
  return /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    m.sort((g, q) => g.name.localeCompare(q.name)).map(
      ({
        id: g,
        name: q,
        type: $,
        widget: C,
        settings: D,
        misconfigured: U,
        icon: Z,
        iconColors: Q
      }) => {
        const ee = `partner-integration-${g}`, J = `partner-integration-${$}`, G = /* @__PURE__ */ Ue.jsx(_m, { icon: Z, color: Q }), P = D?.reduce(
          (W, ne) => (W[ne.key] = ne.value, W),
          {}
        );
        return o ? /* @__PURE__ */ Ue.jsx("div", { className: "icon-holder", children: G }, `partner-icon-${g}`) : /* @__PURE__ */ Ue.jsxs(
          rr,
          {
            onToggle: () => {
              s(
                a(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: g,
                  widgetType: $.toLowerCase()
                }
              ), i(ee);
            },
            isOpen: a(ee),
            className: J,
            children: [
              /* @__PURE__ */ Ue.jsx(rr.Header, { avatar: G, children: q }),
              /* @__PURE__ */ Ue.jsx(rr.Content, { children: U ? /* @__PURE__ */ Ue.jsx(wn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ue.jsx(
                ob.Provider,
                {
                  value: {
                    onError: (W, ne) => console.warn(
                      `Something went wrong with a partner widget of type '${$}' and id '${g}'`,
                      W,
                      ne
                    )
                  },
                  children: /* @__PURE__ */ Ue.jsx(
                    Ub,
                    {
                      integrationId: g,
                      type: $,
                      configuration: e,
                      showNotification: r,
                      showModal: F,
                      children: wS(C, {
                        conversationContext: n,
                        settings: P
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ Ue.jsx(
      Mb,
      {
        isOpen: S,
        setIsOpen: N,
        headline: h.headline,
        text: h.text,
        confirmLabel: h.confirmLabel,
        confirmVariant: h.confirmVariant,
        cancelLabel: h.cancelLabel,
        cancelVariant: h.cancelVariant,
        onConfirm: h.onConfirm ? () => {
          try {
            h.onConfirm && h.onConfirm();
          } finally {
            N(!1), v(f);
          }
        } : void 0,
        onCancel: h.onCancel ? () => {
          try {
            h.onCancel && h.onCancel();
          } finally {
            N(!1), v(f);
          }
        } : void 0,
        children: h.children
      }
    )
  ] });
}, h4 = ({
  widgetConfiguration: e
}) => {
  const n = et(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = et(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, y4 = "FULL_ACCESS", g4 = "2", k4 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [y4],
        version: g4
      })
    }).then((l) => l.json())
  };
}, v4 = "dixaApiToken", Op = "dixaApiTokenId", cS = "dixaApiTokenName", Xv = (e) => [Op, cS].every(
  (r) => e.find((i) => i?.key === r)
);
function b4({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = _4(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const _4 = (e) => [
  {
    key: v4,
    value: e.value,
    secret: !0
  },
  {
    key: Op,
    value: e.id,
    secret: !1
  },
  {
    key: cS,
    value: e.name,
    secret: !1
  }
], x4 = Qr`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, S4 = Qr`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, N4 = Qr`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, j4 = Qr`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, w4 = "_wrapper_1lmim_1", C4 = "_wrapperBox_1lmim_4", F4 = "_wrapperBoxErrorBorder_1lmim_9", Pu = {
  wrapper: w4,
  wrapperBox: C4,
  wrapperBoxErrorBorder: F4
}, I4 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (q) => q.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, S = `Insert your ${h.label.toLowerCase()}`, N = `Insert your ${v.label.toLowerCase()}`, [F, I] = se({
    username: "",
    password: ""
  }), g = pt(
    (q) => {
      m({
        target: {
          name: s,
          value: q
        }
      });
    },
    [s, m]
  );
  return qe(() => {
    g(
      F.username !== "" && F.password !== "" ? window.btoa(`${F.username}:${F.password}`) : ""
    );
  }, [F]), /* @__PURE__ */ Ue.jsx(
    An,
    {
      required: e,
      label: a,
      meta: l,
      className: Pu.wrapper,
      children: /* @__PURE__ */ Ue.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: ct(Pu.wrapperBox, {
            [Pu.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ue.jsx(
              ir,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: F.username,
                  onChange: (q) => I({
                    username: q?.target.value ?? "",
                    password: F.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ue.jsx(
              ir,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: N,
                input: {
                  name: s,
                  value: F.password,
                  onChange: (q) => I({
                    username: F.username,
                    password: q?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function E4({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: S,
  prefix: N,
  integrationId: F,
  integrationType: I,
  configuration: g,
  settings: q,
  otherProps: $
}) {
  const C = v === "custom" && $?.component, D = u(n)?.value;
  return C ? /* @__PURE__ */ Ue.jsx(
    C,
    {
      configuration: g,
      integrationId: F,
      integrationType: I,
      label: r,
      settings: q,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
    /* @__PURE__ */ Ue.jsx(nn, { span: 3, children: /* @__PURE__ */ Ue.jsx(
      T4,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: S,
        children: v === "input" ? /* @__PURE__ */ Ue.jsx(
          ir,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: D,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: N,
            ...e && !S && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Ue.jsx(
          I4,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: S,
            label: r,
            widgetSettingsKey: n,
            settings: q,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Ue.jsx(An, { label: r, children: /* @__PURE__ */ Ue.jsx(
          sb,
          {
            input: {
              name: n,
              value: "",
              checked: D,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Ue.jsx(An, { label: r, children: /* @__PURE__ */ Ue.jsx(
          Kr,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {}),
            value: D ? [
              {
                label: ($?.selectItems || []).find(
                  (U) => U.value === D
                )?.label,
                value: D
              }
            ] : [],
            equalityFn: (U, Z) => U.value === Z.value,
            children: ($?.selectItems || []).map((U) => /* @__PURE__ */ Ue.jsx(mt.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ Ue.jsx(Ue.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ue.jsx(nn, { span: 3 })
  ] });
}
function T4({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ue.jsx(An, { label: n, children: /* @__PURE__ */ Ue.jsxs(
    Wn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ba = "partner-integrations-widget-name-form-field", Zv = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: sS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), $4 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = ($) => i($), l = ($) => !$ || $ === "", d = ($) => {
    const { [$]: C, ...D } = a;
    o(D);
  }, m = ($) => ({
    ...$,
    settings: $.settings.filter(({ isEditing: C }) => C).map(({ key: C, value: D, secret: U }) => ({
      key: C,
      value: D,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = ($) => {
    if (!$)
      return;
    const {
      target: { name: C, value: D }
    } = $;
    a[C] && !l(D) && d(C), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === C ? { ...U, value: D } : U
      )
    });
  }, h = ($) => {
    if (!$)
      return;
    const {
      target: { name: C, checked: D }
    } = $;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === C ? { ...U, value: D } : U
      )
    });
  }, v = ($, C) => {
    if (!C)
      return;
    const { selectedValues: D } = C, U = D?.[0];
    if (U) {
      const Z = r.settings.map(
        (Q) => Q.key === $ ? { ...Q, value: U?.value } : Q
      );
      i({
        ...r,
        settings: Z
      });
    } else {
      const Z = r.settings.filter(
        (Q) => Q.key !== $
      );
      i({
        ...r,
        settings: Z
      });
    }
  }, S = ($) => {
    i({
      ...r,
      enabled: $
    });
  }, N = ($) => {
    if (!$)
      return;
    const {
      target: { value: C }
    } = $;
    a[Ba] && !l(C) && d(Ba), i({
      ...r,
      name: C
    });
  }, F = ($, C) => {
    const { settings: D } = r, U = D.map((Z) => Z.key === C ? {
      ...Z,
      isEditing: $,
      ...!$ && { value: "" }
    } : Z);
    a[C] && !$ && d(C), i({
      ...r,
      settings: U
    });
  }, I = ($) => r.settings.find(
    (C) => C.key === $
  ), g = async ($) => {
    $.preventDefault(), q() && n(m(r));
  }, q = () => {
    const $ = {}, { name: C, settings: D } = r;
    return l(C) && ($[Ba] = u.input), D.forEach(
      ({ key: U, value: Z, required: Q, isEditing: ee, type: J, customValidation: G }) => {
        if (Q && ee)
          if (G) {
            const P = G(Z);
            typeof P == "string" && ($[U] = P);
          } else
            typeof Z == "string" && l(Z) && ($[U] = u[J]);
      }
    ), o($), !Object.keys($)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: S,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: F,
    handleChangeName: N,
    handleSubmit: g,
    getSettingValueByKey: I,
    initializeFormData: s,
    validate: q
  };
}, D4 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], eb = "The configuration of the integration is not correct. Please check the settings.", R4 = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = kn(), { deleteDixaApiToken: l, createDixaApiToken: d } = k4({
    type: n,
    baseUrl: a.baseUrl
  }), u = HS().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = D4.includes(n), [v, S] = se(), [N, F] = se(!1), [I, g] = se(!1), [q, $] = se(!1), [C, D] = se(null), [U, Z] = se(), {
    hasShopifyWidgetOAuth: Q,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: J
  } = h4({
    featureFlags: a.featureFlags,
    widgetConfiguration: U
  }), G = n === "YOTPO" && !!U?.additionalProperties?.isUsingOAuth, P = f && n === "SHOPIFY", ke = lS({
    SHOPIFY: {
      hasShopifyOAuth: Q,
      isShopifyMarketplaceApp: ee,
      isCreationMode: f
    },
    YOTPO: {
      hasYotpoOAuth: G,
      isCreationMode: f
    }
  })[n].settingsConfiguration, me = ke.filter(({ type: le }) => le !== "hidden").filter(({ hideOnCreate: le }) => f ? !le : !0), {
    error: de,
    loading: he,
    refetch: H
  } = US(x4, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (le) => {
      if (Object.keys(le).length === 0)
        $(!0);
      else {
        $(!1);
        const Ne = le?.Management?.widgetConfigurations[0];
        Ne && Z(Ne);
      }
    }
  }), [be, { error: Ce }] = Lp(
    f ? N4 : S4,
    {
      onError: (le) => {
        S(le), F(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (le) => {
        if (F(!1), Object.keys(le).length !== 0) {
          if (f && r(le?.Management?.createWidgetConfiguration?.id), !f) {
            const Ne = le?.Management?.updateWidgetConfiguration;
            Ne.misconfigured ? D(
              Ne?.misconfigurationCause ?? eb
            ) : D(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [K] = Lp(j4, {
    onError: (le) => {
      S(le), F(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      F(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: ze,
    handleIsEnabled: Be,
    errors: Pe,
    handleChangeText: Me,
    handleChangeBoolean: Ie,
    handleChangeSelect: Le,
    handleEditSecret: De,
    handleChangeName: rn,
    handleSubmit: je,
    getSettingValueByKey: We,
    initializeFormData: Ge
  } = $4({
    onSubmit: async (le) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), F(!0);
      const Ne = le.settings.map(
        (j) => typeof j.value == "boolean" ? { ...j, value: j.value.toString() } : j
      ), Ae = Xv(Ne) && f;
      let Ee = [];
      if (Ae) {
        const j = await d().catch(
          (_) => {
            F(!1), console.warn("API-Token (creation) error resonse", _), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        j?.data && (Ee = b4({
          token: j.data,
          settings: Ne
        }));
      }
      const cn = {
        ...le,
        settings: [
          ...Ee.length > 0 ? Ee : Ne
        ]
      };
      (Ae && Ee.length > 1 || !Ae && Ee.length === 0) && (be({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...cn
        }
      }), Ne.forEach(
        (j) => j.secret && De(!1, j.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: Zv({
          settingsFromBackend: J,
          settingsConfiguration: ke,
          creating: !0
        })
      }
    }
  });
  qe(() => {
    if (U) {
      const le = Zv({
        settingsFromBackend: U.settings,
        settingsConfiguration: ke
      });
      Ge({
        enabled: !!U.enabled,
        name: U.name,
        settings: le
      }), U.misconfigured ? D(
        U?.misconfigurationCause ?? eb
      ) : D(null);
    }
  }, [U]);
  const pe = et(() => o ? !o.isCoupled : !0, [o]);
  return de || Ce || v ? /* @__PURE__ */ Ue.jsx(
    wn,
    {
      error: de || v,
      retry: de ? H : void 0
    }
  ) : N || he ? /* @__PURE__ */ Ue.jsx(un, { "data-testid": "widget-settings-loading" }) : q ? /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ue.jsx(On, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ue.jsxs("form", { children: [
    C && /* @__PURE__ */ Ue.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ue.jsx(
      Ja,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ue.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: C }),
          /* @__PURE__ */ Ue.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ue.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ue.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ue.jsxs(
      zt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          !P && /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
            /* @__PURE__ */ Ue.jsx(nn, { children: /* @__PURE__ */ Ue.jsx(An, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ue.jsx(
              sb,
              {
                input: {
                  name: "enabled",
                  checked: ze.enabled,
                  value: "dummy",
                  onChange: (le) => Be(le.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ue.jsx(nn, { span: 3, children: /* @__PURE__ */ Ue.jsx(
              ir,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ba,
                  value: ze.name,
                  onChange: rn
                },
                meta: {
                  error: Pe[Ba]
                }
              }
            ) }),
            /* @__PURE__ */ Ue.jsx(nn, { span: 3 })
          ] }),
          me?.map(
            ({
              key: le,
              secret: Ne,
              label: Ae,
              placeholder: Ee = "",
              required: cn = !1,
              type: j,
              prefix: _,
              readOnly: T,
              ...Y
            }) => {
              const { settings: X } = ze, O = X.find(
                (B) => B.key === le
              );
              return /* @__PURE__ */ Ue.jsx(CS, { children: /* @__PURE__ */ Ue.jsx(
                E4,
                {
                  widgetSettingsKey: le,
                  isEditingField: !!O?.isEditing,
                  handleEditSecret: De,
                  handleChangeText: Me,
                  handleChangeBoolean: Ie,
                  handleChangeSelect: Le,
                  getValueByKey: We,
                  isSecret: Ne,
                  label: Ae,
                  placeholder: Ee,
                  required: cn,
                  errors: Pe,
                  type: j,
                  isCreationMode: f,
                  prefix: _,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: T,
                  settings: ke,
                  otherProps: Y
                }
              ) }, le);
            }
          )
        ]
      }
    ),
    !P && /* @__PURE__ */ Ue.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ue.jsx(Wn, { onClick: je, children: "Submit" }),
      !f && /* @__PURE__ */ Ue.jsx(
        Ke,
        {
          content: "The widget is used in automations",
          disabled: pe,
          children: /* @__PURE__ */ Ue.jsx(
            Wn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), g(!0);
              },
              disabled: !pe,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ue.jsx(
      Mb,
      {
        isOpen: I,
        setIsOpen: g,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Xv(ze.settings)) {
            const le = ze.settings.find(
              ({ key: Ne }) => Ne === Op
            )?.value;
            le && l(le).catch((Ne) => {
              console.warn("API-Token (deletion) error response", Ne), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          K({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ue.jsx(b, { children: h ? /* @__PURE__ */ Ue.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ue.jsx(
            ue,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ue.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ue.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ue.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              ze.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ue.jsxs(Ue.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          ze.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, mM = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ Ue.jsx(
  ob.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ Ue.jsx(
      Ub,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ue.jsx(
          R4,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
);
var Uo = { exports: {} }, nb;
function O4() {
  if (nb) return Uo.exports;
  nb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(C, D, U) {
    return Function.prototype.apply.call(C, D, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(C) {
    return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
  } : r = function(C) {
    return Object.getOwnPropertyNames(C);
  };
  function i($) {
    console && console.warn && console.warn($);
  }
  var a = Number.isNaN || function(C) {
    return C !== C;
  };
  function o() {
    o.init.call(this);
  }
  Uo.exports = o, Uo.exports.once = I, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l($) {
    if (typeof $ != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof $);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function($) {
      if (typeof $ != "number" || $ < 0 || a($))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + $ + ".");
      s = $;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(C) {
    if (typeof C != "number" || C < 0 || a(C))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
    return this._maxListeners = C, this;
  };
  function d($) {
    return $._maxListeners === void 0 ? o.defaultMaxListeners : $._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(C) {
    for (var D = [], U = 1; U < arguments.length; U++) D.push(arguments[U]);
    var Z = C === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ee;
      if (D.length > 0 && (ee = D[0]), ee instanceof Error)
        throw ee;
      var J = new Error("Unhandled error." + (ee ? " (" + ee.message + ")" : ""));
      throw J.context = ee, J;
    }
    var G = Q[C];
    if (G === void 0)
      return !1;
    if (typeof G == "function")
      n(G, this, D);
    else
      for (var P = G.length, W = S(G, P), U = 0; U < P; ++U)
        n(W[U], this, D);
    return !0;
  };
  function m($, C, D, U) {
    var Z, Q, ee;
    if (l(D), Q = $._events, Q === void 0 ? (Q = $._events = /* @__PURE__ */ Object.create(null), $._eventsCount = 0) : (Q.newListener !== void 0 && ($.emit(
      "newListener",
      C,
      D.listener ? D.listener : D
    ), Q = $._events), ee = Q[C]), ee === void 0)
      ee = Q[C] = D, ++$._eventsCount;
    else if (typeof ee == "function" ? ee = Q[C] = U ? [D, ee] : [ee, D] : U ? ee.unshift(D) : ee.push(D), Z = d($), Z > 0 && ee.length > Z && !ee.warned) {
      ee.warned = !0;
      var J = new Error("Possible EventEmitter memory leak detected. " + ee.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      J.name = "MaxListenersExceededWarning", J.emitter = $, J.type = C, J.count = ee.length, i(J);
    }
    return $;
  }
  o.prototype.addListener = function(C, D) {
    return m(this, C, D, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(C, D) {
    return m(this, C, D, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f($, C, D) {
    var U = { fired: !1, wrapFn: void 0, target: $, type: C, listener: D }, Z = u.bind(U);
    return Z.listener = D, U.wrapFn = Z, Z;
  }
  o.prototype.once = function(C, D) {
    return l(D), this.on(C, f(this, C, D)), this;
  }, o.prototype.prependOnceListener = function(C, D) {
    return l(D), this.prependListener(C, f(this, C, D)), this;
  }, o.prototype.removeListener = function(C, D) {
    var U, Z, Q, ee, J;
    if (l(D), Z = this._events, Z === void 0)
      return this;
    if (U = Z[C], U === void 0)
      return this;
    if (U === D || U.listener === D)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[C], Z.removeListener && this.emit("removeListener", C, U.listener || D));
    else if (typeof U != "function") {
      for (Q = -1, ee = U.length - 1; ee >= 0; ee--)
        if (U[ee] === D || U[ee].listener === D) {
          J = U[ee].listener, Q = ee;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? U.shift() : N(U, Q), U.length === 1 && (Z[C] = U[0]), Z.removeListener !== void 0 && this.emit("removeListener", C, J || D);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(C) {
    var D, U, Z;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[C]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(U), ee;
      for (Z = 0; Z < Q.length; ++Z)
        ee = Q[Z], ee !== "removeListener" && this.removeAllListeners(ee);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (D = U[C], typeof D == "function")
      this.removeListener(C, D);
    else if (D !== void 0)
      for (Z = D.length - 1; Z >= 0; Z--)
        this.removeListener(C, D[Z]);
    return this;
  };
  function h($, C, D) {
    var U = $._events;
    if (U === void 0)
      return [];
    var Z = U[C];
    return Z === void 0 ? [] : typeof Z == "function" ? D ? [Z.listener || Z] : [Z] : D ? F(Z) : S(Z, Z.length);
  }
  o.prototype.listeners = function(C) {
    return h(this, C, !0);
  }, o.prototype.rawListeners = function(C) {
    return h(this, C, !1);
  }, o.listenerCount = function($, C) {
    return typeof $.listenerCount == "function" ? $.listenerCount(C) : v.call($, C);
  }, o.prototype.listenerCount = v;
  function v($) {
    var C = this._events;
    if (C !== void 0) {
      var D = C[$];
      if (typeof D == "function")
        return 1;
      if (D !== void 0)
        return D.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function S($, C) {
    for (var D = new Array(C), U = 0; U < C; ++U)
      D[U] = $[U];
    return D;
  }
  function N($, C) {
    for (; C + 1 < $.length; C++)
      $[C] = $[C + 1];
    $.pop();
  }
  function F($) {
    for (var C = new Array($.length), D = 0; D < C.length; ++D)
      C[D] = $[D].listener || $[D];
    return C;
  }
  function I($, C) {
    return new Promise(function(D, U) {
      function Z(ee) {
        $.removeListener(C, Q), U(ee);
      }
      function Q() {
        typeof $.removeListener == "function" && $.removeListener("error", Z), D([].slice.call(arguments));
      }
      q($, C, Q, { once: !0 }), C !== "error" && g($, Z, { once: !0 });
    });
  }
  function g($, C, D) {
    typeof $.on == "function" && q($, "error", C, D);
  }
  function q($, C, D, U) {
    if (typeof $.on == "function")
      U.once ? $.once(C, D) : $.on(C, D);
    else if (typeof $.addEventListener == "function")
      $.addEventListener(C, function Z(Q) {
        U.once && $.removeEventListener(C, Z), D(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof $);
  }
  return Uo.exports;
}
var P4 = O4();
function pM() {
  const e = new P4.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  dj as GraphQLClientProvider,
  Mb as IntegrationModal,
  uM as PartnerIntegrations,
  mM as PartnerIntegrationsSettings,
  N4 as createWidgetConfigurationMutation,
  j4 as deleteWidgetConfigurationMutation,
  x4 as getWidgetConfigurationByIdQuery,
  lS as getWidgetDefinitions,
  pM as initializePartnerEventEmitter,
  S4 as updateWidgetConfigurationMutation,
  hj as usePartnerIntegrationWidgetConfigurations,
  h4 as useShopifyConfiguration
};
